var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEraser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 935 1009",
    width: 935,
    height: 1009,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "all-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #f9f9f8 } \n\t\t.s1 { fill: #ededed } \n\t\t.s2 { fill: #c9f1ff } \n\t\t.s3 { fill: #fcecb3 } \n\t\t.s4 { fill: #f7fea5 } \n\t\t.s5 { fill: #dcdddc } \n\t\t.s6 { fill: #9ee5fe } \n\t\t.s7 { fill: #f5bcc8 } \n\t\t.s8 { fill: #f4de97 } \n\t\t.s9 { fill: #aebbf2 } \n\t\t.s10 { fill: #ffb1a5 } \n\t\t.s11 { fill: #d2c7b9 } \n\t\t.s12 { fill: #68d7fd } \n\t\t.s13 { fill: #c4b8aa } \n\t\t.s14 { fill: #db9ba7 } \n\t\t.s15 { fill: #b4d377 } \n\t\t.s16 { fill: #b4a89a } \n\t\t.s17 { fill: #ec8b7e } \n\t\t.s18 { fill: #3fb8e2 } \n\t\t.s19 { fill: #a69b8c } \n\t\t.s20 { fill: #f17f56 } \n\t\t.s21 { fill: #6576c3 } \n\t\t.s22 { fill: #968a7a } \n\t\t.s23 { fill: #8da755 } \n\t\t.s24 { fill: #837767 } \n\t\t.s25 { fill: #2c2d2c } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "l4Qk5HBNuQnfgr6Jldq8t4A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pJSPkQ44P",
    className: "s0",
    d: "m-1285 4746.5c0-16.5 1-17.5 17.5-17.5 16.5 0 17.5 1 17.5 17.5 0 16.5-1 17.5-17.5 17.5-16.5 0-17.5-1-17.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBnaCkIGK",
    className: "s0",
    d: "m-1680 3839v-20h27.5 27.5v17c0 15-2 17-15.5 20-35 7-39.5 5-39.5-17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pekEobHGe",
    className: "s0",
    d: "m-2791.5 3850.5c-4.5-4-4.5-28-0.5-38.5 2-5 9-8 20-8h17v25 25h-16.5c-9.5 0-18.5-1.5-20-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5Ugxd6Rt",
    className: "s0",
    d: "m1950 3817c-69-14.5-145.5-55.5-185.5-99.5-49.5-54-69.5-130-54.5-209 17-90 104-169.5 218.5-200 31.5-8.5 53.5-10.5 114-10.5 89 0 130 8.5 194 42 50.5 26 97 72 119 117 29 58.5 31 145 4.5 200-9 18.5-13 22-25.5 22-13.5 0-14.5 1.5-14.5 18 0 9.5-2 22-5 27-8 15-64.5 50-80.5 50-9.5 0-20 5-29 14.5-10 10.5-24 17-51 23-48.5 12-160 14.5-204.5 5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZPLu5was",
    className: "s0",
    d: "m-2815 3759.5c0-32.5 3-35.5 41.5-35.5h18.5v25c0 23.5-1 25-12.5 25-8 0-12.5 3-12.5 7.5 0 5-5.5 7.5-17.5 7.5h-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgSmppmGW",
    className: "s0",
    d: "m-2722.5 3757c-5.5-28.5-2-35.5 19-37l18.5-1.5v27.5 28h-17.5c-15.5 0-17.5-1.5-20-17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1A4e2cqCJ",
    className: "s0",
    d: "m-2805 2656.5c0-15.5 1.5-17.5 12.5-17.5 9 0 12.5-2.5 12.5-10 0-5.5 3-19 6-30 6-18 8-20 22.5-20 14.5 0 16.5 1.5 16.5 14 0 7.5-2.5 22-5.5 32.5-4 15-7.5 18.5-17 18.5-10.5 0-12.5 2.5-12.5 15 0 14-1.5 15-17.5 15-16.5 0-17.5-1-17.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRR9HWKbR",
    className: "s0",
    d: "m-2695 2176.5c0-16.5 1-17.5 17.5-17.5 16.5 0 17.5 1 17.5 17.5 0 16.5-1 17.5-17.5 17.5-16.5 0-17.5-1-17.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17mYcyf4R",
    className: "s0",
    d: "m-2649.5 2089v-40h17c15 0 16.5 1.5 19.5 17.5 2 10 2 28 0 40-3 21.5-4 22.5-20 22.5h-16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DvC5WOkh",
    fillRule: "evenodd",
    className: "s0",
    d: "m2095 975l-12.5-10-1.5-145.5c-1-80-2.5-145.5-3.5-145.5-3.5 0-30 12-32.5 15-3 3.5-160.5 95-183.5 107-9 4.5-28 8-42 8-22 0-29-2.5-40.5-13.5-12.5-12-14-16.5-14-46.5 0-19 2.5-36.5 6.5-41.5 3-4.5 74.5-47.5 158-95.5l152-87.5-1-45-1-45.5h23c30 0 82.5 15 82.5 23.5 0 4.5 6.5 6.5 20 6.5 16.5 0 21 2.5 27 14 4 7.5 15 21.5 25 30.5 14.5 14 18 21 18 36.5 0 18-1.5 19.5-38 40.5l-37.5 22v159.5c0 159.5-3 202.5-14 213.5-3 3-22 6.5-42 7.5-30.5 1.5-38 0.5-48.5-8zm67.5-404c7.5-8 7.5-9-1.5-18.5-16.5-16-40.5 1.5-26 19 8 10 17.5 9.5 27.5-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p0Au1QFFu",
    className: "s0",
    d: "m35 526.5c0-16.5 1-17.5 17.5-17.5 16.5 0 17.5 1 17.5 17.5 0 16.5-1 17.5-17.5 17.5-16.5 0-17.5-1-17.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHorVMnEy",
    className: "s0",
    d: "m90 426.5c0-12 2.5-17.5 7.5-17.5 4.5 0 7.5-4.5 7.5-12.5 0-8 3-12.5 7.5-12.5 4.5 0 7.5-4.5 7.5-12.5 0-11 2-12.5 17.5-12.5 16.5 0 17.5 1 17.5 17.5 0 12-2.5 17.5-7.5 17.5-4.5 0-7.5 4.5-7.5 12.5 0 8-3 12.5-7.5 12.5-4.5 0-7.5 4.5-7.5 12.5 0 11-2 12.5-17.5 12.5-16.5 0-17.5-1-17.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGW8wJFe6",
    className: "s0",
    d: "m155 319.5c0-19.5 4.5-30.5 13-30.5 4 0 7-5 7-12.5 0-7 2-12.5 4.5-12.5 2.5 0 6-5.5 7.5-12.5 2.5-10.5 6-12.5 20.5-12.5 16.5 0 17.5 1 17.5 17 0 9.5-3.5 20.5-7.5 25-4 4-7.5 9.5-7.5 12.5 0 3-3.5 5.5-7.5 5.5-4 0-7.5 4.5-7.5 9.5 0 19-5.5 25.5-23 25.5-15.5 0-17-1.5-17-14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRDDTSisz",
    className: "s0",
    d: "m-2812.5 255c-33-11.5-40-25-40-82 0-42.5-0.5-44-11-44-9.5 0-11.5-2.5-11.5-16 0-9 6-28 13.5-42.5 12-24 14.5-26.5 30-26.5 14.5 0 16.5 1.5 16.5 12.5 0 7 1.5 12.5 4 12.5 2 0 2.5-18 1.5-40.5-4-88.5 38.5-134.5 124.5-134.5 45.5 0 71.5 10.5 94 37.5 40.5 49.5 30.5 154.5-18 185-12.5 8-15.5 13.5-16 27 0 22-27 71.5-50.5 93-10.5 9-27.5 19-38 22-27.5 8-70.5 6.5-99-3.5z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "l4EPH4H7NbCwoYzmRkNcL0N"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pR7JxT3qS",
    className: "s1",
    d: "m-1175 3950c0-3.5-4-6-8.5-5-6 1-8.5-1-7-6 1-4 2.5-23 2.5-42.5l0.5-35 25 0.5c19 0.5 25.5 2.5 26.5 9 1.5 6-2 8-16 8h-18v25 25.5l18-3.5c16.5-3 18-2.5 16 8.5-1 10-4 11.5-16 10.5-8-1-16 1-18.5 5-3.5 5-4.5 5-4.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pc585t6wl",
    className: "s1",
    d: "m-1449.5 3843.5c-0.5-6-6-7.5-27.5-7-25 1-26.5 0.5-24.5-9.5 2-10.5 2-10.5-4-0.5-3 5.5-6.5 10.5-7.5 11.5-0.5 1-6-1-12-4-8.5-4.5-9.5-7-5-12.5 3.5-4 4.5-13.5 3-21-3.5-16 0.5-23 14-28 6.5-2.5 8.5-1.5 6.5 3.5-3.5 9 11 7 17-2.5 3.5-5.5 4.5-5.5 4.5 2 0 4.5 3.5 8.5 7.5 8.5 4 0 7.5 3.5 7.5 7.5 0 4-2 7.5-5 7.5-2.5 0-5 4.5-5 10 0 8.5 3.5 10 25 10 19 0 25 2 25 7.5 0 4-3 7.5-7 7.5-4 0-8.5 4-9.5 9-2 6.5-2.5 7-3 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfje5AzD",
    className: "s1",
    d: "m-1395 3840.5c0-3.5-3.5-6.5-7.5-6.5-4 0-7.5-3-7.5-7 0-4 3.5-8 7.5-10 11-4 9-17-2.5-20.5-14.5-4.5-12-12.5 4-12.5 10.5 0 12-1 6-5-4-2.5-5-5-2.5-5 10.5 0 16 8 19 28 3 16.5 1.5 23.5-6.5 32.5-5.5 6.5-9.5 9-10 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNgoz4yxE",
    className: "s1",
    d: "m-1269.5 3839.5c-0.5-4-4-5.5-11-4-8 2-9.5 1-6.5-5.5 2-4.5 3.5-13.5 3.5-19.5-0.5-6.5 1.5-10 4-8.5 2.5 1.5 4.5 0 4.5-2.5 0-3-3-5.5-6-5.5-4-0.5-3-3 2.5-7 5-4 13.5-6 18.5-4.5 11 3 13.5 14.5 4 18-5 1.5-5 4.5 0 13 8 13.5 7.5 20.5-1 20.5-4 0-8.5 3-9.5 6.5-2 4.5-3 4-3-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZxhjbp26",
    className: "s1",
    d: "m-1115 3829c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqPcXmSIL",
    className: "s1",
    d: "m-1048 3822.5c2.5-14.5 1.5-17.5-7-20-5.5-1.5-18.5-0.5-28.5 2-28.5 6.5-32.5 5.5-30.5-6.5 1.5-11 3.5-11.5 35.5-10 21 1 33.5-0.5 33.5-3.5 0-3 2-5.5 4.5-5.5 6 0 14 24 13.5 42.5-0.5 12-3 15.5-12.5 16.5-11 1.5-11.5 0.5-8.5-15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQ4VaKSSg",
    className: "s1",
    d: "m-1173 3818.5c1.5-8.5 3-20 3-25 0-10 12-13 17.5-4.5 2 3 2 14.5 0 25-2.5 15.5-5.5 20-13.5 20-9 0-10-2-7-15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKJ01I8qN",
    className: "s1",
    d: "m227.5 3777.5c-4.5-21-4.5-26-1-44.5 6-28.5 18.5-25 18.5 5 0 13 1.5 28.5 3 34 2 8 0 11.5-7.5 13.5-8 2-11 0-13-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pr2s6lbSO",
    className: "s1",
    d: "m-1528 3759.5c2-2.5 0-6-3-7-3.5-1.5 2.5-2.5 13.5-2.5 11 0 15 1.5 9 2.5-6.5 1-11.5 4.5-11.5 7 0 2.5-2.5 4.5-5.5 4.5-2.5 0-4-2-2.5-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paK1kui7k",
    className: "s1",
    d: "m-1180 3740.5c0-3.5-3-6.5-7-6.5-6 0-7.5-11-9-53-1.5-54 1-67 13.5-67 6 0 7.5 10 7.5 52.5 0 43.5 1.5 52.5 7.5 52.5 4 0 7.5-3.5 7.5-7.5 0-11 13.5-9.5 16.5 2 3.5 14-5 25-17 22-6-2-12.5 0-15 4-3 5-4.5 5-4.5 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1SRGpynw",
    className: "s1",
    d: "m228 3693c-1.5-9-2.5-38-1.5-64l1-47.5-39-1.5c-36-1.5-39.5-0.5-42 9-5 18.5-16.5 11.5-16.5-10v-20h57.5 57.5v75c0 62.5-1 75-7.5 75-4 0-8-6.5-9.5-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15UGo4J7h",
    className: "s1",
    d: "m-1620 3650.5c0-5-1.5-14.5-3.5-21.5-3-11-2.5-12 5-5.5 9.5 7.5 11.5 28 3.5 33-2.5 1.5-5-1-5-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piDCNSDYL",
    className: "s1",
    d: "m-1162 3636c-5.5-14-3-22 6.5-22 10.5 0 15 8 11.5 21.5-2.5 10.5-14 11-18 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEp5ZhL2e",
    className: "s1",
    d: "m510 3568.5c0-9-1-9.5-7.5-4.5-6.5 5.5-7.5 4-7.5-7 0-11.5 2-13 17.5-13 16.5 0 17.5 1 17.5 17.5 0 14-2 17.5-10 17.5-7 0-10-3.5-10-10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2pfB4znp",
    className: "s1",
    d: "m-1797 3534c-2-7-4-14-3.5-16 0.5-2.5-1.5-4-4.5-4-2.5 0-5 2.5-5 5.5 0 3.5-5 0-10.5-7.5-6-7.5-9.5-15-7.5-16.5 1.5-2-0.5-7.5-5.5-12.5-4.5-5-6.5-9-4-9 2 0 1-3-2-7-4.5-5-3.5-8.5 3-13.5 5-4 7-4.5 5-1-4 6.5 13 18.5 18.5 13 1.5-1.5 3 0.5 3 4.5 0 4.5 3.5 9.5 8 11 7.5 3 7.5 2 1.5-5.5-4-4.5-4.5-7-1-5 3.5 2 7 0 8.5-5 1-5 1.5 0 0 11-2 20 2.5 33.5 11 33 2.5-0.5 4.5 2 4.5 4.5 0 3-2 4.5-5 4-2.5-1-6 5.5-7.5 13.5l-3 15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pF3eSVnPi",
    className: "s1",
    d: "m-1730 3524.5c0-2.5-4.5-5.5-10.5-7-8.5-2-10-5.5-8-18 1.5-8.5 0.5-15.5-1.5-15.5-2.5 0-3-5-1.5-11 1.5-6.5 3-25 3.5-41.5l0.5-30 22.5 1c12.5 0.5 24 1 26.5 1 2 0.5 3.5 5.5 3.5 11 0 9.5-2 10-17.5 7.5l-17.5-3.5v43 43l17.5-3.5c15-2.5 17.5-1.5 17.5 6 0 5.5-2 12-4 14.5-4.5 6-31 8.5-31 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXYrx1uFe",
    className: "s1",
    d: "m240 3514.5c0-31-2-30.5 90.5-30.5 81 0 84.5 0.5 84.5 10 0 9.5-3.5 10-80 10-44 0-79.5 1.5-79.5 4 2 12-1.5 21-8 21-5 0-7.5-5-7.5-14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKTwWw2n4",
    className: "s1",
    d: "m115 3511.5c0-5.5-10-7.5-48.5-8.5l-49-1.5-1.5-63.5c-1-61.5-1-64 9-64 5.5 0 10 2.5 10 5 0 3 7 5 15 5q15 0 15 7.5c0 4-3.5 7.5-8 7.5-4.5 0-9 4.5-10.5 10-1.5 5.5-4.5 10-7 10-2.5 0-4.5 8-4.5 17.5 0 9.5 2.5 17.5 5 17.5 3 0 5 3.5 5 8 0 4.5 4.5 9 10 10.5 5.5 1.5 10 4.5 10 7 0 2.5 14.5 4.5 32.5 4.5h32.5v17.5c0 12-2.5 17.5-7.5 17.5-4 0-7.5-3.5-7.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxUJup4T9",
    className: "s1",
    d: "m460 3511.5c5-6.5 4.5-7.5-4.5-7.5-7 0-10.5-3-10.5-10 0-8 3.5-10 17.5-10 16.5 0 17.5 1 17.5 17.5 0 15.5-1.5 17.5-13 17.5-11 0-12.5-1-7-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DrYU98YQ",
    className: "s1",
    d: "m-1191.5 3505.5c-2-1.5-3.5-27.5-3.5-57 0-58.5 0.5-59.5 32.5-59.5 17.5 0 23.5 7.5 19 24.5-3 12-16.5 14.5-16.5 3 0-4-3.5-7.5-7.5-7.5-6 0-7.5 9-7.5 50 0 38.5-1.5 50-6.5 50-4 0-8.5-1.5-10-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plCsubviU",
    className: "s1",
    d: "m516.5 3490.5c-10.5-4-7.5-15 4.5-18 13.5-4 19-0.5 19 12 0 9.5-9.5 12-23.5 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13HYWoE2c",
    className: "s1",
    d: "m-1715 3461.5c0-24 1-27.5 10-27.5 9 0 10 3.5 10 27.5 0 24-1 27.5-10 27.5-9 0-10-3.5-10-27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbkEV8jxn",
    className: "s1",
    d: "m630 3429c0-5.5-3.5-10-7.5-10-4 0-7.5-3.5-7.5-7.5 0-8-13.5-8.5-376-7.5-76.5 0-144.5-1-151.5-3-15-3.5-17-17-2.5-17 5.5 0 10-2 10-5 0-2.5 3.5-5 8-5 4.5 0 9-4.5 10.5-10 3-12 31.5-14.5 31.5-3 0 9 22.5 13 56.5 9.5 19.5-2 28.5-5 28.5-9.5 0-11.5 23.5-8.5 26.5 3 1.5 5.5 6 10 10.5 10 4.5 0 8 2.5 8 5 0 3 53.5 5 150 5 96.5 0 150-2 150-5 0-2.5 3-5 6.5-5 3 0 12-3.5 20-7 13-7 13.5-7 13.5 5 0 7.5 3 12 7.5 12 4 0 7.5 4.5 7.5 10 0 7.5 3.5 10 14.5 10h14l-8 17.5c-9 19-20.5 23-20.5 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfgaeaari",
    className: "s1",
    d: "m-1749.5 3354.5c-0.5-9.5-1.5-18.5-2.5-20-1-1.5 0-7 1.5-12.5 3-8 9.5-9 61-9 54 0 57 0.5 58.5 10.5 1.5 10 0 10.5-48.5 10.5-41.5 0-50.5 1.5-50.5 7.5 0 6 9 7.5 50.5 7.5 45 0 50 1 48.5 9-1.5 7.5-9.5 9-59.5 11l-57.5 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1gLRRtO1",
    className: "s1",
    d: "m-1519 3365c-7.5-5-9.5-39.5-2.5-46.5 3-3 27.5-4.5 59.5-3.5 47 1.5 54.5 2.5 56 10.5 1.5 7.5-3.5 8.5-48.5 8.5-41.5 0-50.5 1.5-50.5 7.5 0 6 9 7.5 50.5 7.5 45 0 50 1 48.5 9-1.5 7.5-8.5 8.5-54 10-29 0.5-55.5-1-59-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjXTQeo5e",
    className: "s1",
    d: "m-1295 3364c-3.5-2-5-12.5-4-25.5l1.5-22h57.5c50.5 0 57.5 1 59 9 1.5 7.5-3.5 8.5-48.5 8.5-41.5 0-50.5 1.5-50.5 7.5 0 6 9 7.5 50.5 7.5 45 0 50 1 48.5 9-1.5 7.5-8.5 8.5-55 9-29 0.5-55.5-1-59-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Dq566feV",
    className: "s1",
    d: "m136.5 3325.5c-3.5-1.5-6.5-9-6.5-17 0-9.5-2.5-14.5-7.5-14.5-4 0-7.5-4.5-7.5-10 0-6.5 3.5-10 10-10 5.5 0 10 3.5 10 7.5 0 4.5 4.5 7.5 12 7.5 27 0 38.5 13 14.5 16q-13.5 1.5-16.5 12c-1.5 5.5-5.5 9.5-8.5 8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvnWEsy38",
    className: "s1",
    d: "m230 3316c0-4.5-4.5-9-10-10.5-14.5-4-12.5-16.5 2.5-16.5 8 0 12.5-3 12.5-7.5 0-4 4.5-7.5 10-7.5 6.5 0 10 3.5 10 10 0 5.5-2 10-5 10-2.5 0-5 7-5 15q0 15-7.5 15c-4 0-7.5-3.5-7.5-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12Ntzbm5s",
    className: "s1",
    d: "m697.5 3274c5-5.5 9.5-9.5 9.5-9 0.5 1 4 5.5 7.5 10.5 6 7.5 5 8.5-9.5 8.5-16 0-16.5 0-7.5-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pACM5D4lY",
    className: "s1",
    d: "m-1938.5 3255.5c-1.5-5-4-11-5.5-14-1.5-2.5 0.5-2 4 1 6.5 6 11.5 21.5 7 21.5-1.5 0-3.5-4-5.5-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1G74xQJky",
    className: "s1",
    d: "m359 2770.5c-5-1-9-5.5-9-9.5 0-5.5 8.5-7 40-7 30.5 0 40 1.5 40 7 0 11-43 17-71 9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "py0rNJgcW",
    className: "s1",
    d: "m298.5 2761c-32.5-7.5-48.5-15-48.5-22 0-7.5 17.5-6 58.5 4 28 6.5 36.5 10.5 36.5 17.5 0 10-7 10-46.5 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnnGm6DMK",
    className: "s1",
    d: "m460 2755.5c0-6.5 8-11.5 30-17.5 60-18 77-5 19.5 14.5-39 13.5-49.5 14-49.5 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1F32uipuK",
    className: "s1",
    d: "m570 2711.5c0-10.5 2.5-12.5 15-12.5 11.5 0 15-2 15-10 0-7.5 3.5-10 12-10 9 0 12.5-3 14-11 1-8 5.5-12 15-13 10.5-1.5 13.5-4.5 15-15 1-9.5 5-14 13-15 8-1.5 11-5 11-14 0-8.5 2.5-12 10-12 8 0 10-3.5 10-15 0-12.5 2-15 12.5-15 7 0 12.5 1.5 12.5 4 0 8.5-39 60.5-64.5 86.5-26 25.5-78 64.5-86.5 64.5-2.5 0-4-5.5-4-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGKD7Mq7q",
    className: "s1",
    d: "m-1630.5 2709c-26-4.5-47-14.5-78.5-36.5-22-16-47.5-59.5-54-92-3-14.5-2-16.5 7.5-16.5 8.5 0 10.5 3 10.5 14.5 0 8 1.5 15.5 4 16.5 2 1 11.5 14.5 21 30.5 9.5 15.5 20 28.5 23.5 28.5 4 0 8 3.5 9.5 7.5 2 4 6 7.5 9.5 7.5 4 0 10 3 13.5 6.5 8 8 47 18.5 68.5 18.5 12 0 15.5 2 15.5 10 0 11-9 12-50.5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14u4g8LyY",
    className: "s1",
    d: "m-1560 2704.5c0-10.5 1.5-10.5 94-10.5 51.5 0 105.5-1.5 120-3 21.5-3 26-2 26 4 0 12.5-17.5 15-131 17.5-108.5 2.5-109 2.5-109-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvFOq4xRQ",
    className: "s1",
    d: "m171.5 2701.5l-14-12 19-0.5c16.5 0 18.5 1.5 18.5 12.5 0 15.5-5.5 16-23.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p08dR6pGa",
    className: "s1",
    d: "m-1315 2686.5c0-11 2-12.5 17-12.5 15 0 17.5-1.5 19-13.5 1-10 4.5-14.5 13-15.5 8-1.5 11-5 11-14 0-6.5 2-12 4.5-12 2.5 0 6-5.5 7.5-12.5 2-7 5.5-12.5 8-12.5 3 0 5-6.5 5-15 0-11.5 2-15 10-15 28.5 0-13.5 82.5-58.5 115-29 20.5-36.5 22-36.5 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVaMALmzV",
    className: "s1",
    d: "m120 2659l-27.5-27.5 14.5-1.5c10.5-1.5 18.5 2 29 13 11 10.5 14.5 18.5 13 29l-1.5 14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkIV8tZ5C",
    className: "s1",
    d: "m78 2610c-4.5-5-17.5-27-28.5-49-20-39-20.5-39.5-9.5-41 13.5-2 20 6 20 25.5 0 8.5 2.5 13.5 7.5 13.5 4.5 0 7.5 4.5 7.5 12.5 0 8 3 12.5 7.5 12.5 5 0 7.5 5.5 7.5 17.5 0 20-0.5 20.5-12 8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12iVCEIlS",
    className: "s1",
    d: "m726.5 2535.5c1.5-10.5 8.5-38 15.5-61 7-23 13-50.5 13-61 0-16.5 1.5-19.5 10.5-19.5 10 0 10.5 1.5 7 31.5-4.5 38-15 78.5-27.5 107-12 27-22 28.5-18.5 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSwbu0cxu",
    className: "s1",
    d: "m-1225 2489c0-46.5 0.5-50 10-50 9 0 10 3.5 10 39 0 45-3.5 61-13 61-5.5 0-7-11-7-50z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnvTfbrQd",
    className: "s1",
    d: "m13 2458c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwMtzq4oO",
    className: "s1",
    d: "m7 2411.5c-4.5-24 4.5-81 20.5-130 15.5-47.5 65.5-152.5 72.5-152.5 3 0 5 6.5 5 15 0 18-29.5 80-38.5 80-4 0-6.5 6.5-6.5 17.5 0 9.5-2 17.5-4.5 17.5-2.5 0-5.5 9-7.5 20-1.5 11-5 20-7.5 20-5 0-9.5 26-13.5 86.5-2.5 31.5-5 43.5-10 43.5-3.5 0-8-8-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pud2J4gOF",
    className: "s1",
    d: "m-2222.5 2404c-2-3-6-3.5-9-1.5-4.5 2.5-4.5 1.5-0.5-4 3-4 5-11 4.5-15.5-1-5 0.5-10 3-12 2.5-1.5 3-5.5 1.5-8.5-2-3.5-1.5-4 1-2 5.5 5.5 6.5 28 1 31.5-2.5 1.5-2 6 1.5 10 3 4 4.5 7 3 7-1.5 0-4.5-2.5-6-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plM9YaX20",
    className: "s1",
    d: "m755 2374.5c0-8-5.5-34-12.5-57.5-7-23.5-12.5-45.5-12.5-48.5 0-3-3.5-8.5-7.5-12.5-4-4.5-7.5-13-7.5-19.5 0-6.5-2-12.5-4.5-13.5-2.5-0.5-11.5-15.5-20-32.5-15-30-20.5-61.5-11-61.5 13 0 75.5 146 87.5 206 10.5 49.5 10 54-2 54-7.5 0-10-3.5-10-14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYiWMGwWi",
    className: "s1",
    d: "m-1225 2186.5c0-43.5 1.5-52.5 7.5-52.5 4 0 7.5 3 8 6.5 0.5 3 1.5 27 2.5 52.5 1.5 43 1 46-8 46-9.5 0-10-3.5-10-52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzUBrxDdc",
    className: "s1",
    d: "m105 2116c0-6 17-32 21-32 2 0 4 8 4 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMEsgeMMP",
    className: "s1",
    d: "m650 2101.5c0-14-2-17.5-10-17.5-8 0-10-3.5-10-17.5 0-9.5 2-17.5 4-17.5 3.5 0 41 61.5 41 67.5 0 1.5-5.5 2.5-12.5 2.5-11 0-12.5-2-12.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppx4IT5PT",
    className: "s1",
    d: "m-1762.5 2095.5c5-26 20-54 43.5-79.5 20-21.5 63-47 80-47 5 0 9-3.5 9-7.5 0-4 2-7.5 4-7.5 2 0 4.5-7 5-16 2.5-29.5 29.5-62.5 62-76.5 25-10 39-9.5 39 1.5 0 8.5-21 18.5-51 24.5-10.5 2-14 5.5-14 14.5 0 6.5-2 12-4.5 12-5 0-15.5 38.5-15.5 56 0 10-4 13-23.5 18-12.5 3.5-33 13-45 21-12 8.5-25.5 15-29.5 15-3.5 0-7 4.5-7 10 0 5-3 11.5-6 13.5-7.5 5-29 48.5-29 59 0 4.5-4.5 7.5-10.5 7.5-9.5 0-10.5-2-7-18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFONfXPgS",
    className: "s1",
    d: "m-1235 2081.5c0-19.5 7-23 15-8 8 15.5 6 25.5-5 25.5-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkjjaHGSi",
    className: "s1",
    d: "m150 2041c0-6 17-32 21-32 2 0 4 8 4 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDEB5OXxi",
    className: "s1",
    d: "m-1276.5 2030.5c-2-1.5-3.5-8.5-3.5-15 0-10-2.5-11.5-17-11.5-9.5 0-20.5-3.5-25-7.5-4-4-12-7.5-17.5-7.5-11.5 0-13.5-6-18.5-51-2.5-28.5-4.5-34-12.5-34-5 0-12-4-15.5-9-7.5-10-30.5-21-44-21-7 0-10-3.5-10-10.5 0-10 2-10.5 21-7.5 44 7 74.5 40.5 81.5 89.5 3 22.5 4.5 25 24 33.5 25 10.5 52 30.5 62 44.5 6.5 10 6 10.5-7.5 10.5-8 0-16-1.5-17.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGVi8jo9W",
    className: "s1",
    d: "m-1185.5 2003l-36-31.5 17-2.5c12-2 21 0 30.5 6 19.5 13.5 21.5 19 7 19-20 0-15 9 6 11 16 1.5 18.5 3.5 20 15.5 1 7.5-0.5 13.5-3.5 13.5-2.5 0-21-14-41-31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAFuPqVvg",
    className: "s1",
    d: "m600 2026.5c0-4-2-7.5-5-7.5-2.5 0-5-3.5-5-7.5 0-4-2-7.5-5-7.5-2.5 0-5-3.5-5-7.5 0-4-2-7.5-5-7.5-2.5 0-5-3.5-5-7.5 0-4-2-7.5-5-7.5-2.5 0-5-3.5-5-7.5 0-4-2-7.5-5-7.5-2.5 0-5-3.5-5-7.5 0-4-2-7.5-5-7.5-2.5 0-5-3.5-5-7.5 0-4-2-7.5-5-7.5-2.5 0-5-3.5-5-7.5 0-4-2-7.5-5-7.5-2.5 0-5-3.5-5-7.5 0-4-2-7.5-5-7.5-2.5 0-5-4.5-5-10 0-5.5-3.5-10-7.5-10-5 0-7.5-5.5-7.5-17.5 0-15.5-1.5-17.5-12.5-17.5-9 0-12.5-2.5-12.5-10 0-5.5-3.5-10-7.5-10-5 0-7.5-5.5-7.5-17.5 0-9.5 1-17.5 2.5-17.5 6.5 0 158 217.5 166 237.5 2 5.5-1 7.5-10.5 7.5-8 0-13-3-13-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8chuuX87",
    className: "s1",
    d: "m185 1985.5c0-5 30-50 38-56.5 6-5.5 7-3.5 7 12 0 10-2 18-5 18-2.5 0-5 3.5-5 7.5 0 4-2 7.5-5 7.5-2.5 0-5 3.5-5 7.5 0 4.5-4.5 7.5-12.5 7.5-7 0-12.5-1.5-12.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHW1kdyoN",
    fillRule: "evenodd",
    className: "s1",
    d: "m-1255.5 1940c-25.5-23-32-41-15-41 7.5 0 75.5 52 75.5 57.5 0 1-8 2.5-18 3.5-15.5 2-21-1-42.5-20zm20.5-11c0-2.5-5.5-5-12.5-5-7 0-12.5 2.5-12.5 5 0 3 5.5 5 12.5 5 7 0 12.5-2 12.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FacPsayF",
    className: "s1",
    d: "m235 1910c0-2 22-34 49-71 81-112 102-140 105.5-140 3 0 14.5 14 42.5 51.5l14 18.5h-15.5c-12 0-15.5-2-15.5-9.5 0-5-4.5-10.5-10-12-5.5-1.5-10-6-10-10.5 0-5-4.5-8-12.5-8-11 0-12.5 2-12.5 17.5 0 14-2 17.5-10 17.5-7.5 0-10 3.5-10 12.5 0 10-2.5 12.5-12.5 12.5-11 0-12.5 2-12.5 17.5 0 12-2.5 17.5-7.5 17.5-4 0-7.5 4.5-7.5 10 0 5.5-2 10-5 10-2.5 0-5 3.5-5 7.5 0 4-3.5 7.5-7.5 7.5-4 0-7.5 4.5-7.5 10 0 7.5-3.5 10-12.5 10-11 0-12.5 2-12.5 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-2-12.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pR3T4baXm",
    className: "s1",
    d: "m-1238 1877c-9.5-7-9.5-7.5 0-16.5 6.5-6.5 10-7.5 11.5-2.5 1.5 3 6.5 6 12 6 6 0 9.5 3.5 9.5 10 0 12-18 13.5-33 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2q65gVjC",
    className: "s1",
    d: "m-1140 1874c0-9.5 3.5-10 47.5-10 30.5 0 47.5-2 47.5-5.5 0-7 21-3.5 23.5 3.5 1 3.5-1.5 9.5-6 14-6.5 6.5-19 8-60.5 8-48.5 0-52-0.5-52-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVTzMTo46",
    className: "s1",
    d: "m-1505 1862c0-8 12.5-12 26.5-9 16 4 9.5 16-9 16-12 0-17.5-2.5-17.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1jfALTMt",
    className: "s1",
    d: "m-1273.5 1830.5c-14.5-5.5-4.5-22.5 32.5-54 33.5-29 38.5-32 40-23 1 6 5.5 10.5 10 10.5 6 0.5 3.5 5-9 15.5-13.5 11.5-18 13-19 7-1-4-5-7.5-9-7.5-8.5 0-9.5 20-0.5 20 3 0.5-3 8-13.5 17.5-20.5 18-21 18.5-31.5 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEvF7vObN",
    className: "s1",
    d: "m-1180 1749.5c0-6.5-3-10.5-8.5-10.5-7.5 0-7.5-1 0.5-9.5 5-5.5 18-16 28.5-23.5 18-12 21-13 27.5-6 7 6.5 6 9-5.5 23-7.5 9-20 20.5-28 26.5l-14.5 10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIsaJIn2Y",
    className: "s1",
    d: "m1194.5 1723c0-1-1-5.5-2-10.5-1.5-7.5-0.5-8 5.5-3 3.5 3 5.5 7.5 4 10-2.5 4.5-6.5 6-7.5 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19yeO6JFK",
    className: "s1",
    d: "m-1480 988c0-5 2-9 4.5-9 2.5 0 6-4 7-8.5 2-7 2.5-7.5 3-1 0 4-3 12-7 17.5-6.5 8.5-7 8.5-7.5 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pit1paK5K",
    className: "s1",
    d: "m0 756.5c0-7 2.5-12.5 5-12.5 3 0 5 5.5 5 12.5 0 7-2 12.5-5 12.5-2.5 0-5-5.5-5-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkf9YAZVd",
    className: "s1",
    d: "m22 763.5c-1.5-3-1-7.5 2-10.5 3-3 5.5-1 7.5 5.5 2.5 11-3.5 14.5-9.5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXuAaFuHm",
    className: "s1",
    d: "m-2806 260.5c-5.5-1.5-9-7-9-13.5v-11.5l27.5 7.5c32.5 9 37.5 21.5 9 20.5-10.5-0.5-23-1.5-27.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSuQ04aN",
    className: "s1",
    d: "m-2755 257c0-6.5 14-13 29-13 3 0 6 4.5 6 10 0 8-3.5 10-17.5 10-11.5 0-17.5-2.5-17.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxkEDUFCQ",
    className: "s1",
    d: "m-2852 213.5c-9-45.5 6-55.5 18-12 7.5 27.5 7.5 27.5-3.5 27.5-8.5 0-12-3.5-14.5-15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmBxrCVlp",
    className: "s1",
    d: "m-2768.5 121.5l-14-12 19-0.5c16.5 0 18.5 1.5 18.5 12.5 0 15.5-5.5 16-23.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqd7PLiuS",
    className: "s1",
    d: "m544 890.5c-5-1-9-5.5-9-9.5 0-5.5 8-7 35-7 26.5 0 35 1.5 35 7 0 11-35 16.5-61 9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p0CwC08nG",
    className: "s1",
    d: "m2588.5 360.5c-2-1.5-3.5-9.5-3.5-16.5 0-7.5-3.5-22-7.5-31.5-4-10-7.5-25-7.5-33.5 0-15 1-15.5 18.5-14 18.5 1.5 18.5 1.5 27.5 36.5 5 19.5 9 41 9 49 0 12-2 13.5-16.5 13.5-9.5 0-18.5-1.5-20-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poMr1TODM",
    className: "s1",
    d: "m2555 241.5c0-16.5 1-17.5 17.5-17.5 16.5 0 17.5 1 17.5 17.5 0 16.5-1 17.5-17.5 17.5-16.5 0-17.5-1-17.5-17.5z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "l2puKoR2Z66jPFQkMYPXTox"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pvus1dFqQ",
    className: "s2",
    d: "m-1555.5 4902.5c-51-21.5-81.5-50.5-104-98.5-12-25-13-33-13-90 0-58.5 1-64.5 14-91 18-36.5 50.5-69.5 87.5-87.5 27-13 32.5-14 93.5-14 63 0 66 0.5 95 16 37 19 69 52.5 86.5 90.5 12.5 26 13.5 34 13.5 88.5 0 56.5-1 62-15.5 92.5-19 39.5-48.5 70-86 88.5-24.5 12-34.5 13.5-85.5 15-52 1.5-61 0.5-86-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDK8sNQ4r",
    className: "s2",
    d: "m2386.5 477c-15-7-16.5-9.5-16.5-29.5v-22.5l45-25.5c33.5-19 50-25.5 65-25.5h20v35c0 33-1 36.5-17 53.5-15.5 17-19 18.5-48.5 20-20.5 1-38-1-48-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSMDyLlE7",
    className: "s2",
    d: "m2081 301c-17-12-26-34-26-64.5 0-47.5 20-72.5 58.5-72.5h21.5v72.5 72.5h-21.5c-11.5 0-26.5-3.5-32.5-8z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "l6ou2DbA3TMkFjRnAKFJTE1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pui09IDMl",
    className: "s3",
    d: "m1973 4780.5c-6-37.5-4.5-41.5 14-41.5 15.5 0 17 1.5 20 19 6 37 4.5 41-14 41-15.5 0-17-1.5-20-18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZKMZa3iY",
    className: "s3",
    d: "m2080.5 4774.5c-5-3.5-6-11.5-3-35 3.5-30.5 3.5-30.5 20-30.5 15 0 16.5 1.5 19.5 19 1.5 10 3 26 3 35 0 15-1 16-16 16-9 0-19.5-2-23.5-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVN17PSdi",
    className: "s3",
    d: "m2115 4676.5c0-9.5 2.5-17.5 5-17.5 3 0 5-5.5 5-12.5 0-11 2-12.5 17.5-12.5 14 0 17.5 2 17.5 10 0 6.5 3.5 10 10 10 8 0 10 3.5 10 17 0 16-1 17-23 20-40.5 5.5-42 5-42-14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSKD11HHa",
    className: "s3",
    d: "m1865 4609.5v-20.5h20.5 20l-1.5 19c-1.5 17.5-2.5 18.5-20 20l-19 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BnKT4gG7",
    className: "s3",
    d: "m2040 4496.5c0-16.5 1-17.5 17.5-17.5 16.5 0 17.5 1 17.5 17.5 0 16.5-1 17.5-17.5 17.5-16.5 0-17.5-1-17.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poc1s7GGM",
    className: "s3",
    d: "m2059.5 2617.5c-26-17-35.5-40-33-77.5 2-27 6.5-38 33-84 16.5-29 30.5-53.5 30.5-54.5 0-0.5-14-4-31-7-35.5-7-71.5-22-114.5-48.5-44.5-27-45-26.5 49.5-182 43-71.5 106-175.5 139.5-231 108.5-179.5 104.5-174 125-174 43.5 0 132.5 71.5 165 133 9 16.5 19.5 45 24 62.5 8.5 37.5 10 113 2 149-4 20-4 27 2.5 36.5 9.5 15 48 158.5 51.5 192 3.5 32-4.5 56-24 75-13 12.5-19.5 14.5-51.5 16-55.5 3-82.5-16.5-90.5-65-3.5-18.5-12.5-31.5-12.5-17.5 0 6.5-109.5 201-141 250-19.5 30.5-35.5 38.5-75.5 38.5-25 0-36-2.5-49-11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQKzNSh3z",
    className: "s3",
    d: "m-1445 2510c-9.5-4.5-21.5-16.5-27.5-26-9.5-16.5-10-26-10-145 0-118.5 0.5-128.5 10-144.5 18.5-31 34.5-35.5 125.5-35.5 75.5 0 81.5 0.5 97.5 11.5 32.5 21.5 34.5 31.5 34.5 168.5 0 137-2 147-34.5 168.5-16 11-22 11.5-97.5 11.5-66.5 0-83.5-1.5-98-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p152L8tc0u",
    className: "s3",
    d: "m-1601 1980c-7.5-1.5-9-7.5-9-34 0-38.5 8.5-57 31.5-71.5 15.5-9.5 24.5-10.5 99.5-10.5 77.5 0 83.5 0.5 99.5 11.5 9.5 6 21 19 25.5 28.5 10.5 20.5 12 69.5 3 72.5-8.5 2.5-239 6-250 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmHk7n5qQ",
    className: "s3",
    d: "m-3319 1103c-9.5-9.5-7.5-32 10-103.5l16.5-66.5 28.5-14.5c16-8 36.5-14.5 46-14.5h17l3.5 32.5c2 18 4.5 32.5 5.5 32.5 1 0 13.5-4.5 27.5-10.5 14.5-5.5 34-9.5 44-8.5 17 1.5 18 2.5 19.5 20.5 1 13-1 22.5-7 29-4.5 5-43.5 32-87 59.5-65.5 41.5-82 50-98.5 50-10.5 0-22-2.5-25.5-6z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "lEsyn3BOp2hOR71dMY210Y"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prOMBCVvI",
    className: "s4",
    d: "m1972 4764.5c-4.5-40.5-6-42-32.5-36-12 3-29.5 5.5-38 5.5-15.5 0-16.5-1-16.5-16.5 0-11 5.5-24.5 15.5-38.5 12.5-17 14-22 8.5-25.5-3.5-2.5-14-9.5-22.5-15-13.5-8.5-16.5-13.5-16.5-27.5 0-19.5 3-21.5 41.5-26.5 19-2.5 25.5-5.5 24.5-10.5-1-4-3-22.5-4.5-41l-3-34h17c11 0 24 5.5 36.5 15 11 8.5 21.5 15 23.5 15 2 0 10-10 18-22.5 12.5-20 16-22.5 32.5-22.5h18.5l3.5 35.5c3 33 4 35 14 32.5 5.5-2 24.5-4.5 42-6.5l31-3v16.5c0 10.5-6 24-17 39.5l-17.5 23.5 25 14c23.5 13 25 15 23.5 32l-1.5 18.5-32.5 5c-36 6-34 2-27.5 54l4 28.5h-20c-14 0-25.5-4-39-14.5l-19.5-14.5-16.5 24.5c-14.5 21.5-19 24.5-34 24.5h-17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZGZMkpqV",
    className: "s4",
    d: "m-2849.5 288c-30-14.5-50.5-47.5-50.5-80 0-23.5 0.5-24 15-24 11.5 0 21 6.5 43.5 29.5 24.5 25 34 31 59 38 16.5 4.5 33 9 36.5 10 3 1.5 6 10 6 20v17.5h-43.5c-35 0-48.5-2-66-11z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "l2GqM4EtAStpzBTd9W0wsny"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "p15v0e05Hl",
    className: "s5",
    d: "m2429.5 259c-0.5-2.5-1-8-1.5-11-0.5-3.5-3.5-9-7-12-4-2.5-6-10-5-16.5 1.5-11 1.5-11 12-2 6.5 5.5 10 14.5 9.5 24-0.5 8.5 1.5 16.5 4.5 18.5 3.5 2.5 2 4-3 4-5 0-9.5-2-9.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pq2jcySqU",
    className: "s5",
    d: "m552 5237.5c-71.5-41.5-129-95.5-163.5-155-10.5-17.5-45.5-78-78-134-56-97.5-59-102-75.5-105-23-3.5-37-11.5-47-26.5-11-17-10-28 2-28 5.5 0 10 3 10 6.5 0 9.5 40 33.5 56 33.5 12 0 16 3.5 25.5 24 6 13 13.5 26 16 29 3 3 11 16.5 17.5 30 7 13.5 15.5 27.5 18.5 31 3.5 3.5 8 12 9.5 19 1.5 6.5 5 12 7 12 2.5 0 7 8 10.5 17.5 3.5 9.5 8 17.5 10 17.5 2 0 6 7.5 10 16.5 3.5 8.5 7.5 17 9 18.5 4.5 4 40.5 59.5 40.5 62 0 1.5 16 18 36 36.5 19.5 18.5 40 38 45 43 5 4.5 11 8.5 13.5 8.5 2.5 0 5.5 1.5 6.5 4 1 2 14.5 10.5 30 18.5 18.5 9.5 29 18 29 24 0 12-13.5 10.5-38-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pH5QrcZHZ",
    className: "s5",
    d: "m-1238.5 5219.5c-9-5.5-24.5-24.5-35.5-44-83-141.5-100.5-174-103.5-193-4-22.5-14-45.5-26-59.5-5.5-6.5-10.5-7-23-3.5-26 7.5-33.5 6-33.5-7.5 0-15 17-20 50-14 20 3.5 24 6.5 34.5 25.5 6.5 12 14 32 16.5 44.5 2 13 18 47 36.5 78.5 18 31 32.5 58.5 32.5 61.5 0 3 2 6 4 7 2.5 1 13.5 17.5 25 37.5 20 34 41 56.5 52.5 56.5 9.5 0 38-22 40.5-31.5 2.5-10-10-41-20.5-52.5-3.5-3.5-8-12-9.5-19-1.5-6.5-5-12-7-12-2 0-6.5-7.5-10.5-16-3.5-9-8-17.5-9.5-19-4.5-3-50-82.5-50-86.5 0-1.5-11-13.5-25-26.5-13.5-12.5-26-28-28-33.5-2-6-6.5-13.5-10-17.5-4-3.5-7-10-7-14 0-4-3.5-7-7.5-7-4 0-7.5 3.5-7.5 7.5 0 5-5.5 7.5-17.5 7.5-21.5 0-22-5-2.5-17 24.5-14 52.5-46.5 65.5-74.5 6.5-14.5 13.5-27 16-27.5 2-1 5-10.5 6.5-21.5 2.5-15 5.5-19.5 13-19.5 9 0 10 2 6.5 23-4.5 30-18.5 63-40 92l-17 23 10.5 17.5c5.5 9.5 20.5 28.5 33.5 42 24.5 26 131.5 208.5 137.5 234 4.5 18.5-9.5 47-29 59-20 12-41.5 12-61.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16M7JylKj",
    className: "s5",
    d: "m570 5173c0-40.5-38.5-157.5-58.5-178-3.5-3.5-8-12-9.5-19-1.5-6.5-5-12-7-12-2.5 0-6-5-8-11-1.5-6-6.5-14-10-18-4-3.5-7-12-7-19 0-7-3-12-7-12-3.5 0-10-7.5-13.5-16-3.5-9-9.5-19.5-13-23-3.5-3.5-6.5-12-6.5-19 0-7-3-12-7-12-4 0-9-5-11-11-1.5-6-6.5-14-10-18-4-3.5-7-10-7-14 0-4-2-7-5-7-7 0-6.5-48.5 0.5-53 8-5 1.5-30-11-42.5-7.5-7.5-19.5-12-35.5-13.5-19.5-2-24-4-24-11.5 0-5.5-2-9.5-4.5-9.5-2.5 0-7-7-10.5-15.5-8.5-19.5-32.5-43.5-48-47.5-7.5-2-12-6.5-12-13 0-9 2-10 16-7 24 5 47 25 61.5 55 12 24.5 15 27 33.5 30 47 7.5 72 50.5 51.5 89.5-7 14-6.5 16 26.5 72.5 129.5 221 133 228 148 302.5 11 53 10.5 68.5-2 68.5-8 0-10-3.5-10-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pA18u535Q",
    className: "s5",
    d: "m-1527.5 4919c-67-16.5-121.5-66-145.5-133-15.5-42-16-58.5-1.5-56 8.5 1 13.5 9 21.5 34.5 6 18 17 42.5 24.5 54 8.5 12.5 11 20.5 7.5 20.5-3.5 0-1 3 6 7 7 3.5 25.5 14.5 41.5 24.5 16.5 10 36 19.5 44 21 8 2 14.5 5.5 14.5 8 0 2.5 5.5 4.5 12.5 4.5 9 0 12.5 2.5 12.5 10 0 11-9.5 12-37.5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poHYBgCUC",
    className: "s5",
    d: "m2215.5 4798c0.5-9 1-9.5 3-2.5 1 4.5 4.5 7 7.5 5.5 3.5-2 4-1 2 2-6 10-13 6.5-12.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pp2XtyXsc",
    className: "s5",
    d: "m180 4770c0-5 3.5-14 8-20 7-10 6.5-12-5-27.5-17.5-22.5-28-49.5-28-71 0-36.5 30-73.5 64.5-80.5 13-3 15.5-2 15.5 7 0 6.5-4.5 11-13.5 13-7 2-17.5 9-22.5 16-5.5 6.5-13 12-17 12-16.5 0-2.5 74.5 17 86.5 6 4 8.5 51 3 65.5-4.5 11-22 10.5-22-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptmsYjEcO",
    className: "s5",
    d: "m-1294.5 4693.5c-3-9-5.5-20-5.5-25 0-13-27.5-58.5-49-81-19.5-20.5-63-45-89.5-50.5-22.5-5-81.5-6.5-81.5-2.5 0 2-7 5-15 7-24 5.5-71.5 40-89.5 65-9.5 13-22 38.5-28 57-9 26.5-13.5 33.5-22.5 34.5-11 2-11 0.5-8-20 5-31.5 29-80 52.5-105.5 43-46.5 119-72.5 183-63 85.5 13 164 91.5 175.5 176 3 21.5 2.5 23.5-7 23.5-7 0-12-5-15.5-15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEXsh1GNx",
    className: "s5",
    d: "m513.5 3990.5c-8-7.5-1.5-56.5 7.5-56.5 8.5 0 19 14 19 24.5 0 6 3 10.5 7.5 10.5 4 0 7.5 2.5 7.5 5 0 3-5.5 5-12.5 5-8 0-12.5 3-12.5 7.5 0 7.5-10.5 10.5-16.5 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17waVc2tm",
    className: "s5",
    d: "m625 3989c0-2.5-6.5-5-15-5-17 0-21-12.5-5-16.5 10-2.5 10-7 10-285 0-265-0.5-283-8.5-285-5-1.5 0-2.5 11-3 18.5-0.5 24-4.5 60-40.5l39.5-39.5-12-13c-15.5-16.5-20-16-20 4 0 13.5-5.5 22-31.5 47.5-25.5 25-34.5 31-47.5 31-8.5 0-15.5-1.5-15.5-3.5 0.5-2.5 26.5-28.5 58-59l56.5-54.5 24 23.5 23.5 23.5-54 54-53.5 53.5v166 166l46.5 1.5 46 1.5 1.5 24c1 14-0.5 23.5-3.5 23.5-3 0-5.5 3.5-5.5 7.5 0 4 2.5 7.5 5 7.5 3 0 5 16 5 37.5 0 40-0.5 40.5-27.5 38-16-1.5-25.5-25.5-10-25.5 6 0 7.5-8 7.5-42.5 0-34.5-1.5-42.5-7.5-42.5-4 0-7.5-2-7.5-5 0-2.5-8-5-17.5-5-9.5 0-17.5 2.5-17.5 5 0 3-3.5 5-7.5 5-6 0-7.5 8-7.5 42.5 0 34.5 1.5 42.5 7.5 42.5 4.5 0 7.5 4.5 7.5 12.5 0 8-3 12.5-7.5 12.5-6 0-7.5 9-7.5 50 0 46.5-0.5 50-10 50-5.5 0-10-2-10-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17lHSWBUg",
    fillRule: "evenodd",
    className: "s5",
    d: "m-2764 3949.5c-5-8.5-18-34-29-56.5l-19.5-41.5-51.5-25c-28.5-13.5-54-27.5-57-31.5-8.5-10 2.5-18 58.5-43.5 41.5-18.5 50.5-24.5 56-38 3.5-9 5.5-17 4-18.5-2.5-2.5-41 2.5-172 22.5l-52 8-79.5 100.5c-44 55.5-82 101-83.5 102-2 0.5-6.5-19.5-9.5-45-6-46.5-37.5-304.5-56-459-5.5-45.5-11.5-90-13-98.5-3.5-22.5 3-21 40 7.5 59 47 432.5 326 439 328.5 4 1.5 11.5-7 19-21 7-13.5 16-24 20-24 8.5 0 62.5 105 57.5 112.5-1.5 3-7.5 5-13 5-7 0-9.5-3.5-9.5-15 0-8-2-15-4-15-2.5 0-9.5-11-16-25-6.5-13.5-13.5-25-15-25-2 0-6.5 7-10 15-3.5 8.5-9 15-12.5 15-3.5 0-7.5 8-8.5 17.5l-2 17.5h31.5c24.5 0 31.5 1.5 31.5 7.5 0 4-3.5 7.5-8 7.5-6 0-7 4.5-6 19 1.5 17 3 18.5 18 20 17.5 2 22-4 23-28.5 0.5-17 6-16 65.5 12.5 64 31 63.5 35-6 68.5l-54 26-27.5 55c-15 30-30 55.5-33.5 56.5-3.5 1-10.5-5-15.5-13.5zm30.5-53c7.5-15.5 13.5-30 13.5-32.5 0-3-14.5-5-32.5-5h-32.5l10 20c5.5 10.5 10 25.5 10 32.5 0 23 16.5 15 31.5-15zm-436.5-25.5c0-4.5 4.5-9 10-10.5 5.5-1.5 10-7 10-12.5 0-5.5 4.5-11 10-12.5 5.5-1.5 10-7 10-12 0-5.5 3.5-11 7.5-12.5 4-2 7.5-6 7.5-10 0-4 4.5-9.5 10-13 5.5-3.5 10-9 10-12.5 0-3.5 4.5-9 10-12.5 5.5-3.5 10-9 10-12.5 0-3.5 4.5-9 10-12.5 5.5-3.5 10-9 10-12 0-13.5 20.5-19 128.5-35 101.5-15.5 135-22 109.5-22-4.5 0-9.5-3.5-11-7.5-2-4-6-7.5-10-7.5-4 0-7-3.5-7-7.5 0-4-4.5-7.5-10-7.5-5.5 0-11.5-3.5-13-7.5-2-4-6-7.5-10-7.5-4 0-7-3.5-7-7.5 0-4-4.5-7.5-10-7.5-5.5 0-11.5-3.5-13-7.5-2-4-6.5-7.5-10-7.5-4 0-8.5-3.5-10-7.5-2-4-6.5-7.5-10-7.5-4 0-8.5-3.5-10-7.5-2-4-6.5-7.5-10-7.5-4 0-8.5-3.5-10-7.5-2-4-6.5-7.5-10-7.5-4 0-8.5-3.5-10-7.5-2-4-6.5-7.5-10-7.5-4 0-8.5-3.5-10-7.5-2-4-6.5-7.5-10-7.5-4 0-8.5-3.5-10-7.5-2-4-6.5-7.5-10-7.5-4 0-8.5-3.5-10-7.5-2-4-6.5-7.5-10-7.5-4 0-8.5-3.5-10-7.5-2-4-6.5-7.5-10-7.5-4 0-8.5-3.5-10-7.5-2-4-6.5-7.5-10-7.5-4 0-8.5-3.5-10-7.5-2-4-6.5-7.5-10-7.5-4 0-8.5-3.5-10-7.5-2-4-6.5-7.5-10-7.5-4 0-8.5-3.5-10-7.5-2-4-6.5-7.5-10-7.5-4 0-8.5-3.5-10-7.5-2-4-6.5-7.5-10-7.5-4 0-8.5-3.5-10-7.5-2-4-6.5-7.5-10-7.5-4 0-8.5-3.5-10-7.5-2-4-6.5-7.5-10-7.5-4 0-8.5-3.5-10-7.5-2-4-6.5-7.5-10.5-7.5-6 0-7 4-5 16.5 3 16 14 105 43.5 348.5 8.5 70 16.5 135 18 144 2.5 16 12 22.5 12 8zm402.5-47c0-16.5-1-17.5-17.5-17.5-14.5 0-18 2-19 11.5-3 20 2.5 27 20 25 15-1.5 16.5-3 16.5-19zm70.5 1.5c-0.5-18-1-19-18-19-14.5 0-18 2-19 11.5-3 19.5 2.5 26 20.5 26 16.5 0 17-0.5 16.5-18.5zm-123-36.5c0-34-0.5-35-12.5-35-7 0-12.5 3-12.5 6.5 0 4-9 11-20 16-11 5-20 10.5-20 12 0 2.5 56 33.5 64 35 0.5 0.5 1-15 1-34.5zm205-1c0-2-2-4-5-4-2.5 0-5-3-5-7 0-4.5-7-8-18.5-9-10.5-1.5-23-4-27.5-6-8-3.5-9-0.5-9 29v33l32.5-16c18-9 32.5-18 32.5-20zm-151-33c2-18-6.5-24-26.5-19-9.5 2.5-12.5 6.5-12.5 17.5 0 18 4 21.5 22.5 19.5 13-1.5 15-3.5 16.5-18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHxb502Q6",
    className: "s5",
    d: "m-1185 3934c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p0EU5LbJs",
    className: "s5",
    d: "m-1158 3929c1.5-9 3-27 3-40.5 0-21.5 1.5-24.5 10-24.5 9.5 0 10.5 2.5 9 39-1.5 36.5-2 38.5-13.5 40-11 1.5-11.5 0.5-8.5-14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5E7ghXta",
    fillRule: "evenodd",
    className: "s5",
    d: "m515 3906.5c0-12.5-22.5-17.5-80.5-17.5-51 0-54.5-0.5-54.5-10 0-8.5 3.5-10 25-10h25v-85h-67c-56.5 0-67.5-1-70-8-6.5-16.5-2.5-34.5 10.5-48 7.5-7.5 10.5-14 7.5-14-3.5 0-6-4.5-6-10 0-5.5-3.5-10-7.5-10-4.5 0-7.5 4.5-7.5 11.5 0 16-9 23.5-28.5 23.5-15.5 0-16.5-1-16.5-17 0-9.5 2.5-19 5-20.5 3-2 5 3 5 11 0 12.5 11.5 2.5 105-91 58-57.5 105-106 105-107.5 0-1.5-10-2-22.5-1-31.5 2.5-57.5-3-57.5-11.5 0-6 9.5-7.5 50-7.5 31.5 0 50-2 50-5.5 0-3 10.5-4.5 26.5-3.5l26 1.5 1.5 25.5c1.5 23 0.5 26-10 29-7 2.5-9 4.5-5 6.5 4 1.5 6 16 6 47 0 26.5 2 44.5 5 44.5 3 0 5 8 5 17.5 0 9.5-2 17.5-5 17.5-2.5 0-5 10-5 22.5 0 12.5 2.5 22.5 5 22.5 3 0 5 14 5 32.5 0 18.5-2 32.5-5 32.5-3 0-5 26.5-5 70 0 59-1 70-7.5 70-4 0-7.5-3.5-7.5-7.5zm-4-250c1-53.5 0.5-97.5-1-97.5-1.5 0-46.5 44-100 97.5l-97.5 97.5h197z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvxcLpJ2H",
    fillRule: "evenodd",
    className: "s5",
    d: "m2315 3890q-67.5-18-93-58.5c-8-12.5-16.5-22.5-19.5-22.5-2.5 0-19 4.5-36.5 10-178.5 56-389-21.5-453-166-22-50-22-73.5 0-74 5 0 23.5 56.5 22 67-0.5 2.5 1 6 3.5 7.5 2.5 1.5 14 16.5 25 33.5 34 50 117.5 98.5 199 115.5 19 4 36 9 36.5 12 2.5 6 21 6 21-0.5 0-2.5 10-5 22.5-5 12.5 0 22.5 2.5 22.5 5 0 6.5 13.5 6.5 16 0 1-2.5 18.5-8 39-12 20.5-4 47-11 58-15.5l21-8 3.5-36c8.5-88 47.5-119.5 104-83.5l23.5 15 12.5-25c7-13.5 15-36 18-50 3-13.5 7.5-25 10-25 2.5 0 4.5-6.5 4.5-15 0-8-2-15-5-15-2.5 0-6-8.5-8-18.5-9-50-47.5-108-93.5-143.5-44-33-132.5-68-174-68-17.5 0-34.5-5.5-34.5-11 0-2.5 3.5-8 8-12.5 6.5-7 12.5-7 46-1.5 112.5 18 213 86 253.5 171 34 71.5 34 135-1 204.5l-17 34 10.5 30.5c10.5 32 10 45.5-4 61.5-10 11-29.5 11-66.5-1.5-50.5-17.5-67 5-29.5 40.5 32.5 31 75.5 41.5 153.5 38 52-2 62.5-1.5 65 5 1.5 4-0.5 10.5-4 14-9 9.5-64.5 16-64.5 8 0-3-6.5-5.5-15-5.5-8 0-15 2.5-15 5 0 7.5-28 5.5-65-4zm20-138c0-5.5-2.5-14-5-18-3.5-6-7-5-20 7.5l-15.5 15 13.5 5.5c18 7.5 27 4 27-10zm-58-20.5c17.5-12.5 36.5-22.5 42.5-22.5 7 0 10.5-3 10.5-10 0-7.5-3.5-10-12-10-7 0-20.5-4.5-30-10.5-31.5-18.5-51 0.5-56.5 54.5-3.5 33-2.5 33 45.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSVPHc6vU",
    className: "s5",
    d: "m115 3696.5c0-172-1-197.5-7.5-197.5-4 0-7.5-2-7.5-4.5 0-7 33.5-10.5 106.5-10.5 57.5 0 68.5 1 68.5 7.5 0 4-3.5 7.5-7.5 7.5-10 0-17.5 20-17.5 46.5 0 11.5-1.5 26-3 32.5-3.5 12.5-17 15.5-17 3.5 0-6-8-7.5-42.5-7.5h-42.5v147.5c0 128 1 147.5 7.5 147.5 4 0 7.5 3.5 7.5 7.5 0 4.5-4.5 7.5-12.5 7.5-7 0-12.5 2.5-12.5 5 0 3-4.5 5-10 5-10 0-10-3.5-10-197.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Gx3zCVTi",
    className: "s5",
    d: "m-1113 3832c-5.5-14 0-40.5 9.5-42 6.5-1.5 8.5 1.5 8.5 14.5v16l33-3c31.5-3 32.5-3 31 8-1.5 10-4.5 11-40.5 12.5-30 1-39.5 0-41.5-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BU0Z4NPJ",
    className: "s5",
    d: "m-1721.5 3831c-2-2-3.5-13.5-3.5-25.5 0-18 1.5-21.5 10-21.5 8 0 10 3.5 10 15.5v16l50-2.5c49-2.5 50.5-2 49 8-1.5 10-5 10.5-57 12-30 0.5-56.5-0.5-58.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFOimtrIZ",
    className: "s5",
    d: "m-1496.5 3813c-3-23.5-1.5-29 9.5-29 4.5 0 7 5.5 7 15.5v16l50-2.5c49-2.5 50.5-2 49 8-1.5 10-5 10.5-57 12l-55.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puIaBxPTp",
    className: "s5",
    d: "m-1271.5 3831c-2-2-3.5-13.5-3.5-25.5 0-18 1.5-21.5 10-21.5 8 0 10 3.5 10 15.5v16l50-2.5c49-2.5 50.5-2 49 8-1.5 10-5 10.5-57 12-30 0.5-56.5-0.5-58.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1UTadjEm",
    className: "s5",
    d: "m-1050 3799c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p47PmC6hb",
    className: "s5",
    d: "m-1625 3794c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXHZNPnXw",
    className: "s5",
    d: "m-1400 3794c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKbbc5Adn",
    className: "s5",
    d: "m-1175 3794c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5li80YTd",
    className: "s5",
    d: "m230 3774c0-8 3.5-10 15-10 11.5 0 15 2 15 10 0 8-3.5 10-15 10-11.5 0-15-2-15-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DXMGpmhO",
    className: "s5",
    d: "m-1715 3686.5c0-53 1-58 9-56.5 7.5 1.5 8.5 8 8.5 56.5 0 48.5-1 55-8.5 56.5-8 1.5-9-3.5-9-56.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4Tnqllqe",
    className: "s5",
    d: "m-1192 3730c-4-7 2.5-26 9.5-26 6.5 0 12.5 10.5 12.5 23 0 7.5-17.5 10-22 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12uVTENfi",
    className: "s5",
    d: "m-1165 3724c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSpeH8ECp",
    className: "s5",
    d: "m-1190 3623.5c0-9 2.5-10 21-8.5 15.5 1 22 4 23 10.5 1.5 7-2 8.5-21 8.5-20 0-23-1.5-23-10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18k9dL9pO",
    className: "s5",
    d: "m1700 3539c-6.5-4-6.5-8.5 1-37.5 12-44 29.5-73.5 69-113 49.5-50 122-86 198.5-99.5 31.5-5.5 36.5-5.5 43.5 1.5 12.5 12 9.5 18-10.5 21-151 24-251.5 99-276.5 206.5-6 26-11 30-25 21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1EFIa6RlH",
    className: "s5",
    d: "m-1745 3509c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDDUoHCQz",
    className: "s5",
    d: "m-1715 3461.5c0-53 1-58 9-56.5 7.5 1.5 8.5 8 8.5 56.5 0 48.5-1 55-8.5 56.5-8 1.5-9-3.5-9-56.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p157nttUks",
    className: "s5",
    d: "m-1191.5 3503c-3-10.5 2-24 9.5-24 4 0 7 2.5 7 5 0 3 7 5 15 5 11.5 0 15 2 15 10 0 8.5-3.5 10-22 10-13.5 0-23-2.5-24.5-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10qWT1moG",
    className: "s5",
    d: "m18.5 3495.5c-1-2.5-1.5-10.5-0.5-19 0.5-8 1.5-18 1.5-21 0.5-3.5 4-6.5 8-6.5 5.5 0 7.5 6 7.5 25 0 18.5-2 25-7 25-4 0-8.5-1.5-9.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psiu379eN",
    className: "s5",
    d: "m100 3379c0-2.5 3.5-5 7.5-5 5.5 0 7.5-10 8.5-48.5l1.5-49 66.5-1.5c59-1 66.5-0.5 69.5 7.5 2 4.5 0.5 9.5-2.5 10.5-3.5 1-6 7.5-6 14 0 7.5-3 12-7.5 12-4 0-7.5-3.5-7.5-7.5 0-5.5-5.5-7.5-19.5-7.5-11 0-21-3-22.5-6-2.5-5-3.5-5-6 0-1.5 3-10.5 6-20 6h-17v35c0 28 1.5 35 7.5 35 4 0 7.5 2.5 7.5 5 0 3-13.5 5-30 5-16.5 0-30-2-30-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgce3EQzA",
    className: "s5",
    d: "m-1650 3341.5c0-19 1.5-22.5 10-22.5 8.5 0 10 3.5 10 22.5 0 19-1.5 22.5-10 22.5-8.5 0-10-3.5-10-22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pT2gLCkx",
    className: "s5",
    d: "m-1521.5 3360c-1.5-2-2.5-12-2-22.5 0.5-14.5 2.5-18.5 9.5-18.5 7.5 0 9 4 9 22.5 0 16.5-2 22.5-7 22.5-4 0-8.5-1.5-9.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKGDOAcIs",
    className: "s5",
    d: "m-1425 3341.5c0-19 1.5-22.5 10-22.5 8.5 0 10 3.5 10 22.5 0 19-1.5 22.5-10 22.5-8.5 0-10-3.5-10-22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CHZFCPHf",
    className: "s5",
    d: "m-1200 3341.5c0-19 1.5-22.5 10-22.5 8.5 0 10 3.5 10 22.5 0 19-1.5 22.5-10 22.5-8.5 0-10-3.5-10-22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p02DVExdM",
    className: "s5",
    d: "m-1745 3327c0-10 6-13 19-9.5 16.5 4 13.5 16.5-4 16.5-9.5 0-15-2.5-15-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJ25QcNoL",
    className: "s5",
    d: "m-1295 3327.5c0-10 4.5-12.5 15.5-10 14 4 12 16.5-3 16.5-7 0-12.5-3-12.5-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16Q2KnCIK",
    className: "s5",
    d: "m369 2770.5c-5-1-9-5.5-9-9.5 0-5.5 7.5-7 30-7 22 0 30 2 30 7 0 10.5-27.5 16-51 9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNyxzeLhJ",
    className: "s5",
    d: "m301.5 2760.5c-20.5-4.5-31.5-9.5-31.5-14.5 0-8.5 13-9 51-1 22.5 4.5 29 8 29 15 0 10.5-6.5 11-48.5 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pq6i5tEjo",
    className: "s5",
    d: "m430 2760c0-7 6.5-10.5 29-15 38-8 51-7.5 51 1 0 4-12 10-32.5 15-41 10-47.5 10-47.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCULX2ae2",
    className: "s5",
    d: "m220.5 2731c-19.5-9.5-35.5-20-35.5-22.5 0-8.5 29.5-4.5 52.5 6.5 17 8.5 22.5 14 22.5 22.5 0 6.5-1 11.5-2 11.5-1 0-17.5-8-37.5-18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfP1QHwke",
    className: "s5",
    d: "m520 2736.5c0-9 3.5-13 13.5-15.5 7.5-2 17-6.5 20.5-10.5 3.5-3.5 12-6.5 19-6.5 7.5 0 12-3 12-7.5 0-4 4.5-7.5 10-7.5 5.5 0 10-3.5 10-7.5q0-7.5 15-7.5c12.5 0 15-2 15-11.5 0-14.5 14.5-28.5 29-28.5 9 0 11-3 11-15q0-15 7.5-15c4 0 7.5-4.5 7.5-10 0-5.5 3.5-10 7.5-10 4.5 0 7.5-4.5 7.5-12.5 0-7 2.5-12.5 5-12.5 3 0 5-4.5 5-9.5 0-5.5 3.5-13 7.5-17.5 4-4 7.5-12 7.5-17.5 0-6 2-10.5 4-10.5 2 0 7-17 10.5-37.5 5.5-31 8.5-37.5 16-37.5 12 0 12 8.5-1 55-21.5 78.5-64.5 147-123.5 196.5-28 24-75.5 53-102 63-13 5-14 4.5-14-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "py5nUwPAl",
    className: "s5",
    d: "m-1622 2708.5c-71-10.5-130-66.5-141-133.5-3-19-2.5-21 7.5-21 6.5 0 10.5 3 10.5 8.5 0 9 11 42.5 15 46.5 1.5 1.5 10.5 13 20 26 9.5 13 20 24 23 24 2.5 0 9.5 4 15 9 16.5 15 43 22 93.5 24.5 34 2 48.5 4.5 48.5 9 0 12.5-35.5 15-92 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9M3KyFgb",
    className: "s5",
    d: "m-1365 2699.5c0-6.5 3-10.5 8.5-10.5 13.5 0 43-12 53.5-21 5.5-5 17.5-9 26.5-9 15.5 0 16.5-1 16.5-17 0-9.5 1.5-18 4-19 5.5-2.5 26-48.5 26-59 0-7 3.5-10 10.5-10 10 0 10.5 2 7.5 20.5-10 61-71.5 122.5-132.5 132.5-18.5 3-20.5 2.5-20.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxf7ZLsXY",
    className: "s5",
    d: "m152.5 2687l-20-17.5 19-0.5c20 0 25.5 6 22.5 25-1.5 10-2.5 10-21.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn0Y0pctp",
    className: "s5",
    d: "m-3357.5 2670.5c-36.5-19-57-52.5-57.5-92.5 0-18 2-24 7.5-24q7.5 0 7.5-15 0-15-7.5-15c-6.5 0-7.5-28-7.5-222.5 0-194.5 1-222.5 7.5-222.5 5.5 0 7.5-5.5 7.5-20 0-14.5-2-20-7.5-20-10.5 0-9.5-27.5 2-52.5 11-24.5 41-52 61-56 8-1.5 14.5-4 14.5-6 0-1.5-22.5-25.5-50-53-32-31.5-50-53.5-50-60.5 0-10.5 16-29.5 20.5-24.5 1.5 1 11.5-6.5 22-17.5 11-11 17.5-20 15-20-2.5 0 1-5.5 7.5-12.5 6.5-7 14.5-12.5 18-12.5 8.5 0 42.5 30 40 34.5-1.5 2 32.5 38.5 75 81 42 42 77 75 77 72.5 0-2.5 3.5-1 8.5 2.5 6 5.5 42 7.5 163.5 9.5l155.5 2.5 67 34c37 18.5 76 41 86.5 49.5 32 25.5 51 74 29 74-8 0-10-3.5-10-17.5 0-12-2.5-17.5-7.5-17.5-4 0-7.5-4.5-7.5-10 0-6.5-3.5-10-10-10-5.5 0-10-1.5-10-3.5 0-2.5-9-8.5-20-13.5-11-5.5-20-11.5-20-14 0-2-3-4-6.5-4-3.5 0-23-8-43-17.5-20.5-10-37.5-17-38.5-16-4 4-12 74-12 106 0 44.5 11 69 41.5 94 26 21.5 40.5 23 73 8.5 12-5.5 27-10 33.5-10 10 0 12-2.5 12-15 0-8 2-15 4.5-15 2.5 0 6-8 7.5-17.5 2.5-13 6-17.5 13-17.5 12.5 0 12.5 11 0.5 37.5-16 35.5-43 54-96.5 65-8 1.5-14 6-14 10 0 4-3.5 7.5-7.5 7.5-6.5 0-7.5 23.5-7.5 180 0 156.5 1 180 7.5 180 16 0 3.5 50-19 74-20.5 22-68.5 40.5-68.5 26 0-3.5-81.5-5-235-5-153.5 0-235 1.5-235 5 0 7.5-20.5 5.5-37.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11GcmfoWc",
    className: "s5",
    d: "m91 2626.5l-16.5-20 13.5-1.5c17.5-2.5 23 4 21 24.5l-1.5 17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzUWHtLZs",
    className: "s5",
    d: "m2072.5 2632c-34.5-15-62-64.5-55.5-99 1.5-9 16.5-40 32.5-69 16.5-29 28-54 26.5-55.5-2-2-14.5-6-28.5-9-30-7.5-118.5-53-160-83-69.5-50-114-118.5-125-194-3.5-21-2.5-23.5 6-23.5 7.5 0 10.5 6 15 27.5 8 36.5 33 87.5 57.5 114.5 10.5 12 19 24.5 19 27.5 0 3 3.5 5.5 7.5 5.5 4 0 10 4.5 13.5 10 3.5 5.5 8 10 10.5 10 3.5 0 58.5 35 63.5 40.5 1.5 1.5 10 5.5 19 9 8.5 4 16 10 16 13.5 0 4 5 7 10.5 7 6 0 26.5 5.5 45.5 12.5 19 7 39 12.5 44.5 12.5 7.5 0 9.5 3.5 9.5 19 0 12-3.5 23-9.5 29-5 5.5-11 15-12.5 21-2 6-6.5 14-9.5 17-3.5 3.5-12.5 20.5-21 38-13.5 29-14 33-8 47.5 3.5 9 8 22 9 30 2 9.5 5.5 13.5 13.5 13.5 5.5 0 15 3.5 20 7.5 12 9 36.5 9.5 51 1 17.5-10 40-30.5 43.5-40.5 5-13 79-140 83.5-143 2-1.5 5-7.5 7-13.5 2-6.5 6.5-14.5 9.5-18 3.5-3.5 12.5-19 21-35 13-25 16.5-28.5 30-28.5 13.5 0 16 3 27 27.5 19.5 45 57 64.5 90.5 47.5 21.5-11 43.5-35.5 48-53 4-15-33.5-163.5-49-196-8-17.5-9.5-27-7-47.5 8.5-62.5 8.5-63.5 18.5-63.5 11 0 12 12 4 49.5-4.5 21.5-4 29 4.5 51.5 15 40 51 180 51 198.5 0 37-34 75.5-74 84.5-43 10-82-9-101.5-48.5l-13.5-26.5-17.5 29.5c-9.5 16-39 67.5-66 114-27 47-54.5 92.5-61 101.5-23.5 32-72.5 45-109 29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pddaImCxQ",
    className: "s5",
    d: "m45 2550.5c-14.5-30.5-35-98-35-115 0-3.5 4-6.5 9.5-6.5 7.5 0 10.5 6.5 16 37.5 3.5 20.5 8.5 37.5 10.5 37.5 2 0 4 8 4 17.5 0 11.5 2.5 17.5 7 17.5 8.5 0 13 11 13 30.5 0 23-8 17-25-19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DDhVTkEw",
    className: "s5",
    d: "m-1225 2339c0-107.5 1-130 7-130 11 0 13 17 13 130 0 113-2 130-13 130-6 0-7-22.5-7-130z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phmawxyAf",
    className: "s5",
    d: "m755 2394.5c0-17.5-5.5-47.5-13.5-73.5-7-24.5-14-53-15.5-63-1-12-4.5-19-9-19-4.5 0-7-6-7-17.5 0-25.5 8.5-21.5 22.5 10.5 37 83.5 54 192 30 192-6 0-7.5-7-7.5-29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1EhZSvGos",
    className: "s5",
    d: "m8 2401.5c-4-16.5 1.5-37.5 10-37.5 5 0 7 7 7 25 0 27.5-11.5 35.5-17 12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p52qsrVUG",
    className: "s5",
    d: "m10 2353c0-15 6.5-29 13-29 4.5 0 7 6 7 17.5 0 14-2 17.5-10 17.5-5.5 0-10-3-10-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjThnak8c",
    className: "s5",
    d: "m20 2313c0-15 6.5-29 13-29 4.5 0 7 6 7 17.5 0 14-2 17.5-10 17.5-5.5 0-10-3-10-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p154FSiQqz",
    className: "s5",
    d: "m40.5 2248c12.5-31.5 14-34 20-34 2.5 0 4.5 8 4.5 17.5 0 9.5-2 17.5-5 17.5-2.5 0-5 5.5-5 12.5 0 10-2.5 12.5-12.5 12.5h-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19vaHpEUp",
    className: "s5",
    d: "m658 2131c-1.5-4.5-3-12-3-17.5 0-5-3-9.5-7-9.5-7.5 0-13-10.5-13-25.5 0-5-3.5-9.5-7.5-9.5-4 0-7.5-3.5-7.5-7.5 0-4-2-7.5-5-7.5-2.5 0-6-5.5-8-12.5-1.5-7-5-12.5-7.5-12.5-2.5 0-4.5-3.5-4.5-7.5 0-4-2-7.5-5-7.5-2.5 0-5-8-5-17.5 0-20 4.5-22 15-6 21 32 85 141 85 144.5 0 7.5-24 4-27-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYzujbWBe",
    className: "s5",
    d: "m-1763.5 2106.5c3.5-23.5 17-54.5 35.5-79 14-19.5 57-47 84.5-54 22-6 22.5-6.5 25.5-31 3.5-32 22-60 49.5-74.5 19-10.5 28-11.5 91-11.5 56 0 73 1.5 85 8.5 19.5 10.5 40.5 33 47 50.5 5 12.5 4.5 13.5-6.5 13.5-12.5 0-18-8.5-18-28 0-9.5-2.5-12-13.5-12-8-0.5-19.5-3.5-26.5-7.5-22-12.5-155-8.5-155 4.5 0 3-4.5 8.5-10 12-13 8-25 37.5-25 61.5 0 14-2 19.5-7.5 19.5-4 0-7.5 1.5-7.5 4 0 4.5-36 16-50 16-5.5 0-10 3.5-10 7.5 0 4-4.5 7.5-10 7.5-5.5 0-10 3.5-10 7.5 0 4-4.5 10-10 13.5-5.5 3.5-10 9-10 12 0 2.5-4 9.5-8.5 15-10.5 11-21.5 40.5-21.5 56 0 8-3 11-10.5 11-10 0-10.5-2-8-22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnpX5Im6s",
    className: "s5",
    d: "m100 2126c0-8 96-162 101-162 2.5 0 4 8 4 17.5 0 9.5-2 17.5-5 17.5-2.5 0-5 3.5-5 7.5 0 4-2 7.5-5 7.5-2.5 0-5 3.5-5 7.5 0 4-3.5 7.5-7.5 7.5-4.5 0-7.5 4.5-7.5 12.5 0 7-2 12.5-5 12.5-2.5 0-5 3-5 7 0 4-3 10.5-7 14-3.5 4-8.5 12-10 18-2 6-7 11-11 11-4 0-7 5-7 12.5 0 10-2.5 12.5-12.5 12.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvMdzOd0D",
    className: "s5",
    d: "m-1230 2114.5c0-5-6.5-22.5-15-38.5-8-16-15-35.5-15-43 0-12.5-2-14-16.5-14-9 0-21-4-26.5-9-5.5-5-16-11-23.5-13-7.5-1.5-13.5-5.5-13.5-8 0-3-3.5-5-7.5-5-5 0-7.5-5.5-7.5-17.5 0-20 12-24.5 17-6 2 7.5 11.5 14.5 30 23 36.5 15.5 73 54 87 92 14 36.5 14 48.5 1 48.5-6.5 0-10-3.5-10-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHqwZ8oHe",
    className: "s5",
    d: "m1762 2028.5c2-14 8.5-39.5 15-56.5 13-34 59.5-117.5 86.5-154 39.5-54.5 106-99 171.5-114.5 38.5-9.5 106-8 142.5 2.5 56.5 16.5 163.5 79 203.5 119 42.5 42.5 75.5 109.5 82.5 168 2.5 24 2 26-8 26-8.5 0-10.5-3-10.5-14.5 0-23-23-84.5-42-113.5-10-15-18-30.5-18-34.5 0-4-3-7.5-7-7.5-4 0-11.5-5-16.5-11-5-6.5-14-14.5-19-17.5-5.5-3.5-30-19-55-35-56.5-36-114-61-155.5-68-27-4.5-40-4-72.5 2.5-51 10.5-113 39.5-128.5 60.5-3.5 4.5-13 8.5-21.5 8.5-12.5 0-14.5 2-14.5 15 0 8-3 16.5-6.5 18.5-3 2-9 10-13 17.5-4 7.5-11 18-15.5 23-5 5-10.5 14-12 20-2 6-5.5 11-7.5 11-2 0-6.5 8-10 17.5-3.5 9.5-9.5 17.5-13.5 17.5-4 0-7 4-7 9 0 5-5.5 23.5-12.5 40.5-7 17-14 41-16 53-2.5 18-5 22.5-13 22.5-9 0-9.5-2-6.5-25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppGmTgRj",
    className: "s5",
    d: "m-1211 1979c-34.5-30.5-64.5-58.5-66-63-3.5-9.5 0.5-17 9-17 12 0 138 114.5 138 125 0 19.5-18.5 9.5-81-45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptt5nulik",
    className: "s5",
    d: "m555 1961.5c0-4-2-7.5-5-7.5-2.5 0-5-3.5-5-7.5 0-4-2-7.5-5-7.5-2.5 0-5-3.5-5-7.5 0-4-2-7.5-5-7.5-2.5 0-5-3.5-5-7.5 0-4-2-7.5-5-7.5-2.5 0-5-3.5-5-7.5 0-4-2-7.5-5-7.5-2.5 0-5-4.5-5-10 0-5.5-3.5-10-7.5-10-4 0-7.5-3.5-7.5-7.5 0-4-2-7.5-5-7.5-2.5 0-5-4.5-5-10 0-5.5-3.5-10-7.5-10-5 0-7.5-5.5-7.5-17.5 0-15.5-1.5-17.5-12.5-17.5-9 0-12.5-2.5-12.5-10 0-5.5-3.5-10-7.5-10-4 0-7.5-4-7.5-9.5 0-5-4.5-10.5-10-12-6-1.5-10-7-10-13 0-6-3-10.5-7-10.5-12.5 0-23 6-23 13 0 4-3.5 7-7.5 7-4 0-7.5 4.5-7.5 10 0 5.5-3.5 11.5-7.5 13-4 2-7.5 6.5-7.5 10 0 4-3.5 8.5-7.5 10-4 2-7.5 6-7.5 10 0 4-3.5 7-7.5 7-4 0-7.5 4.5-7.5 10 0 7.5-3.5 10-12.5 10-11 0-12.5 2-12.5 17.5 0 12-2.5 17.5-7.5 17.5-4 0-7.5 4.5-7.5 10 0 5.5-2 10-5 10-2.5 0-5 3.5-5 7.5 0 4-2 7.5-5 7.5-2.5 0-5 3.5-5 7.5 0 4-2 7.5-5 7.5-2.5 0-5 3.5-5 7.5 0 4-2 7.5-5 7.5-2.5 0-5 3.5-5 7.5q0 7.5-15 7.5h-15.5l21-31c24-35.5 109.5-154 138-191.5 11-13.5 22.5-25 26.5-25 8.5 0 83 98 150.5 196.5l45 66h-15c-10.5 0-15.5-2.5-15.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNlgpZxjd",
    className: "s5",
    d: "m-1229 1880.5c-17.5-3.5-13-23.5 5.5-25.5 7.5-1 13.5 0.5 13.5 3.5 0 3.5 18 5.5 50 5.5 39 0 50 1.5 50 7 0 3.5-5 8-11 10-12.5 3-90 3-108-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVcwevtiH",
    className: "s5",
    d: "m-1081 1880.5c-16.5-4-10-16.5 8.5-16.5 9.5 0 17.5-2.5 17.5-5.5 0-3 6-4.5 14-3.5 9.5 1 14 4.5 15 13 1 6.5-1 11.5-5 11.5-22 2.5-42.5 3-50 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pA3B2tHlV",
    className: "s5",
    d: "m-1275 1826.5c-3.5-4-4-10-1.5-14 3.5-6.5 42-41 113-102 19-16.5 33.5-17.5 33.5-2 0 8-110.5 110-130.5 121-5.5 3-10.5 2-14.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjfoDO2fA",
    fillRule: "evenodd",
    className: "s5",
    d: "m-3340 1103.5c0-53.5 3-69.5 13-69.5 5.5 0 7 9 7 38 0 21 1.5 37 4 36 2-1 13.5-6.5 26-12.5 20.5-9 106.5-63 151-94 10-7 21.5-19 25.5-26.5 19.5-37.5 85.5-148.5 89-150 2.5-1 4.5-4 4.5-7 0-6 64.5-120 70-124 1.5-1.5 4.5-6.5 6.5-11.5 4-11.5 119-210 123.5-213.5 1.5-1.5 6-10 9.5-18.5 4-9 8.5-16.5 11-16.5 2.5 0 4.5-2.5 4.5-6 0-7 45-86 51-88 2-1 4-4 4-7 0-3 9-21 20-40l19.5-34-21 3.5c-59 11-114.5-3-126.5-31.5-9-21.5-9.5-52-0.5-52 4 0 10 10.5 14 24 6 20 10 25 29.5 35 57.5 29 114 3 155-70.5l16-29-14 4c-8 2-29 4-47 4-38.5-0.5-66.5-14-96.5-47l-18.5-20.5-9.5 19.5c-5.5 10.5-12.5 29.5-16 42.5-5.5 23-5.5 23-27.5 23-20.5 0-22-1-22-13.5-0.5-13.5-0.5-13.5-12.5 6-6.5 11-14.5 22.5-17 26-3 3.5-5.5 7.5-5.5 9.5 0 5.5-71.5 129.5-76 131-2 1-4 4-4 7 0 5.5-44 84.5-49.5 89-1.5 1.5-8.5 13.5-15.5 27-6.5 13.5-14.5 27-17.5 30-2.5 3.5-12.5 20.5-22 38.5-9.5 17.5-18.5 33-20 34.5-1.5 1.5-9.5 15.5-18 31.5-8 15.5-16 28.5-17.5 28.5-1.5 0-6 8-9.5 17.5-3.5 9.5-8 17.5-10.5 17.5-2 0-5.5 5.5-7 12-1.5 7-6 15.5-9.5 19-3 4-12.5 19.5-21 35.5-8 15.5-16 28.5-18 28.5-2 0-5 5.5-6.5 12-1.5 7-6 15.5-9.5 19-3 3.5-11.5 17.5-18.5 31-6.5 13.5-14.5 27-17.5 30-8 8.5-27.5 56-27.5 67.5 0 7.5-3 10.5-10.5 10.5-10 0-10.5-2-7.5-23.5 2-18 17-48 56.5-116.5 29.5-51 86-148.5 125.5-217.5 39.5-68.5 133-231.5 208-362 75.5-132 145-247.5 156.5-260.5 51.5-57.5 134.5-64 186-13.5 28 27 41.5 54.5 44 91 3.5 41-4 58-79.5 187.5-76 131-79.5 136-287.5 497.5-92 159.5-173.5 296-180.5 304-7 7.5-37 29-66 47-29 18.5-75.5 49-104 67.5-28 19-54.5 35.5-58.5 37.5-6.5 2-7.5-5-7.5-44zm513.5-1052.5c-2.5-3-31.5 52-35.5 68-2 7 6-5 17-27 11.5-21.5 19.5-40 18.5-41zm185.5 62c26-12.5 44.5-35.5 56.5-71.5 8.5-26.5 8.5-28.5 0-55.5-16-48-54-77-100.5-77-62 0-110 48-110 110 0 55 32.5 95 85 105 22.5 4.5 42.5 1.5 69-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgw3FN808",
    className: "s5",
    d: "m-1726 1066c-50-9-149-41-149-48 0-3 14-20 31.5-38.5 17-18.5 39-45 48.5-59.5 9.5-14 19-26 21.5-26 2 0 3.5 8 3.5 17.5 0 12-2.5 17.5-7.5 17.5-4 0-7.5 4.5-7.5 10 0 5.5-3.5 10-7.5 10-4 0-7.5 4.5-7.5 10 0 8-3.5 10-15 10-13.5 0-15 1.5-15 16.5 0 9-2.5 19-5.5 22-4 4 0 7 14 11.5 10.5 3.5 20 8 21.5 9.5 3 4 50 14.5 99 22 29.5 4.5 36 7 36 14.5 0 10.5-7 11-61 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOSCjl6cG",
    className: "s5",
    d: "m-1640 1064c0-8 3.5-10 17.5-10 20 0 24.5 12 6.5 17-19 5-24 3.5-24-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13JY7ex5P",
    className: "s5",
    d: "m-1595 1054c0-8 3.5-10 17.5-10 19.5 0 23 7 8 15-15.5 8-25.5 6-25.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p04Bd0XJB",
    className: "s5",
    d: "m-1550 1034.5c0-13 2-15.5 12.5-15.5 10 0 12.5-2.5 12.5-12.5 0-14 8-19 25-16.5 10 1.5 9.5 2.5-5 20-8.5 10.5-22 23.5-30 29l-15 10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p177pOE1nk",
    className: "s5",
    d: "m334.5 1000.5c-36.5-9.5-62.5-21.5-129.5-61.5-65-38-110.5-77-134.5-114-19-30-39-82.5-43.5-115-3-22.5-2-25.5 8-28.5 6-2 11.5-2.5 12.5-1.5 1 1 5.5 18.5 9.5 39 12 56.5 37 103.5 74.5 138 43.5 40.5 150.5 103.5 197.5 116.5 94 26 188.5 5 254.5-56.5l28.5-26.5h-37.5c-21.5 0-44.5-3-54.5-7.5-9.5-4-98-54-196-111-98-56.5-179.5-103-180.5-103-1.5 0-7 7.5-13 16.5-6 9-10.5 12.5-10.5 8 0-4 3-12 7-17 6-8.5 4.5-11-14-26.5-11-9.5-25.5-27-31.5-38.5q-20.3-39.8-22.5-16.5c-2 31.5-8.5 54-15 54-8 0-19-14-19-24 0-28.5 46.5-144 71.5-177 11.5-15 131-217 195.5-331 30.5-53.5 64-89.5 96.5-103.5 31-14 82-17.5 112-8 12.5 4 79 39 147.5 78.5 68.5 39.5 144.5 83 169 97 72 41 107.5 83 116 137.5 3 18.5 2.5 20.5-7.5 20.5-7.5 0-10.5-3-10.5-10.5 0-16-25.5-64-44-82.5-9.5-9.5-18-17-18.5-17-2.5 0-54-31.5-57.5-35-1.5-1.5-13-8-26-14.5-13.5-6.5-24-14-24-16 0-2.5-3-4.5-7-4.5-4 0-10.5-3-14-6.5-3.5-3.5-14-9.5-22.5-13-9-3.5-16.5-8.5-16.5-10.5 0-2-5.5-5.5-12-7-7-1.5-15.5-6-19-9.5-3.5-3.5-16-10.5-27.5-15.5-12-5.5-21.5-11-21.5-13 0-2.5-5.5-5.5-12-7-7-1.5-15.5-6-19-9.5-3.5-3-24.5-15-46-26-34.5-17.5-44-20-72.5-20-38.5 0-70 13-98 41-9.5 9.5-17.5 18.5-17.5 19 0 3-32 55-35.5 57.5-2 1.5-4.5 7.5-6.5 14-2 6-6 11-8.5 11-2.5 0-4.5 3-4.5 7 0 4-3 10.5-7 14-3.5 4-8.5 12-10 18-2 6-6 11-8.5 11-2.5 0-4.5 3-4.5 7 0 4-3 10.5-6.5 14-3.5 3.5-9.5 14-13 23-3.5 8.5-8.5 16-11 16-2.5 0-4.5 3-4.5 7 0 4-3 10.5-6.5 14-3.5 3.5-9.5 14-13 23-3.5 8.5-8 16-10 16-2 0-6.5 8-10 17.5-3.5 9.5-8.5 17.5-11 17.5-2.5 0-4.5 3-4.5 7 0 4-3 10.5-6.5 14-3.5 3.5-9.5 14-13 23-3.5 8.5-8.5 16-11 16-2.5 0-4.5 3.5-4.5 7.5 0 4-2 7.5-5 7.5-2.5 0-5 3-5 7 0 4-2 8-4.5 9-4 1.5-50.5 93.5-50.5 100.5 0 2 4.5 3.5 10 3.5 8.5 0 10 3.5 10 20 0 15 2 20 8 20 10 0 21.5 14 22 26.5 0 5.5 4 8.5 11.5 8.5 12.5 0.5 28.5 11 28.5 19.5 0 3 7 5.5 15 5.5 11.5 0 15 2 15 10 0 7.5 3.5 10 14.5 10 19.5 0 30.5 4.5 30.5 13 0 4 5 7 12.5 7 8 0 12.5 3 12.5 7.5 0 4 4.5 7.5 9.5 7.5 15 0 25.5 5.5 25.5 13 0 4 4.5 7 9.5 7 15 0 25.5 5.5 25.5 13 0 4 4.5 7 9.5 7 15 0 25.5 5.5 25.5 13 0 4 5 7 12.5 7 8 0 12.5 3 12.5 7.5 0 4 4.5 7.5 9.5 7.5 15 0 25.5 5.5 25.5 13 0 4 4.5 7 9.5 7 15 0 25.5 5.5 25.5 13 0 4 5 7 12.5 7 8 0 12.5 3 12.5 7.5 0 4 4 7.5 9.5 7.5 5 0 22 6 37.5 13 25.5 11.5 32 12.5 64.5 9.5 37-4 53.5-10.5 53.5-21.5 0-3.5 3.5-7.5 7.5-9 4-2 7.5-6 7.5-10 0-3.5 3-8.5 6.5-10.5 3.5-2 9.5-11.5 13-20 5-12 10-16.5 18.5-16.5 12 0 12 0 4.5 18-4 10-19.5 34.5-33.5 54-56.5 77-104 116-167.5 138.5-36 13-127.5 16-167 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXYtDSDKn",
    fillRule: "evenodd",
    className: "s5",
    d: "m-1485 944.5c0-8 2.5-21 5-28 3-7.5 8.5-33 12.5-56.5 4-23.5 10.5-45 14-47 4-2.5 2-4-5-4-10 0-11.5-2.5-11.5-17.5 0-18 6.5-23.5 12-9.5 1.5 4.5 5 7 7.5 6 7-2 75.5-109 78.5-122.5 7.5-28.5-14.5-59.5-53-76-40-17.5-67-6-87.5 37.5-7 15-15 27-17.5 27-4.5 0-13 19.5-11 26.5 0.5 2-1.5 8.5-4.5 14.5-4 7.5-4 11 0 13.5 3 2-12 6.5-33 10-21 3.5-41.5 9.5-45 13.5-4 4-11.5 7-17 7-5 0-9.5 3.5-9.5 7.5 0 4-4.5 7.5-10 7.5-5.5 0-10 3.5-10 7.5 0 5-5.5 7.5-17.5 7.5-9.5 0-17.5-1-17.5-2.5 0-1 15-13.5 33-27 31-23.5 45-30.5 78.5-37.5 11.5-2.5 18-12 40.5-57 15-29.5 35.5-62.5 45.5-73.5 10-11 46.5-71.5 81-135 73-135 116-201 195-301.5 73-93 170.5-210 206-247.5 25.5-27 45.5-36.5 45.5-21.5 0 12-19.5 71.5-55.5 168.5-82.5 224.5-127.5 325-195.5 437-23.5 38.5-57.5 94.5-75.5 124-18 30-36.5 66-40.5 80-9 30.5-34.5 63.5-49.5 64-8.5 0.5-9 1-2 3 4.5 1 8.5 3.5 8.5 5.5 0 1.5-12.5 22.5-27.5 46.5-24 37.5-28.5 49-35 87-8.5 47-19 77.5-27 77.5-3 0-5.5-6.5-5.5-14.5zm143-325.5c4 0 7-5 7-12.5 0-7 2.5-12.5 5-12.5 3 0 5-3.5 5-7.5 0-4 3.5-7.5 7.5-7.5 4.5 0 7.5-4.5 7.5-12.5 0-8 3-12.5 7.5-12.5 4.5 0 7.5-4.5 7.5-12.5 0-7 2.5-12.5 5-12.5 3 0 5-3.5 5-7.5 0-4 3.5-7.5 7.5-7.5 4.5 0 7.5-4.5 7.5-12.5 0-8 3-12.5 7.5-12.5 4.5 0 7.5-4.5 7.5-12.5 0-7 2-12.5 4.5-12.5 2.5 0 6-5.5 7.5-12.5 2-7 6.5-12.5 10.5-12.5 4.5 0 7.5-5 7.5-12.5 0-8 3-12.5 7.5-12.5 4 0 7.5-4.5 7.5-10 0-14.5 16-45 23.5-45 3.5 0 6.5-5.5 6.5-12.5 0-14 15-47.5 21-47.5 2 0 4-4 4-8.5 0-12 21-61.5 26-61.5 2 0 4-5.5 4-12.5 0-7 2.5-12.5 5-12.5 3 0 5-5.5 5-12.5 0-7 2.5-12.5 5-12.5 3 0 5-5.5 5-12.5 0-7 2.5-12.5 5-12.5 3 0 5-5.5 5-12.5 0-7 1.5-12.5 4-12.5 2 0 6.5-11.5 10-26 3-14 8-27 10.5-28.5 2-1.5 5.5-11.5 7.5-21.5 2-10.5 5.5-19 8-19 3 0 5-4.5 5-10 0-5 8-31.5 17.5-58 17.5-48.5 19.5-59 7.5-44.5-3.5 4-9.5 7.5-13 7.5-4 0-7 4-7 8.5 0 10-14 26.5-23 26.5-3.5 0-7 5-8 11.5-1 7-5.5 11.5-12.5 12.5-7.5 1-11.5 5.5-12.5 15-1 8-6 15.5-12.5 18.5-6.5 2.5-11.5 8.5-11.5 13.5 0 4.5-4 11.5-9 15-5 3.5-10.5 10.5-12.5 15.5-2 5.5-8 10.5-13.5 12-5.5 1.5-10 7-10 12.5 0 5.5-4.5 11-10 12.5-5.5 1.5-10 7-10 12.5 0 5.5-4.5 11-10 12.5-5.5 1.5-10 7-10 12 0 5-3 11-6.5 13-4 2-8 8-10 13-1.5 4.5-6.5 8.5-11 8.5-4 0-7.5 4.5-7.5 10 0 5.5-3.5 11.5-7.5 13-4 2-7.5 6.5-7.5 10 0 4-3.5 8.5-7.5 10-4 2-7.5 6-7.5 10 0 4-2 7-5 7-2.5 0-5 3.5-5 7.5 0 4.5-3.5 9-7.5 10.5-4 2-7.5 6-7.5 10 0 4-2 7-5 7-2.5 0-5 3.5-5 7.5 0 4-2 7.5-5 7.5-2.5 0-5 3.5-5 7.5 0 4-2 7.5-5 7.5-2.5 0-5 3-5 7 0 4-3 10.5-7 14-3.5 4-8.5 12-10 18-2 6-7 11-11 11-4 0-7 4.5-7 10 0 14.5-10.5 35-18.5 35-3.5 0-6.5 4.5-6.5 10 0 14.5-16 45-23.5 45-3.5 0-6.5 4.5-6.5 10 0 17-16 45-26 45-6.5 0-9 4-9 15 0 8.5-3.5 22-7.5 30l-7.5 14 26.5 3.5c36 4.5 43.5 7 43.5 15.5 0 4 5 7 13 7 8.5 0 14 3 15.5 10 1.5 5.5 4.5 10 6.5 10 2.5 0 6 5 8 11.5 2 6 4.5 8.5 5.5 5 1.5-3.5 5.5-6.5 9.5-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pA58TIFJd",
    className: "s5",
    d: "m-1764.5 870.5c12-31.5 40-86.5 44.5-86.5 3 0 5 8 5 17.5 0 12-2.5 17.5-7.5 17.5q-7.5 0-7.5 15 0 15-7.5 15c-5 0-7.5 5.5-7.5 17.5 0 15.5-1.5 17.5-12.5 17.5-11.5 0-12-1-7-13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puWjbjbJR",
    className: "s5",
    d: "m705 764.5c0-19.5 4.5-30.5 13-30.5 4 0 7-4.5 7-9.5 0-15 5.5-25.5 13-25.5 4 0 7-4.5 7-9.5 0-15 5.5-25.5 13-25.5 4 0 7-5 7-12 0-7 3-15.5 7-19 3.5-4 8.5-12 10-18 2-6 7-11 11-11 4 0 7-4.5 7-9.5 0-15 5.5-25.5 13-25.5 4 0 7-4.5 7-10.5 0-10 8-29.5 14.5-34.5 1.5-1.5 8.5-14.5 15-28.5 7-14.5 14-26.5 16.5-26.5 2 0 4-3 4-7 0-4 3-10.5 6.5-14 8.5-9 38.5-75.5 38.5-85.5 0-5 4-8.5 10-8.5 20 0 10 36-28.5 104-117.5 206-184.5 321-187.5 321-2.5 0-4-6.5-4-14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8stnVKa7",
    fillRule: "evenodd",
    className: "s5",
    d: "m2125.5 590.5c-5.5-5-12-16-13.5-25-2.5-13-0.5-18.5 9.5-28.5 16.5-16.5 35.5-16.5 51-0.5 17 16.5 16.5 38.5-0.5 52-16.5 13-32.5 13.5-46.5 2zm39.5-23c0-3-3.5-9.5-8.5-14.5-7.5-8.5-8.5-8.5-17.5-0.5-8.5 7.5-8.5 9-1.5 17 8.5 8.5 27.5 7.5 27.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14pPsExd4",
    fillRule: "evenodd",
    className: "s5",
    d: "m2389 480.5c-5-1-9-5.5-9-9.5 0-4-3.5-7-7.5-7-5 0-7.5-5.5-7.5-17.5 0-12 2.5-17.5 7.5-17.5 4 0 7.5-3 7.5-6.5 0-8 20.5-18.5 35-18.5 5.5 0 10-3 10-7 0-4 5-9 11-11 6-1.5 14-6.5 18-10 3.5-4 15.5-7 26-7 18.5 0 19.5 1 23 17.5 7 39.5-11 87.5-33.5 87.5-5 0-9.5 2.5-9.5 5 0 5-54 6-71 1.5zm80-34c12.5-13.5 16-21.5 16-37.5 0-11-2.5-20-5-20-11 0-95 51.5-95 58.5 0 10.5 30 22 50 19 11.5-1.5 23-8 34-20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pP0ivDBy8",
    className: "s5",
    d: "m2094 310.5c-5.5-1.5-9-7-9-14.5 0-9.5-2.5-12-12-12-13 0-18-8-18-30.5 0-20 11.5-18.5 19.5 3 6 17.5 26.5 37.5 38.5 37.5 5.5 0 7-12 7-57.5 0-45.5-1.5-57.5-7-57.5-12 0-32.5 20-38.5 37.5-8 21.5-19.5 23-19.5 3 0-22.5 5-30.5 18-30.5 9.5 0 12-2.5 12-12.5 0-13.5 13-19.5 38-16.5l14.5 1.5v75 75l-17.5 1c-9.5 0-21.5-0.5-26-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjk1MZsJR",
    className: "s5",
    d: "m2161.5-34.5c-3.5-1.5-6.5-6-6.5-10.5 0-7 1-7 4.5-1.5 3.5 5.5 4.5 5.5 7 0 1.5-5 4-5.5 8-1.5 7 6.5-3 17-13 13.5z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "l2MSJ0PeEufB2LYONGrRyv1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pJCtHohiW",
    className: "s6",
    d: "m512.5 5205.5c-40-26.5-78.5-63.5-101-96.5-8-12.5-44.5-74-81-137-56-98-65.5-118-65.5-136v-21.5l45-25c34.5-20 49.5-25.5 66-25.5h21.5l57.5 99c105 180.5 118.5 214 123.5 315l3 51h-17c-12 0-27.5-7-52-23.5z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "l34QrNIurdU4CNQVk6o5XH5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "p1AejtClv2",
    className: "s7",
    d: "m-1620 1060.5c0-6.5 8-11.5 29-18 15.5-4.5 33.5-8.5 40-8.5 8.5 0 11-3 11-12.5 0-10 2.5-12.5 12.5-12.5 10.5 0 12.5-2.5 12.5-15q0-15 7.5-15c4.5 0 7.5-4.5 7.5-12.5 0-8 3-12.5 7.5-12.5 4.5 0 7.5-4.5 7.5-12.5 0-25.5 11.5-57.5 21-57.5 11 0 11 6 1 40.5-19.5 65.5-60.5 115.5-109.5 134-34.5 13-47.5 13.5-47.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DZ6nwM1s",
    className: "s7",
    d: "m-1748.5 1060.5c-14-5.5-6.5-16.5 11-16.5 14 0 17.5 2 17.5 10 0 10-13 13-28.5 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4i5q6qjj",
    className: "s7",
    d: "m-1851 1029.5c-32.5-10-33-23-1.5-19 26.5 2.5 29 4.5 26.5 17-1.5 9-2.5 9-25 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16bKO0s4T",
    className: "s7",
    d: "m-1844.5 985c21.5-29.5 47.5-60.5 51-60.5 2-0.5 3.5 7.5 3.5 17 0 15-1.5 17.5-12 17.5-10.5 0-12.5 3-14 16.5-1.5 14-3.5 16-18.5 17.5-16.5 1.5-17 1-10-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15H0ksseZ",
    className: "s7",
    d: "m-1761.5 864c9-19 19-35 21.5-35 3 0 5 8 5 17.5 0 12-2.5 17.5-7.5 17.5-5 0-7.5 5.5-7.5 17.5 0 16-1.5 17.5-14 17.5h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGReA1rBu",
    className: "s7",
    d: "m527.5 879.5c-20-5-14.5-2-213.5-117-172.5-99.5-174-100.5-174-116.5 0-9 6.5-27 14.5-40.5 23.5-40 67-114.5 116.5-201.5 70.5-123 68-120 90-120 15.5 0 47 16.5 167.5 86 231.5 133.5 222 129.5 272 116.5 80-20.5 80-10.5-4 135-34.5 60.5-75 133.5-90 162.5-14.5 29-34.5 59.5-43.5 68.5-28 26-88.5 38-135.5 27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pT9cfEN1N",
    className: "s7",
    d: "m-1725 790c0-5 26.5-30 51.5-48.5l18.5-13.5v15.5c0 14-1.5 15.5-15 15.5-12.5 0-15 2-15 11.5 0 6.5-2.5 14-6 17.5-6.5 6.5-34 8.5-34 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pimkJy6ox",
    className: "s7",
    d: "m-1485 766.5c0-21.5 5-22 16.5-3 11 19 11 20.5-4 20.5-11 0-12.5-2-12.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psvk5sHT",
    className: "s7",
    d: "m-1545 721.5c0-12 0.5-12.5 16-6 23 9.5 24 18.5 2 18.5-16 0-18-1.5-18-12.5z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "l5zvqVwedFfhdcria9ZleIB"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pzAxhVd9J",
    className: "s8",
    d: "m1976.5 4787c-3.5-4-7.5-24-9.5-45-3-32.5-2.5-38 4.5-38 8 0 10.5 8.5 16.5 54l3 27 22-33c12.5-18 24-33 26.5-33 2.5 0 17.5 10 33 22.5 16 12.5 30 21.5 31 20.5 1-1-1.5-17-6-35-9.5-42-9.5-43 2-43 7.5 0 10.5 6 15.5 32 3.5 17.5 4.5 39 2.5 47.5-3 13.5-5.5 15.5-20.5 15.5-12 0-17-2.5-17-7.5 0-4-4.5-7.5-10-7.5-5.5 0-11.5-3.5-13-7.5-5.5-14-19.5-7.5-30 14-8.5 18-12.5 21-27.5 22-9.5 1-19.5-1.5-23-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pl0xaeVv3",
    className: "s8",
    d: "m1880 4719c0-13.5 2.5-21.5 7.5-23 4-2 7.5-6 7.5-10 0-4 3.5-7 7.5-7 4 0 7.5-4.5 7.5-10 0-11.5 9-16.5 24.5-14 9.5 1.5 9 3-7.5 24-10 12.5-20 26.5-23 31.5-4 8-3.5 9 4.5 6.5 5-1 17.5-4 28-6 16-2.5 18.5-2 18.5 6.5 0 7.5-5.5 11-25.5 15.5-14 3.5-30.5 6-37.5 6-10.5 0-12-2-12-20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIiu8WvsT",
    className: "s8",
    d: "m2120 4687c0-7 14.5-13 34-13 18 0 12.5-8.5-17.5-26-32-19-39-29-20-29 18 0 28.5 5 28.5 13 0 4 5 7 11.5 7 19 0 33.5 13.5 33.5 32 0 16-1 17-23 20-35.5 4.5-47 3.5-47-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prPpgziZv",
    className: "s8",
    d: "m1871 4629.5c-7-5.5-11-15-11-24 0-13.5 2-15.5 19-18.5 30.5-5 46-3.5 46 4 0 7-14.5 13-33.5 13-16.5 0-14 6.5 6 17 9.5 5.5 17.5 11.5 17.5 14 0 8-33.5 4-44-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phbDkIrqy",
    className: "s8",
    d: "m2133 4583c18-24.5 18.5-25.5 7-22.5-41.5 10-50 10-50 0 0-7 6-10.5 26.5-15.5 14.5-3 32.5-6 40-6 12 0 13.5 2 13.5 17 0 14-2 17.5-11 19-9 1-12 5.5-13 18-1.5 14-3.5 16-16.5 16h-15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pH4mgpKCS",
    className: "s8",
    d: "m1928 4540.5c-1.5-10.5-3-25-3-32.5 0-12.5 1.5-14 17.5-14 9.5 0 17.5 2.5 17.5 5 0 3 3.5 5 7.5 5 4 0 7.5 3.5 7.5 7.5 0 4 4.5 7.5 10 7.5 8 0 10 3.5 10 15.5v15.5l-25.5-19-25.5-18.5 3.5 23.5c3.5 21 2.5 23-6.5 23-7.5 0-10.5-4.5-13-18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pphboNOVo",
    className: "s8",
    d: "m2003.5 4555.5c-5.5-5-4-21.5 1.5-21.5 3 0 5-3.5 5-7.5 0-4 2.5-7.5 5-7.5 3 0 5-3.5 5-7.5 0-4 2.5-7.5 5-7.5 3 0 5-3.5 5-7.5 0-4 2.5-7.5 5-7.5 3 0 5-3.5 5-7.5 0-5 5-7.5 17-7.5 15.5 0 17 1.5 20 19 5 32 3.5 51-4.5 51-6.5 0-9.5-11-14-44.5-0.5-4-11 7.5-23 26-21.5 33-25.5 37-32 30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puOPNWbCx",
    className: "s8",
    d: "m2064 2622.5c-3.5-3.5-10.5-8-15-10-5-1.5-9-6.5-9-10.5 0-4-2.5-8-6-9-4-1.5-7-16.5-8-40.5-2-38.5-2-38.5 10.5-38.5 12 0 12.5 1 8 18-9 32.5 14.5 71.5 48.5 80 6.5 1.5 12 6 12 10 0 9-32 9.5-41 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLZaxGzNE",
    className: "s8",
    d: "m2125 2619c0-2.5 6.5-8 14.5-12 17-9 26.5-24 106.5-163.5 34.5-60 66-121.5 71-138.5 5.5-17 11-31 13-31 2 0 9 19.5 15 44 6.5 24 14.5 50 18.5 57.5 17.5 35.5 72 44 101.5 16 26.5-25.5 28-39.5 10-109-24-94.5-34.5-127-42.5-133.5-9.5-8-9.5-15 0.5-56 5.5-21.5 11-34 15-34 8 0 9.5 24 3 47.5-5.5 19-1.5 52.5 6 52.5 9 0 48 153 48 188 0 31.5-12.5 59.5-29 65.5-4.5 2-10 5-11.5 7.5-5 8-57 10.5-76.5 4-14-4.5-18-8.5-18-18 0-9.5-2.5-12-12.5-12-10.5 0-12.5-2.5-12.5-15 0-8-2-15-4.5-15-2.5 0-6-5.5-7.5-12.5-3.5-14.5-13-17-13-3 0 15-5.5 25.5-13 25.5-4 0-7 5-7 12 0 7-3 15.5-6.5 19-3.5 3.5-9.5 14-13 23-3.5 8.5-10 16-13.5 16-4 0-7 5-7 12.5 0 8-3 12.5-7.5 12.5-4 0-7.5 4.5-7.5 9.5 0 15-5.5 25.5-13 25.5-4 0-7 4.5-7 9.5 0 15-5.5 25.5-13 25.5-4 0-7 5-7 12.5 0 8-3 12.5-7.5 12.5-4.5 0-7.5 4.5-7.5 12.5 0 7-2 12.5-5 12.5-2.5 0-5 3.5-5 7.5 0 4-4.5 7.5-10 7.5-6.5 0-10 3.5-10 10 0 8-3.5 10-17.5 10-9.5 0-17.5-2-17.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18Aoz5cl5",
    className: "s8",
    d: "m-1423.5 2520.5c-8-1.5-11.5-5.5-11.5-14 0-11 1.5-12 13-7.5 7 3 38.5 5 70 5 53.5 0 57 0.5 57 10 0 9.5-3 10-58.5 9.5-32.5-0.5-64-2-70-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppyY5LGfH",
    className: "s8",
    d: "m-1285 2509c0-2.5 6.5-8 14.5-12.5 18.5-9.5 34-28.5 38-47.5 2-9 6.5-15 11-15 6.5 0 7.5 4.5 5 23-1 13-4.5 24.5-7 26.5-2.5 1.5-6 7-8 12-1.5 4.5-6.5 8.5-11 8.5-4 0-7.5 2.5-7.5 5 0 3-8 5-17.5 5-9.5 0-17.5-2-17.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prgvryhGH",
    className: "s8",
    d: "m2050 2481.5c0-12 2.5-17.5 7.5-17.5 4 0 7.5-4.5 7.5-9.5 0-14.5 5.5-25.5 12.5-25.5 3.5 0 7.5-6.5 8.5-14.5 2-14 1-14.5-22-17.5-20-3-24-5-24-14 0-9 2-10 16.5-7 8.5 2 26.5 5 40 6.5 13 1.5 23.5 4 23.5 6 0 6.5-62 110.5-66 110.5-2 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppC5xXA7G",
    className: "s8",
    d: "m-1479.5 2470.5c-8-28.5-7-56.5 2-56.5 4.5 0 8 7 10 19 1.5 10 7 27 12 37.5l9.5 18.5h-14c-12.5 0-15.5-2.5-19.5-18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZlIVi2lb",
    className: "s8",
    d: "m1986.5 2373c-6.5-3-11.5-8.5-11.5-12.5 0-3.5-5-6.5-11-6.5-16.5 0-74.5-36.5-109-68.5-69-63.5-97.5-150-85.5-255 6-50.5 20.5-87 61.5-156 39.5-66.5 88-117.5 134-139.5 75-37 175.5-40.5 250.5-10 36 15 114.5 59.5 114.5 64.5 0 2.5 3.5 4.5 7.5 4.5 4.5 0 9 3.5 10.5 7.5 2 4 6 7.5 9.5 7.5 9 0 52 49.5 55.5 64 2 6 4.5 11 6.5 11 5.5 0 15.5 23.5 15.5 35 0 5.5 2 10 4 10 5 0 16 45 16 65.5 0 9-2.5 14.5-7 14.5-4.5 0-9.5-12.5-15-35.5-4.5-19.5-15.5-49.5-24-66-21.5-41-73-92-116-116l-34.5-19-9 12c-5 6.5-43 68.5-85 137-41.5 69-111.5 184.5-155.5 257l-80 132 11.5 9c6.5 5 29.5 18 50.5 29.5 21.5 11.5 39 23 39 25.5 0 6-30 5-43.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdcnEONdu",
    className: "s8",
    d: "m-1485 2253c0-38.5 8-64 20-64 6.5 0 10-3.5 10-10 0-6.5 3.5-10 9.5-10 5.5 0 10.5-2.5 11.5-6 1.5-4 22-6.5 60-8 65.5-2.5 111 1.5 120.5 11 3 3.5 10 7.5 15 9.5 4.5 1.5 8.5 6.5 8.5 10.5 0 4 2.5 8 5.5 9 3 1 6.5 12.5 8 25.5 2.5 19 1.5 23.5-5 23.5-4.5 0-9-6-11-15-4-18.5-19.5-38-37.5-47.5-21.5-11-134.5-10.5-158.5 1-21.5 10-36.5 33-36.5 56.5 0 25-5 40-13 40-5 0-7-7-7-26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p176EToUOu",
    fillRule: "evenodd",
    className: "s8",
    d: "m-1611.5 1980.5c-6-6-3.5-51.5 3.5-69 4-9.5 10.5-17.5 14.5-17.5 4 0 8.5-4.5 10-10 5-18.5 32.5-25 105-25 59 0 69 1.5 88.5 11.5 33 16.5 45 37.5 45 79v34.5h-131.5c-72.5 0-133.5-1.5-135-3.5zm246-19.5c8.5-3 4.5-32.5-7-50.5-17.5-26.5-34-31.5-107-31.5-74.5 0-93 6-108 35-10.5 20-10 49 1 51 12 2.5 213-1 221-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdwPo0NzG",
    fillRule: "evenodd",
    className: "s8",
    d: "m-3321 1105l-14-8.5v-96c0-53 2.5-107.5 5.5-121.5l5.5-25.5 23 1.5 23.5 1.5 1.5 25c2 38.5 3 39.5 26.5 27.5 11.5-6 27-10 36-9 16 1.5 16 1.5 17.5 33 1.5 34.5 3.5 35.5 32.5 23.5 10-4 28.5-7.5 41-7.5h22.5v19c0 14.5-3.5 22.5-13.5 32-24.5 22.5-171 114-182.5 114-6.5 0-17.5-4-25-9zm78.5-36.5c22-14 50-31.5 62-39 36-22 65.5-45.5 65.5-53 0-13-9.5-13-40.5 0-49.5 20-52.5 19-56.5-22.5-2-19-4.5-35-6-35-1 0-15 6.5-31 14.5l-28.5 14.5-16.5 66c-17 68.5-16.5 80 3.5 80 4.5 0 26.5-11.5 48-25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBLyTMNmN",
    className: "s8",
    d: "m-2772.5 294c-1.5-2.5-8-5.5-14-6-6 0-1-2 11.5-4 24-3.5 23-4-22-18.5-35-10.5-43-21.5-16-21.5 10 0 18 2.5 18 5.5 0 4 13 5 45 2.5l45-4v18.5c0 16-2 19-17.5 25.5-20 8-45.5 9.5-50 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZX6mES13",
    className: "s8",
    d: "m-2890 221.5c0-4-3.5-7.5-7.5-7.5-5.5 0-7.5-6-7.5-25v-25h17.5c15.5 0 18 1.5 21 15 1.5 8.5 4.5 15 7 15 2.5 0 4.5 8.5 4.5 19l-0.5 18.5-15.5-17.5-15-17.5 3 16.5c1.5 9 0.5 16-2 16-3 0-5-3.5-5-7.5z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "l3BI5jUFeMQipZwaUWUc3Bj"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pCwaNoRIg",
    className: "s9",
    d: "m-1391 606.5c-33.5-30.5-32.5-41 9-110 18.5-30.5 42.5-72 54.5-92.5 42.5-75.5 102-178.5 128-223 15-25.5 36-62 47-81.5 11-19.5 38-66.5 60.5-104.5 39-67 40.5-68.5 58.5-70 18-1.5 18.5-1 18.5 15 0 17-23 84-79 229-60 155.5-90 216.5-183.5 369.5-54.5 89.5-55 90-72.5 90-13.5 0-22.5-4.5-41-22z"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "l4l6LJJr4oY6PKHpoCj12n9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pkItOWUE6",
    className: "s10",
    d: "m-1718.5 1065.5c-14-5.5-6.5-16.5 11-16.5 14 0 17.5 2 17.5 10 0 10-13 13-28.5 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DjV7Ql8b",
    className: "s10",
    d: "m-1809.5 1044c-30-11-42-20-31.5-23.5 7-2.5 8.5-36.5 1-36.5-2.5 0-1-4 4-9 20-21 71-92 71-99 0-1.5 3.5-11 8-21 21.5-48.5 35-72.5 42-75 9-3.5 20-14 20-19.5 0.5-4 26.5-24 55.5-42 7-4.5 23.5-10.5 36-13.5 19-4 23.5-3.5 23.5 2 0 4 3.5 7 7.5 7 4 0 7.5-4.5 7.5-10 0-5.5 3.5-10 7.5-10 4 0 7.5 3 7.5 6.5 0 3.5 13.5 12.5 30 20 30.5 14 38.5 23.5 20 23.5-9.5 0-10 1-2.5 15 10 19 10 88.5 0 126.5-27 104.5-80 135.5-231 136-42 0-76.5 1.5-76.5 4 0 2 7 3.5 15 3.5 12.5 0 15 2 15 12.5 0 7-0.5 12.5-1 12.5-1-0.5-13.5-5-28.5-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFeTKKDR0",
    className: "s10",
    d: "m-1560 1036.5c0-11 2-12.5 17.5-12.5 20.5 0 21.5 2.5 6.5 15.5-16 12.5-24 12-24-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17LEta9Hs",
    className: "s10",
    d: "m-1863.5 1025c-14.5-2-15-14-1-18.5 12.5-4 16-1.5 13.5 11-1 6-5 8.5-12.5 7.5z"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "l54VWrgR7OXLB2e84tmqafM"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "p10X1BmvyW",
    className: "s11",
    d: "m573.5 5245c-12.5-2.5-8.5-18 5.5-20 8-1.5 11 1 11 8.5 0 11.5-4 14.5-16.5 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKF0rgRJp",
    className: "s11",
    d: "m509.5 5208l-22-16.5 17.5-1.5c9.5-1 18 0.5 19 3.5 1 3 5 5.5 9 5.5 4 0 7 5 7 12.5 0 16.5-4 16-30.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjlNqrTdh",
    className: "s11",
    d: "m-1172 5176.5c1.5-22 4.5-41 5.5-42.5 5.5-6 16.5 18.5 16.5 35.5 0 13-4 23-12.5 33l-13 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12lV8imQr",
    className: "s11",
    d: "m570 5176.5c0-20 12-24.5 17-6 5 18.5 3.5 23.5-7 23.5-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16zXEyyhS",
    className: "s11",
    d: "m-3380 4979.5c0-176.5-1-205.5-7.5-205.5-11 0-9.5-134.5 2-139 4-1.5 8.5 0 9.5 3 1 4 19.5 6 57.5 6.5 76 1 84.5 3 91.5 23.5 6 19.5 6.5 503 0.5 509-2 2.5-37.5 5-78.5 6l-75 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12yyEfkpo",
    className: "s11",
    d: "m440 5148c-8.5-9-20.5-22.5-26-30l-9.5-14h15c14 0 15.5 1.5 15.5 15 0 12.5 2 15 12.5 15 10.5 0 12.5 2.5 12.5 15 0 8.5-1 15-2 15-1 0-9-7.5-18-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pV4gzQMJ4",
    className: "s11",
    d: "m-1329 5077c-19.5-34.5-36-63.5-36-65 0-1.5 5.5-3 12.5-3 11 0 12.5 2 12.5 17.5 0 14 2 17.5 10 17.5 7.5 0 10 3.5 10 12.5 0 8 3 12.5 7.5 12.5 5 0 7.5 5.5 7.5 17.5 0 14 2 17.5 10 17.5 8 0 10 3.5 10 17.5 0 9.5-1.5 17.5-4 17.5-2 0-20-28-40-62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pG2Q9jJ6X",
    className: "s11",
    d: "m-1205 5086.5c0-14-2-17.5-10-17.5-8 0-10-3.5-10-17.5 0-9.5 2-17.5 4-17.5 3.5 0 41 61.5 41 67.5 0 1.5-5.5 2.5-12.5 2.5-11 0-12.5-2-12.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5LxG1yvF",
    className: "s11",
    d: "m2224 5088.5c-15.5-8.5-10-14.5 13.5-14.5 16.5 0 22.5-2 22.5-7.5 0-4.5 4.5-7.5 12.5-7.5 11.5 0 12.5-1.5 12.5-25 0-26 6-32 15-15.5 12.5 23.5-2.5 50.5-37 66-23.5 10.5-27.5 11-39 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13Dx2ibVb",
    className: "s11",
    d: "m353.5 5019c-15.5-27.5-28.5-51-28.5-52.5 0-1.5 5.5-2.5 12.5-2.5 11 0 12.5 2 12.5 17.5 0 14 2 17.5 10 17.5 8 0 10 3.5 10 17.5 0 14 2 17.5 10 17.5 8 0 10 3.5 10 17.5 0 9.5-2 17.5-4 17.5-2 0-16.5-22.5-32.5-50z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6WkX3bAA",
    className: "s11",
    d: "m2183.5 5044.5c-11-19-11-20.5 4-20.5 11 0 12.5 2 12.5 17.5 0 21.5-5 22-16.5 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14t2Ig7yX",
    className: "s11",
    d: "m2158.5 4999.5c-11-19-11-20.5 4-20.5 11 0 12.5 2 12.5 17.5 0 21.5-5 22-16.5 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9t92MeqW",
    className: "s11",
    d: "m515 4991.5c0-14-2-17.5-10-17.5-8 0-10-3.5-10-17.5 0-9.5 2-17.5 4-17.5 3.5 0 41 61.5 41 67.5 0 1.5-5.5 2.5-12.5 2.5-11 0-12.5-2-12.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKhb2uDoL",
    className: "s11",
    d: "m2260 4976.5c0-21.5 5-22 16.5-3 11 19 11 20.5-4 20.5-11 0-12.5-2-12.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pS3uvyW67",
    className: "s11",
    d: "m-1280 4955.5l0.5-19 12 14c16 18 15.5 23.5 0 23.5-11 0-12.5-2-12.5-18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTIdfX11T",
    className: "s11",
    d: "m-1382.5 4954c-10-19-9.5-20 5-20 11 0 12.5 2 12.5 17.5 0 21.5-7 22.5-17.5 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptTNSVmBg",
    className: "s11",
    d: "m2123.5 4939.5c-11-19-11-20.5 4-20.5 11 0 12.5 2 12.5 17.5 0 21.5-5 22-16.5 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfKUCacmU",
    className: "s11",
    d: "m-1511 4920.5c-16.5-4-10-16.5 8.5-16.5 14 0 17.5 2 17.5 10 0 10-7 11.5-26 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pR6bMk8vO",
    className: "s11",
    d: "m-1465 4914c0-8 3.5-10 17.5-10 20 0 24.5 12 6.5 17-19 5-24 3.5-24-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CJlQ3Scn",
    className: "s11",
    d: "m460 4896.5c0-14-2-17.5-10-17.5-8 0-10-3.5-10-17.5 0-14-2-17.5-10-17.5-7.5 0-10-3.5-10-12.5 0-8-3-12.5-7.5-12.5-5 0-7.5-5.5-7.5-17.5 0-9.5 2-17.5 4-17.5 4 0 76 121 76 127 0 1.5-5.5 3-12.5 3-11 0-12.5-2-12.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "py0FtPFyU",
    className: "s11",
    d: "m-1335 4891.5c0-21.5 5-22 16.5-3 11 19 11 20.5-4 20.5-11 0-12.5-2-12.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HrtVIhFI",
    className: "s11",
    d: "m278.5 4889.5c-11-19-11-20.5 4-20.5 11 0 12.5 2 12.5 17.5 0 21.5-5 22-16.5 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pD0yeMM7F",
    className: "s11",
    d: "m2205 4881.5c0-21.5 5-22 16.5-3 11 19 11 20.5-4 20.5-11 0-12.5-2-12.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pF6I483lT",
    className: "s11",
    d: "m-1636.5 4848c-32.5-44.5-34-49-16-49 10.5 0 12.5 2.5 12.5 15 0 11.5 2 15 10 15 8 0 10 3.5 10 17.5 0 9.5-1 17.5-2 17.5-1.5 0-8-7.5-14.5-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1EX82ICqj",
    className: "s11",
    d: "m-1330 4842c0-16.5 1-18 15.5-18h15l-10.5 15c-15.5 22-20 22.5-20 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1ImKGntt",
    className: "s11",
    d: "m2068.5 4844.5c-11-19-11-20.5 4-20.5 11 0 12.5 2 12.5 17.5 0 21.5-5 22-16.5 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWi7V58gV",
    className: "s11",
    d: "m1975 4831.5c0-9.5 2.5-17.5 5-17.5 3 0 5-3.5 5-7.5 0-4 2.5-7.5 5-7.5 3 0 5-3.5 5-7.5 0-4.5 4.5-7.5 12.5-7.5 7 0 12.5 1.5 12.5 3.5 0 5.5-37.5 61.5-41 61.5-2.5 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGOHV5dIB",
    className: "s11",
    d: "m2170 4821.5c0-14-2-17.5-10-17.5-8 0-10-3.5-10-17.5 0-14-2-17.5-10-17.5-8 0-10-3.5-10-17.5 0-14-2-17.5-10-17.5-8 0-10-3.5-10-17.5 0-16 1.5-17.5 14-17.5 10 0 11.5 1.5 6.5 4.5-6 4 0 17 28.5 67.5 20 34.5 36 64 36 65.5 0 1.5-5.5 2.5-12.5 2.5-11 0-12.5-2-12.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzhf3XfiU",
    className: "s11",
    d: "m185 4809.5c-8-15.5-6-25.5 5-25.5 8 0 10 3.5 10 17.5 0 19.5-7 23-15 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15wueivef",
    className: "s11",
    d: "m1963 4768c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p184TYg0UU",
    className: "s11",
    d: "m187.5 4755.5c2.5-5 4-13 4.5-17.5 0-5 4-9 9-9 7 0 9 4 9 17.5 0 15.5-1.5 17.5-13 17.5-10.5 0-12.5-1.5-9.5-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDGM48alp",
    className: "s11",
    d: "m-1290 4741.5c0-14 2-17.5 10-17.5 10.5 0 12 5 7 24-5 18-17 13.5-17-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pt7UByYjd",
    className: "s11",
    d: "m1850.5 4736.5c25-34.5 29.5-37 29.5-15.5 0 12.5-2 18-7.5 18-4 0-7.5 3-7.5 7 0 6-14 12.5-26.5 13-2.5 0 3-10 12-22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7Ek5KmB2",
    className: "s11",
    d: "m395 4716.5c0-24.5 11.5-32 16.5-11.5 4 15.5-1 34-9.5 34-5 0-7-6.5-7-22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1SFOKjqK",
    className: "s11",
    d: "m-1685 4698c0-15 6.5-29 13-29 4.5 0 7 6 7 17.5 0 14-2 17.5-10 17.5-5.5 0-10-3-10-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRh1ngbTO",
    className: "s11",
    d: "m2155 4689c0-8 3.5-10 17.5-10 20 0 24.5 12 6.5 17-19 5-24 3.5-24-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjQTiC0G5",
    className: "s11",
    d: "m-1295 4666.5c0-20 12-24.5 17-6 5 18.5 3.5 23.5-7 23.5-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14m2GeGdq",
    className: "s11",
    d: "m355 4669c0-11 10-13 25.5-5 15 8 11.5 15-8 15-14 0-17.5-2-17.5-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17eSNZZlh",
    className: "s11",
    d: "m315 4651.5c0-20.5 8-23 16-5 3 7 8.5 12.5 12.5 12.5 3.5 0 6.5 2.5 6.5 5 0 3-8 5-17.5 5-16.5 0-17.5-1-17.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12EBsIKoR",
    className: "s11",
    d: "m-1669 4635.5c17.5-37 24-40.5 24-14 0 15.5-1.5 17.5-13 17.5-7 0-12-1.5-11-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8yNLmwu3",
    className: "s11",
    d: "m160 4629.5c0-5.5 5.5-16.5 12.5-24l12-14 0.5 16c0 22-4.5 31.5-15.5 31.5-6 0-9.5-3.5-9.5-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIh3FtfWs",
    className: "s11",
    d: "m1850 4620.5c-7-4.5-13.5-10-15-11.5-1.5-2-6.5-4.5-11-6.5-12.5-4.5-11-11.5 2.5-15.5 18.5-5 23.5-3.5 23.5 7 0 6.5 3.5 10 10 10 7.5 0 10 3.5 10 12.5 0 14.5-3.5 15.5-20 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnfnuGid9",
    className: "s11",
    d: "m-1335 4589c0-13.5-1.5-15-15-15-13.5 0-15-1.5-15-15.5v-15l14 9.5c13 9.5 26.5 23.5 40.5 42.5 6 7.5 5 8.5-9 8.5-14 0-15.5-1.5-15.5-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbli3GYca",
    className: "s11",
    d: "m2145 4587c0-16.5 1-18 15.5-18h15l-10.5 15c-15.5 22-20 22.5-20 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17GPSV4pa",
    className: "s11",
    d: "m1928 4563c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8aUt6IIh",
    className: "s11",
    d: "m-1607.5 4554c10.5-11.5 67-40 79.5-40 4.5 0 8 4 8 10 0 7.5-3.5 10-12.5 10-7 0-12.5 2-12.5 4.5 0 2.5-8 7.5-17.5 11-9.5 3.5-17.5 8.5-17.5 10.5 0 2-8 4-18.5 4-18 0-18 0-9-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDm1sBpD2",
    className: "s11",
    d: "m2180 4542c0-14 2-17.5 13-20 7.5-2 14.5-2.5 16-1 2.5 2.5-22.5 38-27 38-1 0-2-7.5-2-17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2rwmtB2i",
    className: "s11",
    d: "m2070 4531.5c0-22 13-24 17.5-3 1.5 8.5 7 16 11.5 17 4.5 1.5 0 2.5-10 3-18.5 0.5-19 0-19-17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyr3tFpqq",
    className: "s11",
    d: "m2065 4486.5c0-20 12-24.5 17-6 5 18.5 3.5 23.5-7 23.5-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKPQLwIWv",
    className: "s11",
    d: "m1907.5 4473.5c-2-8.5-2-16.5-0.5-18 5.5-5.5 18 9.5 18 21.5 0 17.5-13.5 15-17.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pN01YgQgZ",
    className: "s11",
    d: "m2058 4456c-2-4.5 0.5-14.5 5.5-21.5l8.5-13 3.5 12.5c6.5 22.5 5 30-5 30-5 0-11-3.5-12.5-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pooZ2p8Zp",
    className: "s11",
    d: "m625 3989c0-2.5-5.5-5-12.5-5-15 0-17-12.5-2.5-16.5 5.5-1.5 10-6 10-10.5 0-4.5 3-8 6.5-8 7 0 20 33.5 15.5 41-3.5 5.5-17 5-17-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCjoFbYDg",
    fillRule: "evenodd",
    className: "s11",
    d: "m520 3774h-12.5c-8 0-12.5-3-12.5-7.5 0-4 3.5-7.5 7.5-7.5 14 0 17.5-25 17.5-130.5 0-89.5-1-104.5-7.5-104.5-5 0-7.5 5-7.5 14 0 11-19.5 33-106.5 120l-106.5 106h21.5c15 0 21.5 2 21.5 7 0 3.5-4 8-8.5 9-16 4-66.5 5-81.5 1.5-16.5-3.5-20.5-17.5-5-17.5 8 0 10-3.5 10-15 0-8-2-15-5-15-2.5 0-5-8-5-17.5 0-12 2.5-17.5 7.5-17.5 4 0 7.5 3.5 7.5 7.5 0 4 1.5 7.5 3 7.5 4.5 0 129.5-120.5 147.5-142.5 5-5.5 14-14.5 20-20.5 6.5-6 19.5-19.5 28.5-31l16-20.5-13.5-2c-13.5-2-13.5-2-2.5-6 6-2 11-6.5 11-10.5 0-5 8.5-6.5 35-5.5 33.5 1 35 1.5 35.5 13.5 0.5 7 1.5 117 2.5 245 1.5 218 2 232.5 10.5 235.5 6 2.5 3 4-9.5 4l-19 0.5zm-25-244c9.5-8.5 15.5-17 13.5-19-1.5-2-6.5-0.5-10.5 2.5-6 5-7.5 4-9.5-5.5-1.5-9.5-2-9.5-1.5 2 0.5 14.5-7 24-64 84l-35.5 37.5 45-43c25-23.5 53-50 62.5-58.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWsRClPcs",
    className: "s11",
    d: "m-2766 3943c-19.5-34-20.5-39-7-39 12.5 0 18 8.5 18 28 0 8.5 2.5 12 10 12 9 0 9.5 1.5 5 10-8 14.5-12.5 12.5-26-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pylSOeZPH",
    className: "s11",
    d: "m-3195 3914c0-6.5 3.5-10 10-10 11.5 0 13 5 4 14-9 9-14 7.5-14-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEClYYO8G",
    className: "s11",
    d: "m2360 3896.5c-4-1-16-3-26-5-12-2-19-5.5-19-10 0-8.5-13-10.5-16-2.5-2.5 7.5-41-12.5-61-32-13.5-14-18-22.5-18-35.5 0-16.5-1-17.5-17.5-17.5-20 0-21.5-2.5-7.5-14 7-6 12-18.5 15-41 9-58.5 9.5-60 23-60 11 0 11.5 1 6.5 14-3 7.5-7.5 26-10.5 41-2.5 15-6 33.5-7.5 41.5-1.5 8-0.5 13.5 3 13.5 3 0 5.5-5.5 5.5-12 0-8 6-16 19-25 23.5-16 26-16 26-1 0 10.5 2.5 12 30.5 15 17 2 32 2.5 33.5 0.5 1.5-1.5 0.5-11.5-2.5-22.5-5-19-4.5-20 6.5-20 13.5 0 14 4 8.5 42.5l-3 23.5-33.5-2.5c-18.5-1.5-38-5-43.5-8.5-8-5.5-12-5-23 2.5-15.5 10-16 15-6 32.5 4 7 7 17.5 7.5 24 0 9 3 11 15 11 18 0 50 12.5 50 19.5 0 2.5 17 6 37.5 8 32 3 37.5 5 37.5 13 0 9-9 11-30 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbD3YG5PB",
    className: "s11",
    d: "m2405 3889c0-6 3.5-10 9-10 4.5 0 20.5-1.5 35-3 17.5-2.5 26-1.5 26 2q0 12.8-43.5 18c-24.5 3-26.5 2.5-26.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pC4IeU7Ij",
    className: "s11",
    d: "m-3197 3883c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPXm34ahy",
    className: "s11",
    d: "m679 3890.5c-34.5-1.5-44-3.5-44-9 0-4-3.5-7.5-7.5-7.5-8 0-11-14.5-8-43.5 1-11.5 15.5-7 15.5 5 0.5 31 3.5 33.5 42.5 33.5 40.5 0 42.5-1.5 42.5-42.5 0-36.5-4-42.5-25.5-42.5-16 0-19.5-1.5-19.5-10 0-8.5 3.5-10 23-10 36 0 39.5 6.5 39.5 72 0 45.5-1.5 55.5-7.5 55.5-4 0.5-27 0-51-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIWkU5umG",
    className: "s11",
    d: "m135.5 3870.5c0.5-10.5 1.5-15 3-10 2 8 13 8.5 130.5 9.5 70.5 0 131 1 133.5 1.5 3 1 9 1.5 14 2 4.5 0 8.5 4 8.5 8 0 6.5-19.5 7.5-145 7.5h-145z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbxc42otS",
    className: "s11",
    d: "m-3155 3863c0-15.5 1.5-19 10-19 7.5 0 10-3.5 10-12.5 0-10.5 2.5-12.5 15.5-12.5h15l-10 14c-5.5 7.5-16.5 21.5-25 31l-15 17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FBM9Yl5u",
    className: "s11",
    d: "m-2804 3855.5c1-5 6.5-9.5 13-10.5 8.5-1.5 11 1 11 8.5 0 8-3 10.5-13 10.5-9.5 0-12.5-2.5-11-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17qNDC3HN",
    className: "s11",
    d: "m-2755 3834c0-16.5 1.5-20 10-20 8 0 10 3.5 10 15q0 15 7.5 15c4 0 7.5 2.5 7.5 5 0 3-8 5-17.5 5-17 0-17.5-0.5-17.5-20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFhkm0QVd",
    className: "s11",
    d: "m-3202 3838c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p83kjpn8y",
    className: "s11",
    d: "m-2815 3836.5c0-4 2.5-7.5 5-7.5 3 0 5 3.5 5 7.5 0 4-2 7.5-5 7.5-2.5 0-5-3.5-5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmvseJzqX",
    className: "s11",
    d: "m2080 3824.5c0-9 21.5-20.5 38-20.5 14 0 7 19-8.5 24.5-22.5 8-29.5 7-29.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16kSwzRe1",
    className: "s11",
    d: "m-1625 3817c0-10 2.5-13 10.5-13 7.5 0 10 2.5 8.5 11-2.5 17-19 18.5-19 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pq2wH3PzN",
    className: "s11",
    d: "m-1400 3806.5c0-19.5 1.5-23 9-21.5 6.5 1 8.5 6.5 8.5 21.5 0 15-2 20.5-8.5 21.5-7.5 1.5-9-2-9-21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZ8eBc40T",
    className: "s11",
    d: "m-1175 3817c0-10 2.5-13 10.5-13 7.5 0 10 2.5 8.5 11-2.5 17-19 18.5-19 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pi3bufAtg",
    className: "s11",
    d: "m1944 3825.5c-16.5-4-10-16.5 8.5-16.5 14 0 17.5 2 17.5 10 0 10-7 11.5-26 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEeA3lifq",
    className: "s11",
    d: "m2010 3819.5c0-8.5 4-9.5 30-9 25.5 0 30 1.5 30 9.5 0 7.5-4 9-30 9-26 0-30-1-30-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7z58AJk6",
    className: "s11",
    d: "m-1050 3803.5c0-12 2-15 9-13.5 5 1 9 7 10 15.5 1.5 11-0.5 13.5-8.5 13.5-8.5 0-10.5-3-10.5-15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWpzJnfrN",
    className: "s11",
    d: "m1886.5 3806.5c-21.5-9-21-17.5 1-17.5 15.5 0 17.5 1.5 17.5 12.5 0 7-0.5 12.5-1 12.5-1-0.5-9-3.5-17.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pg6LNZ9mt",
    className: "s11",
    d: "m2135 3807c0-6.5 14-13 29-13 3 0 6 4.5 6 10 0 8-3.5 10-17.5 10-11.5 0-17.5-2.5-17.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzDEkoPKL",
    className: "s11",
    d: "m-2914.5 3799.5c-8.5-5.5-3.5-20.5 7-20.5 4.5 0 7.5 4.5 7.5 12.5 0 13.5-3 15-14.5 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPp0WOePh",
    className: "s11",
    d: "m-2603.5 3796.5c-3.5-4-6.5-9.5-6.5-12.5 0-2.5-6-5-13.5-5q-28.5 0-25.5-19.5c1.5-10.5 2-10.5 33 4.5 32 15 43 27.5 30.5 35.5-9 5.5-11 5.5-18-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAYx9MFTT",
    className: "s11",
    d: "m626 3785.5c1.5-18.5 2-19 23-20.5 18.5-1.5 21-0.5 21 8.5 0 8-3 10.5-13 10.5-8.5 0-14 3-15.5 10-1.5 5.5-6 10-10 10-5 0-6.5-5-5.5-18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pV8HWNkqk",
    className: "s11",
    d: "m-2805 3787c0-6.5 14-13 29-13 3 0 6 4.5 6 10 0 8-3.5 10-17.5 10-11.5 0-17.5-2.5-17.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Bw5zQojl",
    className: "s11",
    d: "m-2725 3783.5c0-9 2.5-10 13-8 10 1.5 14 0 15.5-7 4.5-17 16.5-11 16.5 8 0 17.5 0 17.5-22.5 17.5-19.5 0-22.5-1.5-22.5-10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3yBoTwTh",
    className: "s11",
    d: "m1816 3769.5c-15-11-19.5-17.5-17.5-25 2-8-0.5-10-14.5-11.5-15.5-1.5-16.5-3-18-21l-1.5-19.5 36 33.5c20 18 38.5 33 40.5 33 2 0 4 5.5 4 12.5 0 16-4 15.5-29-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjCCvvcot",
    className: "s11",
    d: "m-2885 3769c0-6.5 58.5-35 71.5-35 5 0 8.5-4 8.5-10 0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6 0-10 3.5-10 9 0 5.5-9 12.5-26.5 20-27.5 11.5-53.5 14.5-53.5 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXwrQfF9v",
    className: "s11",
    d: "m445 3767c0-8 12.5-12 26.5-9 16 4 9.5 16-9 16-12 0-17.5-2.5-17.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXFcr0ufR",
    className: "s11",
    d: "m-2755 3751.5c0-20 12-24.5 17-6 5 18.5 3.5 23.5-7 23.5-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptBPIRpY3",
    className: "s11",
    d: "m-3060 3743c0-17 1.5-19 12.5-19 9 0 12.5-2.5 12.5-10 0-8 3.5-10 17.5-10 21.5 0 24 12.5 4 17-8 2-21 12-30 22l-16 18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18F1sSnDF",
    className: "s11",
    d: "m-2695 3744c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poxK7Lq71",
    className: "s11",
    d: "m-1745 3734c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyjhNgzUj",
    className: "s11",
    d: "m-1720 3734c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GiYhKFxa",
    className: "s11",
    d: "m-2710 3726.5c0-4-2-7.5-5-7.5-2.5 0-5-8-5-17.5 0-9.5 2.5-17.5 5.5-17.5 6.5 0 21 34.5 17.5 43-3.5 9.5-13 9-13-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVUhghIIa",
    className: "s11",
    d: "m-1186.5 3730.5c-9-8.5-2.5-16.5 14-16.5 14 0 17.5 2 17.5 10 0 7.5-3.5 10-14 10-8 0-16-1.5-17.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2cHoDYw1",
    className: "s11",
    d: "m-3217 3718c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pX7qDY57i",
    className: "s11",
    d: "m-2970 3705c0-8 7-10 44.5-15 56.5-7.5 60.5-7.5 60.5 1.5 0 7-3.5 8-65 17.5-42 6.5-40 6.5-40-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOpInqSCv",
    className: "s11",
    d: "m2307.5 3703.5c2-3-1.5-10.5-8-17.5l-11-12h10.5c6 0 11-2.5 11-5 0-3 4-2.5 10 1 8 5.5 11 4.5 17-3.5 4.5-5.5 8-7 8-3.5 0 3 3.5 6 7.5 6 9.5 0 9.5 2.5-1 20.5-8.5 14.5-16.5 19-16.5 9.5 0-2.5-2-5-5-5-2.5 0-5 3.5-5 7.5 0 4-4.5 7.5-10.5 7.5-6 0-8.5-2-7-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNc23FLZy",
    className: "s11",
    d: "m-2835 3684c0-8 3.5-10 17.5-10 20 0 24.5 12 6.5 17-19 5-24 3.5-24-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piyPVJrUa",
    className: "s11",
    d: "m-3222 3678c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUgvJRKtC",
    className: "s11",
    d: "m625 3661.5c0-21 1.5-27.5 7.5-27.5 7.5 0 9 4 9 27.5 0 23.5-1.5 27.5-9 27.5-6 0-7.5-6.5-7.5-27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5M5eWpKZ",
    className: "s11",
    d: "m1723 3666c-4.5-12.5-3.5-37 2-37 4 0 25 35 25 42.5 0 6.5-24 1.5-27-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxcbRsKm5",
    className: "s11",
    d: "m-2840 3651.5c0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-8 0-10-3.5-10-15.5 0-12 1.5-14.5 6.5-11 3 3 29 22 57.5 43.5 28 21 51 39.5 51 40.5 0 1.5-8 2.5-17.5 2.5-12 0-17.5-2.5-17.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4rjRa8Rb",
    className: "s11",
    d: "m-3227 3638c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxGobFPCW",
    className: "s11",
    d: "m-2765 3635.5c0.5-9.5 9.5-17.5 17-15 13 5 9.5 18.5-4.5 18.5-7 0-12.5-1.5-12.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GPSkg3Sb",
    className: "s11",
    d: "m1698 3603c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdR1jQXeP",
    className: "s11",
    d: "m230 3575.5c0-17 6-31.5 13-31.5 5 0 7 6.5 7 20 0 16.5-1.5 20-10 20-6 0-10-3.5-10-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWLRQSoqD",
    className: "s11",
    d: "m-1720 3509c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p146Qai7Qr",
    className: "s11",
    d: "m120 3511c0-4.5-4.5-9-10-10.5-17.5-4.5-12-16.5 7.5-16.5 16.5 0 17.5 1 17.5 17.5 0 12-2.5 17.5-7.5 17.5-4 0-7.5-3.5-7.5-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10ImzUVV1",
    className: "s11",
    d: "m2354 3494l-8-25h12c9.5 0 14.5 4 20 17.5 10 24.5 9 32.5-4.5 32.5-9.5 0-13-4.5-19.5-25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnx6hHJjk",
    className: "s11",
    d: "m-1183.5 3505.5c-14-5.5-6.5-16.5 11-16.5 14 0 17.5 2 17.5 10 0 10-13 13-28.5 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HVhiOw69",
    className: "s11",
    d: "m1715 3487c0-16 1.5-18 12.5-18 12 0 12.5 0.5 6 16-9.5 23-18.5 24-18.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXrTsXeYu",
    className: "s11",
    d: "m155 3484c0-9.5 3.5-10 57.5-10 54 0 57.5 0.5 57.5 10 0 9.5-3.5 10-57.5 10-54 0-57.5-0.5-57.5-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6EzIXkhW",
    className: "s11",
    d: "m-3247 3473c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmVEYyxDp",
    className: "s11",
    d: "m25 3436.5c0-14 2-17.5 10-17.5 8 0 10 3.5 10 17.5 0 14-2 17.5-10 17.5-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prcfZMXYD",
    className: "s11",
    d: "m625 3439.5c0-16-11-40.5-18-40.5-4 0-7-2-7-5 0-2.5-3.5-5-7.5-5-13.5 0-7.5-12.5 10-20.5l17.5-8 0.5 15.5c0.5 15 0.5 15 4-3 2-10 11.5-27.5 21-38 9.5-11 24.5-29 33.5-40.5 18-22.5 30.5-26 34.5-10.5 1.5 5.5 4.5 10 7 10 2.5 0 4.5 8.5 4.5 18.5 0 15.5-4.5 22.5-31.5 50-23 23-35.5 31.5-45 31.5-10 0-13.5 2.5-13.5 9.5 0 5.5 2.5 10.5 5.5 11.5 8.5 3 0.5 34-8.5 34-4 0-7-4-7-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzMzmROVs",
    className: "s11",
    d: "m1730 3439.5c0-3 5.5-11.5 12.5-19l12-14 0.5 19c0 16.5-1.5 18.5-12.5 18.5-7 0-12.5-2-12.5-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10VV3Iq3k",
    className: "s11",
    d: "m2319 3429l-14-17.5 13-1.5c16.5-2 18-0.5 16 19.5l-1.5 17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptW65OO44",
    className: "s11",
    d: "m-1745 3414c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17GWZXc1a",
    className: "s11",
    d: "m-3257 3393c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5x9lIhtr",
    className: "s11",
    d: "m1762.5 3394c1.5-2.5 9.5-9.5 17.5-15l15-10.5v15c0 14.5-1.5 15.5-18 15.5-10 0-16.5-2-14.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4cGzTFRc",
    className: "s11",
    d: "m2277 3385.5c-12-11-15-16.5-12.5-25.5l3-11.5 15.5 14c12 11 15 16.5 12.5 25.5l-3 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqgWsO6sa",
    className: "s11",
    d: "m20 3384c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18KDVVFRp",
    className: "s11",
    d: "m100 3381.5c0-4 3.5-7.5 8-7.5 4.5 0 9-4.5 10.5-10 3-12 21.5-13.5 21.5-2 0 4.5 4.5 9 10 10.5 5.5 1.5 10 6 10 9.5 0 5-8 7-30 7-23.5 0-30-1.5-30-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pndfKXB1x",
    className: "s11",
    d: "m2220 3351c-12.5-6.5-34.5-15.5-48.5-20.5-36.5-11.5-36-23.5 0.5-20 26 2.5 58 16 58 24.5 0 2 4.5 4 10 4 7.5 0 10 3.5 10 12.5 0 15-1.5 15-30-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAgLj9QIP",
    className: "s11",
    d: "m-3262 3348c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwMwzkMRq",
    className: "s11",
    d: "m1845 3346.5c0-11 2-12.5 17.5-12.5 21.5 0 22 5 3 16.5-19 11-20.5 11-20.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHlbzjNGA",
    className: "s11",
    d: "m-1425 3336.5c0-18.5 11-24.5 17-9.5 6 16 3 27-7 27-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poW4AZ18V",
    className: "s11",
    d: "m-1200 3336.5c0-18.5 11-24.5 17-9.5 6 16 3 27-7 27-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plG9DNVII",
    className: "s11",
    d: "m1890 3334c0-2.5-3.5-5-7.5-5-4 0-7.5-2.5-7.5-5 0-7 32-20.5 34-14.5 1 2.5 5 4.5 9.5 4.5 4 0 6.5 2.5 5.5 6-3 8-34 21-34 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pf6ws6OmA",
    className: "s11",
    d: "m126 3305.5l1.5-19 46.5-1.5c38-1 46 0 46 6 0 9-23.5 14.5-52.5 12-16.5-1-21 0.5-25 10-8 18.5-18.5 13.5-16.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAOheRs5S",
    className: "s11",
    d: "m2115 3316.5c-4-1-16-3-26-5-12-2-19-5.5-19-10 0-8.5 5.5-9 44-4.5 21 3 26 5 26 12.5 0 9-6 10.5-25 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FhTT0bT4",
    className: "s11",
    d: "m1980 3297c0-6.5 14-13 29-13 3 0 6 4.5 6 10 0 8-3.5 10-17.5 10-11.5 0-17.5-2.5-17.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFVYLwWc3",
    className: "s11",
    d: "m425 2759c0-8 3.5-10 17.5-10 20 0 24.5 12 6.5 17-19 5-24 3.5-24-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paQkx8dNI",
    className: "s11",
    d: "m256.5 2746.5c-20-8.5-21.5-17.5-2.5-17.5 23.5 0 36 5.5 36 15.5 0 11.5-11 12-33.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkJ2Rc0Zk",
    className: "s11",
    d: "m490 2744.5c0-10 12.5-15.5 36.5-15.5 8.5 0 13.5-2.5 13.5-7.5 0-5 5.5-7.5 17.5-7.5 14 0 17.5-2 17.5-10 0-5.5 3.5-10 7.5-10 4 0 7.5-2 7.5-5 0-2.5 4.5-5 10-5 5.5 0 10-3.5 10-7.5 0-5.5 5.5-7.5 19-7.5l18.5 0.5-17.5 15c-31.5 27-112 69.5-132 69.5-4.5 0-8-4-8-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14dycRRAb",
    className: "s11",
    d: "m174.5 2703l-22-16.5 17.5-1.5c9.5-1 18 0.5 19 3.5 1 3 5 5.5 9 5.5 4 0 7 5 7 12.5 0 16.5-4 16-30.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pg3HzSLXt",
    className: "s11",
    d: "m-1320 2687c0-11.5 2-13 17.5-13 26.5 0 23 6.5-13.5 24-2.5 1-4-4-4-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGa35XYsk",
    className: "s11",
    d: "m-3341 2675.5c-16.5-4-10-16.5 8.5-16.5 14 0 17.5 2 17.5 10 0 10-7 11.5-26 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p26W12AkH",
    className: "s11",
    d: "m-3382 2651l-14.5-14.5 14-1.5c17-2 18.5-0.5 16.5 16.5l-1.5 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSBhht0pm",
    className: "s11",
    d: "m670 2627c0-12.5 2-18 7.5-18 4 0 7.5-4.5 7.5-10 0-5.5 2.5-10 5-10 3 0 5-3.5 5-7.5 0-4 3.5-7.5 7.5-7.5 4.5 0 7.5-4.5 7.5-12.5 0-10 2.5-12.5 12.5-12.5 9.5 0 11.5 2 9 9-4.5 12.5-45 73.5-54 81-6.5 5.5-7.5 3.5-7.5-12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqQAXa6fr",
    className: "s11",
    d: "m2080.5 2632.5c-9.5-3.5-18.5-9-19.5-13-2-5.5 2.5-6.5 24.5-4 15 2 33 3.5 41 3.5 16.5 0 18.5 12.5 2.5 17-16.5 4-29 3.5-48.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1F8GSg9jq",
    className: "s11",
    d: "m-3405 2619.5c-8-15.5-6-25.5 5-25.5 8 0 10 3.5 10 17.5 0 19.5-7 23-15 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pb5LnWkX9",
    className: "s11",
    d: "m76.5 2604.5c-20-26.5-20.5-30.5-4-30.5 7.5 0 12.5 3 12.5 7 0 4 2.5 8 5.5 9 3 1 4.5 9.5 3.5 19l-1.5 17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3uxdUP7U",
    className: "s11",
    d: "m-1754 2600.5c-3-5-6.5-18.5-8.5-30-3-19-2.5-21.5 6.5-21.5 9.5 0 16 18.5 16 49 0 13-8 14.5-14 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14ccQua9s",
    className: "s11",
    d: "m-2775 2586.5c0-14 2-17.5 10-17.5 10.5 0 12 5 7 24-5 18-17 13.5-17-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FwG5ensz",
    className: "s11",
    d: "m-3412 2573c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pseSIow6X",
    className: "s11",
    d: "m-3412.5 2393c0-125.5 1-136.5 9-138 8-1.5 8.5 8 8.5 136 0 129-0.5 138-9 138-8 0-8.5-9-8.5-136z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CxgBOezA",
    className: "s11",
    d: "m30 2514.5c-8-15.5-6-25.5 5-25.5 8 0 10 3.5 10 17.5 0 19.5-7 23-15 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbHwzxdy2",
    className: "s11",
    d: "m735 2506.5c0-14 2-17.5 10-17.5 11 0 13 10 5 25.5-8 15-15 11.5-15-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxX9ptDvU",
    className: "s11",
    d: "m-1295 2512.5c0-4 8-9 17.5-12 16.5-5.5 17.5-5 17.5 6.5 0 10.5-2.5 12-17.5 12-11 0-17.5-2.5-17.5-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pK3BTwqPC",
    className: "s11",
    d: "m13 2448c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2GTuNt2c",
    className: "s11",
    d: "m750 2441.5c0-14 2-17.5 10-17.5 10.5 0 12 5 7 24-5 18-17 13.5-17-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pufzCb69J",
    className: "s11",
    d: "m2060 2451c0-6 17-32 21-32 2 0 4 8 4 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZxMxKVTE",
    className: "s11",
    d: "m2260 2436.5c0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-15.5 1.5-17.5 12.5-17.5 7 0 12.5 1 12.5 2.5 0 6-37.5 67.5-41 67.5-2 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15YmpveQf",
    className: "s11",
    d: "m2425 2424c0-8 3.5-10 17.5-10 19.5 0 23 7 8 15-15.5 8-25.5 6-25.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJrG7otXb",
    className: "s11",
    d: "m-1225 2394c0-21.5 11.5-28.5 16.5-10 3.5 14-1.5 30-9.5 30-5 0-7-6.5-7-20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxDguez1K",
    className: "s11",
    d: "m2054 2400.5c-16.5-4-10-16.5 8.5-16.5 14 0 17.5 2 17.5 10 0 10-7 11.5-26 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUAXeCG7F",
    className: "s11",
    d: "m1982.5 2371.5c-59-31.5-64.5-37.5-35-37.5 14 0 17.5 2 17.5 10 0 8 3.5 10 16.5 10 21 0 30 6 27.5 19.5l-1.5 11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAb0mZzFA",
    className: "s11",
    d: "m2495 2346.5c0-24.5 11.5-32 16.5-11.5 4 15.5-1 34-9.5 34-5 0-7-6.5-7-22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AlbqM3wv",
    className: "s11",
    d: "m12.5 2343c8-47 47-149 57-149 8.5 0 6.5 33.5-2 42-4 4-7.5 12-7.5 17.5 0 6-2 10.5-4.5 10.5-2.5 0-5.5 9-7.5 20-1.5 11-5 20-7.5 20-2.5 0-5.5 13.5-7.5 30-3 25.5-5 30-13.5 30-9.5 0-10-2-7-21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13ReifxPc",
    className: "s11",
    d: "m750 2346.5c0-20 12-24.5 17-6 5 18.5 3.5 23.5-7 23.5-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTsml9DkR",
    className: "s11",
    d: "m2320 2300.5c0-10 8.5-25 11.5-21.5 1 1.5 3.5 8.5 5.5 16.5 2.5 11.5 1.5 13.5-7 13.5-6 0-10-3.5-10-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1d4rtC1a",
    className: "s11",
    d: "m1850.5 2283.5l-17.5-17 14-1.5c18-2 24 4 22 22l-1.5 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPVSwzidd",
    className: "s11",
    d: "m-1225 2274c0-21.5 11.5-28.5 16.5-10 3.5 14-1.5 30-9.5 30-5 0-7-6.5-7-20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pX7iV3GdG",
    className: "s11",
    d: "m720 2246.5c0-12-2.5-17.5-7.5-17.5-5 0-7.5-5.5-7.5-17.5 0-32.5 12-18.5 35.5 41.5 3.5 9.5 2.5 11-8 11-11 0-12.5-2-12.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p04UQoz8y",
    className: "s11",
    d: "m2470 2236.5c0-20 12-24.5 17-6 5 18.5 3.5 23.5-7 23.5-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5wvH8Bgf",
    className: "s11",
    d: "m-3412.5 2163c0-59 1-66.5 9-68 7.5-1.5 8.5 4 8.5 66 0 62-1 68-9 68-8 0-9-5.5-8.5-66z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGTD66Hv8",
    className: "s11",
    d: "m2455 2186c0-7-3.5-16-7.5-20-8-8.5-10.5-42-3-42 6 0 24.5 38 28.5 59 3 14 2 16-7.5 16-8 0-10.5-3-10.5-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJhZKBb7E",
    className: "s11",
    d: "m-2695 2166.5c0-9 2.5-12.5 10-12.5 6.5 0 10-3.5 10-10 0-5.5 2.5-10 5-10 3 0 5-3.5 5-7.5 0-4.5 4.5-7.5 12-7.5 16.5 0 12 15-12 40.5-21.5 22.5-30 24.5-30 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puXbEht0z",
    className: "s11",
    d: "m85 2155.5c0-6.5 42-76.5 46-76.5 2 0 4 8 4 17.5 0 12-2.5 17.5-7.5 17.5-4 0-7.5 4.5-7.5 10 0 18.5-11 35-23.5 35-6 0-11.5-1.5-11.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pq8PCpUOj",
    className: "s11",
    d: "m1765.5 2129c-7-33.5-7-35 4-35 9 0 15.5 19.5 15.5 49 0 22-14 11.5-19.5-14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pY6tMhFGn",
    className: "s11",
    d: "m665 2131.5c0-21.5 5-22 16.5-3 11 19 11 20.5-4 20.5-11 0-12.5-2-12.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15t62nfti",
    className: "s11",
    d: "m2440 2096.5c0-14 2-17.5 10-17.5 10.5 0 12 5 7 24-5 18-17 13.5-17-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p136A3FTbG",
    className: "s11",
    d: "m-3115 2081c0-17 11-27 30.5-27h16.5l-20 20c-23 23.5-27 24.5-27 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIGmudbxl",
    className: "s11",
    d: "m-1754 2075.5c17.5-37 24-40.5 24-14 0 15.5-1.5 17.5-13 17.5-7 0-12-1.5-11-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peaz0kUsK",
    className: "s11",
    d: "m625 2061.5c0-21.5 5-22 16.5-3 11 19 11 20.5-4 20.5-11 0-12.5-2-12.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FtQor3jO",
    className: "s11",
    d: "m-2660 2051.5c0-15.5-1.5-17.5-12.5-17.5-10.5 0-12.5-2.5-12.5-15 0-15 0-15 12.5-7 14 9 32.5 37 32.5 49 0 4.5-4 8-10 8-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnCEm4iO",
    className: "s11",
    d: "m-3415 2045.5c0-21.5 5.5-36.5 13-36.5 5 0 7 7 7 25 0 21.5-1.5 25-10 25-7.5 0-10-3.5-10-13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pS1wb9GvJ",
    className: "s11",
    d: "m-3065 2024c0-21.5 6.5-26 15-10 4 7 3.5 12.5-1 20-9.5 15-14 12-14-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRDVSe4dt",
    className: "s11",
    d: "m155 2036c0-6 17-32 21-32 2 0 4 8 4 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNUrVLZjQ",
    className: "s11",
    d: "m-1181 2004l-16-13.5 16-2.5c12-1.5 19.5 1 32 11l16 13.5-16 2.5c-12 1.5-19.5-1-32-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNijz7dnO",
    className: "s11",
    d: "m-1700 2005c0-4 26-21 32-21 1.5 0 3 5.5 3 12.5 0 11-2 12.5-17.5 12.5-9.5 0-17.5-2-17.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13gKgPpfC",
    className: "s11",
    d: "m-1320 1991c0-7 1.5-12 4-11 36.5 17.5 40 24 13.5 24-15.5 0-17.5-1.5-17.5-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15wND9Zsh",
    className: "s11",
    d: "m-2740 1986.5c0-15 1.5-15 20.5-4 19 11.5 18.5 16.5-3 16.5-15.5 0-17.5-1.5-17.5-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbEuKzD34",
    className: "s11",
    d: "m575 1992c0-4-2.5-8-5.5-9-3-1-4.5-9.5-3.5-19l1.5-17.5 16.5 22c19.5 26.5 20 30.5 3.5 30.5-7.5 0-12.5-3-12.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pC4pLJ6iL",
    className: "s11",
    d: "m190 1980c0-2.5 7.5-14.5 16.5-26.5l16-22 1.5 17.5c1 9.5-0.5 18-3.5 19-3 1-5.5 5-5.5 9 0 4-5 7-12.5 7-7 0-12.5-2-12.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAlBL1VXS",
    className: "s11",
    d: "m-1625 1969c4-2.5 7.5-7.5 8-11 0-3.5 1-10.5 1-15 0.5-5 4.5-9 8.5-9 5.5 0 7.5 5.5 7.5 20 0 19-0.5 20-16 20-12.5 0-14.5-1.5-9-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWnqXlezh",
    className: "s11",
    d: "m-1215 1958.5v-15l15 10.5c22 15.5 22.5 20 3 20-16.5 0-18-1-18-15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdGAuD4pl",
    className: "s11",
    d: "m-3345 1949c0-8 3.5-10 17.5-10 20 0 24.5 12 6.5 17-19 5-24 3.5-24-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbxEsPR5S",
    className: "s11",
    d: "m-1360 1926.5c0-19.5 7-23 15-8 8 15.5 6 25.5-5 25.5-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptrshKdDb",
    className: "s11",
    d: "m-1262.5 1931c-12.5-11.5-16-24-8-29 3.5-2.5 50.5 29.5 50.5 34 0 1-7 3-15 4-11 1.5-19-1-27.5-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6V5QRuSp",
    className: "s11",
    d: "m1815 1901c0-6 17-32 21-32 2 0 4 8 4 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2hNC94KW",
    className: "s11",
    d: "m268 1863c10-14.5 23-31 28-36.5 9-9.5 9-9.5 9 9 0 16.5-1.5 18.5-12.5 18.5-11 0-12.5 2-12.5 17.5 0 16-1 17.5-15.5 17.5h-15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psd6sAoDa",
    className: "s11",
    d: "m-1505 1867c0-8 12.5-12 26.5-9 16 4 9.5 16-9 16-12 0-17.5-2.5-17.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFm53y1FI",
    className: "s11",
    d: "m2380 1846c0-19.5 4.5-19 20 3l10.5 15h-15c-14.5 0-15.5-1.5-15.5-18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZd1Q1YiF",
    className: "s11",
    d: "m475 1836.5c0-15.5-1.5-17.5-12.5-17.5-9 0-12.5-2.5-12.5-10 0-5.5-3.5-10-7.5-10-4 0-7.5-4.5-7.5-10 0-5.5-3.5-10-7.5-10-5 0-7.5-5.5-7.5-17.5 0-9.5 1-17.5 2-17.5 2.5 0 32.5 38.5 65 84l19 26h-15.5c-14.5 0-15.5-1.5-15.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjyV7DT0Y",
    className: "s11",
    d: "m-3421.5 1825c-10.5-11.5-8.5-25 6.5-38.5 10-9 10-8.5 9.5 8-0.5 9.5-2 22.5-4 28.5l-3 12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkNVVDLPO",
    className: "s11",
    d: "m-3304.5 1792c-26-26.5-31-34-29.5-46 1.5-14 2.5-13.5 49 31.5l47.5 46-17.5 0.5c-15.5 0-22.5-4.5-49.5-32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZAzy3mmC",
    className: "s11",
    d: "m-1245 1807c0-4.5-4-8-8.5-8-6.5-0.5-4.5-4.5 8.5-15.5 13.5-11.5 18-13 19-7 1 4 5 7.5 9 7.5 10 0 5 7-13 20-12.5 9-15 9.5-15 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCxeMwylT",
    className: "s11",
    d: "m1880 1799c5.5-8 17-19.5 25-25l15-10.5v14.5c0 18-18.5 36-37 36h-13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11smdiACw",
    className: "s11",
    d: "m-1200 1759.5c0-14.5 1.5-15.5 18-15.5 19.5 0 19 4.5-3 20l-15 10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFbYvZRug",
    className: "s11",
    d: "m1971 1733c1.5-3.5 9.5-9 18-12.5 15.5-6.5 16-6 16 6 0 11-2 12.5-18 12.5-11.5 0-17-2-16-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pex64850",
    className: "s11",
    d: "m-1155 1719.5c0-13 2-15.5 12.5-15.5 17.5 0 16 9-3.5 24.5-8 6-9 5.5-9-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pp0TMLOLN",
    className: "s11",
    d: "m-3340 1134c0-8 3.5-10 15-10 17 0 19 3.5 6.5 13-13 9.5-21.5 8.5-21.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmDLlaC0z",
    className: "s11",
    d: "m-3300 1110.5c0-12.5 2-14 17.5-15 22-1 22 3 0 17.5l-17.5 11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18ypwENwA",
    className: "s11",
    d: "m-3260 1089c0-6 50-40 58.5-40 12.5 0 6 8-22.5 26.5-31 19.5-36 21.5-36 13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJki4k0Qh",
    className: "s11",
    d: "m-1680 1072.5c-1.5-1.5-12.5-4-25-5.5-32-4.5-49.5-7.5-72.5-14-11-2.5-20-4.5-20-3.5 0 0.5-5-1.5-11-5-6.5-3-11.5-8-11.5-10.5 0-8 23-6 66.5 6 33 9 54 11.5 107.5 11 60.5 0 74.5 2.5 61 10.5-11.5 7-90 16-95 11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peTaBDbPH",
    className: "s11",
    d: "m-1565 1041.5c0-9 2.5-12.5 10-12.5 5.5 0 10-2 10-5 0-8.5 17-25 26-25 6.5 0 9-4 9-12.5 0-10 2.5-12.5 12.5-12.5 15.5 0 15.5 4 1.5 22.5-19 24-46 48.5-60 54-7 2.5-9 0.5-9-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyi9Liazf",
    className: "s11",
    d: "m-3175 1034.5c0-6 20-20.5 28.5-20.5 11 0 7 7.5-8 16.5-16.5 9.5-20.5 10.5-20.5 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOaYL0gNo",
    className: "s11",
    d: "m-1875 1018.5c0-3.5 26-31 42-44 7-6 8-5 8 9 0 14-1.5 15.5-15 15.5-12.5 0-15 2-15 12 0 9.5-2.5 12-10 11.5-5.5-0.5-10-2-10-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptoW5YlKA",
    className: "s11",
    d: "m346.5 1003.5c-21.5-5-28.5-16-13.5-21.5 4.5-1.5 22.5-0.5 40.5 2 17.5 3 40 4 49.5 2 15-2.5 17-2 17 7.5 0 9-3 10.5-22 10.5-12 0-28 1-36 2-8 1.5-24 0-35.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzYHKSbce",
    className: "s11",
    d: "m2129 995c-5-1-9-5-9-9 0-5 6.5-7 22.5-7 16.5 0 22.5 2 22.5 7.5 0 4-3 7.5-6 8-3.5 0-10 1-14 1.5-4 0.5-11.5 0.5-16-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTROdg02W",
    className: "s11",
    d: "m480 982.5c0-4 8-9 17.5-12 16.5-5.5 17.5-5 17.5 6.5 0 10.5-2.5 12-17.5 12-11 0-17.5-2.5-17.5-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUux47pjA",
    className: "s11",
    d: "m-3100 961.5c0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-15.5 1.5-17.5 12.5-17.5 7 0 12.5 1 12.5 2.5 0 6-57.5 102.5-61 102.5-2 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GMy0Cydk",
    className: "s11",
    d: "m249 963c-22.5-12-29-18-29-27 0-6.5 1-12 2-12 6.5 0 88 46.5 88 50.5 0 9.5-34 3.5-61-11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1D0FHhu62",
    className: "s11",
    d: "m2084 971c-9-10.5-10.5-16.5-9.5-43 0.5-13 3-19 8-19 8.5 0 14 24.5 11.5 52-1.5 18.5-2 19-10 10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10GS5P5xK",
    className: "s11",
    d: "m2185 975c0-3-3.5-6-7.5-6-7 0-7-1.5-0.5-11 4-6.5 8.5-19 10.5-27.5 2-9.5 6.5-16.5 10.5-16.5 6.5 0 10 19 7 40-1 9.5-20 29.5-20 21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pchKrdUqv",
    className: "s11",
    d: "m-1490 951.5c0-14 2-17.5 10-17.5 11 0 13 10 5 25.5-8 15-15 11.5-15-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Dc043zyf",
    className: "s11",
    d: "m-1820 959c0-3 4.5-9 10-13.5 5.5-5 10-11.5 10-15 0-3.5 2-6.5 4-6.5 2.5 0 7.5-6 11.5-13.5 4-8 11-18.5 16-23.5 8.5-9.5 8.5-9.5 8.5 8.5 0 15-2 18.5-10 18.5-8 0-10 3.5-10 15q0 15-7.5 15c-4 0-7.5 4.5-7.5 10 0 7.5-3.5 10-12.5 10-7 0-12.5-2.5-12.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puoCgfdI6",
    className: "s11",
    d: "m156.5 906.5l-14-12 19-0.5c16.5 0 18.5 1.5 18.5 12.5 0 15.5-5.5 16-23.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p145KMGHwc",
    className: "s11",
    d: "m615 902c0-16.5 1-18 15.5-18h15l-10.5 15c-15.5 22-20 22.5-20 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14FBJINTp",
    className: "s11",
    d: "m-1467.5 860.5c2-19 5.5-34.5 8-35.5 2.5-1 4.5-6 4.5-11.5 0-6 3.5-9.5 10-9.5 8 0 10-3.5 10-15 0-12.5 2-15 12.5-15 7 0 12.5 1.5 12.5 4 0 2-8 15.5-18 30-14.5 21.5-26.5 59-27 85 0 0.5-3.5 1-8 1-7 0-7.5-4.5-4.5-33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJCsgkQUz",
    className: "s11",
    d: "m118 877.5c-13.5-13-18-21-18-33.5v-16l27 27c15 14.5 24.5 27.5 21 28.5-3 1-7 4-8.5 6.5-1.5 2.5-11-3-21.5-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRlIC5dze",
    className: "s11",
    d: "m-1758.5 865.5c1-5 4-14 7.5-20 3.5-6 6-14 6-18 0-4 4.5-12 10-18.5 5.5-6.5 10-13.5 10-16 0-6 39.5-44 45.5-44 3 0 4.5 6 3.5 14-1 9.5-4.5 14-12.5 15-7.5 1-11.5 5-11.5 12 0 5.5-4 11-10 12.5-5.5 1.5-10 6.5-10 11.5 0 14.5-5.5 25-13 25-4.5 0-7 6-7 17.5 0 14-2 17.5-10 17.5-6.5 0-9.5-3-8.5-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DaisRlsV",
    className: "s11",
    d: "m469 855c-18.5-11-17.5-16 3.5-16 15.5 0 17.5 1.5 17.5 12.5 0 14.5-3 15-21 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwpfYzqDE",
    className: "s11",
    d: "m-3025 831.5c0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-15.5 1.5-17.5 12.5-17.5 7 0 12.5 1 12.5 2.5 0 6-37.5 67.5-41 67.5-2 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14PZkwyz1",
    className: "s11",
    d: "m81.5 837c-6.5-8-11.5-18.5-11.5-23.5 0-5.5-2-9.5-4.5-9.5-2.5 0-7-7.5-10.5-16-3.5-9-11-26-16-38-6.5-14.5-8.5-26.5-6-38.5 5-27 14.5-21 23.5 15 4.5 17.5 15 46 23.5 63.5 9.5 19 15 37 14 46l-1.5 15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15BLpPH8R",
    className: "s11",
    d: "m2075 754.5c0-46.5-1-87.5-2.5-91.5-1.5-4 4-10.5 13.5-16 11-7 16.5-8 18-4 3 9.5 11 7 11-4 0-8 3.5-10 17.5-10 9.5 0 17.5 2 17.5 4 0 2.5-11 10.5-25 18-13.5 7.5-26 16-28 18.5-1.5 3-3.5 39.5-4.5 81-2 95.5-1 88.5-10 88.5-6.5 0-7.5-12.5-7.5-84.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prlbPpALL",
    className: "s11",
    d: "m374 800c-18.5-11-17.5-16 3.5-16 15.5 0 17.5 1.5 17.5 12.5 0 14.5-3 15-21 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12yDQtQCq",
    className: "s11",
    d: "m1777.5 795.5c-24.5-24.5-35.5-61.5-18-61.5 9.5 0 15.5 12.5 15.5 34 0 6 2.5 11 6 11 11 0 43.5 17.5 44 24 0 12-33 7-47.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIQtVpqQB",
    className: "s11",
    d: "m1856.5 795.5c-6.5-1-11.5-4-11.5-5.5 0-3.5 191.5-116 197.5-116 1.5 0 2.5 5.5 2.5 12.5 0 11-2 12.5-17.5 12.5-14 0-17.5 2-17.5 10 0 8-3.5 10-18.5 10-14 0-17 1.5-11.5 5 4 2.5 6 5.5 5 7-4.5 4-114.5 68-116 67.5-1-0.5-6.5-2-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxdZLAtlX",
    className: "s11",
    d: "m-1501.5 760c-9.5-10.5-11.5-31-3-31 7 0 34.5 27.5 34.5 34.5 0 9-23 6-31.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plS1FuEAP",
    className: "s11",
    d: "m-1410 761.5c0-4-2-7.5-5-7.5-9 0-5-10.5 10-26 8.5-8 15-17 15-19.5 0-2.5 2.5-4.5 5-4.5 3 0 5-3.5 5-7.5 0-4.5 4.5-7.5 12.5-7.5 7 0 12.5 1.5 12.5 3.5 0 6-47.5 76.5-51 76.5-2.5 0-4-3.5-4-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBLTSiFbe",
    className: "s11",
    d: "m715 741.5c0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-15.5 1.5-17.5 12.5-17.5 7 0 12.5 1 12.5 2.5 0 6-57.5 102.5-61 102.5-2 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmYk0C44x",
    className: "s11",
    d: "m261.5 735c-17.5-10-31.5-20-31.5-22 0-2 8-4 17.5-4 14 0 17.5 2 17.5 10 0 8 3.5 10 17.5 10 15.5 0 17.5 1.5 17.5 12.5 0 7-1.5 12.5-3.5 12.5-2.5-0.5-18-8.5-35-19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pw2Zy1oe1",
    className: "s11",
    d: "m-1662 734.5c5.5-5 15-11 21-12.5 6-2 11-5.5 11-7.5 0-2 3-4 6.5-4.5 29-2.5 47-9 50.5-19 1.5-4.5 5-6 8-4.5 2.5 1.5 5-0.5 5-4.5 0-4.5 5-18 11-30.5 8.5-17 14-22.5 22.5-22.5 11.5 0 11.5 0 4 19-4.5 10-12.5 26-18 35-9.5 17-12.5 31.5-5.5 30 6-1 21 7 21 11.5 0 6-28.5 5.5-40.5-0.5-12.5-7-69.5 4-69.5 13.5 0 4-6.5 6.5-18.5 6.5-18 0-18.5 0-8.5-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmA5rsulw",
    className: "s11",
    d: "m-2950 701.5c0-15.5 1.5-17.5 12.5-17.5 15 0 15 1.5 4 20.5-11.5 19-16.5 18.5-16.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBAqfRfXA",
    className: "s11",
    d: "m174 685c-18.5-11-17.5-16 3.5-16 15.5 0 17.5 1.5 17.5 12.5 0 14.5-3 15-21 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pouM6uXe7",
    className: "s11",
    d: "m30 664c0-16.5 1.5-20 10-20 8.5 0 10 3.5 10 20 0 16.5-1.5 20-10 20-8.5 0-10-3.5-10-20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pT2ACeDgu",
    className: "s11",
    d: "m1800 680c0-4 26-21 32-21 1.5 0 3 5.5 3 12.5 0 11-2 12.5-17.5 12.5-9.5 0-17.5-2-17.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyJ7ZrZQX",
    className: "s11",
    d: "m1845 661.5c0-11 2-12.5 17.5-12.5 21.5 0 22 5 3 16.5-19 11-20.5 11-20.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFSAxaZR8",
    className: "s11",
    d: "m120.5 654c-20.5-15-50.5-55.5-50.5-68.5 0-3.5-2-6.5-4.5-6.5-2 0-7 13.5-10 30-4.5 21.5-8 30-14 30-6.5 0-7.5-4.5-5-28.5 4-46 10-56.5 31-56.5 12 0 17.5 2.5 17.5 7.5 0 10.5 16.5 44.5 24 49 3 2 6 7.5 6 11 0 4 3.5 7.5 7.5 7.5 4.5 0 9 3.5 10.5 7.5 2 4 6 7.5 10 7.5 4 0 7 5 7 12.5 0 16-4 15.5-29.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnqvxvI2W",
    className: "s11",
    d: "m-1345 626.5c0-12 2.5-17.5 7.5-17.5 4.5 0 7.5-4.5 7.5-12.5 0-7 2.5-12.5 5-12.5 3 0 5-3.5 5-7.5 0-4 3.5-7.5 7.5-7.5 4.5 0 7.5-4.5 7.5-12.5 0-10 2.5-12.5 12.5-12.5 7 0 12.5 1.5 12.5 3 0 6-57.5 97-61 97-2.5 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzTJERHfd",
    fillRule: "evenodd",
    className: "s11",
    d: "m2188 632c-2.5-10.5-5-11.5-25.5-9-12.5 1-22.5 0.5-22.5-2 0-2.5 28.5-21.5 64-41.5 35-20.5 64.5-37.5 65-38.5 1-0.5-7.5-9.5-18.5-19.5-11-10-25-26-31-35.5l-10-17-16 8c-10.5 6-16 6.5-17.5 2.5-1-3-6-5.5-11.5-5.5-7 0-9.5 3.5-9.5 12.5 0 10-2.5 12.5-12.5 12.5-8 0-12.5 3-12.5 7.5 0 4-4.5 7.5-10 7.5-5 0-11.5 3-13.5 6.5-4.5 7-26.5 23.5-32 23.5-2 0-2-24.5-0.5-54l2.5-54.5-19-21-19.5-21 20 1.5c17 1.5 19.5 3 21 15.5 1 8.5 4.5 13.5 10 13.5 24.5 0 101 18 101 23.5 0 4 6 6.5 15 6.5 12.5 0 15 2 15 12.5 0 10 2.5 12.5 12.5 12.5 10.5 0 12.5 2.5 12.5 14.5 0 13 2 15 16.5 16.5 15.5 1.5 16 2.5 17.5 26.5l1.5 25-34 20c-18.5 11-43 21.5-54 23-19 3-19 3-3.5 3.5 15 1 16 2 16 18.5 0 20.5-12 24.5-17 5.5zm-51-150c37.5-21.5 40.5-28 11.5-28-6 0-20.5-4.5-32-10l-21.5-9.5v34.5c0 19.5 0.5 35 1.5 35 1 0 19-10 40.5-22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4Dpsdxhj",
    className: "s11",
    d: "m-1380 621.5c-7.5-14.5-40-34.5-63-39.5-8.5-2-21.5-1-28.5 1.5-12.5 5-13.5 4-13.5-7 0-12 1.5-12.5 30-12.5 23.5 0 30 1.5 30 7.5 0 5 5.5 7.5 17.5 7.5 14 0 17.5 2 17.5 10 0 7.5 3.5 10 12.5 10 11 0 12.5 2 12.5 17.5 0 20.5-5.5 22.5-15 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11J6SrdbB",
    className: "s11",
    d: "m790 611.5c0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-15.5 1.5-17.5 12.5-17.5 7 0 12.5 1 12.5 2.5 0 6-37.5 67.5-41 67.5-2 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pR7Xo7Ngb",
    className: "s11",
    d: "m1895 625c0-2 14.5-12.5 32.5-22.5 30.5-17.5 33.5-18.5 41-11 8.5 9 8 10-16 23.5-7 4-10 4-11.5-0.5-3-9.5-11-6-11 4.5 0 8-3.5 10-17.5 10-9.5 0-17.5-2-17.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piRzC7LwS",
    className: "s11",
    d: "m-3185 616c0-6 17-32 21-32 2 0 4 8 4 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkk6PdiGw",
    className: "s11",
    d: "m-1530 604.5c0-3 5.5-11.5 12.5-19l12-14 0.5 19c0 16.5-1.5 18.5-12.5 18.5-7 0-12.5-2-12.5-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppWc9ibzL",
    className: "s11",
    d: "m2139 595c-15.5-3-10.5-16 6-16 13.5 0 15-2 18-20q5.3-34.5 18-7.5c10.5 23.5-14.5 50-42 43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DqxcDe4i",
    className: "s11",
    d: "m2335 566.5c-42.5-12.5-45-13.5-45-21 0-8.5 16-7.5 64 4 19.5 5 26 9 26 15.5 0 11-12.5 11.5-45 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pW5w1ntpi",
    className: "s11",
    d: "m2405 564.5c0-8.5 4-10.5 25-13.5 14-2 25-5 25-7.5 0-2 8-6.5 17.5-10 9.5-3.5 17.5-8.5 17.5-10.5 0-2 4.5-4 10-4 5.5 0 10-3.5 10-7.5 0-4 4.5-7.5 10-7.5 7 0 10-3.5 10-10.5 0-6 4-11.5 10-13 5.5-1.5 10-5.5 10-9.5 0-3.5 4-14.5 8.5-24.5 6-12.5 11.5-17.5 20-17.5 11.5 0 11.5 0 4 19-25.5 61-89 110.5-159 123.5-16.5 3-18.5 2.5-18.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pV8puQlHs",
    className: "s11",
    d: "m2000 565c0-4 26-21 32-21 1.5 0 3 5.5 3 12.5 0 11-2 12.5-17.5 12.5-9.5 0-17.5-2-17.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIfrji91d",
    className: "s11",
    d: "m-2855 536.5c0-15.5 1.5-17.5 12.5-17.5 15 0 15 1.5 4 20.5-11.5 19-16.5 18.5-16.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HeufqxSZ",
    className: "s11",
    d: "m2125 539c0-7 19.5-16 28-13 4 1.5 7 6 7 10.5 0 5.5-5 7.5-17.5 7.5-9.5 0-17.5-2-17.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pafWm22Wx",
    className: "s11",
    d: "m-1280 521.5c0-12 2.5-17.5 7.5-17.5 4.5 0 7.5-4.5 7.5-12.5 0-8 3-12.5 7.5-12.5 4.5 0 7.5-4.5 7.5-12.5 0-8 3-12.5 7.5-12.5 4.5 0 7.5-4.5 7.5-12.5 0-8 3-12.5 7.5-12.5 4.5 0 7.5-4.5 7.5-12.5 0-10 2.5-12.5 12.5-12.5 7 0 12.5 1.5 12.5 3 0 6-77.5 132-81 132-2.5 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p0E2o5L6O",
    className: "s11",
    d: "m61.5 518c9.5-23 18.5-24 18.5-2 0 16-1.5 18-12.5 18-12 0-12.5-0.5-6-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HrSUsywt",
    className: "s11",
    d: "m-1465 511c0-6 17-32 21-32 2 0 4 8 4 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1d1BAl9v",
    className: "s11",
    d: "m-2820 476.5c0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-15.5 1.5-17.5 12.5-17.5 7 0 12.5 1 12.5 2.5 0 6-37.5 67.5-41 67.5-2 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psNgAi8p4",
    className: "s11",
    d: "m865 476.5c0-12 2.5-17.5 7.5-17.5 4.5 0 7.5-4.5 7.5-12.5 0-10 2.5-12.5 12.5-12.5 7 0 12.5 1.5 12.5 3 0 6-32.5 57-36 57-2.5 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPF6bmGTp",
    className: "s11",
    d: "m-1435 456c0-6 17-32 21-32 2 0 4 8 4 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p117FT2J8u",
    className: "s11",
    d: "m2195 426.5c0-26.5 12-31.5 17.5-7 2.5 10 5.5 14.5 10.5 12.5 4.5-1.5 7 1 7 7 0 8-3.5 10-17.5 10-17.5 0-17.5 0-17.5-22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6tCacjLF",
    className: "s11",
    d: "m2580 391.5c0-14 2-17.5 10-17.5 10.5 0 12 5 7 24-5 18-17 13.5-17-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piZTTXhUG",
    className: "s11",
    d: "m-1405 401c0-6 17-32 21-32 2 0 4 8 4 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYWiQbNRh",
    className: "s11",
    d: "m2300 395c0-4 26-21 32-21 1.5 0 3 5.5 3 12.5 0 11-2 12.5-17.5 12.5-9.5 0-17.5-2-17.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdneSVlJT",
    className: "s11",
    d: "m2016.5 369.5c-9-12-20.5-33-25.5-47.5-18-48-20-113-3-113 5.5 0 7 7.5 7 32 0 17.5 3.5 41.5 7.5 53 4 11.5 7.5 26.5 7.5 33 0 7.5 3 12 7.5 12 4 0 7.5 3 7.5 7 0 4 2.5 8 5.5 9 3 1 4.5 9.5 3.5 19l-1.5 17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwUkahryP",
    className: "s11",
    d: "m-1190 368c0-21.5 6-30.5 19.5-28l10.5 1.5-10.5 21.5c-12.5 25-19.5 27-19.5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phzP0B6tQ",
    className: "s11",
    d: "m2190 344c0-18 2-25 7-25 7.5 0 13 15 13 36.5 0 10-2.5 13.5-10 13.5-8.5 0-10-3.5-10-25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15BUia6Bc",
    className: "s11",
    d: "m-2745 346.5c0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-12 2.5-17.5 7.5-17.5 4.5 0 7.5-4.5 7.5-12.5 0-10 2.5-12.5 12.5-12.5 7 0 12.5 1 12.5 2.5 0 6-72.5 127.5-76 127.5-2.5 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQsaoyUYw",
    className: "s11",
    d: "m2360 360c0-4 26-21 32-21 1.5 0 3 5.5 3 12.5 0 11-2 12.5-17.5 12.5-9.5 0-17.5-2-17.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6dafalhM",
    className: "s11",
    d: "m-1380 356c0-6 17-32 21-32 2 0 4 8 4 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pK6v6Va3J",
    className: "s11",
    d: "m2576 325.5c-10.5-38-13-61.5-6-61.5 7 0 23 36.5 27.5 64 3 18.5 2 21-6 21-7 0-11-6-15.5-23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pc5iptCyy",
    className: "s11",
    d: "m-1160 302c0-12.5 2-18 7.5-18 5 0 7.5-5.5 7.5-17.5 0-12 2.5-17.5 7.5-17.5 5 0 7.5-5.5 7.5-17.5 0-9.5 2.5-17.5 5-17.5 3 0 5-5.5 5-12.5 0-7 2.5-12.5 5-12.5 3 0 5-5.5 5-12.5 0-7 2.5-12.5 5-12.5 3 0 5-5.5 5-12.5 0-7 2-12.5 4.5-12.5 2.5 0 5.5-9 7.5-20 2.5-17 5-20 15.5-20h12.5l-11 29c-26.5 71.5-77.5 188-83 190-4 1-6-4-6-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BoW3hmcr",
    className: "s11",
    d: "m910 301.5c0-19.5 7-23 15-8 8 15.5 6 25.5-5 25.5-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSmp3A2O8",
    className: "s11",
    d: "m2455 305c0-3.5 61.5-41 67.5-41 1.5 0 2.5 5.5 2.5 12.5 0 11-2 12.5-17.5 12.5-14 0-17.5 2-17.5 10 0 8-3.5 10-17.5 10-9.5 0-17.5-2-17.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSIYEvCg2",
    className: "s11",
    d: "m-1307 238c10-14.5 23-31 28-36.5 9-9.5 9-9.5 9 9 0 16.5-1.5 18.5-12.5 18.5-11 0-12.5 2-12.5 17.5 0 16-1 17.5-15.5 17.5h-15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWeoM3mZx",
    className: "s11",
    d: "m820 201.5c0-15 1.5-15 20.5-4 19 11.5 18.5 16.5-3 16.5-15.5 0-17.5-1.5-17.5-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZNzLZp6S",
    className: "s11",
    d: "m-1260 174c15.5-22 20-22.5 20-3 0 16.5-1 18-15.5 18h-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKt76cQyR",
    className: "s11",
    d: "m1990.5 170.5c7.5-20 27.5-54 36.5-61.5 7-5.5 8-4 8 12 0 10-2 18-5 18-2.5 0-5 3.5-5 7.5 0 4-3.5 7.5-7.5 7.5q-7.5 0-7.5 15c0 12.5-2 15-12.5 15-11.5 0-12-1-7-13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GalfoRD6",
    className: "s11",
    d: "m-2885 151.5c0-9.5 2.5-17.5 5-17.5 3 0 5-2 5-5 0-2.5-4.5-5-10-5-8 0-10 3.5-10 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3 0-5 35-62.5 42.5-70 3.5-4 8.5-11.5 10-17 1.5-5.5 7.5-10 12.5-10 5 0 11-4.5 12.5-10 1.5-5.5 6-10 9.5-10 3.5 0-2.5 17-15.5 43-20.5 41.5-27 67-16.5 67 3 0 5-4.5 5-9.5 0-12.5 44-100.5 50.5-100.5 9.5 0 2.5 36-8 42-14 7.5-17.5 13.5-17.5 29 0 7.5-2.5 24-6 36.5-6 21.5-7 22.5-25 22.5-18.5 0-19-0.5-19-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pw1Ia72Lf",
    className: "s11",
    d: "m735 156.5c0-4.5-4.5-7.5-12.5-7.5-10 0-12.5-2.5-12.5-12.5 0-7 1.5-12.5 3-12.5 6 0 57 32.5 57 36 0 2.5-8 4-17.5 4-12 0-17.5-2.5-17.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdqu4fqm6",
    className: "s11",
    d: "m-1185 79c15.5-22 20-22.5 20-3 0 16.5-1 18-15.5 18h-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAJ8Wq8Kh",
    className: "s11",
    d: "m-1070 77c0-16 1.5-18 12.5-18 12 0 12.5 0.5 6 16-9.5 23-18.5 24-18.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peSGFtZNP",
    className: "s11",
    d: "m2071 72c17-15 60-31.5 93.5-36 23.5-3 25.5-2.5 25.5 7 0 8.5-4.5 10.5-32.5 13.5-18 1.5-32.5 5.5-32.5 8 0 2.5-6.5 4.5-15 4.5q-15 0-15 7.5c0 5.5-5.5 7.5-18.5 7.5l-19-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pk6MmWUJc",
    className: "s11",
    d: "m560 51.5c0-15 1.5-15 20.5-4 19 11.5 18.5 16.5-3 16.5-15.5 0-17.5-1.5-17.5-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16hdqAA9W",
    className: "s11",
    d: "m-1055 37c0-16 1.5-18 12.5-18 12 0 12.5 0.5 6 16-9.5 23-18.5 24-18.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdn4HkGUT",
    className: "s11",
    d: "m-1144.5 30.5c20-26 71.5-86.5 73-86.5 0.5 0 1.5 8 1.5 17.5 0 15.5-1.5 17.5-12.5 17.5-10.5 0-12.5 2.5-12.5 15 0 12.5-2 15-12.5 15-10.5 0-12.5 2.5-12.5 15 0 13.5-1.5 15-15.5 15-14.5 0-15-1-9-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plB7xDFx9",
    className: "s11",
    d: "m360 35c0-4 26-21 32-21 1.5 0 3 5.5 3 12.5 0 11-2 12.5-17.5 12.5-9.5 0-17.5-2-17.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzhrhDd3G",
    className: "s11",
    d: "m-1030-29.5c0-26 5.5-36.5 18-36.5h12l-9 23.5c-10 27-21 34-21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1cuxbUHZ",
    className: "s11",
    d: "m-1005-108.5c0-14 2-17.5 10-17.5 10.5 0 12 5 7 24-5 18-17 13.5-17-6.5z"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "luY2t7Aix09I6eMF3xEpbX"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "py4lBIDGT",
    className: "s12",
    d: "m563 5165.5c-9.5-50.5-9.5-56.5 1.5-56.5 6.5 0 10.5 3 10.5 9 0 4.5 1.5 20.5 3 35 3 21.5 2 26-4.5 26-4.5 0-9-6-10.5-13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Ht4KmU8y",
    className: "s12",
    d: "m543 5069.5c-1.5-2-5-10-7.5-17.5-5-12-4-13 7-13 11 0 12.5 2 12.5 17.5 0 16.5-6 23-12 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnK05plt",
    className: "s12",
    d: "m503.5 4989.5c-11-19-11-20.5 4-20.5 11 0 12.5 2 12.5 17.5 0 21.5-5 22-16.5 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11NFeUwZi",
    className: "s12",
    d: "m305 4916.5c0-21.5 5-22 16.5-3 11 19 11 20.5-4 20.5-11 0-12.5-2-12.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRa5GeHW2",
    className: "s12",
    d: "m413.5 4834.5c-11-19-11-20.5 4-20.5 11 0 12.5 2 12.5 17.5 0 21.5-5 22-16.5 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11jb2Eecl",
    className: "s12",
    d: "m301 2753.5c-48.5-9.5-101.5-33.5-140-64.5-22.5-17.5-26-22.5-26-37.5 0-16 1-17.5 15.5-17.5 9.5 0 23 5.5 34 14 41 32 84 51 145.5 64 45 9.5 86.5 8.5 132.5-3 83-21 131-54 202.5-137l12.5-14.5-16.5 8.5c-53 27-167.5 36.5-242.5 20-59-13-123-46.5-166.5-88-66.5-63-101-133-112-226-10-86 3-146 57-260.5 28-59 100.5-180 146.5-243.5 26.5-36.5 29.5-39 46.5-39 18 0 20 2 68 66.5 148 197 261.5 394 292.5 507 14.5 51.5 11.5 156.5-5 208-11 33-11 33.5-29.5 34-10 0.5-14.5 1.5-9.5 3 16 4 10.5 31.5-13 64.5-50.5 69-131 123.5-206.5 139.5-37.5 8-150 9.5-186 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkNNZPWCB",
    className: "s12",
    d: "m-2794.5 2175c-32-16-38-30-39.5-92.5-1-31-0.5-72 1.5-92l3.5-36.5h20c25 0 106.5 38 133.5 62.5 26 23.5 32 40.5 29.5 81.5-2 40-14.5 61-44 76-25.5 13-80 13.5-104.5 1z"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "l2JGj3LIvWFzrWr8xa1OsMr"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "p174tLyF25",
    className: "s13",
    d: "m570 5232c0-10 2.5-13 10.5-13 7.5 0 10 2.5 8.5 11-2.5 17-19 18.5-19 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJVjhXYht",
    className: "s13",
    d: "m544 5230c-18.5-11-17.5-16 3.5-16 15.5 0 17.5 1.5 17.5 12.5 0 14.5-3 15-21 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcsCSbJRy",
    className: "s13",
    d: "m-1205 5214.5c0-11 9.5-15.5 31.5-15.5l16 0.5-14 12c-17 15-33.5 16.5-33.5 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prNQq3XNw",
    className: "s13",
    d: "m570 5186.5c0-24.5 11.5-32 17-11 6 22 3.5 33.5-7 33.5-8.5 0-10-3.5-10-22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdEnHpvs2",
    className: "s13",
    d: "m485 5189l-17.5-14.5 19-0.5c17.5 0 18.5 1 18.5 15 0 8.5-0.5 15-1.5 15-0.5 0-9-6.5-18.5-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNQbeDOVg",
    className: "s13",
    d: "m-1286.5 5149c-15.5-27.5-28.5-51-28.5-52.5 0-1.5 5.5-2.5 12.5-2.5 11 0 12.5 2 12.5 17.5 0 14 2 17.5 10 17.5 8 0 10 3.5 10 17.5 0 14 2 17.5 10 17.5 8 0 10 3.5 10 17.5 0 9.5-2 17.5-4 17.5-2 0-16.5-22.5-32.5-50z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p92X7oTiz",
    className: "s13",
    d: "m-3392 5185.5c-2.5-6-1-469.5 1.5-521.5 0.5-4 0-12-0.5-17.5-1-6 2-10.5 7.5-11.5 6-1 8.5 1.5 8.5 8.5 0 8 3.5 10.5 14 11 8 0.5 10 1.5 5 3-8.5 2-9 18.5-9 257v254.5h17.5c14 0 17.5 2 17.5 10 0 8-3.5 10-17.5 10-12 0-17.5-2.5-17.5-7.5 0-4-2-7.5-5-7.5-2.5 0-5 4.5-5 10 0 12-12.5 13.5-17 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbUr4KLjY",
    className: "s13",
    d: "m-3285 5177.5c0-7.5 14-13.5 34-13.5 13 0 12 25 12-267.5 0.5-144.5-1.5-213.5-5-221-3.5-6.5-13-11.5-26-13.5-13-2-20-5.5-20-10.5 0-6.5 12-7.5 77-7.5 93.5 0 105 2 113 19.5 7.5 16 7.5 505-0.5 512.5-2.5 3-45 6-94.5 7-78 2-90 1-90-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJwjtCkHc",
    className: "s13",
    d: "m-1179 5146.5c-7-14.5-8-42.5-2-42.5 4.5 0 18.5 22.5 25.5 41.5 5 12 4 13.5-6.5 13.5-7.5 0-13.5-4.5-17-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3VNmEU9F",
    className: "s13",
    d: "m565 5136.5c0-20 12-24.5 17-6 5 18.5 3.5 23.5-7 23.5-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17IIKzeAs",
    className: "s13",
    d: "m415.5 5118c-17.5-24-150.5-249.5-150.5-256.5 0-1.5 5.5-2.5 12.5-2.5 11 0 12.5 2 12.5 17.5 0 14 2 17.5 10 17.5 8 0 10 3.5 10 17.5 0 14 2 17.5 10 17.5 7.5 0 10 3.5 10 12.5 0 8 3 12.5 7.5 12.5 5 0 7.5 5.5 7.5 17.5 0 14 2 17.5 10 17.5 8 0 10 3.5 10 17.5 0 14 2 17.5 10 17.5 8 0 10 3.5 10 17.5 0 14 2 17.5 10 17.5 8 0 10 3.5 10 15 0 11.5 2 15 10 15 6.5 0 10 3.5 10 10 0 5.5 3.5 10 7.5 10 5 0 7.5 5.5 7.5 17.5 0 9.5-1 17.5-2.5 17.5-1 0-11-12-22-26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNr9uBQTT",
    className: "s13",
    d: "m2221.5 5086.5c-8-3.5-18.5-12-23-19.5l-8.5-13h15c11.5 0 15 2 15 10 0 8 3.5 10 17.5 10 11.5 0 17.5 2.5 17.5 7 0 10-16.5 12.5-33.5 5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phnj3GHus",
    className: "s13",
    d: "m547 5069c-2-11-5-20-7.5-20-2.5 0-4.5-6.5-4.5-15q0-15-7.5-15c-5 0-7.5-5.5-7.5-17.5 0-14-2-17.5-10-17.5-8 0-10-3.5-10-17.5 0-14-2-17.5-10-17.5-7.5 0-10-3.5-10-12.5 0-8-3-12.5-7.5-12.5-5 0-7.5-5.5-7.5-17.5 0-9.5 2-17.5 4-17.5 6 0 78 127 90.5 159 13 33 13 41 0.5 41-7.5 0-10.5-4.5-13-20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6kfMARSx",
    className: "s13",
    d: "m-1220 5061.5c0-14-2-17.5-10-17.5-8 0-10-3.5-10-17.5 0-14-2-17.5-10-17.5-7.5 0-10-3.5-10-12.5 0-8-3-12.5-7.5-12.5-5 0-7.5-5.5-7.5-17.5 0-9.5 2-17.5 4-17.5 4 0 76 121 76 127 0 1.5-5.5 3-12.5 3-11 0-12.5-2-12.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbJDXWaFT",
    className: "s13",
    d: "m-1350.5 5038c-25.5-45-26.5-49-12.5-49 13 0 18 8.5 18 30.5 0 11 2.5 14.5 10 14.5 8 0 10 3.5 10 17.5 0 9.5-2 17.5-4 17.5-2 0-12-14-21.5-31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLZIRYWT1",
    className: "s13",
    d: "m2178.5 5034.5c-11-19-11-20.5 4-20.5 11 0 12.5 2 12.5 17.5 0 21.5-5 22-16.5 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDi01cCTp",
    className: "s13",
    d: "m2265 4986.5c0-14-2-17.5-10-17.5-7.5 0-10-3.5-10-12.5 0-7.5-3-12.5-7-12.5-7.5 0-13-10.5-13-25.5 0-5-3.5-9.5-7.5-9.5-5 0-7.5-5.5-7.5-17.5 0-14-2-17.5-10-17.5-8 0-10-3.5-10-17.5 0-9.5 2-17.5 4-17.5 3.5 0 96 156 96 162 0 1.5-5.5 3-12.5 3-11 0-12.5-2-12.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTqYXoqp7",
    className: "s13",
    d: "m-1377 4966c-5-19.5-27-52-35.5-52-4 0-7.5-3.5-7.5-7.5 0-5 5.5-7.5 17.5-7.5 15.5 0 17.5 1.5 17.5 12.5 0 8 3 12.5 7.5 12.5 4 0 7.5 4.5 7.5 10 0 5.5 2.5 10 5 10 3 0 5 8 5 17.5 0 21-12 24-17 4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8guOHHDh",
    className: "s13",
    d: "m2138.5 4964.5c-11-19-11-20.5 4-20.5 11 0 12.5 2 12.5 17.5 0 21.5-5 22-16.5 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXSoJtJni",
    className: "s13",
    d: "m-1318.5 4929c-1.5-5.5-4.5-10-7-10-2.5 0-4.5-5.5-4.5-12.5 0-7.5-3-12.5-7-12.5-8.5 0-13-11-13-30.5 0-9.5 2.5-14.5 7.5-14.5 4 0 7.5-4.5 7.5-10 0-5.5 3.5-10 7.5-10 4 0 7.5-4.5 7.5-10 0-5.5 3.5-10 7.5-10 5 0 7.5-5 7.5-14.5 0-8 2.5-15.5 5.5-16.5 3-1 6.5-23 8-50.5 2-34.5 5-48.5 9.5-48.5 16 0 14 66-3.5 113-5.5 14.5-18 36.5-28 49.5-17.5 23.5-17.5 24-10 40.5 4.5 9 16.5 25.5 26.5 37l18 20h-18.5c-14 0-19-2.5-21-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZAmxO45x",
    className: "s13",
    d: "m-1470 4914c0-8 3.5-10 17.5-10 20 0 24.5 12 6.5 17-19 5-24 3.5-24-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXvpqsnLE",
    className: "s13",
    d: "m-1552.5 4908.5c-30.5-12-67.5-38.5-82-59l-11-15.5h15c13 0 15.5 2 15.5 12.5 0 10 2.5 12.5 12.5 12.5 9 0 12.5 2.5 12.5 10 0 7.5 3.5 10 12.5 10 14 0 37.5 10 37.5 16 0 2 7 4 15 4 11.5 0 15 2 15 10 0 12.5-10 12.5-42.5-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4HPFeXsd",
    className: "s13",
    d: "m2076 4856.5c-19.5-34.5-36-63.5-36-65 0-1.5 5.5-2.5 12.5-2.5 10 0 12.5 2.5 12.5 12.5 0 8 3 12.5 7.5 12.5 5 0 7.5 5.5 7.5 17.5 0 14 2 17.5 10 17.5 8 0 10 3.5 10 17.5 0 14 2 17.5 10 17.5 8 0 10 3.5 10 17.5 0 9.5-1.5 17.5-4 17.5-2 0-20-28-40-62.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BkfWu1qo",
    className: "s13",
    d: "m425 4836.5c0-21.5 5-22 16.5-3 11 19 11 20.5-4 20.5-11 0-12.5-2-12.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Dg1HFzEn",
    className: "s13",
    d: "m1973.5 4841c-10-51-10-57 1-57 7.5 0 10.5 3 10.5 12 0 6.5 1.5 18 3 26 1.5 9 0 18.5-4.5 24-7 9.5-7.5 9.5-10-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p525cXSFI",
    className: "s13",
    d: "m219 4838.5c-14.5-8-10.5-14.5 8.5-14.5 14 0 17.5 2 17.5 10 0 11-12 13-26 4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZ0en41VK",
    className: "s13",
    d: "m194 4820.5c-14.5-17-15-26.5-1.5-26.5 11 0 12.5 2 12.5 17.5 0 20-0.5 20.5-11 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjvDGPSVo",
    className: "s13",
    d: "m-1664.5 4801.5c-9.5-20.5-20-57-20.5-71 0-3.5 4-6.5 9-6.5 7.5 0 10.5 7 16 32.5 3.5 18 8.5 32.5 11 32.5 2 0 4 8 4 17.5 0 23.5-7 22-19.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRgFzfvVI",
    className: "s13",
    d: "m2155 4796.5c0-14-2-17.5-10-17.5-8 0-10-3.5-10-17.5 0-14-2-17.5-10-17.5-6.5 0-10-3.5-10-10 0-5.5-2-10-5-10-6 0-7-33.5-1-36.5 2-1.5 20-4 40-6 31-3 36-2.5 36 4.5 0 5-6.5 8.5-18.5 10.5-34.5 5.5-41.5 7.5-41.5 12 0 2.5 12.5 26 27.5 52.5 15 26 27.5 48.5 27.5 50 0 2-5.5 3-12.5 3-11 0-12.5-2-12.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMCbb8wT7",
    className: "s13",
    d: "m390 4786.5c0-4-2-7.5-5-7.5-2.5 0-5-8-5-17.5 0-9.5 2-17.5 4.5-17.5 3 0 6.5-10 8.5-22.5 2-14 5.5-22.5 10-22.5 10.5 0 11 29 1 49-5 9-4 14 2.5 25.5 11 19 11 20.5-4 20.5-8 0-12.5-3-12.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1vXeDs7G",
    className: "s13",
    d: "m180 4776c0-4.5 4-14.5 8.5-22 8-14 8-15-5-33.5-16.5-24-16.5-26.5-1-26.5 9 0 12.5 2.5 12.5 9.5 0 5 4.5 10.5 10 12 7.5 2 10 7 10 20.5 0 12.5-2 18-7.5 18q-7.5 0-7.5 15c0 11.5-2 15-10 15-6 0-10-3.5-10-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11GXQe9yv",
    className: "s13",
    d: "m2090 4771.5c0-9 2-11.5 7.5-9.5 4.5 2 7.5 0 7.5-5 0-4.5 4-8 10-8 8 0 10 3.5 10 17.5 0 16.5-1 17.5-17.5 17.5-15.5 0-17.5-1.5-17.5-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CCQETKJI",
    className: "s13",
    d: "m1963 4763c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1COGp6b4l",
    className: "s13",
    d: "m1843.5 4747.5c6.5-9 18.5-14 49-20 49.5-10.5 62.5-10.5 62.5-1 0 4-1.5 7.5-3 7.5-1.5 0-27.5 5.5-58 12.5-30.5 7-56.5 12.5-57.5 12.5-1 0 2-5.5 7-11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11SBT7cWL",
    className: "s13",
    d: "m1873.5 4708c2.5-3.5 12.5-16 21.5-28 19-23.5 20-21.5-16-42-23.5-13.5-24-19-1.5-19 12 0 17.5 2.5 17.5 7.5 0 4.5 4.5 7.5 12.5 7.5 12 0 12.5 1.5 12.5 27.5 0 24-1 27.5-10 27.5-7.5 0-10 3.5-10 12.5 0 10.5-2.5 12.5-15.5 12.5-12 0-14.5-1.5-11-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9sDBoGHZ",
    className: "s13",
    d: "m-1683 4690.5c7-41 9-46.5 16-46.5 8 0 8.5 7.5 4 42-2.5 18.5-5.5 23-13 23-9 0-9.5-2.5-7-18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjzhMlJgK",
    className: "s13",
    d: "m2195 4684.5c0-13 19.5-17 35-6.5l12.5 8-15 3.5c-26.5 6-32.5 5-32.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plcaINMjy",
    className: "s13",
    d: "m365 4672c0-9.5 2-11.5 9.5-9.5 5.5 1.5 13.5 7 18.5 12 8.5 9 8 9.5-9.5 9.5-16 0-18.5-1.5-18.5-12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Eh5b6S6P",
    className: "s13",
    d: "m158 4666c-4.5-18 1-42 10-42 5 0 7 7 7 27.5 0 20-2 27.5-7 27.5-4 0-8.5-6-10-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4C1jjQ1R",
    className: "s13",
    d: "m-1300 4658.5c0-5.5-3.5-13.5-7.5-17.5-4-4.5-7.5-15.5-7.5-25 0-15-1.5-17-12.5-17-9 0-12.5-2.5-12.5-10 0-6.5-3.5-10-10-10-8 0-10-3.5-10-15.5v-15l14.5 10c26 19 65.5 81 65.5 103.5 0 4-4.5 7-10 7-7 0-10-3.5-10-10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAQNc4S6u",
    className: "s13",
    d: "m2170 4664c0-2.5-3.5-5-7.5-5-4 0-7.5-3.5-7.5-7.5 0-4.5-4.5-7.5-12-7.5-12.5 0-18-10.5-18-36 0-9 2.5-14 7.5-14 4 0 7.5-4.5 7.5-10 0-6.5 3.5-10 10-10 7.5 0 10-3.5 10-13 0-10.5-2-12.5-8.5-9.5-5 1.5-19.5 4.5-32.5 6-19.5 2.5-24 1.5-24-5 0-5.5 12.5-10.5 47.5-18.5 67-15.5 69.5-12 30 39.5-18 23-32.5 43-32.5 45 0 1.5 14.5 12 32.5 23 18 11 32.5 21.5 32.5 23.5 0 2-8 4-17.5 4-9.5 0-17.5-2-17.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzhlr1joI",
    className: "s13",
    d: "m310 4644q0-15-7.5-15c-5 0-7.5-5-7.5-14.5 0-12.5-2-15-18.5-18-23-4-47-4-76.5 0l-22.5 3 14-12.5c7.5-7 21.5-14 31-16 47-8.5 86 18.5 107.5 75.5 4.5 11.5 3.5 12.5-7.5 12.5-10.5 0-12.5-2.5-12.5-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqnVknBDN",
    className: "s13",
    d: "m1834 4610c-18.5-11-17.5-20 2.5-23.5 88.5-14.5 93.5-15 93.5-3 0 8.5-5 10-37.5 13-32 3-37.5 5-37.5 13 0 11.5-3.5 11.5-21 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piZ85kYqb",
    className: "s13",
    d: "m-1415 4531.5c0-12 0.5-12.5 16-6 23 9.5 24 18.5 2 18.5-16 0-18-1.5-18-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puztNsJGF",
    className: "s13",
    d: "m1995 4529c0-2.5 3-5 6.5-5 4 0 10-5.5 13.5-12.5 9.5-17.5 15-15.5 15 5 0 16.5-1 17.5-17.5 17.5-9.5 0-17.5-2-17.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CpmtQ9kJ",
    className: "s13",
    d: "m-1530 4522c0-6.5 14-13 29-13 3 0 6 4.5 6 10 0 8-3.5 10-17.5 10-11.5 0-17.5-2.5-17.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pi5QPrIhB",
    className: "s13",
    d: "m-1465 4519c0-10.5 5-12 24-7 18 5 13.5 17-6.5 17-14 0-17.5-2-17.5-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvYJBSZmg",
    className: "s13",
    d: "m1912.5 4493.5c-4.5-19.5-7-37-5.5-38 2-2.5 68 47.5 68 51.5 0 1-7.5 2-17 2-12 0-18-2.5-19.5-8.5-1.5-5-2.5-0.5-3 10-0.5 12.5-3 18.5-7.5 18.5-5 0-10-12-15.5-35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOIrBOoiU",
    className: "s13",
    d: "m2065 4491.5c0-20 12-24.5 17-6 5 18.5 3.5 23.5-7 23.5-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8ANuQmaO",
    className: "s13",
    d: "m2030 4491c0-6 17-32 21-32 2 0 4 8 4 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pY4Afwb0A",
    className: "s13",
    d: "m2060 4454.5c0-8.5 2.5-16.5 5.5-18 7-4.5 9-2 12.5 16.5 3 14 2 16-7.5 16-8.5 0-10.5-3-10.5-14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7my7vXAD",
    className: "s13",
    d: "m516.5 3979c2-9 3.5-19.5 3.5-23 0-11 13.5-8 16.5 3 1.5 7 7 10 15.5 10 9.5 0 13 2.5 13 10 0 6.5-3.5 10-9.5 10-5 0-16.5 1.5-25.5 3.5-16.5 3-16.5 3-13.5-13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBAKQUu1F",
    className: "s13",
    d: "m620 3984c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "po9AmZBKL",
    className: "s13",
    d: "m-2762 3951c-4.5-11.5-4-12 12.5-12 12 0 15 1.5 12.5 8-1.5 4.5-3 9-3 10 0 6-19.5 1-22-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBo68S1JK",
    className: "s13",
    d: "m-1165 3934.5c0-8 3-10.5 13-10.5 16.5 0 15 16.5-2 19-8.5 1.5-11-1-11-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pes84bkuM",
    className: "s13",
    d: "m-3191.5 3921c-2-2-3.5-9-3.5-15.5 0-8 3-11.5 10-11.5 7.5 0 10-3.5 10-12.5 0-10.5 2.5-12.5 15.5-12.5h15l-10 14c-22 29.5-33.5 41.5-37 38z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCuBFDF77",
    className: "s13",
    d: "m625 3903c0-21 6.5-49 10.5-49 2.5 0 4.5 3.5 4.5 7.5 0 4 5.5 8.5 12.5 10.5 7 1.5 12.5 6.5 12.5 10 0 4-5.5 9.5-12.5 12-7 2.5-12.5 8-12.5 12.5 0 4-3.5 7.5-7.5 7.5-4.5 0-7.5-4.5-7.5-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbeNfG18u",
    className: "s13",
    d: "m2366 3893.5c-6.5-2.5-18.5-4.5-27.5-5-28.5-1-43.5-5-43.5-12 0-11.5 21.5-13 61.5-4 30.5 7 38.5 10.5 38.5 17.5 0 10-10.5 11-29 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfYJ0YCtM",
    className: "s13",
    d: "m2400 3890.5c0-7 6-11 22.5-15.5 34-9 53.5-8 51.5 3-1 5.5-8 9.5-21.5 11.5-11 2-27.5 5-36 7-14 3-16.5 2.5-16.5-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5NVt8srs",
    className: "s13",
    d: "m-3197 3878c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p93CoA3lF",
    className: "s13",
    d: "m130 3871.5c0-9.5 2.5-17.5 5-17.5 3 0 5 3.5 5 7.5 0 4 2.5 8 5 8 3 0.5 7.5 1.5 10 2 3 0.5 8.5 1.5 12.5 2 4 0 7.5 4 7.5 8 0 5.5-6 7.5-22.5 7.5-22.5 0-22.5 0-22.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1iPlyhh7",
    className: "s13",
    d: "m-2800 3874.5c-11-21-3.5-30.5 23-30.5 9 0 12-2.5 12-10.5 0-12.5 11-24.5 22.5-24.5 6 0 8 4 6.5 16-1.5 15-0.5 16.5 17.5 19.5 24 4 26.5 6.5 20.5 23-5.5 16-17 21-17 7.5 0-12.5-16.5-17-47-13-18 2.5-23 5.5-23 12.5 0 12.5-8 12-15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxRuqhZDM",
    className: "s13",
    d: "m-1185 3874c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DCpFr9hy",
    className: "s13",
    d: "m2271 3870.5c-28-13.5-46-35-46-54.5 0-21 5-21.5 17-2 5 8.5 17.5 21 28.5 28.5 13.5 9 19.5 16.5 19.5 24.5 0 6.5-0.5 12-1 12-1 0-9-4-18-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLqA3jy5d",
    className: "s13",
    d: "m-3140 3841.5c0-14 2-17.5 10-17.5 7.5 0 10-3.5 10-12.5 0-9 2.5-12.5 10-12.5 7.5 0 10-3.5 10-12.5 0-9 2.5-12.5 10-12.5 7.5 0 10-3.5 10-12.5 0-10.5 2.5-12.5 15.5-12.5 12 0 14.5 1.5 11 6.5-27 34.5-83 103.5-84.5 103.5-1 0-2-8-2-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Eu0oW0Qd",
    className: "s13",
    d: "m-3202 3830.5c-9.5-50.5-9.5-56.5 1.5-56.5 6.5 0 10.5 3 10.5 9 0 4.5 1.5 20.5 3 35 3 21.5 2 26-4.5 26-4.5 0-9-6-10.5-13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HC3dVhWI",
    className: "s13",
    d: "m-2836 3838.5c-15-8.5-10-14.5 11-14.5 16.5 0 20 1.5 20 10 0 11-16 13.5-31 4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmxVlMg0",
    className: "s13",
    d: "m-2694 3835.5c1-6.5 7-9.5 20.5-10.5 20-1.5 24.5 5.5 9 14-16 8-31.5 6.5-29.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AaNAc2mJ",
    className: "s13",
    d: "m-1050 3811.5c0-28 13-32 18-5.5 3.5 19.5 0 28-11 28-5 0-7-6-7-22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEMZl9Z6N",
    className: "s13",
    d: "m1967.5 3825.5c-9-3-18-4.5-19-3-5 5-33.5-4.5-33.5-11 0-10 22-13 48.5-7 43.5 10 124 8.5 171.5-3.5 51-13.5 70-21.5 70-30.5 0-3.5 2.5-6.5 5-6.5 3 0 5 7.5 5 16.5 0 14.5-2.5 17-24.5 27.5-13.5 6-31 11-38.5 11-8 0-22.5 2.5-32 5.5-24.5 7.5-131.5 8.5-152.5 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11C9e4Zsl",
    className: "s13",
    d: "m-1625 3806c0-19 1.5-22.5 8.5-21 15.5 3 14.5 44-1 44-5.5 0-7.5-6-7.5-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8siPAov5",
    className: "s13",
    d: "m-1175 3806c0-19 1.5-22.5 8.5-21 15.5 3 14.5 44-1 44-5.5 0-7.5-6-7.5-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSUTqEvkI",
    className: "s13",
    d: "m-2815 3802.5c0-15.5 2-17.5 19.5-22.5 25.5-8 30.5-7.5 30.5 2 0 11.5-12.5 22-27 22-8 0-13 3-13 7.5 0 4-2 7.5-5 7.5-2.5 0-5-7.5-5-16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GWeofSOr",
    className: "s13",
    d: "m-2695 3811.5c0-4.5-4.5-7.5-10.5-7.5-12 0-24.5-11-24.5-22 0-9.5 7.5-10 29.5-2.5 13.5 4.5 15.5 8 15.5 22.5 0 9.5-2 17-5 17-2.5 0-5-3.5-5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11gJip6N2",
    className: "s13",
    d: "m-1110 3799c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGwjlwXzr",
    className: "s13",
    d: "m1876.5 3801.5c-10-4-16.5-10.5-16.5-16 0-7-1-7.5-4.5-2-4 6.5-9 5-30-9-6-4-6-5.5 0.5-12.5 7.5-7 11-6.5 38.5 7.5 24.5 12.5 30.5 17.5 30.5 27.5 0 6.5-0.5 12-1 12-1-0.5-9-3.5-17.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pejxvmjwX",
    className: "s13",
    d: "m-1720 3794c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2sPZjiVx",
    className: "s13",
    d: "m-1270 3794c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSMSdHs9o",
    className: "s13",
    d: "m713.5 3789.5c-2-8-6.5-9-38-8-19.5 1-35.5-0.5-35.5-3 0-2.5-3.5-4.5-7.5-4.5-5 0-7.5-5.5-7.5-17.5 0-12 2.5-17.5 7.5-17.5 4 0 7.5 3.5 7.5 7.5 0 11 21 17.5 58 17.5h32v17.5c0 19-12 25-16.5 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pp9iF8n7F",
    className: "s13",
    d: "m-2920 3789c0-6 16.5-17 41.5-27.5 18.5-7.5 18.5-7.5 18.5 4 0 8.5-5 14-17.5 20-19.5 9.5-42.5 11.5-42.5 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peLRDyRVJ",
    className: "s13",
    d: "m2345 3777c0-19.5-12-53-18.5-53-2.5 0-7 2.5-10.5 6-4.5 4.5-6 3.5-6-5 0-6-2.5-11-6-11-4.5 0-4.5-1.5 0-6 3.5-3.5 6-8.5 6-11 0-8-31.5-28-43-28-11.5 0-37 26-37 37.5 0 4-4.5 7.5-10 7.5-6.5 0-10-3.5-10-10 0-5.5 4.5-14.5 10-20 5.5-5.5 10-13 10-17 0-4 5-11 11-15 12.5-9 29-10.5 29-3 0 3 6.5 5 14.5 5 8.5 0 21 5.5 30 13l15 12.5 13-25c7-14 14.5-25.5 17-25.5 2.5 0 4-29.5 3.5-65-0.5-57.5 0.5-65 8-65 12 0 17.5 22.5 16 70-1 44.5-9 73-29.5 108l-12.5 21 10 22c13 28.5 13 55 0 66.5-10 9-10 8.5-10-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18FmWHMWt",
    className: "s13",
    d: "m-2624 3784.5c-4-2-6-9-5-15l1.5-10.5 21.5 10.5c11.5 6 21 12.5 21 15 0 5.5-30.5 6-39 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxp85FT00",
    className: "s13",
    d: "m2294 3785.5c-5.5-1.5-9-7-9-14.5 0-7.5-3-12-7.5-12-4 0-7.5 2.5-7.5 5 0 3-8 5-17.5 5-9.5 0-17.5-1.5-17.5-3.5 0-2.5 11.5-11.5 25-20.5 23-14.5 25-15.5 25-6 0 5.5 2 10 5 10 2.5 0 3.5 3 2 7-1.5 4.5 4.5 8.5 20 13 27 7.5 31.5 20.5 7 19.5-9-0.5-20.5-1.5-25-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRKBKrAcC",
    className: "s13",
    d: "m230 3769.5c0-6 3.5-10.5 7.5-10.5 4.5 0 7.5-4.5 7.5-12 0-11.5 10.5-17.5 29.5-18 5.5 0 5.5 2-1 9-13.5 14.5-10 17.5 6.5 6l15-10.5v15c0 17.5-7.5 23-41 27.5-22 3.5-24 3-24-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pttpGxuLy",
    className: "s13",
    d: "m-2758.5 3766.5c-3.5-4-6.5-13-6.5-20 0-8-3-12.5-7.5-12.5-4 0-7.5-2-7.5-5 0-2.5 7.5-5 16.5-5 15.5 0 17.5 2 22.5 19.5 3.5 10.5 6 21.5 6 25 0 8-16 6.5-23.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvRe9mYaS",
    className: "s13",
    d: "m-3212 3753c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18yMtJet7",
    className: "s13",
    d: "m1791.5 3751c-9-7-16.5-16-16.5-20 0-4-3.5-7-7.5-7-8 0-31-28.5-28.5-35.5 0.5-2.5-1-4.5-4-4.5-2.5 0-5-6.5-5-15 0-9.5-2.5-15-7-15-7.5 0-13-15-13-36 0-21.5 12.5-16.5 19.5 7.5 8 27 34.5 67 60.5 92.5 16 15 20.5 23 19 33l-1.5 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19VfVf7jL",
    className: "s13",
    d: "m2210 3736.5c0-14 2-17.5 10-17.5 10.5 0 12 5 7 24-5 18-17 13.5-17-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14gPzq5Xj",
    className: "s13",
    d: "m-1176 3730.5c-18-4.5-10-16.5 11.5-16.5 16.5 0 20 1.5 18.5 9-1.5 8.5-14.5 12-30 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUCRf1w73",
    className: "s13",
    d: "m-2805 3721c0-10.5 9-27 15-27 3 0 5 8 5 17.5 0 14-2 17.5-10 17.5-5.5 0-10-3.5-10-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXs0ZCfMO",
    className: "s13",
    d: "m-3217 3713c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17zsM0MSa",
    className: "s13",
    d: "m-3005 3709c0-8 3.5-10 17.5-10 20 0 24.5 12 6.5 17-19 5-24 3.5-24-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13WQEEezP",
    className: "s13",
    d: "m-2940 3699c0-8 3.5-10 17.5-10 20 0 24.5 12 6.5 17-19 5-24 3.5-24-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzBVA8Quy",
    className: "s13",
    d: "m-2729 3696.5c-7.5-15.5-8-42.5-1-42.5 5 0 16 19 25 42.5 4 11 3.5 12.5-7 12.5-7.5 0-13.5-4.5-17-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p75yW522L",
    className: "s13",
    d: "m-2870 3689c0-8 3.5-10 17.5-10 20 0 24.5 12 6.5 17-19 5-24 3.5-24-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GWkapI4f",
    className: "s13",
    d: "m-3222 3673c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Gxb12GLB",
    className: "s13",
    d: "m-2820 3658.5v-15l15 10.5c22 15.5 22.5 20 3 20-16.5 0-18-1-18-15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CAD1AwUm",
    className: "s13",
    d: "m233.5 3616c-2.5-47-0.5-62 9-62 7.5 0 12.5 27 12.5 71.5 0 29.5-1 33.5-9.5 33.5-8 0-9.5-5.5-12-43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgvTW6zUP",
    className: "s13",
    d: "m-2755 3634c0-18 6.5-19 17-4 11 15.5 10 19-4.5 19-10.5 0-12.5-2.5-12.5-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pu7Mv901q",
    className: "s13",
    d: "m-1745 3639c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15gfa3oey",
    className: "s13",
    d: "m-1720 3639c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pS2B8WYyL",
    className: "s13",
    d: "m-3227 3633c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16UyfZk5b",
    className: "s13",
    d: "m-3232 3585.5c-9.5-50.5-9.5-56.5 1.5-56.5 6.5 0 10.5 3 10.5 9 0 4.5 1.5 20.5 3 35 3 21.5 2 26-4.5 26-4.5 0-9-6-10.5-13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIJfBho13",
    className: "s13",
    d: "m-2940 3576.5c0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-8 0-10-3.5-10-15.5 0-12 1.5-14.5 6.5-11 3 3 60.5 46 127.5 96 66.5 50 121 91.5 121 93 0 1.5-8 2.5-17.5 2.5-12 0-17.5-2.5-17.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzlJatcDF",
    className: "s13",
    d: "m1701.5 3537c1.5-39 4.5-52 16-75.5 7.5-16 18-30 23-31 5.5-1.5 9.5-7 9.5-12 0-21 83-86.5 103.5-81.5 8.5 2.5 11.5 1 11.5-5 0-14.5 62-36 131.5-45.5 21-3 23.5-2 23.5 6.5 0 10-5.5 12-66 25.5-13 3-30.5 5.5-38.5 5.5-8.5 0-15.5 2-15.5 4.5 0 2.5-16.5 13-36 23-48.5 24.5-82.5 54.5-112 98.5-13.5 20-26 37.5-27.5 39-1.5 1.5-2.5 8-2.5 15 0 7-0.5 27.5-1 46.5-1 30-2 33.5-11.5 33.5-9.5 0-10-2.5-8-47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUgSOQcwF",
    className: "s13",
    d: "m515 3561.5c0-9-6-9.5-14-1.5-4.5 4.5-6 2.5-6-10 0-15 1-16 17.5-16 16.5 0 17.5 1 17.5 17.5 0 12-2.5 17.5-7.5 17.5-4 0-7.5-3.5-7.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p109HmmVh5",
    className: "s13",
    d: "m450.5 3525.5c4-5 10.5-11.5 14.5-15 4-3 5.5-7.5 3.5-10-5-5-174-8.5-197-4-13.5 2.5-16.5 5.5-16.5 15 0 9-2.5 12.5-10 12.5-7.5 0-10-3.5-10-13.5v-14l-84-1c-46-0.5-93-2.5-104.5-4l-21.5-3v-47.5-47l19 0.5c10 0.5 15 1.5 10 3-8.5 2-12.5 25-10 58l1.5 18.5 63.5 0.5c35 0.5 134.5 1 222 1.5 87 0 159.5 1.5 161 3.5 5.5 5-3.5 39.5-10 39.5-4 0-7 3.5-7 7.5 0 5-5 7.5-15.5 7.5-14.5 0-15-1-9-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3vW56jPA",
    className: "s13",
    d: "m508 3516.5c8.5-13 3.5-17-7-6.5-4.5 4.5-6 3.5-6-5 0-9 3-11 17.5-11 16.5 0 17.5 1 17.5 17.5 0 16-1 17.5-15 17.5-15 0-15 0-7-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pciKWcP4Q",
    className: "s13",
    d: "m-3242 3513c-5.5-21-3.5-29 7-29 8.5 0 10 3.5 10 20 0 22.5-11.5 28.5-17 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pURp2aZcz",
    className: "s13",
    d: "m-1176 3505.5c-18-4.5-10-16.5 11.5-16.5 16.5 0 20 1.5 18.5 9-1.5 8.5-14.5 12-30 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRV4nbR3y",
    className: "s13",
    d: "m-3247 3468c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HOXO4iyq",
    className: "s13",
    d: "m2332.5 3447.5c-7-11-9.5-21-7.5-31l2.5-14.5 13 16c9 12 12 21 10.5 31.5-2.5 18.5-6 18-18.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAvNbQrct",
    className: "s13",
    d: "m625 3426.5c0-15 1.5-17.5 12-17.5 11.5 0 12 1 6.5 17.5-3 9.5-8 17.5-12 17.5-4 0-6.5-6.5-6.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUbmO0txe",
    className: "s13",
    d: "m-3252 3428c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HBtgrW6D",
    className: "s13",
    d: "m-1720 3414c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmfE6HE9d",
    className: "s13",
    d: "m-3257 3388c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2Zb4elAM",
    className: "s13",
    d: "m628.5 3390.5c-2-1.5-3.5-10.5-3.5-20 0-15 1.5-16.5 15-16.5h15l-8.5 14-9 13.5 14-9 13.5-8.5v15c0 13.5-1.5 15-16.5 15-9.5 0-18.5-1.5-20-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11ACgRv2L",
    className: "s13",
    d: "m-3200 3381.5c0-4-4.5-7.5-10-7.5-8 0-10-3.5-10-15.5v-15l22.5 16c34.5 25 37 29.5 15.5 29.5-12.5 0-18-2-18-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFQ0KeroO",
    className: "s13",
    d: "m2254 3370c-13-8.5-19-16-19-24 0-6.5 2-12 4-12 9 0 47 31 42.5 34.5-3 1.5-6 5.5-7 8.5-1.5 3.5-9 1-20.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psPfBqlFw",
    className: "s13",
    d: "m-1650 3342c0-17 2-23 7.5-23 15.5 0 16.5 41 1 44-7 1.5-8.5-2-8.5-21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DllERaWs",
    className: "s13",
    d: "m-1425 3344c0-24 12.5-28 17.5-5 3.5 16.5 0.5 25-10.5 25-5 0-7-6-7-20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BPBEeTiK",
    className: "s13",
    d: "m-1200 3344c0-24 12.5-28 17.5-5 3.5 16.5 0.5 25-10.5 25-5 0-7-6-7-20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1ApBRRxFu",
    className: "s13",
    d: "m-3262 3343c-1.5-6.5-3-17-3-23.5 0-11.5 0.5-12 10-3 11.5 10.5 13.5 37.5 3 37.5-3.5 0-8-5-10-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ph6MWGUf6",
    className: "s13",
    d: "m2201 3341c-18-7.5-19-9.5-9.5-19.5 5.5-5 9.5-5 22.5 0.5 18 7.5 19 9.5 9.5 19.5-5.5 5-9.5 5-22.5-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p176LZ3rpu",
    className: "s13",
    d: "m703 3321.5c8.5-13 3.5-17-7-6.5-4.5 4.5-6 2.5-6-10 0-15 1-16 17.5-16 17.5 0 17.5 0 17.5 22.5 0 21.5-0.5 22.5-15 22.5-15 0-15 0-7-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvV230VKM",
    className: "s13",
    d: "m2133 3316.5c-8-4.5-18.5-6.5-24-4.5-15 4.5-44-7.5-44-18.5 0-9 2.5-9.5 26.5-6.5 52 7 71 13.5 72.5 26 2 13.5-9.5 14.5-31 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14NTzDdJy",
    className: "s13",
    d: "m235 3289c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p56WERfUX",
    className: "s13",
    d: "m316.5 2763c-23-5-30.5-19-10-19 29 0 48.5 6.5 48.5 15.5 0 10.5-6 11-38.5 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piqa8RTiA",
    className: "s13",
    d: "m450 2754c0-8 3.5-10 17.5-10 20 0 24.5 12 6.5 17-19 5-24 3.5-24-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17Vx9I2sK",
    className: "s13",
    d: "m246.5 2741.5c-21.5-9-21-17.5 1-17.5 15.5 0 17.5 1.5 17.5 12.5 0 7-0.5 12.5-1 12.5-1-0.5-9-3.5-17.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAsOgyr8s",
    className: "s13",
    d: "m194 2715c-18.5-11-17.5-16 3.5-16 15.5 0 17.5 1.5 17.5 12.5 0 14.5-3 15-21 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18sAcVkmV",
    className: "s13",
    d: "m-1668.5 2693c-26-12.5-27.5-19-4-19 9.5 0 17.5 2.5 17.5 5 0 3 5.5 5 12.5 5 9 0 12.5 2.5 12.5 10 0 13-11 12.5-38.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prGiR9Koq",
    className: "s13",
    d: "m-1345 2694c0-8 3.5-10 17.5-10 19.5 0 23 7 8 15-15.5 8-25.5 6-25.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwOEtOr0k",
    className: "s13",
    d: "m145 2679l-17.5-14.5 19-0.5c17.5 0 18.5 1 18.5 15 0 8.5-0.5 15-1.5 15-0.5 0-9-6.5-18.5-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phRB3MlvN",
    className: "s13",
    d: "m615 2679.5c0-14.5 1.5-15.5 18-15.5 19.5 0 19 4.5-3 20l-15 10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phzs3nNy",
    className: "s13",
    d: "m-2858.5 2672c-10-12-7.5-17 10-20.5 8.5-2 23.5-8 32.5-13 9-5 20.5-9.5 26-9.5 7.5 0 9.5-5.5 12.5-35 3-30.5 5-35 13.5-35 9 0 9.5 2 6.5 26.5-5.5 41-25.5 71-52 76.5-4 0.5-8.5 3.5-10 6.5-6 9-32.5 11.5-39 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pu2futBTM",
    className: "s13",
    d: "m-3353.5 2663.5c-14-4-16.5-7-16.5-19.5v-14.5l16.5 9c8.5 5.5 23.5 11 32.5 13 9 2 16 6.5 16 10.5 0 8-23 9-48.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2fDYKS7D",
    className: "s13",
    d: "m-1265 2647c0-16.5 1-18 15.5-18h15l-10.5 15c-15.5 22-20 22.5-20 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvc78wSNk",
    className: "s13",
    d: "m-3394.5 2636c-13.5-17.5-13-22 2-22 11 0 12.5 2 12.5 17.5 0 9.5-1 17.5-2 17.5-1.5 0-7-6-12.5-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzp0FBXhc",
    className: "s13",
    d: "m99 2634l-14-17.5 13-1.5c16.5-2 18-0.5 16 19.5l-1.5 17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paASm8fI7",
    className: "s13",
    d: "m2085 2633c-9.5-2.5-24.5-10-33-16.5-17-13-35-48-30.5-59.5 5-13 17.5-9 21 6.5 4.5 21.5 39.5 55.5 57 55.5 5 0 18.5-3.5 30-7.5 20-7 20.5-7 20.5 4.5 0 9-4 12.5-19.5 17-22 7-22 7-45.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p09w0etUx",
    className: "s13",
    d: "m-1745 2620.5c-4-8-8-15.5-9-17.5-1-2.5 4-4 11-4 11.5 0 13 2 13 17.5 0 21-6 22.5-15 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "podqOK9y1",
    className: "s13",
    d: "m-1235 2598c0-30.5 6.5-49 16-49 9 0 9.5 2.5 6.5 21.5-4 24-10.5 38.5-17.5 38.5-3 0-5-5-5-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11PFkyR6H",
    className: "s13",
    d: "m2170 2604.5c0-3-3.5-5.5-8-5.5-6.5 0-6-2 2-13.5 15.5-22.5 135.5-231 143.5-249.5 7.5-19 17.5-22.5 17.5-7 0 8 2.5 9.5 12 7 10-2.5 12 0 18 20 14.5 52 64.5 71.5 106.5 42l13.5-9.5v15c0 13-2 15.5-12.5 15.5-7 0-12.5 2.5-12.5 5 0 3-13.5 5-30.5 5-42 0-61.5-12.5-79-50l-13.5-28.5-37 64c-26 44.5-40 64.5-46 64.5-6.5 0-9 4-9 15 0 9-10.5 33.5-25.5 60-25 43.5-39.5 62.5-39.5 50.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pujvixB6w",
    className: "s13",
    d: "m63.5 2584.5c-11-19-11-20.5 4-20.5 11 0 12.5 2 12.5 17.5 0 21.5-5 22-16.5 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12Z4TNx33",
    className: "s13",
    d: "m-3412 2568c-7.5-28-1.5-69 10-69 5.5 0 7 9.5 7 40 0 30.5-1.5 40-7 40-3.5 0-8-5-10-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pe5RvorRp",
    className: "s13",
    d: "m-1762 2568c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvexh09nl",
    className: "s13",
    d: "m43 2544.5c-1.5-2-5-10-7.5-17.5-5-12-4-13 7-13 11 0 12.5 2 12.5 17.5 0 16.5-6 23-12 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQkLQCHvP",
    className: "s13",
    d: "m725 2532c0-16 1.5-18 12.5-18 12 0 12.5 0.5 6 16-9.5 23-18.5 24-18.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phRtJkNfj",
    className: "s13",
    d: "m2030 2518.5c0-21.5 24-64.5 36-64.5 7 0 9-4 9-17.5 0-15.5 1.5-17.5 12.5-17.5 7 0 12.5 1 12.5 2 0 6.5-62 113-65.5 113-2.5 0-4.5-7-4.5-15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbAox0EVY",
    className: "s13",
    d: "m-1420 2519c0-2.5-6.5-5-15-5-13.5 0-15-1.5-15-15v-14.5l16.5 9c8.5 5.5 23.5 11 32.5 13 22 4.5 21.5 17.5-1.5 17.5-9.5 0-17.5-2-17.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13WdHxsMv",
    className: "s13",
    d: "m-1325 2517c0-7 14.5-13 34-13 7.5 0 11 3 11 10 0 8.5-3.5 10-22.5 10-16 0-22.5-2-22.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptZUBEP0m",
    className: "s13",
    d: "m21 2483c-3-12-6.5-31-8.5-42.5-3-19-2-21.5 6-21.5 7.5 0 10.5 6.5 15.5 32.5 8 41.5 7.5 52.5-1 52.5-4 0-9-9-12-21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5VTVQqmJ",
    className: "s13",
    d: "m740 2492c0-26 6-43 15.5-43 11 0 11.5 3 4 33-6 23.5-19.5 30.5-19.5 10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEuPmqeaS",
    className: "s13",
    d: "m-1247.5 2481c6.5-7 13.5-19.5 15-27.5 4.5-21 17.5-19 17.5 3 0 9.5-2 17.5-5 17.5-2.5 0-5 4.5-5 10 0 8-3.5 10-17.5 10h-17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptBt3xAJa",
    className: "s13",
    d: "m-1485 2446.5c0-20 12-24.5 17-6 5 18.5 3.5 23.5-7 23.5-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plbnoatdj",
    className: "s13",
    d: "m-1765 2331.5c0-124 0.5-127.5 10-127.5 9.5 0 10 3.5 10 127.5 0 124-0.5 127.5-10 127.5-9.5 0-10-3.5-10-127.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pO92oa49E",
    className: "s13",
    d: "m2090 2394c0-7 3.5-10 11.5-10 15 0 20 5 13 13.5-9 10-24.5 8-24.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "po33lIRsx",
    className: "s13",
    d: "m2020 2377c0-11.5 1-12 17.5-6.5 9.5 3 17.5 8 17.5 12 0 4-6.5 6.5-17.5 6.5-15 0-17.5-1.5-17.5-12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcSnCggv9",
    className: "s13",
    d: "m2490 2371.5c0-14 2-17.5 10-17.5 11 0 13 10 5 25.5-8 15-15 11.5-15-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUo5ymjvw",
    className: "s13",
    d: "m1965 2351.5c0-15 1.5-15 20.5-4 19 11.5 18.5 16.5-3 16.5-15.5 0-17.5-1.5-17.5-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdia9l7fZ",
    className: "s13",
    d: "m1919 2335c-18.5-11-17.5-16 3.5-16 15.5 0 17.5 1.5 17.5 12.5 0 14.5-3 15-21 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwLgFbX7b",
    className: "s13",
    d: "m2478.5 2290.5c-7-27-14.5-61.5-16.5-76.5-2-15-5-28.5-7-30-1.5-1.5-9.5-13.5-17-27.5-12.5-23-13-26.5-7.5-46 8.5-30.5 21.5-29.5 18.5 1-1.5 12.5-1 22.5 0.5 22.5 6 0 18.5 31 27.5 67.5 4.5 19.5 12 45 15.5 57.5 4 12.5 9 35.5 10.5 51.5 3 23 2 28.5-4 28.5-5 0-11.5-15-20.5-48.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYrY7okct",
    className: "s13",
    d: "m-3410.5 2313c-2-33-3-259.5-1-270 1-8 5.5-14 9.5-14 6 0 7 23 7 145 0 125.5-1 145-7.5 145-4 0-7.5-3-8-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pD72xVsvX",
    className: "s13",
    d: "m1875 2304l-17.5-14.5 19-0.5c17.5 0 18.5 1 18.5 15 0 8.5-0.5 15-1.5 15-0.5 0-9-6.5-18.5-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17yC6Sxmb",
    className: "s13",
    d: "m725 2266.5c0-7-2-12.5-5-12.5-2.5 0-5-8-5-17.5 0-11-2.5-17.5-6.5-17.5-9 0-38.5-62-38.5-80 0-8.5 2-15 5-15 5 0 47.5 84 64.5 129l10.5 26h-12.5c-10 0-12.5-2.5-12.5-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGBJwwX8a",
    className: "s13",
    d: "m-1485 2231.5c0-14 2-17.5 10-17.5 10.5 0 12 5 7 24-5 18-17 13.5-17-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FOCzGFk3",
    className: "s13",
    d: "m-1230 2233.5c0-13-17.5-40.5-30.5-48-19-11.5-18.5-16.5 3-16.5 12 0 17.5 2.5 17.5 7.5 0 4 3.5 7.5 7.5 7.5 4 0 7.5 4.5 7.5 10 0 5.5 2.5 10 5 10 3 0 5 8 5 17.5 0 12-2.5 17.5-7.5 17.5-4 0-7.5-2.5-7.5-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxqvhuT9E",
    className: "s13",
    d: "m-2775 2226.5c0-4-2-7.5-5-7.5-2.5 0-5-6-5-13.5 0-7.5-5-18.5-11-25l-10.5-11.5h18c13 0 18.5 2 18.5 7.5q0 7.5 15 7.5c8.5 0 15-2 15-5 0-2.5 8-5 17.5-5 11.5 0 17.5 2.5 17.5 7 0 7.5-15 13-36 13-13 0-14 1.5-14 20 0 16.5-1.5 20-10 20-5.5 0-10-3.5-10-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUhErSI1f",
    className: "s13",
    d: "m1788 2196.5c-7.5-15-14.5-34-16-42.5-3-13-2-15 7-15 8 0 11.5 4 14 18.5 2 10.5 6.5 22 10.5 25.5 7.5 7.5 9 41 2 41-2.5 0-10.5-12.5-17.5-27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOPH2Xfv2",
    className: "s13",
    d: "m60.5 2205.5c9-24 36-71.5 40-71.5 9 0 4 30.5-9 57.5-10.5 21.5-16 27.5-25 27.5-10 0-11-1.5-6-13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5RQI0aow",
    className: "s13",
    d: "m-1450 2179c0-14 1.5-15 17.5-15 9.5 0 17.5-2 17.5-5 0-2.5 8-5 17.5-5 24.5 0 23.5 13.5-1 18-10.5 1.5-26.5 7.5-35 12.5l-16.5 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FbNbDl71",
    className: "s13",
    d: "m-2690 2166.5c0-17 10.5-27.5 27.5-27.5 12.5 0 12.5 0.5 5 12-4.5 7-13.5 16-20.5 20.5-11.5 7.5-12 7.5-12-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHN3nq1Mq",
    className: "s13",
    d: "m-1366 2170.5c-5-1-9-5.5-9-9.5 0-5 7-7 27.5-7 20 0 27.5 2 27.5 7 0 10.5-24 15.5-46 9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16QOFUBa0",
    className: "s13",
    d: "m-1306 2170.5c-16.5-4-10-16.5 8.5-16.5 14 0 17.5 2 17.5 10 0 10-7 11.5-26 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPPRqJJsb",
    className: "s13",
    d: "m-2842 2123c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poEO7twB3",
    className: "s13",
    d: "m-1762 2110.5c3.5-26.5 10-41.5 17-41.5 6 0 6 10 2 42-2.5 18.5-5.5 23-13 23-8.5 0-9.5-2.5-6-23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11vrl4xhL",
    className: "s13",
    d: "m-1230 2111.5c0-20 12-24.5 17-6 5 18.5 3.5 23.5-7 23.5-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14BbHdCHC",
    className: "s13",
    d: "m-2655 2106.5c0-14 2-17.5 10-17.5 10.5 0 12 5 7 24-5 18-17 13.5-17-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p83iH0wYZ",
    className: "s13",
    d: "m105 2121c0-6 52.5-92 56-92 2 0 4 8 4 17.5 0 12-2.5 17.5-7.5 17.5-4.5 0-7.5 4.5-7.5 12.5 0 9-2.5 12.5-10 12.5-8 0-10 3.5-10 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVCt4jfpN",
    className: "s13",
    d: "m1764.5 2115.5c-3-37.5-2-74 3.5-103 7-35 38.5-108.5 47-108.5 12 0-0.5 53.5-14.5 65-7 5.5-18.5 69-17.5 95 1 38-2.5 60-11 60-4 0-7.5-4-7.5-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdTwwpoIT",
    className: "s13",
    d: "m645 2101.5c0-8-3-12.5-7.5-12.5-4.5 0-7.5-4.5-7.5-12.5 0-8-3-12.5-7.5-12.5-4.5 0-7.5-4.5-7.5-12.5 0-8-3-12.5-7.5-12.5-4 0-7.5-3.5-7.5-7.5 0-4-2-7.5-5-7.5-2.5 0-5-8-5-17.5 0-9.5 2-17.5 4-17.5 4 0 76 115.5 76 122 0 1.5-5.5 3-12.5 3-10 0-12.5-2.5-12.5-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p153tVvutl",
    className: "s13",
    d: "m-3150.5 2096.5c-4.5-5-7-13.5-5.5-22.5 2-13.5 3-14 13-8 13 8.5 43 5 43-5.5 0-3.5 5-13.5 10.5-21.5l11-14.5-94.5-98c-75-77.5-95-101-96-113-1.5-15-1.5-15.5 9.5-8 16.5 12 130 125 127.5 127.5-1.5 1 16.5 19 40 40 30 28 42 42 42 50.5 0 8.5-10.5 22.5-35.5 46.5-36.5 35-50.5 40.5-65 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pv7cB1I1u",
    className: "s13",
    d: "m2442.5 2051.5c-2-15-2.5-32-1-37 3.5-13-13.5-72-30.5-105.5-7.5-15-14-29-15-31-1-2.5 3.5-4 10-4 14.5 0 28 22 44 70.5 10 32.5 16.5 100.5 11.5 123.5-5 21-15.5 12-19-16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7DtZFOu9",
    className: "s13",
    d: "m-2665 2053.5c0-3.5-3.5-8.5-8-11.5-5-4-7-11.5-6-20.5l1.5-14.5 15.5 16c21.5 21 25 36 9 36-6.5 0-12-2.5-12-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFkT5jxux",
    className: "s13",
    d: "m-1265 2036.5c0-10-2.5-12.5-12.5-12.5-10.5 0-12.5-2.5-12.5-15.5v-16l16 12.5c8.5 6.5 21.5 19.5 28 28l12.5 16h-16c-13 0-15.5-2-15.5-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17mZLIA33",
    className: "s13",
    d: "m-1154.5 2024.5c-7.5-6.5-10.5-14-9.5-23.5l1.5-13.5 16.5 15.5c16 15 19 26 8 29.5-3 1-10.5-2.5-16.5-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXTvjyFkK",
    className: "s13",
    d: "m-2845 2020.5c0-17 6-31.5 13-31.5 5 0 7 6.5 7 20 0 16.5-1.5 20-10 20-6 0-10-3.5-10-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GCb5u0nc",
    className: "s13",
    d: "m-3403.5 2016.5c-9-10-8-16.5 6-40.5 10.5-18 38.5-42 49.5-42 1.5 0 3 5.5 3 12.5 0 7-3 12.5-6.5 12.5-3.5 0-9.5 4.5-13.5 10-4 5.5-11 10-16 10-5 0-9 2.5-9 5 0 3 3 5 7 5 6 0 6 3 1.5 17.5-5.5 18.5-12 21.5-22 10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYIY0qLYh",
    className: "s13",
    d: "m165 2021c0-6 27.5-47 31.5-47 2 0 3.5 8 3.5 17.5 0 9.5-2 17.5-5 17.5-2.5 0-5 3.5-5 7.5 0 4.5-4.5 7.5-12.5 7.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CyZklK6e",
    className: "s13",
    d: "m-1712.5 2014c4-6 35.5-26.5 49-31.5 6.5-2.5 8.5-0.5 8.5 9 0 10-2.5 12.5-12.5 12.5-8 0-12.5 3-12.5 7.5 0 5.5-5.5 7.5-18 7.5-11 0-16.5-2-14.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pspiFv9t5",
    className: "s13",
    d: "m-2750 1981c0-7 1.5-12 4-11 36.5 17.5 40 24 13.5 24-15.5 0-17.5-1.5-17.5-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwcFmzVrm",
    className: "s13",
    d: "m-1358.5 1987.5c-16.5-5.5-23-18.5-9-18.5 10 0 10-35.5 0.5-54-10.5-20.5-23-29.5-49-36-27.5-7-33-20-9-20 32.5 0 75 33 75 58 0 6.5 2.5 12 5 12 3 0 5 9 5 20 0 17 2 21 15 27.5 8.5 4.5 15 10 15 12.5 0 6.5-27.5 5-48.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn5FHYHIU",
    className: "s13",
    d: "m-2838.5 1971c1.5-9.5 0-14-6.5-15.5-6-1.5-8-6-6-15 2-11 4-12 17.5-9.5 8.5 1.5 16 3.5 16.5 4.5 0.5 0.5 0 11.5-1.5 25-2.5 19-4.5 23.5-12.5 23.5-8.5 0-9.5-2.5-7.5-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pg68Xb9Gw",
    className: "s13",
    d: "m-1635 1979c0-2.5 4.5-7 10-10 5.5-3 10-8.5 10-12.5 0-4 3.5-7.5 7.5-7.5 4 0 7.5 3.5 7.5 8 0 4.5 4.5 9 10 10.5 5.5 1.5 10 6 10 9.5 0 5-7.5 7-27.5 7-15 0-27.5-2-27.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjUvpWKpW",
    className: "s13",
    d: "m-1225 1964l-17.5-14.5 17.5-0.5c13 0 23 4.5 35 15l17.5 14.5-17.5 0.5c-13 0-23-4.5-35-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxskYTf7y",
    className: "s13",
    d: "m-3293.5 1959.5c-21.5-10.5-21-20.5 1-20.5 16 0 17.5 1 17.5 15 0 8.5-0.5 14.5-1 14.5-1-0.5-9-4.5-17.5-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pizsCN0jM",
    className: "s13",
    d: "m-1615 1931.5c0-21 31-57.5 56.5-67 11.5-4.5 13.5-4 13.5 4 0 8.5-18.5 20.5-32 20.5-3.5 0-9.5 11.5-13 25-5 18.5-9 25-16 25-5 0-9-3.5-9-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15mXCaOEL",
    className: "s13",
    d: "m-1263.5 1929c-6.5-5.5-11.5-13.5-11.5-17.5 0-11 17-9 27.5 2.5 5 5.5 6.5 10 3.5 10-3 0-6 3.5-7 8-1 6.5-3.5 6-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwbbheP31",
    className: "s13",
    d: "m248 1893c41.5-59.5 67-94 69.5-94 1.5 0 2.5 8 2.5 17.5 0 15.5-1.5 17.5-12.5 17.5-11 0-12.5 2-12.5 17.5 0 15.5-1.5 17.5-12.5 17.5-11 0-12.5 2-12.5 17.5 0 9.5-2 17.5-5 17.5-2.5 0-5 3.5-5 7.5 0 4-2 7.5-5 7.5-2.5 0-5 3.5-5 7.5 0 5-5 7.5-15.5 7.5h-15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8YVtMglp",
    className: "s13",
    d: "m510 1896.5c0-4-2-7.5-5-7.5-2.5 0-5-4.5-5-10 0-5.5-3.5-10-7.5-10-5 0-7.5-5.5-7.5-17.5 0-15.5-1.5-17.5-12.5-17.5-9 0-12.5-2.5-12.5-10 0-5.5-3.5-10-7.5-10-5 0-7.5-5.5-7.5-17.5 0-9.5 1-17.5 2.5-17.5 2 0 51.5 65.5 82 109l11 16h-15c-10.5 0-15.5-2.5-15.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13Jt4j3qw",
    className: "s13",
    d: "m-1238 1872c-4.5-12-0.5-14 28-17 23-2 25-1.5 25 8.5 0 8-3 10.5-13.5 10.5-8 0-19 1.5-25 3-8 2-12.5 0.5-14.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GYj2vAFZ",
    className: "s13",
    d: "m1830 1876c0-6 17-32 21-32 2 0 4 8 4 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqHGkDiXh",
    className: "s13",
    d: "m-1170 1864c0-9.5 3.5-10 61.5-10 67 0 83.5 2.5 83.5 13 0 5.5-14 7-72.5 7-69 0-72.5-0.5-72.5-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pviCD3mgZ",
    className: "s13",
    d: "m2378.5 1855.5c-2-1.5-3.5-8.5-3.5-15.5 0-9.5-2-11.5-9.5-9.5-6 1.5-16-3-26-11.5l-16.5-13.5 13.5-2.5c14.5-3 40 15 58.5 41l10.5 15h-12c-6.5 0-13.5-1.5-15-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pljTGTzYs",
    className: "s13",
    d: "m1865 1819c15.5-22 20-22.5 20-3 0 16.5-1 18-15.5 18h-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pP2mqw4oQ",
    className: "s13",
    d: "m-1275 1819.5c0-7.5 3-10.5 10.5-10.5 12.5 0 11 16.5-2 19-6 1-8.5-1.5-8.5-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxfuyGHX6",
    className: "s13",
    d: "m-3427 1816c-3-8 9.5-29.5 24.5-42 6.5-5.5 7.5-4 7.5 12 0 11.5-2.5 19.5-7.5 21-4 2-7.5 6-7.5 10 0 9.5-13 9-17-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbP9gZxI7",
    className: "s13",
    d: "m-1252.5 1804.5l-14.5-3 16-13c12-9 21-12 31-10.5 16.5 2.5 16 6.5-4 20-9 6-18.5 8-28.5 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15HBlTwPT",
    className: "s13",
    d: "m-3381 1771.5c-1.5-15.5 0-20 12.5-30.5 18-15.5 21.5-15 25 2 1.5 7.5 2 13.5 2 13.5-0.5 0-9.5 7.5-19 16.5l-18.5 17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTDBbM5f",
    className: "s13",
    d: "m-1207.5 1764.5l-14.5-3 16-13c12-9 21-12 31-10.5 16.5 2.5 16 6.5-4 20-9 6-18.5 8-28.5 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16iKCZTEB",
    className: "s13",
    d: "m2245 1751.5c0-15 1.5-15 20.5-4 19 11.5 18.5 16.5-3 16.5-15.5 0-17.5-1.5-17.5-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13eP9zM7R",
    className: "s13",
    d: "m1940 1750c0-4.5 22.5-18.5 41.5-25.5 12-5 13.5-4 13.5 6.5 0 7.5-4.5 13.5-12.5 17-14.5 7-42.5 8-42.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pU8ofMY1f",
    className: "s13",
    d: "m375 1719c6-8 12.5-15 15-15 2.5 0 9 7 15 15l10.5 15h-25.5-25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1G385WtX0",
    className: "s13",
    d: "m-1177.5 1724c1.5-2.5 9.5-9.5 17.5-15l15-10.5v15c0 14.5-1.5 15.5-18 15.5-10 0-16.5-2-14.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17jmw7zKx",
    className: "s13",
    d: "m2139 1720.5c-10-1.5-14-5-14-12 0-11 1.5-11.5 35-4 15.5 3.5 25 8 25 12.5 0 7-15 8-46 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13u4gOHby",
    className: "s13",
    d: "m2045 1712c0-6.5 14-13 29-13 3 0 6 4.5 6 10 0 8-3.5 10-17.5 10-11.5 0-17.5-2.5-17.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjAaQtdvQ",
    className: "s13",
    d: "m-3340 1138c0.5-18.5 7-29.5 15.5-27.5 5.5 1.5 9.5 0.5 9.5-2 0-2.5 6-4.5 14-4.5 7.5 0 19-4.5 26-10 7-5.5 15-10 18.5-10 3 0 6.5-2 7.5-4.5 2-5.5 112-75.5 119-75.5 13 0 1 10-51 42.5-30.5 19.5-58 36-61 37-3 1-6.5 3.5-8 5.5-4 5.5-81 55-85.5 55-2.5 0-4.5-3-4.5-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plNgIonzN",
    className: "s13",
    d: "m-1671 1070.5c-5-1-9-5.5-9-9.5 0-5 6.5-7 25-7 18 0 25 2 25 7 0 10-20.5 15-41 9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pg0LU0y0Q",
    className: "s13",
    d: "m364 1005.5c-12-3-11.5-15 0.5-19 13-4 35.5 2 35.5 10 0 10.5-15.5 14.5-36 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pis9eGUf0",
    className: "s13",
    d: "m416.5 1006c-13-5.5-6-16.5 12.5-19.5 64-10.5 98-23.5 142.5-56 13-9.5 23.5-15 23.5-12 0 3 4 5.5 9 5.5 12 0.5-24.5 31-59 49.5-40 21-112 39.5-128.5 32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppPJTDLIb",
    className: "s13",
    d: "m-3121 993c8.5-8.5 7.5-29-1-29-4 0-13 2-20 5-11.5 4.5-13 3.5-13-7 0-12.5 10.5-18 36.5-18 8.5 0 13.5 2.5 13.5 7.5 0 4 4.5 7.5 10 7.5 5.5 0 10 2 10 4.5 0 8.5-26 35.5-34 35.5-6 0-6.5-1.5-2-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYHHFj9az",
    className: "s13",
    d: "m-1505 982c0-10 2.5-18 5-18 3 0 5-4.5 5-10 0-7.5 3.5-10 13-10 7 0 11.5 1.5 10.5 4-1 2-5.5 11.5-10 21.5-4.5 10-11.5 21-16 24.5-6.5 5.5-7.5 3.5-7.5-12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pX1rrrlyf",
    className: "s13",
    d: "m296.5 986.5c-19.5-8.5-21.5-17.5-3.5-17.5 22.5 0 57 11 57 18 0 9.5-32 9-53.5-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14UlwEyA1",
    className: "s13",
    d: "m2096.5 981.5l-14-12 16-0.5c22 0 31.5 4.5 31.5 15.5 0 13.5-16.5 12-33.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BjPQ09Ql",
    className: "s13",
    d: "m2150 984.5c0-11 9.5-15.5 31.5-15.5l16 0.5-14 12c-17 15-33.5 16.5-33.5 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZvMNCAVU",
    className: "s13",
    d: "m-3207 981c-5.5-14.5-3-22 7-22 5.5 0 10 2.5 10 5 0 3 4.5 5 10 5 12.5 0 13 8 0.5 15-14 7-24 6-27.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1vOc9ged",
    className: "s13",
    d: "m212.5 942c-24.5-15-51.5-33-59-40-7.5-7-16-13-18.5-13-2.5 0-12.5-8-22.5-17.5-12.5-12.5-17.5-22.5-17.5-33v-15.5l29 29.5c18.5 18.5 51.5 42.5 91 66 68.5 40.5 67.5 39.5 64.5 42.5-10.5 9.5-26 5-67-19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXplJjwbr",
    className: "s13",
    d: "m2075 953.5c-7-12.5-1.5-39.5 7.5-39.5 8 0 14.5 25.5 10 40-4 13-10.5 13-17.5-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17RIrpNbh",
    className: "s13",
    d: "m2187.5 954.5c-4-13.5 2.5-35.5 10.5-35.5 9.5 0 14 22 7 34.5-6.5 13-13.5 13.5-17.5 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pslw4RHDB",
    className: "s13",
    d: "m-3211.5 924c-1.5-6.5-5-9-10.5-7-6 2-8 0-8-7.5 0-8.5 3-10.5 17.5-10.5 16.5 0 17.5 1 17.5 17.5 0 19.5-12 25-16.5 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3m0z5y5A",
    className: "s13",
    d: "m-3075 916.5c0-15.5 1.5-17.5 12.5-17.5 15 0 15 1.5 4 20.5-11.5 19-16.5 18.5-16.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTNZ32E5R",
    className: "s13",
    d: "m-3333 898c3.5-17 6.5-22 10.5-18 4.5 4-3.5 34-8.5 34-3 0-4-6.5-2-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1H0IFwJrb",
    className: "s13",
    d: "m609 898.5c10-10.5 7-14.5-9-11-13 2.5-15 1.5-15-8 0-9.5 3-10.5 25.5-10.5h25l-1.5 16.5c-1.5 13.5-3.5 16-16.5 17.5-12 1.5-14 0.5-8.5-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1aybMWNf",
    className: "s13",
    d: "m-1470 871.5c0-14 2-17.5 10-17.5 10.5 0 12 5 7 24-5 18-17 13.5-17-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DSL4mUSg",
    className: "s13",
    d: "m529 885.5c-16.5-4-10-16.5 8.5-16.5 14 0 17.5 2 17.5 10 0 10-7 11.5-26 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWRPXSkwq",
    className: "s13",
    d: "m-3327 865.5c6-16.5 84-151.5 88-151.5 2 0 4 8 4 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 12-2.5 17.5-7.5 17.5-4.5 0-7.5 4.5-7.5 12.5 0 7.5-3 12.5-7 12.5-4.5 0-8 6-9 14-1 9.5-4.5 14-12.5 15-9 1.5-11 0-8.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqNSRj3u7",
    className: "s13",
    d: "m-3040 856.5c0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-15.5 1.5-17.5 12.5-17.5 7 0 12.5 1 12.5 2.5 0 6-37.5 67.5-41 67.5-2 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQkDwOmdS",
    className: "s13",
    d: "m444 840c-27-15.5-49-30-49-32 0-2 8-4 17.5-4 14 0 17.5 2 17.5 10 0 8 3.5 10 17.5 10 14 0 17.5 2 17.5 10 0 8 3.5 10 17.5 10 15.5 0 17.5 1.5 17.5 12.5 0 7-1.5 12.5-3.5 12-2.5 0-26-13-52.5-28.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p159vyxoPr",
    className: "s13",
    d: "m655 846.5c0-12 2.5-17.5 7.5-17.5 4 0 7.5-4.5 7.5-10 0-7.5 3.5-10 12.5-10 7 0 12.5 2 12.5 4.5 0 4.5-34 50.5-37.5 50.5-1.5 0-2.5-8-2.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyBibWlNu",
    className: "s13",
    d: "m-1445 807c0-27 23.5-64 37.5-60 5.5 2 11 4 11.5 5 3 2-16 32-20 32-2 0-4 3-4 7 0 4-5.5 14-12.5 21.5l-12 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVNKi7CXJ",
    className: "s13",
    d: "m55 791.5c-19.5-41.5-26.5-77-26-140 0-39.5 2.5-57 12-82 11.5-32.5 24-45.5 24-26 0 6 3 10.5 7.5 10.5 4 0 7.5 2.5 7.5 5.5 0 3 3.5 8.5 7.5 12.5 4 4.5 7.5 12 7.5 17.5 0 5 2.5 9.5 5 9.5 3 0 5 4 5 9.5 0 5 4.5 10.5 10 12 7 1.5 10 7 10 15.5 0 11 2 13 14.5 13 21 0 30.5 5 30.5 15.5 0 7.5 3.5 9.5 17.5 9.5 14 0 17.5 2 17.5 10 0 8 3.5 10 17.5 10 15.5 0 17.5 1.5 17.5 12.5 0 7-1 12.5-2.5 12.5-4.5 0-108.5-60-122-70.5-17-13.5-40.5-48.5-44-65.5-1.5-7.5-4.5-13-6.5-11.5-7 4.5-15.5 48.5-16 84.5 0 38.5 10 113 16 113 6 0 15 24.5 15 40 0 23.5-8 17.5-25-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p113VypuDy",
    className: "s13",
    d: "m1780.5 796.5c-10.5-9.5-21.5-25.5-24.5-36-6-20-3.5-41.5 5-41.5 2.5 0 3.5-2 2-4.5-6-9 25-31 131.5-92 76-44 114-63.5 125-63.5 11.5 0 15.5-2.5 15.5-8.5 0-5 8-14 17.5-20.5 13.5-8.5 18-15.5 20.5-31 2-12 6-20 10-20 6 0 9.5 9.5 7.5 21.5 0 2 2 3.5 4.5 3.5 7.5 0 79.5-42 80-46 0-2.5-6-4-13.5-4-8-0.5-26-4.5-41-9.5-26-9-27-9-29 0-4 14.5-15.5 11.5-19-5.5-2-8-15.5-27-31.5-43.5-16-16-34-39-40-51.5l-11-22.5 10.5-1.5q19.5-3 19.5 25.5c0 10 2.5 13.5 10 13.5 8 0 10 3.5 10 15 0 13.5 1.5 15 15 15q15 0 15 7.5c0 4 3.5 7.5 7.5 7.5 4 0 7.5 3 7.5 6.5 0 3.5 19 10.5 46.5 17.5 56.5 13.5 63.5 14 63.5 1 0-5.5 3.5-10 7.5-10 4 0 7.5 3.5 7.5 7.5 0 10 9.5 9.5 27.5-2.5 19.5-13 22.5-12.5 22.5 2.5 0 10.5-2.5 12.5-15 12.5q-15 0-15 7.5c0 5-5.5 7.5-17.5 7.5-9.5 0-17.5 2.5-17.5 5 0 3 9 5 20 5 16.5 0 20 1.5 20 10 0 5.5 3 10 6.5 10 12.5 0 29.5 23 27.5 38l-1.5 14-20.5-19.5c-11-11-24.5-26.5-30-34.5l-10.5-14.5-34.5 20c-22 13-44 21.5-60.5 24-23.5 3-26.5 4.5-26.5 15.5 0 7-3 12-7 12-4 0-8 2-9 4.5-3.5 10-99 60.5-113.5 60.5-11.5 0-15.5 2.5-15.5 9 0 6-22 21.5-72.5 50.5-102.5 59-114 75.5-77.5 113 19 19 20 19.5 39.5 14.5 14.5-4 21-4 22.5 0 1 3 2.5 2 2.5-2 1-18 95.5-58.5 95.5-41 0 7.5-29 21-44.5 21-11.5 0-15.5 2-15.5 9 0 13.5-42 35-69 35-17.5 0.5-25-2.5-40.5-16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CnnX02kY",
    className: "s13",
    d: "m690 789c0-20.5 10-40 21-40 7 0 9-4 9-17.5 0-15.5 1.5-17.5 12.5-17.5 7 0 12.5 1 12.5 2 0 6.5-46.5 88-50.5 88-2.5 0-4.5-6.5-4.5-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPQruvXMX",
    className: "s13",
    d: "m331.5 775c-17.5-10-31.5-20-31.5-22 0-2 8-4 17.5-4 14 0 17.5 2 17.5 10 0 8 3.5 10 17.5 10 15.5 0 17.5 1.5 17.5 12.5 0 7-1.5 12.5-3.5 12.5-2.5-0.5-18-8.5-35-19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdgubhNny",
    className: "s13",
    d: "m-2985 761.5c0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-15.5 1.5-17.5 12.5-17.5 7 0 12.5 1 12.5 2.5 0 6-37.5 67.5-41 67.5-2 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phnRboYT8",
    className: "s13",
    d: "m1950 730c0-7.5 194.5-116 208-116 9 0 12.5-2 10.5-7-1.5-4 2-9 9-12 10-4.5 12.5-4 14 3 1.5 6 2.5 5.5 3-2.5 0.5-6.5 3.5-11.5 8-11.5 4 0 7.5-2 7.5-4 0-7.5 29-21 44.5-21 12.5 0 15.5-2 15.5-10.5 0-10 2-10.5 26.5-7.5 14 1.5 30 3 35 3 5 0 8.5 4 8.5 10 0 11.5-5.5 12.5-27.5 4.5-14-5-19-4-50 12.5-43.5 23-51.5 30.5-55.5 51-3 16.5-17 24.5-17 10 0-15-10.5-12.5-52.5 10.5-28.5 16-43.5 27.5-45.5 35.5-3 10.5-17 16-17 6 0-2.5-4.5-5-10-5-5.5 0-10 3-10 6.5 0 10-71.5 48.5-89.5 48.5-8.5 0-15.5-1.5-15.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdRgNVuIZ",
    className: "s13",
    d: "m-1375 700.5c0-16 10.5-46.5 16-46.5 2 0 4-6.5 4-15 0-13 2-15 13-15 10.5 0 12.5 1.5 9.5 9-2 4.5-8 20-12.5 34-15.5 44-30 60.5-30 33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEKwCRfsZ",
    className: "s13",
    d: "m-3225 686.5c0-6 37.5-67.5 41-67.5 2 0 4 8 4 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1-12.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pL9CfPI0r",
    className: "s13",
    d: "m-1570 686.5c0-7.5 31-62.5 35-62.5 8 0 6 28-3.5 47.5-6 12.5-11.5 17.5-20 17.5-6.5 0-11.5-1-11.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXfoxJlxh",
    className: "s13",
    d: "m-2930 669.5c0-19.5 4.5-30.5 13-30.5 4 0 7-5 7-12.5 0-9 2.5-12.5 10-12.5 8 0 10-3.5 10-17.5 0-12 2.5-17.5 7.5-17.5 4 0 7.5-4.5 7.5-9.5 0-17.5 6-25.5 18-25.5 6.5 0 12 1.5 12 3 0 6.5-77.5 137-81 137-2.5 0-4-6.5-4-14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pj6bslUoA",
    className: "s13",
    d: "m775 636.5c0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-15.5 1.5-17.5 12.5-17.5 7 0 12.5 1 12.5 2.5 0 6-37.5 67.5-41 67.5-2 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwLQ5TsjJ",
    className: "s13",
    d: "m-1500 584c0-14 1.5-15 17.5-15 9.5 0 17.5 2 17.5 4.5 0 2.5-8 9-17.5 15l-17.5 10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDZfIRp10",
    className: "s13",
    d: "m-1315 576.5c0-15.5 1.5-17.5 12.5-17.5 15 0 15 1.5 4 20.5-11.5 19-16.5 18.5-16.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3jmQJUAf",
    className: "s13",
    d: "m2155 581.5c0-7 2.5-12.5 5-12.5 3 0 5-5.5 5-12.5 0-10.5-2.5-12.5-15-12.5-16 0-21-11.5-7-17 10.5-4 10-4.5 23.5 8.5 16 15 19.5 27 12.5 40-11 21-24 24.5-24 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbWbfvxa9",
    className: "s13",
    d: "m-1438.5 583c-22.5-7.5-21.5-19 1-19 15.5 0 17.5 1.5 17.5 12.5 0 7-0.5 12.5-1 12-1-0.5-9-3-17.5-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prxF3X4rM",
    className: "s13",
    d: "m2359 570.5c-16.5-4-10-16.5 8.5-16.5 14 0 17.5 2 17.5 10 0 10-7 11.5-26 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkG6zLbCo",
    className: "s13",
    d: "m2395 564c0-8.5 3.5-10 20-10 22.5 0 28.5 11.5 9 17-21 5.5-29 3.5-29-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paWEFQ5WN",
    className: "s13",
    d: "m2440 554c0-8 3.5-10 17.5-10 19.5 0 23 7 8 15-15.5 8-25.5 6-25.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plwylVvIS",
    className: "s13",
    d: "m-3150 556c0-6 92.5-162 96-162 2 0 4 8 4 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 12-2.5 17.5-7.5 17.5-4.5 0-7.5 4.5-7.5 12.5 0 9-2.5 12.5-10 12.5-8 0-10 3.5-10 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwa2JrYlx",
    className: "s13",
    d: "m-1290 536.5c0-12 2.5-17.5 7.5-17.5 4.5 0 7.5-4.5 7.5-12.5 0-10 2.5-12.5 12.5-12.5 7 0 12.5 1.5 12.5 3 0 6-32.5 57-36 57-2.5 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxK5Xs3sb",
    className: "s13",
    d: "m835 534.5c0-22.5 5-30.5 18-30.5 14.5 0 14.5 1.5 1 25.5-13 23-19 25-19 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwoiAvnNQ",
    className: "s13",
    d: "m-1475 531c0-6.5 22-42 26-42 4.5 0 5.5 25.5 1 37-3 7.5-27 12-27 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p159sJz3zx",
    className: "s13",
    d: "m2515 515.5c0-16.5 8-26.5 21-26.5 6.5 0 9-4 9-12.5 0-10 2.5-12.5 12.5-12.5 7 0 12.5 2 12.5 4.5 0 6.5-31.5 44.5-44 53.5-10.5 7.5-11 7-11-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p146IOGx4a",
    className: "s13",
    d: "m-2835 501.5c0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-15.5 1.5-17.5 12.5-17.5 7 0 12.5 1 12.5 2.5 0 6-37.5 67.5-41 67.5-2 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWru0BdPf",
    className: "s13",
    d: "m-1440 466c0-6 17-32 21-32 2 0 4 8 4 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Beu4Jih5",
    className: "s13",
    d: "m106 436.5c14.5-22 19-22 19 0 0 16-1 17.5-15 17.5h-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvOahKslS",
    className: "s13",
    d: "m2572 428c8.5-58.5 9-59 19-59 8.5 0 9.5 2.5 6 24-4 29.5-14.5 56-22.5 56-4 0-5-6.5-2.5-21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCiFwQsoD",
    className: "s13",
    d: "m-1215 411.5c0-15.5 1.5-17.5 12.5-17.5 15 0 15 1.5 4 20.5-11.5 19-16.5 18.5-16.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwZllEaKD",
    className: "s13",
    d: "m-2780 409.5c0-19.5 4.5-30.5 13-30.5 4 0 7-5 7-12.5 0-9 2.5-12.5 10-12.5 8 0 10-3.5 10-17.5 0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-15.5 1.5-17.5 12.5-17.5 7 0 12.5 1 12.5 2.5 0 6-77.5 137.5-81 137.5-2 0-4-6.5-4-14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRhyhsoi1",
    className: "s13",
    d: "m-1410 411c0-6 17-32 21-32 2 0 4 8 4 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQjvvkXhU",
    className: "s13",
    d: "m130 401.5c0-6 72.5-127.5 76-127.5 2.5 0 4 8 4 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 12-2.5 17.5-7.5 17.5-4.5 0-7.5 4.5-7.5 12.5 0 10-2.5 12.5-12.5 12.5-7 0-12.5-1-12.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13rXarvSe",
    className: "s13",
    d: "m2310 390c0-3.5 74.5-47.5 236-140.5 16-9 20-6 31.5 21 7.5 18.5 7.5 18.5-4 18.5-8 0-14-4.5-17.5-12.5-7-15-21-16.5-21-2.5 0 8-3.5 10-17.5 10-14 0-17.5 2-17.5 10 0 8-3.5 10-17.5 10-14 0-17.5 2-17.5 10 0 7.5-3.5 10-12.5 10-7.5 0-12.5 3-12.5 7 0 7.5-10.5 13-25.5 13-5 0-9.5 3.5-9.5 7.5 0 5-5.5 7.5-17.5 7.5-14 0-17.5 2-17.5 10 0 7.5-3.5 10-12.5 10-8 0-12.5 3-12.5 7.5 0 5-5.5 7.5-17.5 7.5-9.5 0-17.5-2-17.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXksbecWE",
    className: "s13",
    d: "m915 366.5c0-14 2-17.5 10-17.5 10.5 0 12 5 7 24-5 18-17 13.5-17-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pc9TvFFuD",
    className: "s13",
    d: "m2190 359c0-22.5 11.5-28.5 17-8.5 5.5 20.5 3.5 28.5-7 28.5-8.5 0-10-3.5-10-20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pySQb1fKk",
    className: "s13",
    d: "m-1385 366c0-6 55.5-97 67.5-110.5l12-14 0.5 19c0 10-2 18.5-5 18.5-2.5 0-5 3.5-5 7.5 0 4-2 7.5-5 7.5-2.5 0-5 3.5-5 7.5 0 4-3.5 7.5-7.5 7.5-4.5 0-7.5 4.5-7.5 12.5 0 9-2.5 12.5-10 12.5-8 0-10 3.5-10 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqiSSoQA2",
    className: "s13",
    d: "m2578 335.5c-4.5-30-3.5-41.5 4-41.5 4.5 0 9 9.5 12.5 25 7 33.5 7 35-4 35-7 0-10-5-12.5-18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CDSdFeGX",
    className: "s13",
    d: "m915 326.5c0-20 12-24.5 17-6 5 18.5 3.5 23.5-7 23.5-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWl7VJqxz",
    className: "s13",
    d: "m-1165 312c0-16 1.5-18 12.5-18 12 0 12.5 0.5 6 16-9.5 23-18.5 24-18.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPSC7mOfE",
    fillRule: "evenodd",
    className: "s13",
    d: "m-3000 296.5c0-6.5 92-162.5 96-162.5 2 0 4 4.5 4 10 0 5.5 3.5 10 7.5 10 5.5 0 7.5-5.5 7.5-21 0-31 4.5-44 15.5-44 7.5 0 9.5-3.5 9.5-19.5 0-11 3.5-23 7.5-27.5 4-4 7.5-9.5 7.5-12.5 0-3 2.5-5.5 5-5.5 3 0 5-3.5 5-7.5 0-4 4.5-7.5 10-7.5 7.5 0 10-3.5 10-12.5 0-8.5 2.5-12.5 9-12.5 7.5 0 9 5 9 37.5 0 32.5-1.5 37.5-9 37.5-6.5 0-9 4-9 14 0 7.5-5.5 23.5-12.5 35.5-9.5 16-12.5 29-12.5 51 0 26-1 29.5-10 29.5-5.5 0-10-2-10-5 0-2.5-2-5-5-5-2.5 0-5 3.5-5 7.5 0 10-8.5 9.5-14.5-1-5-8.5-5-8.5-5.5 0 0 13.5-16.5 8.5-20.5-6.5l-3.5-12.5-0.5 14c-0.5 10-3 13.5-10.5 13.5-8 0-10 3.5-10 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1-12.5-2.5zm142-160.5c2-9.5 12.5-34.5 23.5-55.5 25.5-48 24-65.5-2-23.5-20.5 34-33.5 67-33.5 85 0 18.5 8.5 14 12-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDgFJVsnM",
    className: "s13",
    d: "m900 281.5c0-8-3-12.5-7.5-12.5-5 0-7.5-5.5-7.5-17.5 0-16.5-1-17.5-17.5-17.5-16.5 0-17.5-1-17.5-15.5 0-14 1-15 9-9 29.5 22.5 53.5 51 62.5 76 2.5 6.5 0.5 8.5-9 8.5-10 0-12.5-2.5-12.5-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11WnfcL4s",
    className: "s13",
    d: "m1977.5 260c-1.5-8-1-28 2-45 5-31.5 28-86 36-86 7 0 5.5 33.5-2 41-9 9.5-18.5 50-18.5 79 0 28.5-12 35.5-17.5 11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkt0I86ja",
    className: "s13",
    d: "m-2792.5 266c-40-10.5-42.5-12-42.5-31 0-15.5 1-17 6.5-9.5 16.5 22.5 75.5 31 111 16.5 23.5-10 22.5-10 22.5 4 0 8-3.5 13-11 15-17 4.5-75 8-86.5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8krgIUmS",
    className: "s13",
    d: "m-1135 242c0-10 2.5-18 5-18 3 0 5-5.5 5-12.5 0-7 2.5-12.5 5-12.5 3 0 5-5.5 5-12.5 0-7 2.5-12.5 5-12.5 3 0 5-5.5 5-12.5 0-7 2.5-12.5 5-12.5 3 0 5-5.5 5-12.5 0-10 2.5-12.5 12.5-12.5h12.5l-8.5 21.5c-34 85.5-45 110.5-50.5 112.5-4 1-6-4.5-6-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AisNSQEq",
    className: "s13",
    d: "m220 246c0-6 17-32 21-32 2 0 4 8 4 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPsruoJ5Z",
    className: "s13",
    d: "m-2670 219c0-16.5 24.5-60 33.5-60 4 0 6.5-6.5 6.5-15q0-15 7.5-15c4 0 7.5-3.5 7.5-7.5 0-4-4-7.5-8.5-7.5-6.5 0-4-4.5 9-18l17-17.5 3.5 16.5c2.5 14-0.5 22.5-20.5 56.5-13.5 22-29.5 49.5-35.5 61.5-14 24.5-20 26.5-20 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNn4vDiq9",
    className: "s13",
    d: "m-1275 194c15.5-22 20-22.5 20-3 0 16.5-1 18-15.5 18h-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2Df8cfPQ",
    className: "s13",
    d: "m250 196c0-6 47.5-82 51-82 2.5 0 4 8 4 17.5 0 12-2.5 17.5-7.5 17.5-4.5 0-7.5 4.5-7.5 12.5 0 8-3 12.5-7.5 12.5-4.5 0-7.5 4.5-7.5 12.5 0 10-2.5 12.5-12.5 12.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pErXRYypj",
    className: "s13",
    d: "m785 181.5c0-15 1.5-15 20.5-4 19 11.5 18.5 16.5-3 16.5-15.5 0-17.5-1.5-17.5-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWdy8y5mK",
    className: "s13",
    d: "m-1235 143c8-12 23-30.5 32.5-41.5l17-20 0.5 19c0 15-1.5 18.5-10 18.5-7.5 0-10 3.5-10 12.5 0 8-3 12.5-7.5 12.5-4 0-7.5 4.5-7.5 10 0 8-3.5 10-15.5 10h-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plUHGd52T",
    className: "s13",
    d: "m-2711 145.5c-5-1-9-5.5-9-9.5 0-5 6.5-7 22-7 12 0 31-3.5 42.5-7.5 19.5-6.5 20.5-6.5 20.5 3 0 5.5-5 11.5-11.5 14-16 6-54 10.5-64.5 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbYH74jsU",
    className: "s13",
    d: "m-2764.5 122c-22-16.5-30-28.5-25.5-40 3-9 4-8.5 14.5 5.5 6.5 8.5 20 20 31 26 10.5 6 19.5 13 19.5 16 0 9-23 4.5-39.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pI9w2ivBr",
    className: "s13",
    d: "m675 119c0-8-3.5-10-17.5-10-15.5 0-17.5-1.5-17.5-12.5 0-7 1-12.5 2.5-12.5 6 0 67.5 37.5 67.5 41 0 2-8 4-17.5 4-14 0-17.5-2-17.5-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLwD6pLS",
    className: "s13",
    d: "m-1080 102c0-16 1.5-18 12.5-18 12 0 12.5 0.5 6 16-9.5 23-18.5 24-18.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piI1HsU51",
    className: "s13",
    d: "m2055 83.5c19-16 64.5-39.5 77-39.5 4.5 0 8 4.5 8 10 0 7-3.5 10-10.5 10-5.5 0-13.5 3.5-17.5 7.5-4.5 4-14.5 7.5-22.5 7.5-11 0-14.5 2.5-14.5 10 0 8.5-3.5 10-18.5 10l-19-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZo3tz0YV",
    className: "s13",
    d: "m591.5 80.5c-6.5-2.5-9.5-26.5-3.5-26.5 6.5 0 42 22 42 26 0 4.5-28.5 5-38.5 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqlIA1rpr",
    className: "s13",
    d: "m-1065 62c0-16 1.5-18 12.5-18 12 0 12.5 0.5 6 16-9.5 23-18.5 24-18.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAc2nfMye",
    className: "s13",
    d: "m-2580 46.5c0-14 2-17.5 10-17.5 10.5 0 12 5 7 24-5 18-17 13.5-17-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCaiTmMNu",
    className: "s13",
    d: "m-1160 49c15.5-22 20-22.5 20-3 0 16.5-1 18-15.5 18h-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMjDNGljw",
    className: "s13",
    d: "m2160 47c0-7 14.5-13 34-13 7.5 0 11 3 11 10 0 8.5-3.5 10-22.5 10-16 0-22.5-2-22.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSua8mEUv",
    className: "s13",
    d: "m516.5 38c-7-3.5-11.5-10-11.5-17 0-10.5 1.5-11.5 13.5-6.5 19 7 41.5 21 41.5 25.5 0 6-30.5 4-43.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSbBqPNiR",
    className: "s13",
    d: "m-1050 25.5c0-26 5.5-36.5 18-36.5h12l-9 23.5c-10 27-21 34-21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16IqgpDgh",
    className: "s13",
    d: "m370 30c0-3.5 8.5-9 31.5-20 2-1 3.5 4 3.5 11 0 11.5-2 13-17.5 13-9.5 0-17.5-2-17.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAb5rKHY1",
    className: "s13",
    d: "m435 12c0-8.5 18.5-13.5 34-9.5 20.5 5 13 16.5-11.5 16.5-16 0-22.5-2-22.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GYaED8QV",
    className: "s13",
    d: "m-2815-25c0-16 44.5-60.5 60.5-61 8.5 0 14-3.5 16-9.5 2.5-10.5 46.5-23.5 63-18 6 1.5 16.5 4 24 5.5 23 4.5 41.5 18 41.5 31v11.5l-13.5-9.5c-25-17.5-53.5-23.5-83-16.5-32.5 7.5-57.5 24.5-73.5 50.5-8.5 14-16 20-23.5 20-6.5 0-11.5-1.5-11.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVV5k3rgJ",
    className: "s13",
    d: "m-1018.5-70c2.5-23.5 2-25.5-8-27-10-1.5-9.5-3 10.5-22.5 11.5-12 23.5-21.5 26.5-21.5 12.5 0-11.5 89.5-25 94-5.5 2-6.5-2.5-4-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piZ7n2miL",
    className: "s13",
    d: "m-1060-71c15.5-22 20-22.5 20-3 0 16.5-1 18-15.5 18h-15z"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "l3t0py0cgwQ8VejkuWN3GGU"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pi92IPutX",
    className: "s14",
    d: "m-1745 1059c-54-11.5-81-21-84-28.5-1-4.5 4-6.5 16-6.5 10 0 18 2.5 18 5 0 3 4 5 9 5 4.5 0 29.5 4 54.5 8.5 37.5 7.5 46.5 10.5 46.5 18 0 10.5-5.5 10.5-60-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17rCH7Kdq",
    className: "s14",
    d: "m-1625 1060.5c0-7 6-11 22.5-15.5 28-7.5 47.5-7.5 47.5-0.5 0 6-25.5 17.5-51 22-16.5 3-19 2.5-19-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1B0bLSZOI",
    className: "s14",
    d: "m-1490 947c0-10 2-18 4-18 3.5 0 11-34.5 19-88.5 3-18.5 5-21.5 15.5-21.5 10 0 12 2 9 9-2 4.5-7 26-11 47.5-8 46-21.5 84.5-30.5 87.5-4 1-6-4-6-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HyVx3iS",
    fillRule: "evenodd",
    className: "s14",
    d: "m386 805.5c-159.5-92.5-140.5-81.5-206-118.5-62.5-35-82.5-52-98-85.5-9-19-12-33.5-11.5-60 0-43 6.5-61.5 35.5-103 12-17.5 47-74.5 76.5-127 86.5-150.5 89.5-155 104.5-156.5 11.5-1.5 13-4 13-20 0.5-41 41-96.5 84.5-115 13-6 38.5-12 56.5-14 42.5-4.5 72.5 4.5 136.5 41 154.5 87.5 283 164 301.5 179.5 12 10.5 27 31 36.5 50 15 30.5 15.5 34.5 13.5 76-2.5 49-16 82.5-44 110.5-8 8.5-15 20-15 25.5 0 9-61 123.5-69.5 130.5-1.5 1.5-8.5 13.5-15.5 27-6.5 13.5-14.5 27-17.5 30-5.5 6.5-19.5 32.5-59 109.5-42 82.5-65.5 98.5-144 98.5h-42zm218.5 55.5c36.5-10.5 56-31 87-92 15-29 55.5-102 90-162 35-60.5 62.5-110.5 62-111-0.5-0.5-13.5 2-28.5 6-40 11-79.5 6.5-119.5-14-18-9-100-55.5-182-103-81.5-47-150.5-86-152.5-86-5 0-20.5 25-75 120-50 88-93 162-117 202-11.5 19-13 25.5-8 29 10.5 6.5 340 197 354 204 29.5 15.5 54.5 17.5 89.5 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6YFuoLTq",
    className: "s14",
    d: "m-1474 801.5c-7-15-8-42.5-2-42.5 2.5 0 8.5 8 14 17.5 10.5 20 11 20.5 20 9 6-8 6.5-7 7 10 0 17.5-0.5 18.5-16.5 18.5-13 0-18-3-22.5-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FBhhsfB8",
    className: "s14",
    d: "m-1595 711.5c0-4 3.5-7.5 7.5-7.5 4 0 9.5-4.5 12.5-10 8-15.5 15-12 15 7.5 0 16.5-1 17.5-17.5 17.5-12 0-17.5-2.5-17.5-7.5z"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "l30Dkdh67xHVoaLyeuXpgxe"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ptHDeHMTZ",
    className: "s15",
    d: "m1970 4771.5c0-22 13-24 17.5-2.5 3 12.5 4.5 14.5 10.5 9.5 5.5-4.5 7-4 7 2.5 0 6-4.5 8-17.5 8-16.5 0-17.5-1-17.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwzINYnee",
    className: "s15",
    d: "m2103 4748c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4ZDVBIb8",
    className: "s15",
    d: "m1925 4722c0-4 9.5-9 22-12.5 30-7.5 33-7 33 4 0 6.5-5 10-15.5 12.5-25.5 5-39.5 3.5-39.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5f13wksf",
    className: "s15",
    d: "m2090 4691.5c0-8 7.5-10 49-15 23-2.5 26-2 26 6.5 0 8-5 10-26 13-40 4.5-49 4-49-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkCxbAfAj",
    className: "s15",
    d: "m1921.5 4659c-1.5-6.5-7-10-14.5-10-9.5 0-12-2.5-12-12.5 0-15.5 0.5-15.5 28 0.5 23.5 14 25.5 16.5 16 26-8.5 8.5-14.5 7.5-17.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8povHNdu",
    className: "s15",
    d: "m2126.5 4641c-22.5-13.5-26-22-14-32 4-3.5 15.5-17.5 25.5-31.5 13-18 15.5-24 9-21.5-5.5 2-15.5 5-23 6.5-12 2.5-14 1-14-8 0-11.5 10-13.5 39.5-7.5 13.5 3 15.5 5 15.5 20.5 0 10.5-3 18-7.5 19.5-4 2-7.5 6-7.5 10 0 4-4.5 7-10 7-7.5 0-10 3.5-10 12.5 0 10 2.5 12.5 12.5 12.5 10 0 12.5 2.5 12.5 12.5 0 15.5-2 15.5-28.5-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBFUGtoHM",
    className: "s15",
    d: "m1880 4594c0-8 3.5-10 17.5-10 20 0 24.5 12 6.5 17-19 5-24 3.5-24-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plj2LnAJj",
    className: "s15",
    d: "m1920 4589c0-5.5 3.5-10 7.5-10 5 0 7.5-5.5 7.5-17.5 0-26 12.5-22.5 19.5 6 7 26 3.5 31.5-20.5 31.5-10.5 0-14-2.5-14-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPD99YIFg",
    className: "s15",
    d: "m2068.5 4570.5c-2-1.5-3.5-9.5-3.5-17.5 0-10.5 2.5-14 10-14 5.5 0 10 3.5 10 7.5 0 4 4.5 7.5 10 7.5 13.5 0 12.5 13-1 17-15 4-21.5 3.5-25.5-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psY5Ore18",
    className: "s15",
    d: "m1991.5 4547.5c-7.5-6.5-22.5-18-32.5-25.5l-19-14 3 15.5c3 13.5 2 15.5-7.5 15.5-8.5 0-10.5-3-10.5-17 0-18.5 6-23 30.5-23 9.5 0 14.5 2.5 14.5 7.5 0 4 4.5 7.5 10 7.5 5.5 0 10 3 10 7 0 4 5 8 11.5 9 8 1 11.5 5.5 12.5 15.5 2 16.5-4 17-22.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pH5fvJkPU",
    className: "s15",
    d: "m2035 4496.5c0-16.5 1-17.5 17.5-17.5 16.5 0 17.5 1 17.5 17.5 0 9.5-2 17.5-5 17.5-2.5 0-5-6-5-13.5l-0.5-14-8.5 14c-11 18-16 17-16-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15zUV6rnq",
    className: "s15",
    d: "m-3202.5 941.5c-1.5-18-5-32.5-6.5-32.5-2 0.5-9 3.5-16 7.5-7 4-21 7-31 7.5-18 0-19-1-19-16 0-9 5.5-25.5 11.5-36.5 38-65 281-486.5 314.5-545 22-38.5 43-72.5 46.5-75 5.5-4.5 5-10.5-0.5-32.5-4-15-7-34.5-7-43.5 0-15 1.5-16.5 15.5-16.5 16.5 0 23 5 33.5 25 3.5 7 16 23 28 36 17 18.5 26 24.5 42.5 27 15.5 2.5 20.5 5.5 20.5 12.5 0 12.5-17.5 12.5-46 0-25.5-11-62-49.5-66.5-71-2-8-5-15.5-7.5-17-2-1.5-1 10 2.5 25 13 58 48.5 87.5 104 87.5 25 0 63.5-10 63.5-16.5 0-1.5-10.5-1.5-23.5-0.5-18 1.5-21.5 1-14-2.5 5.5-2.5 17.5-5 27-5l16.5-0.5-3.5 34c-4 40 13 7.5-198.5 375-163 282-165.5 286-181 286-8.5 0-27.5 4.5-42 10-14.5 5.5-33.5 10-43 10h-17z"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "l1las6VxVd5UZkpAqPgK0yO"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "phTpVJODO",
    className: "s16",
    d: "m522 5214.5c-24.5-16-49-34-54-40l-9.5-10.5h18.5c14.5 0 19.5 2 21.5 10 1.5 5.5 7 10 12 10 6 0 9.5 3.5 9.5 10 0 8 3.5 10 15 10q15 0 15 7.5c0 4 4.5 7.5 10 7.5 8.5 0 10-3.5 10-20 0-13.5 2-20 7-20 11 0 17.5 37.5 10 57-5 13.5-18.5 9-65-21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNNe60bOw",
    className: "s16",
    d: "m-1241.5 5214c-10-8-113.5-178.5-113.5-187.5 0-1.5 5.5-2.5 12.5-2.5 11 0 12.5 2 12.5 17.5 0 14 2 17.5 10 17.5 7.5 0 10 3.5 10 12.5 0 8 3 12.5 7.5 12.5 5 0 7.5 5.5 7.5 17.5 0 14 2 17.5 10 17.5 8 0 10 3.5 10 17.5 0 14 2 17.5 10 17.5 7.5 0 10 3.5 10 12.5 0 8 3 12.5 7.5 12.5 4 0 7.5 4 7.5 9.5 0 6.5 4.5 10 15 12.5 10.5 2 15 5.5 15 13 0 13-14.5 13-31.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxwzCac1C",
    className: "s16",
    d: "m-1170 5169c0-33 8-39.5 17-13.5 5.5 15-0.5 39-10.5 42.5-5 1.5-6.5-6.5-6.5-29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p55qaqIg0",
    className: "s16",
    d: "m-3381.5 5185.5c-2-1.5-3.5-12-3.5-22.5 0-13.5 2-19 7.5-19 4 0 7.5 3 7.5 6.5 0.5 18 7 19.5 89.5 19 78-1 80.5-0.5 80.5 9.5 0 9.5-3 10-89 10-49 0-91-1.5-92.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGMu0bP7q",
    className: "s16",
    d: "m-3165 5177c0-7 9.5-10 45-14.5 9.5-1.5 9 10.5 10-253.5 1-240.5 1-242-28-247.5-10.5-2-17-6-17-10.5 0-7 10-7.5 76.5-6 89.5 2 95.5 4.5 103.5 40.5 5.5 27 7 302.5 1.5 410.5-2 42-5.5 71.5-9.5 77-5.5 7.5-18 8.5-94 10-77 2-88 1-88-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10ksZW68",
    className: "s16",
    d: "m561 5126.5c-8-41.5-7.5-52.5 1-52.5 7 0 14 21.5 20.5 64 3 18.5 2 21-6 21-7.5 0-10.5-6.5-15.5-32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZK4h3veL",
    className: "s16",
    d: "m429 5134l-14-17.5 13-1.5c16.5-2 18-0.5 16 19.5l-1.5 17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phQ8F0Qkq",
    className: "s16",
    d: "m-1200 5101.5c0-8-3-12.5-7.5-12.5-5 0-7.5-5.5-7.5-17.5 0-14-2-17.5-10-17.5-8 0-10-3.5-10-17.5 0-14-2-17.5-10-17.5-8 0-10-3.5-10-17.5 0-9.5 1.5-17.5 4-17.5 3.5 0 76 121.5 76 127.5 0 1.5-5.5 2.5-12.5 2.5-10 0-12.5-2.5-12.5-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBgFhzFjl",
    className: "s16",
    d: "m404 5100.5c-4.5-5-39.5-64.5-78.5-132l-70.5-123.5-20-3c-26-4-28-18-2.5-18 12 0 17.5 2.5 17.5 7.5 0 5 5 7.5 14.5 7.5 15.5 0 20.5 7 20.5 30.5 0 11 2.5 14.5 10 14.5 8 0 10 3.5 10 17.5 0 14 2 17.5 10 17.5 7.5 0 10 3.5 10 12.5 0 8 3 12.5 7.5 12.5 5 0 7.5 5.5 7.5 17.5 0 14 2 17.5 10 17.5 8 0 10 3.5 10 17.5 0 14 2 17.5 10 17.5 8 0 10 3.5 10 17.5 0 14 2 17.5 10 17.5 7.5 0 10 3.5 10 12.5 0 8 3 12.5 7.5 12.5 5 0 7.5 5.5 7.5 17.5 0 20-0.5 20.5-11 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXy9oQDME",
    className: "s16",
    d: "m2208 5076.5c-6-6.5-48-76.5-93.5-155-45-78-83.5-142.5-85.5-142.5-1.5 0-13 15.5-25 35-12 19-23 34.5-25 35-3.5 0-6-11-11.5-48.5-3-19.5-2.5-21.5 7-21.5 8 0 10.5 3.5 11 14 0.5 8 1.5 10 3 5 1-5 4.5-9 7-9 2.5 0 4.5-3.5 4.5-7.5 0-4 2.5-7.5 5-7.5 3 0 5-3.5 5-7.5 0-5 5.5-7.5 17.5-7.5 14 0 17.5 2 17.5 10 0 5.5 3.5 10 7.5 10 4.5 0 7.5 4.5 7.5 12.5 0 8 3 12.5 7.5 12.5 5 0 7.5 5.5 7.5 17.5 0 14 2 17.5 10 17.5 8 0 10 3.5 10 17.5 0 14 2 17.5 10 17.5 8 0 10 3.5 10 17.5 0 14 2 17.5 10 17.5 7.5 0 10 3.5 10 12.5 0 8 3 12.5 7.5 12.5 5 0 7.5 5.5 7.5 17.5 0 14 2 17.5 10 17.5 8 0 10 3.5 10 17.5 0 14 2 17.5 10 17.5 8 0 10 3.5 10 17.5 0 14 2 17.5 10 17.5 6.5 0 10 3.5 10 9.5 0 5 4.5 10.5 10 12 7 1.5 10 7 10 15.5 0 16.5-7 16.5-22 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4RrHBnyZ",
    className: "s16",
    d: "m2240 5079.5c0-10.5 9.5-15.5 28-15.5 9.5 0 12-2.5 12.5-13.5 1-22-1-34-6-35.5-2.5-1-4.5-9.5-4.5-19 0-13.5-2-17-10-17-8 0-10-3.5-10-17.5 0-9.5 2-17.5 4-17.5 4.5 0 43 67 48 83 5 16.5-4.5 35-25.5 49-22.5 15.5-36.5 17-36.5 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTctJAYsG",
    className: "s16",
    d: "m528 5031c-1.5-4.5-3-14.5-3-22.5 0-11-2.5-14.5-10-14.5-8 0-10-3.5-10-17.5 0-14-2-17.5-10-17.5-8 0-10-3.5-10-17.5 0-9.5 2-17.5 4-17.5 4 0 56.5 89 62.5 106.5 2.5 6.5 0.5 8.5-8.5 8.5-6.5 0-13.5-3.5-15-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pe8qxpXoZ",
    className: "s16",
    d: "m-1370 4999.5c-8-15.5-6-25.5 5-25.5 8 0 10 3.5 10 17.5 0 19.5-7 23-15 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HcirGVpp",
    className: "s16",
    d: "m-1285 4956.5c0-10-2.5-12.5-12.5-12.5-8 0-12.5-3-12.5-7.5 0-4-3.5-7.5-7.5-7.5-4.5 0-7.5-4.5-7.5-12.5 0-8-3-12.5-7.5-12.5-6.5 0-7.5-6-6.5-33.5 1.5-31 2.5-34 13-35.5 9-1.5 11-5 11-18.5 0-9 3.5-20 7.5-24.5 4-4 7.5-12 7.5-17.5 0-7 3-10.5 10-10.5 5.5 0 10 3 10 7 0 13-16 45.5-35 71l-19 25.5 14.5 23.5c8 13 25 33 37 45 25.5 24 28 33 10 33-10 0-12.5-2.5-12.5-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzgd63LAj",
    className: "s16",
    d: "m-1391.5 4934.5c-11-19-11-20.5 4-20.5 11 0 12.5 2 12.5 17.5 0 21.5-5 22-16.5 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRtWQeHBH",
    className: "s16",
    d: "m-1506 4921c-5-1.5-9-6-9-10 0-5.5 7.5-7 31.5-7 19 0 41-4 57.5-10l26-10v12c0 9-4 13.5-16 17.5-18 6.5-77.5 11-90 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWDvA2J60",
    className: "s16",
    d: "m-1551 4908.5c-14.5-8-10.5-14.5 8.5-14.5 14 0 17.5 2 17.5 10 0 11-12 13-26 4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7xacX9Wn",
    className: "s16",
    d: "m448 4891c-1.5-4.5-3-12-3-17.5 0-5-3.5-9.5-7.5-9.5-5 0-7.5-5.5-7.5-17.5 0-14-2-17.5-10-17.5-7.5 0-10-3.5-10-12.5 0-8-3-12.5-7.5-12.5q-7.5 0-7.5-15 0-15-7.5-15c-5 0-7.5-5.5-7.5-17.5 0-15.5 1.5-17.5 12.5-17.5 13 0 15 3 8 14-2.5 4.5 9.5 29 35.5 72.5 21.5 36.5 39 67.5 39 70 0 7-24 3.5-27-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQ57PTuiJ",
    className: "s16",
    d: "m-1602 4880c-18.5-14-53-54-53-61.5 0-2.5 4-4.5 9-4.5 12 0 71 59 71 71 0 12.5-5 11.5-27-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ph5Mqpv2X",
    className: "s16",
    d: "m2195 4866.5c0-14-2-17.5-10-17.5-8 0-10-3.5-10-17.5 0-9.5 2-17.5 4-17.5 3.5 0 41 61.5 41 67.5 0 1.5-5.5 2.5-12.5 2.5-11 0-12.5-2-12.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRR1TcEk2",
    className: "s16",
    d: "m-1665 4786c0-22 9-21 18.5 2 6.5 15.5 6 16-6 16-11 0-12.5-2-12.5-18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHeVyweWL",
    className: "s16",
    d: "m2140 4771.5c0-14-2-17.5-10-17.5-8 0-10 3.5-10 15 0 14-1.5 15-17.5 15-12 0-17.5-2.5-17.5-7.5 0-4-4.5-7.5-10-7.5-8 0-10-3.5-10-15.5v-15.5l16.5 12c25.5 19 28 20 25 9-2-7 0-10 5.5-10 5.5 0 8-4.5 8-15q0-15-7.5-15c-5 0-7.5-5.5-7.5-17.5 0-16.5 1-17.5 17.5-17.5 12 0 17.5 2.5 17.5 7.5 0 4-3 7.5-7 7.5-14 0-12.5 8 8 42.5 27 47 27.5 47.5 12 47.5-11.5 0-13-2-13-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CCeViny8",
    className: "s16",
    d: "m183.5 4765.5c1.5-5 6-13.5 9.5-18.5 5-7 5-11.5 1-16.5-4-5-2.5-6.5 8-6.5 11.5 0 13 2 13 17.5 0 9.5-2 17.5-5 17.5-2.5 0-5 3.5-5 7.5 0 4.5-4.5 7.5-12.5 7.5-9.5 0-11.5-2-9-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUUx0R9iN",
    className: "s16",
    d: "m1963 4758c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqOPlA8nn",
    className: "s16",
    d: "m-1682 4743c-7-27-1-64 10-64 5.5 0 7 9 7 37.5 0 28.5-1.5 37.5-7 37.5-3.5 0-8-5-10-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poFWgnz1O",
    className: "s16",
    d: "m1855 4733c8-12 23-30.5 32.5-41.5l17-20 0.5 19c0 15-1.5 18.5-10 18.5-7.5 0-10 3.5-10 12.5 0 7.5-3 12.5-7 12.5-3.5 0-8 4.5-9.5 10-1.5 7-7 10-16 10h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1H5e0AJBt",
    className: "s16",
    d: "m-1290 4723c0-14.5-4.5-38.5-10-52.5l-10-26.5h12c9.5 0 13.5 4 17 16.5 13.5 42.5 12 88.5-2 88.5-5 0-7-7-7-26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIIuaYj74",
    className: "s16",
    d: "m388 4706c-1.5-4.5-3-15-3-23.5l0.5-16 12 14c15 17 16.5 33.5 3 33.5-5 0-11-3.5-12.5-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pllKrJoiR",
    className: "s16",
    d: "m167 4693.5c-12.5-20-12-64.5 0.5-64.5 5.5 0 12.5 33.5 12.5 61.5 0 9.5-7.5 11.5-13 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWozrmj5n",
    className: "s16",
    d: "m2145 4689c0-8 3.5-10 17.5-10 20 0 24.5 12 6.5 17-19 5-24 3.5-24-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzcGq3m6H",
    className: "s16",
    d: "m2185 4674c0-11 1.5-20 3.5-20 1.5 0 14.5 7.5 28.5 16l25 16.5-19.5 3.5c-36.5 6.5-37.5 6-37.5-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzPbYSLSV",
    className: "s16",
    d: "m-3384 4663l1.5-21.5 31.5-1.5c28.5-1.5 31-0.5 31 9 0 8.5-3 10-22.5 10-19.5 0-22.5 1.5-25.5 12.5-1.5 7-6.5 12.5-10.5 12.5-5.5 0-6.5-5.5-5.5-21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkRAVihL5",
    className: "s16",
    d: "m-1675 4656c0-10.5 9-27 15-27 3 0 5 8 5 17.5 0 14-2 17.5-10 17.5-5.5 0-10-3.5-10-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEsIVXKWf",
    className: "s16",
    d: "m2145 4641.5c0-15 1.5-15 20.5-4 19 11.5 18.5 16.5-3 16.5-15.5 0-17.5-1.5-17.5-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16e0pgRkN",
    className: "s16",
    d: "m303 4641c-4.5-11-3.5-37 1-37 4.5 0 14.5 16 21 33 4 10.5 3.5 12-7 12-6.5 0-13.5-3.5-15-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poOVuqaet",
    className: "s16",
    d: "m1871.5 4632.5c-27.5-16.5-31-21-20-25 3-1 0-1.5-7.5-0.5-7.5 1-18-2-24.5-7.5l-11-9 24-3c17-2.5 25.5-1.5 28.5 2.5 3 5 4 5 4 0.5 0-3.5 8.5-7.5 19-9 49-8 47.5-7.5 44-23-1.5-8-4.5-21-6-29.5-3-12.5-1.5-15 7-15 7 0 10.5 4.5 13 15.5 4.5 23 3.5 39.5-2 39.5-2.5 0-5 5.5-5 12.5 0 11-2 12.5-16.5 12.5-9 0-18.5 2-21 4.5-3 2.5-9.5 5.5-15 6.5-8.5 2-8 3.5 6 12 11 6 16.5 13.5 16.5 21 0 14-2.5 14-33.5-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmQu39VFo",
    className: "s16",
    d: "m-1660 4620c0-8.5 32-48 34-42 1 3 5 6 9 6 5.5 0 4 5.5-6.5 20-9 13-18 20-25 20-6.5 0-11.5-2-11.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbHtKq3V0",
    className: "s16",
    d: "m-1325 4607.5c0-7-4.5-13-11-16-6.5-3-13.5-10-16.5-16-3-7-9-11.5-16-11.5-6.5 0-11.5-2-11.5-4.5 0-2.5-5.5-6-12.5-7.5-9-2.5-12.5-6.5-12.5-15.5 0-11 1-11.5 14-7 26.5 9 91 69.5 91 85 0 2.5-5.5 4.5-12.5 4.5-9.5 0-12.5-2.5-12.5-11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSRRMmZYB",
    className: "s16",
    d: "m235 4579c0-10.5 5-12 24-7 18 5 13.5 17-6.5 17-14 0-17.5-2-17.5-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZiPmg2fZ",
    className: "s16",
    d: "m2155 4572c0-16.5 1-18 15.5-18h15l-10.5 15c-15.5 22-20 22.5-20 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGFqANLbh",
    className: "s16",
    d: "m-1617.5 4564c1.5-2.5 9.5-9.5 17.5-15l15-10.5v15c0 14.5-1.5 15.5-18 15.5-10 0-16.5-2-14.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12a5P9lMw",
    className: "s16",
    d: "m2070 4536.5c0-20.5 12-24.5 17-5 2 7 6.5 12.5 10.5 12.5 4 0 7.5 2.5 7.5 5 0 3-8 5-17.5 5-16.5 0-17.5-1-17.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pX0GBpxSW",
    className: "s16",
    d: "m2120 4547c0-6.5 14-13 29-13 3 0 6 4.5 6 10 0 8-3.5 10-17.5 10-11.5 0-17.5-2.5-17.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pc4FpJBSZ",
    className: "s16",
    d: "m1985 4536.5c0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-8 0-10-3.5-10-15.5v-15l23 16.5c12.5 9 24 18 25 20 6 9.5 17 2.5 27.5-16 14-24.5 19.5-25.5 19.5-2.5 0 14-2 17.5-10 17.5-7.5 0-10 3.5-10 12.5 0 11-2 12.5-17.5 12.5-12 0-17.5-2.5-17.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plmHc22Ok",
    className: "s16",
    d: "m2165 4537c0-6.5 39.5-20 44.5-15.5 1 1.5-2 7-7 12.5-10.5 11.5-37.5 14-37.5 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15zt9U9Gm",
    className: "s16",
    d: "m-1565 4534.5c0-10 35.5-21.5 72-23 43.5-2 83 5.5 83 15.5 0 5.5-10.5 6.5-53.5 6-30-0.5-64.5 1-77.5 3.5-17.5 2.5-24 2-24-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZNX9c3E6",
    className: "s16",
    d: "m2065 4496.5c0-20 12-24.5 17-6 5 18.5 3.5 23.5-7 23.5-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puJJ7QjnW",
    className: "s16",
    d: "m1910.5 4481c-3.5-13-5-24-4-25 1-1.5 7.5 2.5 14.5 7.5 9.5 8 12 13.5 10 25-3 23-14 19-20.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prpyzhEsW",
    className: "s16",
    d: "m2040 4476.5c0-2.5 7.5-15.5 16-29.5l16.5-25 4 24c2 13.5 3 25 2 26.5-4.5 4-38.5 7.5-38.5 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prOlqZDxe",
    className: "s16",
    d: "m517 3986.5c-2-4.5-2-9-1-10 3.5-3.5 32-6.5 70.5-7 26-0.5 33.5-2 33.5-8 0-4 2.5-7.5 5-7.5 3 0 5 4.5 5 10 0 5.5 2.5 10 5.5 10 3 0 4.5 4 3.5 8.5-1.5 7.5-10 8.5-60.5 10-49.5 1.5-59 0.5-61.5-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13mbmc64F",
    className: "s16",
    d: "m-1181.5 3940.5c-10-9.5-2.5-16.5 19-16.5 16 0 22.5 2 22.5 7 0 11-32.5 18.5-41.5 9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puyOp63Nt",
    className: "s16",
    d: "m-3192 3913c-4.5-18-3.5-23 6-25.5 7-2 7.5-2.5 0.5-3-7.5-0.5-14.5-14-14.5-29 0-3.5 4.5-6.5 10-6.5 7.5 0 10 3.5 10 12.5 0 9 2.5 12.5 10 12.5 7.5 0 10-3.5 10-12.5 0-10.5 2.5-12.5 15.5-12.5 14 0 15 1 9 9-8 10-45 57-50 62.5-1.5 2.5-4.5-1-6.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12cUdPv5K",
    className: "s16",
    d: "m-2735 3909c0-8.5 3.5-22.5 8-31l8-15-42 1.5c-36 2-41.5 1-43-6.5-1.5-7 2-9 16-9 19.5 0 26-6.5 23.5-24.5-1.5-12.5 6.5-20.5 21-20.5 8 0 9 2.5 6 19.5l-3 19.5 22.5 3c12.5 2 23 6.5 23 9.5 0 10.5-29.5 68.5-35 68.5-2.5 0-5-7-5-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPtqHV7Uh",
    className: "s16",
    d: "m2374 3896c-5-1.5-9-5.5-9-9.5 0-4.5 10.5-7.5 34-9.5 18.5-1.5 41.5-4 51.5-6 12-2 19.5-1 22 3 5.5 9-4.5 16-26 18-10.5 1-29 3-41.5 4-12.5 1.5-26.5 1-31 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10B4zFhO7",
    className: "s16",
    d: "m2329 3890.5c-5-1-9-4-9-6 0-2.5-5-3-11-2-6.5 1-16-1-21-5-8.5-6-8.5-8-3-14.5 5.5-6 10.5-6.5 23.5-2.5 9 3 16.5 7 16.5 9.5 0 2 7 4 15 4 11.5 0 15 2 15 10 0 10-7 11.5-26 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pw5wso5bN",
    className: "s16",
    d: "m125 3871.5c0-19.5 12-25 16.5-7.5 1.5 5.5 6 10 10.5 10 4.5 0 8 3.5 8 7.5 0 5-5.5 7.5-17.5 7.5-16.5 0-17.5-1-17.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pD8d7LaaZ",
    className: "s16",
    d: "m625 3871.5c0-19.5 12-25 16.5-7.5 1.5 5.5 6 10 10.5 10 4.5 0 8 3.5 8 7.5 0 5-5.5 7.5-17.5 7.5-16.5 0-17.5-1-17.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgvZC8dfu",
    className: "s16",
    d: "m695 3881.5c0-4 3.5-7.5 8-7.5 4.5 0 9-4.5 10.5-10 4.5-17.5 16.5-12 16.5 7.5 0 16.5-1 17.5-17.5 17.5-12 0-17.5-2.5-17.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pz7JldnuL",
    className: "s16",
    d: "m-1160 3874c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyP1avqta",
    className: "s16",
    d: "m2244.5 3850.5c-11-10-23.5-25-27.5-33-5.5-10.5-10.5-14-17.5-12-7.5 2-9.5 0-9.5-9.5 0-9 2.5-12 10.5-12 10 0 10.5-2 8-30-3.5-39 4-65 19-65 11 0 11 0.5 4.5 26-9.5 35.5-9 51 0.5 47 4-1.5 11-4.5 15-6 11.5-4.5 9.5 17.5-2.5 27-8.5 7.5-9.5 12.5-7 35 3.5 25.5 3.5 26 20 26 15 0 17 1.5 17 12.5 0 17-6.5 15.5-30.5-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNK8xAhhc",
    className: "s16",
    d: "m-2848.5 3831.5c-31.5-14.5-35-24.5-7.5-21.5 10 1.5 22.5 4 27.5 6 7 3.5 8.5 1.5 8.5-13 0-16 1-17 26-23 14-3 26-6.5 27-7 0.5-1 2-9.5 3-19 1.5-17 1-17.5-17.5-19-22-2-26-8.5-18.5-28.5 3-7.5 4.5-15 3-16-2-2-48 3.5-91.5 11.5-14 2.5-16.5 1.5-16.5-6.5 0-8.5 5.5-11 41.5-15.5 22.5-3.5 47-6 55-6 7.5 0 13.5-2 13.5-5 0-2.5 3-3.5 6.5-2 4 1.5 9-3 12.5-10.5 8-18 16-15.5 16 5 0 12-2.5 17.5-7.5 17.5-4.5 0-7.5 4.5-7.5 12 0 6.5-1.5 15.5-3 20-2.5 6.5 0.5 8 15 8 13.5 0 18 2 18 8 0 4.5 2.5 16.5 5.5 27 5.5 17 8 19 32.5 25 26 6.5 27 7 27 23.5 0 18.5-12 23.5-16.5 7-1.5-7-5.5-9-13-7-10.5 2.5-25.5-8-25.5-18 0-3-4.5-5.5-9.5-5.5-5.5 0-11-3-12-6-1.5-3.5-3-1.5-3 5-0.5 16.5-12.5 26.5-29 25-13-1.5-14 0-16.5 18.5-3 24.5-9.5 26-43.5 10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxhHU7zHc",
    className: "s16",
    d: "m-2695 3835c0-10 24.5-21 46.5-21 20 0 16.5 9-7.5 20-27 12.5-39 12.5-39 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4jWEI58H",
    className: "s16",
    d: "m-3202 3825.5c-9.5-50.5-9.5-56.5 1.5-56.5 6.5 0 10.5 3 10.5 9 0 4.5 1.5 20.5 3 35 3 21.5 2 26-4.5 26-4.5 0-9-6-10.5-13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pA6aKrcRQ",
    className: "s16",
    d: "m1968 3828.5c-13.5-2-26-5.5-27.5-8-1.5-2-9.5-4.5-18-5-18-0.5-72.5-24.5-72.5-31 0-9.5 23.5-8 57.5 4 19.5 7 36 14 37.5 15.5 1.5 1.5 9.5 3 17.5 3.5 49 3 62.5 6 62.5 14 0 3.5-5 7.5-11 9.5-13 3.5-13 3.5-46-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNFudGcBZ",
    className: "s16",
    d: "m2064 3830.5c-14-3.5-10.5-15.5 6-19 18-4 35 1 35 10 0 9.5-21 14.5-41 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnxZAjRIP",
    className: "s16",
    d: "m2110 3820.5c0-6.5 8-11.5 26.5-17.5 34-11.5 38.5-11 38.5 1 0 7.5-6 11.5-26 17.5-33 9.5-39 9.5-39-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSQDEDUQS",
    className: "s16",
    d: "m-2630 3806.5c0-11 2-12.5 17.5-12.5 21.5 0 22.5 7 2.5 17.5-19 10-20 9.5-20-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGqQ9PoHc",
    className: "s16",
    d: "m-3105 3796.5c0-14 2-17.5 10-17.5 7.5 0 10-3.5 10-12.5 0-9 2.5-12.5 10-12.5 7.5 0 10-3.5 10-12.5 0-10 2.5-12.5 12.5-12.5 10 0 12.5-2.5 12.5-11.5 0-11 3-12.5 41.5-17.5 52.5-7.5 58.5-7.5 58.5 1 0 7-8 10-50 15.5-36.5 5-38 6-75 53-20 24.5-37 44.5-38 44.5-1 0-2-8-2-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pi9Jdad0M",
    className: "s16",
    d: "m-1109 3800.5c1-5 6.5-9.5 13-10.5 8.5-1.5 11 1 11 8.5 0 8-3 10.5-13 10.5-9.5 0-12.5-2.5-11-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pThksgxoj",
    className: "s16",
    d: "m-1055 3799c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMdzycVKu",
    className: "s16",
    d: "m-1719 3795.5c1-5.5 7-9.5 15.5-10.5 11-1.5 13.5 0.5 13.5 8.5 0 8.5-3 10.5-15.5 10.5-12 0-15-2-13.5-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkJVNE5M1",
    className: "s16",
    d: "m-1630 3794c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFpt8phpt",
    className: "s16",
    d: "m-1495 3794c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "po0xgU7Jk",
    className: "s16",
    d: "m-1405 3794c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pi9PeDq0o",
    className: "s16",
    d: "m-1269 3795.5c1-5 6.5-9.5 13-10.5 8.5-1.5 11 1 11 8.5 0 8-3 10.5-13 10.5-9.5 0-12.5-2.5-11-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCyJiZ3Ev",
    className: "s16",
    d: "m-1185 3794c0-7.5 3.5-10 12.5-10 9 0 12.5 2.5 12.5 10 0 7.5-3.5 10-12.5 10-9 0-12.5-2.5-12.5-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6OY4Ohuc",
    className: "s16",
    d: "m625 3781.5c0-16.5 1-17.5 17.5-17.5 19.5 0 25 12 7.5 16.5-5.5 1.5-10 6-10 10.5 0 4.5-3.5 8-7.5 8-5 0-7.5-5.5-7.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1F99eIh5d",
    className: "s16",
    d: "m2289 3785.5c-17-7-19-9.5-19-26 0-15 4-22 22.5-40.5 17-16.5 21-23.5 16.5-28.5-3.5-4.5-3.5-6.5 0.5-6.5 3 0 5.5-3.5 5.5-8 0-6.5 1.5-7 7.5-2 6 5 9 3 17-10 5-9 12-26 15.5-38 3.5-12 8-22 10-22 1.5 0 2.5-19 2-41.5-1.5-48-13.5-85.5-40-123.5l-17-25h13.5c17 0 31 19 50.5 66 10 25.5 12.5 40.5 13 78.5 0.5 31.5-1.5 48-5 49-3.5 1-5 6-3.5 11.5 2.5 10-33 89.5-41 90.5-2.5 0-15 11.5-27.5 25.5-23.5 26-23 30 3.5 37 19 5 26.5-1 26.5-20.5 0-17 10.5-28.5 19-20 5.5 5.5 3 46.5-3.5 54.5-8 9.5-42.5 9-66.5-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPwRsRcgV",
    className: "s16",
    d: "m233.5 3776c-2-2-3.5-18-3.5-35.5 0-28 1-31.5 10-31.5 6 0 10 3.5 10 8.5 0 6.5 5 3.5 19-10 10.5-10 23-18.5 27.5-18.5 5 0 8.5-4 8.5-10 0-6.5 3.5-10 10-10 6.5 0 10-3.5 10-10 0-6.5 3.5-10 10-10 6.5 0 10-3.5 10-10 0-6.5 3.5-10 10-10 6.5 0 10-3.5 10-10 0-5.5 3.5-10 7.5-10 4 0 7.5-2.5 7.5-6 0-9.5 26-34 36-34 5.5 0 9-3.5 9-10 0-6.5 3.5-10 10-10 5.5 0 10-3.5 10-7.5 0-11.5 30-42.5 41-42.5 5 0 9-3.5 9-7.5 0-5 5.5-7.5 17.5-7.5 16.5 0 17.5 1 17.5 17.5 0 9.5-2 17.5-5 17.5-2.5 0-5 5-5 11.5 0 16-21.5 33.5-41 33.5h-16l27-27.5c14.5-15 25.5-29 23.5-31-2.5-2-60.5 53-129.5 122.5-69.5 69-124.5 127-122.5 129 1.5 2 20-13 41-33l37.5-36.5v17.5c0 19.5-12 34-28.5 34-11.5 0-26.5 15-26.5 26.5 0 6-4.5 8.5-13.5 8.5-8 0-18.5 1.5-24 3-5.5 1.5-12 1-14-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7jF7RO8v",
    className: "s16",
    d: "m1799 3755c-38-28.5-74-75-89-114.5-13-33.5-17.5-126.5-6.5-130 3.5-1.5 4.5-5.5 3-9.5-4.5-12.5 19.5-57 31-57.5 9 0 9-0.5 1-3.5-7.5-3.5-7-5.5 6-21 8.5-9.5 15-14.5 15.5-11 0 3 3.5 6 7.5 6 5.5 0 3 7-10 25.5-9.5 14-21.5 36.5-26 50-5 13.5-10 24.5-12 24.5-1.5 0-2 19.5-0.5 44 1 24 2.5 49.5 3 57.5 0 7.5 2 13.5 4.5 13.5 2 0 3.5 4.5 3.5 10 0 5.5 2 10 4.5 10 2.5 0 6.5 5 8 10.5 7 21 78.5 94.5 92.5 94.5 2.5 0 5 5.5 5 12.5 0 7-2 12.5-4.5 12.5-3 0-19-10.5-36.5-24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "px0sh5rmk",
    className: "s16",
    d: "m-3212 3748c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkXLHf5oC",
    className: "s16",
    d: "m-2840 3749c0-7 19.5-16 28-13 4 1.5 7 6 7 10.5 0 5.5-5 7.5-17.5 7.5-9.5 0-17.5-2-17.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12vhXkSg7",
    className: "s16",
    d: "m-2695 3746.5c0-10.5 12-14.5 24.5-7.5 16 8 12.5 15-7 15-12.5 0-17.5-2-17.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p75OCxxW3",
    className: "s16",
    d: "m-1725 3734.5c0-8 3-10.5 13-10.5 16.5 0 15 16.5-2 19-8.5 1.5-11-1-11-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18CjWMDu4",
    className: "s16",
    d: "m-2718 3718.5c4-21.5 7.5-24 16-12 10 13.5 7 24.5-7.5 26.5-11 2-11.5 0.5-8.5-14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FmGzO60K",
    className: "s16",
    d: "m-1166 3730.5c-15.5-4-10.5-16.5 6.5-16.5 11.5 0 15 2 13.5 8.5-1.5 9-7.5 11.5-20 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4MLqBbFX",
    className: "s16",
    d: "m-3217 3708c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pE7gHRzY9",
    className: "s16",
    d: "m232 3597.5l3.5-97.5-17.5-3c-27-5-24-18 4.5-18 16.5 0 22.5 2 22.5 7.5 0 4.5 5 8 14 8 9.5 0.5 10.5 1.5 3.5 3-9.5 2-10 6-10 98v96l-12 1.5-12 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjy4GIkcR",
    className: "s16",
    d: "m345 3682c0-1 3.5-4.5 7.5-8 6-5 7.5-5 7.5 2 0 4.5-3.5 8-7.5 8-4 0-7.5-1-7.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKupClis1",
    className: "s16",
    d: "m2220 3679.5c0-11.5 23.5-31 40-33.5 21.5-3.5 42.5 9.5 30 18-4 2.5-16 5-26 5-13.5 0-19 2-19 7.5 0 4.5-4.5 7.5-12.5 7.5-7 0-12.5-2-12.5-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puL0PNJwA",
    className: "s16",
    d: "m-3222 3668c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfyAvAWF",
    className: "s16",
    d: "m-2744 3666.5c-7-14.5-8-42.5-2-42.5 4.5 0 18.5 22.5 25.5 41.5 5 12 4 13.5-6.5 13.5-7.5 0-13.5-4.5-17-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcneaN4PL",
    className: "s16",
    d: "m-2835 3656.5c0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-8 0-10-3.5-10-15.5 0-12 1.5-14.5 6.5-11 3 3 29 22 57.5 43.5 28 21 51 39.5 51 40.5 0 1.5-8 2.5-17.5 2.5-12 0-17.5-2.5-17.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn7bnTKYH",
    className: "s16",
    d: "m365 3662c0-1 3.5-4.5 7.5-8 6-5 7.5-5 7.5 2 0 4.5-3.5 8-7.5 8-4 0-7.5-1-7.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pz1ZM0I5L",
    className: "s16",
    d: "m410 3616.5c15-15.5 28-25.5 29.5-22 2 6.5-24 34.5-33 34.5-3.5 0-6.5 3.5-6.5 7.5 0 4-4 7.5-8.5 7.5-6 0 0-9 18.5-27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyz6VH2Do",
    className: "s16",
    d: "m-3227 3628c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10rOpltkO",
    className: "s16",
    d: "m-1165 3629c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJ93lESfX",
    className: "s16",
    d: "m-3232 3580.5c-9.5-50.5-9.5-56.5 1.5-56.5 6.5 0 10.5 3 10.5 9 0 4.5 1.5 20.5 3 35 3 21.5 2 26-4.5 26-4.5 0-9-6-10.5-13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polqCZEeb",
    className: "s16",
    d: "m445 3582c0-1 3.5-4.5 7.5-8 6-5 7.5-5 7.5 2 0 4.5-3.5 8-7.5 8-4 0-7.5-1-7.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8MJsOHWP",
    className: "s16",
    d: "m-2955 3566.5c0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-8 0-10-3.5-10-15.5v-15l22 16c12.5 8.5 30 22 39 30l16.5 14-18.5 0.5c-13.5 0-19-2-19-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19n2kP2SC",
    className: "s16",
    d: "m-1725 3509.5c0-8 3-10.5 13-10.5 16.5 0 15 16.5-2 19-8.5 1.5-11-1-11-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEgiyHjgU",
    className: "s16",
    d: "m120 3502c0-19 6-23 33-23 21.5 0 23 13 2 17.5-10.5 2.5-15 6.5-15 13 0 6-3.5 9.5-10 9.5-8 0-10-3.5-10-17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCPYqFiJW",
    className: "s16",
    d: "m-3242 3503c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1G4WGXu7t",
    className: "s16",
    d: "m20 3489.5c0-5.5 2.5-10.5 5-10.5 3 0 5-4.5 5-10 0-5.5 2.5-10 5-10 3 0 5 3 5 7 0 4 7.5 8.5 17.5 10 20 4 24.5 18 5.5 18-6.5 0-19 1.5-27.5 3-13.5 3-15.5 2-15.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRyeycvq2",
    className: "s16",
    d: "m-3247 3463c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwxewko8q",
    className: "s16",
    d: "m-3252 3423c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plSFwhLlz",
    className: "s16",
    d: "m23.5 3403c-1.5-11.5-1.5-23-0.5-25 1.5-2 23.5-4 49.5-4 40.5 0 47-1 49-8.5 1.5-5 2.5-0.5 3 10l0.5 18.5h-28.5c-39.5 0-51 4-54.5 18-5 19.5-15.5 14-18.5-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTw8pp98x",
    className: "s16",
    d: "m619 3410c-4-14-30.5-16-207-16-153.5 0-157 0-157-10 0-10 3.5-10 171.5-10 103 0 178.5 2 190 5.5 17 4.5 18.5 6.5 18.5 22 0 19-12 25-16 8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYMlHtgd2",
    className: "s16",
    d: "m-1190 3404c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyivZWQgW",
    className: "s16",
    d: "m-3180 3388.5v-15l15 10.5c22 15.5 22.5 20 3 20-16.5 0-18-1-18-15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1A5zmoSuG",
    className: "s16",
    d: "m-3257 3383c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14Hu0Jt7m",
    className: "s16",
    d: "m1795 3379q0-15 7.5-15c4 0 7.5-2 7.5-5 0-2.5 8-5 17.5-5 9.5 0 17.5 1.5 17.5 4 0 2-11.5 11-25 20l-25 16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ps5EC7gEG",
    className: "s16",
    d: "m2267.5 3378.5c-11-8.5-37-23.5-57.5-33-20.5-10-38.5-19.5-40-21.5-1.5-2-15-5-30.5-6.5-15.5-1.5-40.5-5.5-56-9-22.5-5.5-28.5-9-28.5-16 0-10.5-3-10.5 57.5 1.5 61 11.5 74 15.5 110 33 28 13 37.5 20 37.5 27 0 10.5 8 14 11 5 1-3 9.5 1.5 19 9.5 12.5 10.5 15 15 9 15.5-4.5 0-9 2-10 4.5-0.5 3-10.5-2-21.5-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSCXFt8BJ",
    className: "s16",
    d: "m215 3379c0-2.5 3.5-5 7.5-5 6 0 7.5-7.5 7.5-37.5 0-30-1.5-37.5-7.5-37.5-4 0-7.5-2-7.5-5 0-2.5 8-5 17.5-5h17.5v47.5 47.5h-17.5c-9.5 0-17.5-2-17.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17SkBhAXe",
    className: "s16",
    d: "m-1520 3354c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgtSBHdQm",
    className: "s16",
    d: "m645 3350c0-12 5-22 18.5-36 16.5-18 20.5-20 42.5-20h24v17.5c0 13.5-2 17.5-8.5 17.5-5 0-17.5 8-27.5 17.5-28 26.5-34.5 21-7.5-6.5 13-13 23.5-27 23.5-31 0-4-14.5 7.5-32.5 25l-32.5 32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1A4wqhCeG",
    className: "s16",
    d: "m-3240 3352c0-4.5-3.5-6-9.5-4.5-7.5 2-10.5-1-13-13.5-2-8.5-2-17-0.5-18.5 2.5-3 58 36.5 58 41 0 1.5-8 2.5-17.5 2.5-11.5 0-17.5-2.5-17.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBmLs15T7",
    className: "s16",
    d: "m1866.5 3340c-6.5-1-11.5-4-11.5-6.5 0-6.5 30.5-19 38.5-16 3.5 1.5 6.5 0 6.5-3 0-3 8-5.5 17.5-5.5 10.5 0 17.5 2.5 17.5 6.5 0 7.5-53.5 27-68.5 24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptkKv7pn7",
    className: "s16",
    d: "m-1745 3329c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p159p9W2Ww",
    className: "s16",
    d: "m-1520 3329c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15msPhyEa",
    className: "s16",
    d: "m-1295 3329c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEaF5GTOl",
    className: "s16",
    d: "m125 3301.5c0-16.5 1-17.5 17.5-17.5 19.5 0 25 12 7.5 16.5-5.5 1.5-10 6-10 10.5 0 4.5-3.5 8-7.5 8-5 0-7.5-5.5-7.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11NDw6dkH",
    className: "s16",
    d: "m1965 3305.5c0-7 6-10.5 26.5-15.5 35-8 38.5-7.5 38.5 3.5 0 7-5 10-18.5 12-10.5 2-25 4.5-32.5 6.5-11.5 2.5-14 1.5-14-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6LYxXmYT",
    className: "s16",
    d: "m334 2765.5c-16.5-4-10-16.5 8.5-16.5 14 0 17.5 2 17.5 10 0 10-7 11.5-26 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pv8uPvZV6",
    className: "s16",
    d: "m420 2759c0-8 3.5-10 17.5-10 20 0 24.5 12 6.5 17-19 5-24 3.5-24-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BJWH9XsQ",
    className: "s16",
    d: "m284 2755.5c-16.5-4-10-16.5 8.5-16.5 14 0 17.5 2 17.5 10 0 10-7 11.5-26 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppWI3Odht",
    className: "s16",
    d: "m470 2749c0-8 3.5-10 17.5-10 20 0 24.5 12 6.5 17-19 5-24 3.5-24-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p555ojij4",
    className: "s16",
    d: "m-1631 2705.5c-16.5-4-10-16.5 8.5-16.5 14 0 17.5 2 17.5 10 0 10-7 11.5-26 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNJOR6lFu",
    className: "s16",
    d: "m-1370 2699c0-8 3.5-10 17.5-10 20 0 24.5 12 6.5 17-19 5-24 3.5-24-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4Dna9thI",
    className: "s16",
    d: "m154 2686c-16-12.5-29-24-29-25 0-1 8-2 17.5-2 14 0 17.5 2 17.5 10 0 7.5 3.5 10 12.5 10 10.5 0 12.5 2.5 12.5 15 0 8.5-0.5 15-1 15-1 0-14.5-10.5-30-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppN7Z8jg3",
    className: "s16",
    d: "m595 2694.5c0-14.5 1.5-15.5 18-15.5 19.5 0 19 4.5-3 20l-15 10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXRCIn0zh",
    className: "s16",
    d: "m-1705 2669l-17.5-14.5 19-0.5c17.5 0 18.5 1 18.5 15 0 8.5-0.5 15-1.5 15-0.5 0-9-6.5-18.5-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pv0j8s5aU",
    className: "s16",
    d: "m-1290 2669.5c0-14.5 1.5-15.5 18-15.5 19.5 0 19 4.5-3 20l-15 10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7ykV3qi0",
    className: "s16",
    d: "m-3347 2671.5c-11-3.5-24-11.5-30-17l-10-10.5h18.5c10 0 18.5 2.5 18.5 5.5 0 2.5 2.5 3.5 5 2 3-2 12-2 20 0 11.5 2.5 15 6 15 15.5 0 14-8 15-37 4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3BQ9FOMb",
    className: "s16",
    d: "m-2860 2667.5c0-14.5 15-20.5 39.5-15.5 26.5 5.5 16 17.5-21 24.5-17.5 3.5-18.5 3-18.5-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HgzPYSto",
    className: "s16",
    d: "m97 2630.5c-10-13.5-21-27-23.5-30-3.5-5-1-6.5 11-6.5 13 0 15.5 2 15.5 12.5 0 9 2.5 12.5 10 12.5 8 0 10 3.5 10 17.5 0 9.5-1 17.5-2 17.5-1 0-10.5-10.5-21-23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2WY3X4gn",
    className: "s16",
    d: "m-2790 2643c0-5-3.5-9-7.5-9-6 0-5.5-3 2.5-16.5 9.5-15.5 10-27.5 10-223 0.5-114 0-207-1-207.5-32.5-18.5-50.5-42.5-56.5-74.5-3-16.5-2.5-18.5 6.5-18.5 8 0 11 4.5 13.5 20 2 11 5.5 20 8 20 2.5 0 4.5 4.5 4.5 10 0 6.5 3.5 10 10 10 5.5 0 10 2.5 10 5 0 3 3.5 5 7.5 5 4 0 7.5 2 7.5 4.5 0 9 17 10.5 43.5 5 14.5-3.5 26.5-8 26.5-10.5 0-2 4.5-4 10-4 5.5 0 10-3.5 10-7.5q0-7.5 15-7.5c13.5 0 14.5 1 9.5 9-10 16-40 33-68 38.5l-27.5 5.5 0.5 185.5c1 158.5 0 188.5-7 204.5-4 10-6.5 22.5-5 27.5 2 5-2 14-9.5 23-10 11-12.5 12-13 5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZWKV3myp",
    className: "s16",
    d: "m665 2632c0-12.5 2-18 7.5-18 4 0 7.5-4.5 7.5-10 0-6.5 3.5-10 10-10 8 0 10-3.5 10-15 0-12.5 2-15 12.5-15 7 0 12.5 2 12.5 4 0 5.5-48 74-55 78.5-3 2-5-4-5-14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phFph67xU",
    className: "s16",
    d: "m-3401 2623c-5.5-12.5-7-31-5-77.5 2-56.5 3-61.5 11.5-61.5 9 0 9.5 4.5 9.5 59 0 49.5 1.5 61 10 75 7.5 12.5 8.5 16 3 16-4 0-10.5 1-14.5 3-4.5 1.5-9.5-3-14.5-14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7ZSpAnW6",
    className: "s16",
    d: "m2099 2635.5c-5-1.5-9-6.5-9-12 0-8 3.5-9.5 24.5-9.5 14 0 26.5-2 28-5 1.5-2.5 10-5 18.5-5 13 0 14.5 1 8.5 8-13 15.5-50.5 28-70.5 23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GFYr9avK",
    className: "s16",
    d: "m2045.5 2608.5c-17-16.5-17-17-6-18.5 15-2.5 27 9.5 24.5 24.5-1.5 11-2 11-18.5-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1G2Hm4xPe",
    className: "s16",
    d: "m2173.5 2588c-3-10.5 10-39 17.5-39 2 0 4-3.5 4-8 0-4.5 4.5-9 10.5-10.5 7-2 8.5-4 4.5-6.5-4.5-3-4-7.5 3-19.5 5-8.5 11-15.5 13-15.5 2 0 4-4.5 4-10 0-6.5 3.5-10 10-10 8 0 10-3.5 10-15.5 0-11 2.5-16 10-18 7-2 10-7 10-17.5 0-11 3-15.5 10.5-17.5 7-2 8.5-4 4.5-6.5-4.5-3-4-7.5 3-19.5 10-17 11-17.5 21.5-11 5 3-8.5 30.5-60 120-37 63.5-68 115.5-70 115.5-2 0-4.5-5-6-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfmPJp780",
    className: "s16",
    d: "m-1230 2561.5c0-14 2-17.5 10-17.5 10.5 0 12 5 7 24-5 18-17 13.5-17-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pR4dB2JdZ",
    className: "s16",
    d: "m-1762 2563c-5.5-21-3.5-29 7-29 8.5 0 10 3.5 10 20 0 22.5-11.5 28.5-17 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWMIiZCeN",
    className: "s16",
    d: "m39.5 2535.5c-5.5-13.5-11.5-30-13-37.5-2.5-12-1-14 8-14 8.5 0 11 4 13.5 20 2 11 5 20 7.5 20 2.5 0 4.5 8 4.5 17.5 0 24.5-8.5 22-20.5-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3JLlysb6",
    className: "s16",
    d: "m720 2542c0-16 1.5-18 12.5-18 12 0 12.5 0.5 6 16-9.5 23-18.5 24-18.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLDAHgxIp",
    className: "s16",
    d: "m2020 2529c0-5.5 4.5-14.5 9.5-19.5 5.5-5.5 8.5-11 7-12-1.5-1.5 9-22.5 23-46.5 14-24 25-44 24.5-44.5-1-0.5-16.5-5-35-9.5-39.5-10.5-51-17.5-46.5-29 3-8 5-8 20.5-1.5 14.5 6 84 22.5 94.5 22.5 1.5 0 0 4.5-3.5 10-3.5 5.5-9.5 9-12.5 7.5-4.5-1.5-6.5 3-6.5 13 0 8.5-3 16-7.5 17.5-4 2-6 5-5 7.5 3.5 5-32.5 69.5-38.5 69.5-2 0-4 5.5-4 12.5 0 9-2.5 12.5-10 12.5-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcr1Ol7eS",
    className: "s16",
    d: "m-1763.5 2465.5c1.5-30 3-54.5 3-55 0.5-1 4-1.5 8-1.5 6 0 7.5 9.5 7.5 55 0 52.5-0.5 55-10.5 55-10.5 0-10.5-1.5-8-53.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pygCcKXX9",
    className: "s16",
    d: "m-1440 2507c0-11.5 1-12 17.5-6.5 9.5 3 17.5 8 17.5 12 0 4-6.5 6.5-17.5 6.5-15 0-17.5-1.5-17.5-12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptgfNU5Jf",
    className: "s16",
    d: "m-1275 2505.5c0-2.5 8-9 17.5-15.5l17.5-11v15c0 14-1.5 15-17.5 15-9.5 0-17.5-1.5-17.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18ykFSaOp",
    className: "s16",
    d: "m750 2436.5c0-14 2-17.5 10-17.5 10.5 0 12 5 7 24-5 18-17 13.5-17-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHcOG42tz",
    className: "s16",
    d: "m2391 2427.5c-25.5-9.5-45-30.5-42.5-46 1.5-7 3.5-12.5 4.5-12.5 1 0 11 10 22.5 22.5 22 24 38.5 28.5 66.5 17.5 11.5-4.5 13-3.5 13 7 0 18-30.5 23.5-64 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9abRsSd2",
    className: "s16",
    d: "m2480 2402c0-4.5-2-8-4.5-8-6 0 16-44.5 22.5-45 15.5-0.5 8 39.5-9.5 54.5-7.5 6-8.5 5.5-8.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Deh9SjDg",
    className: "s16",
    d: "m12.5 2348c8-47 38-129 47.5-129 2.5 0 5 8 5 17.5 0 9.5-2 17.5-5 17.5-2.5 0-5 5.5-5 12.5 0 7-2 12.5-5 12.5-2.5 0-5 4-5 8.5 0 4.5-4 25-8.5 45-7 29-11 36.5-18 36.5-8 0-9-2.5-6-21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puGTonV1U",
    className: "s16",
    d: "m744 2332.5c-11-44-11.5-58.5-2-58.5 6.5 0 18.5 35.5 26 76.5 2.5 16 2 18.5-6 18.5-7.5 0-11.5-7.5-18-36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgdM5qokN",
    className: "s16",
    d: "m1954 2355c-8-4.5-14-10-14-11.5 0-8 23-8.5 36-0.5 13.5 8 18.5 16 9.5 16-2.5 0-7.5 1-11.5 2.5-3.5 1-12.5-1.5-20-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ps6q5Gqbn",
    className: "s16",
    d: "m-1760 2338c-6.5-198-5.5-234 7.5-234 6.5 0 7.5 18.5 7.5 120 0 103.5-1 120-7.5 120-4 0-7.5-3-7.5-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjn2POG2h",
    className: "s16",
    d: "m1896 2319c-12-8.5-21-19-21-24.5 0-7-4-10.5-13.5-11.5-12-1.5-14.5-4-15.5-18.5l-2-17 29 26c16 14.5 34 30 40.5 34 11 7.5 16 26.5 7.5 26.5-2.5 0-14-7-25-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBUEVmeoD",
    className: "s16",
    d: "m2325 2316.5c0-20 12-24.5 17-6 5 18.5 3.5 23.5-7 23.5-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5AsDMtbs",
    className: "s16",
    d: "m2488 2318.5c-1.5-8.5-3-21-3-27 0-6.5-2-12.5-4-13.5-4-1.5-31-87.5-31-98 0-3.5 4.5-6 10-6 8 0 10 3.5 10 17.5 0 9.5 2 17.5 4.5 17.5 4 0 35.5 106 35.5 119.5 0 3-4 5.5-9.5 5.5-6.5 0-10-5-12.5-15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p42yUwtsM",
    className: "s16",
    d: "m1816.5 2244.5q-16.5-21.8-16.5-39c0-21.5 6-21 18 2.5 5 10 11.5 20 13.5 21.5 2.5 1.5 3.5 10.5 2.5 20l-1.5 17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPMSoZCQS",
    className: "s16",
    d: "m-1440 2171.5c0-8.5 3.5-12 15.5-14.5 45.5-9 55.5 6 12 18-27.5 7.5-27.5 7.5-27.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppb6Hv8tI",
    className: "s16",
    d: "m-1301 2170.5c-16.5-4-10-16.5 8.5-16.5 14 0 17.5 2 17.5 10 0 10-7 11.5-26 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pq4ExmL3u",
    className: "s16",
    d: "m1767 2133c-4.5-21.5-6.5-78.5-3.5-92.5 1.5-6.5 5.5-11.5 9.5-11.5 8.5 0 7.5-7.5 10 61.5 2 48.5 1 58.5-5 58.5-4 0-9-7-11-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7rE0Ekp6",
    className: "s16",
    d: "m-2658 2113c1.5-14.5 3-34 3-42.5 0-21.5 13-22 17.5-1 6 25.5-6 69.5-18.5 69.5-3.5 0-4.5-8.5-2-26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTpDV71D5",
    className: "s16",
    d: "m-1232 2115.5c-4.5-30-3.5-41.5 4-41.5 4.5 0 9 9.5 12.5 25 7 33.5 7 35-4 35-7 0-10-5-12.5-18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDSOkvvLq",
    className: "s16",
    d: "m100 2131.5c0-6 37.5-67.5 41-67.5 2 0 4 8 4 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1-12.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15SQEpt5J",
    className: "s16",
    d: "m2437 2100.5c7-65.5 5.5-103.5-5-140l-11-36.5h11.5c9.5 0 12.5 5 20 31.5 16.5 57 9 173.5-11 173.5-6.5 0-7-5-4.5-28.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWR5u1Vkb",
    className: "s16",
    d: "m650 2106.5c0-21.5 5-22 16.5-3 11 19 11 20.5-4 20.5-11 0-12.5-2-12.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkYtDley0",
    className: "s16",
    d: "m-3150 2079c0-13.5 1-14.5 9.5-9 7.5 4.5 11.5 4.5 17.5-0.5 7-6 8-5 8 9 0 14.5-1 15.5-17.5 15.5-16 0-17.5-1-17.5-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLXZMkC6K",
    className: "s16",
    d: "m-3405 2059c0-16.5 1.5-20 10-20 8.5 0 10 3.5 10 20 0 16.5-1.5 20-10 20-8.5 0-10-3.5-10-20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgnd1ZJip",
    className: "s16",
    d: "m-1729 2033c6.5-8.5 19.5-21.5 28-28l16-12.5v16c0 13-2 15.5-12.5 15.5-10 0-12.5 2.5-12.5 12.5 0 10.5-2.5 12.5-15.5 12.5h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1oCrbSoP",
    className: "s16",
    d: "m150 2046c0-6 17-32 21-32 2 0 4 8 4 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10B8AwL6f",
    className: "s16",
    d: "m-3084 2029.5c4.5-7.5 4.5-11.5-0.5-17.5-5.5-6.5-5.5-8 1.5-8 4.5 0 8-4 8-8.5 0.5-7 3-6 12.5 5 13 15 16 23.5 7.5 23.5-2.5 0-5 3.5-5 7.5q0 7.5-15 7.5c-13.5 0-14.5-1-9-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOyzHiyjX",
    className: "s16",
    d: "m-2845 2030.5c0-17 6-31.5 13-31.5 5 0 7 6.5 7 20 0 16.5-1.5 20-10 20-6 0-10-3.5-10-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwgDB6oT3",
    className: "s16",
    d: "m-1175 2008.5c-24.5-21-30-28-30-40.5 0-13.5 1-14.5 9-8.5 23.5 17.5 31 27.5 31.5 39 0 10.5 1 11.5 4 4 3-8.5 4.5-8 17 4.5 15.5 15 16.5 20 6 23.5-4 2-19.5-7-37.5-22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZxtjY0ow",
    className: "s16",
    d: "m-2700 2019c0-2.5-3.5-5-7.5-5-4.5 0-7.5-4.5-7.5-12.5 0-7 2-12.5 4-12.5 5.5 0 46 29 46 32.5 0 1.5-8 2.5-17.5 2.5-9.5 0-17.5-2-17.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DjMjxcgv",
    className: "s16",
    d: "m-3395 2002c0-4-3-8-6-9-4.5-1.5-3-7.5 5.5-19.5 20.5-30.5 66.5-53.5 76-39 7.5 12.5 5 18.5-10.5 22-19 4-38 19.5-47.5 38-8 15.5-17.5 19.5-17.5 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12gFgP7rW",
    className: "s16",
    d: "m580 1991.5c0-21.5 5-22 16.5-3 11 19 11 20.5-4 20.5-11 0-12.5-2-12.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQwiryd7B",
    className: "s16",
    d: "m-1664 1988c1-3.5 12.5-9.5 25-13.5l23-7 2-26.5c2.5-28 22.5-62 37-62 3.5 0 11.5-4.5 17-10 12-12 40-13.5 40-2.5 0 4.5-7 8.5-18.5 10.5-25.5 4.5-50.5 29-57.5 55.5-3 12-7 21.5-9.5 21.5-2.5 0-4.5 7.5-4.5 17 0 15-2 17-15.5 20-25.5 5-40.5 3.5-38.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pczbGgvvz",
    className: "s16",
    d: "m187 1986.5c4-11 42-66.5 48-70 3-2 5 4 5 14.5 0 10-2 18-5 18-2.5 0-5 3.5-5 7.5 0 4-4.5 7.5-10 7.5-8 0-10 3.5-10 15 0 13-2 15-13 15-9.5 0-12.5-2-10-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GJzbrvqS",
    className: "s16",
    d: "m-2838 1973.5c2.5-12.5 1-16-7-18-16-4-11.5-15 7.5-18.5 17.5-3.5 37.5 3 37.5 12 0 3-4.5 5-10 5-8 0-10 3.5-10 17.5 0 14.5-2 17.5-10.5 17.5-9.5 0-10.5-2-7.5-15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1EmqnBf59",
    className: "s16",
    d: "m-3116.5 1980.5c-2-1.5-3.5-10.5-3.5-20 0-18-8.5-23-11-6-1.5 10.5-2 10.5-15-3-8.5-8.5-14-19.5-14-27.5v-13.5l22.5 10.5c12 6 22 13.5 22.5 17 0 3.5 6.5 6 14.5 6 8.5 0 16.5 2.5 18 5 2 3-3 5-10.5 5h-14l14.5 15 14.5 15h-17.5c-10 0-19.5-1.5-21-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4zvQBj2k",
    className: "s16",
    d: "m-1231.5 1958c-15.5-13-19-19.5-17.5-30.5l1.5-14.5 19 17c15.5 13 19 19.5 17.5 30.5l-1.5 14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAucRlvWM",
    className: "s16",
    d: "m550 1956.5c0-4-2-7.5-5-7.5-2.5 0-5-3.5-5-7.5 0-4-2-7.5-5-7.5-2.5 0-5-3.5-5-7.5 0-4-2-7.5-5-7.5-2.5 0-5-8-5-18 0-23 4.5-19.5 35 26l25.5 37h-15.5q-15 0-15-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p48dN7RwJ",
    className: "s16",
    d: "m-1361 1931.5c-7-26-7-27.5 1-27.5 9.5 0 20 22.5 20 43 0 22.5-13 12.5-21-15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pm519dX4S",
    className: "s16",
    d: "m-3227.5 1873l-60-59h17.5c15.5 0 23 5 62 44.5 37.5 38 43.5 46 42 58.5-1.5 14-3.5 12.5-61.5-44z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQmW3xFPY",
    className: "s16",
    d: "m1810 1911c0-7.5 23.5-42 28.5-42 3.5 0 5-3 3.5-6.5-4-11.5 26.5-48.5 40.5-48.5 11.5 0 11 2-17.5 46-16.5 25.5-30 48-30 50 0 2-5.5 4-12.5 4-7 0-12.5-1-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6yjiNGUX",
    className: "s16",
    d: "m2389 1871.5c-10.5-14.5-19-29-19-31.5 0-2.5-4.5-6-10-7.5-5.5-1.5-10-6-10-11 0-4.5-3-7.5-6-6.5-11 2.5-79.5-43-76.5-50.5 2-4.5-0.5-6-8-4-5.5 1.5-20.5-2.5-33.5-9-13-6-32-14.5-42-18-19-6.5-27.5-24.5-11.5-24.5 15 0 69 25 121 56 56 33.5 95.5 67.5 119 103 12 18 13 22.5 7 26.5-10.5 6.5-10.5 6.5-30.5-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "py0tcqcLY",
    className: "s16",
    d: "m273 1858c51-71 114-154 116.5-154 3 0 22 23.5 57.5 71.5l14 18.5h-15.5c-12 0-15.5-2-15.5-10 0-5.5-3.5-10-7.5-10-4 0-7.5-4.5-7.5-10 0-5.5-3.5-10-7.5-10-4.5 0-7.5-4.5-7.5-12.5 0-9-2.5-12.5-10-12.5-7.5 0-10 3.5-10 12.5 0 8-3 12.5-7.5 12.5-4 0-7.5 4.5-7.5 10 0 5.5-3.5 10-7.5 10-4 0-7.5 4.5-7.5 10 0 5.5-3.5 10-7.5 10-4 0-7.5 4.5-7.5 10 0 7.5-3.5 10-12.5 10-11 0-12.5 2-12.5 17.5 0 15.5-1.5 17.5-12.5 17.5-11 0-12.5 2-12.5 17.5 0 16-1 17.5-15.5 17.5h-15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDG15EjxA",
    className: "s16",
    d: "m-1426 1875.5c-12-3-11.5-16.5 0.5-16.5 15 0 25.5 5.5 25.5 13 0 7-9 8-26 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pR3GtTe2d",
    className: "s16",
    d: "m-1045 1869.5c0-7.5 3-10.5 10.5-10.5 7 0 9.5 2.5 8.5 8.5-2.5 13-19 14.5-19 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEmfEAHrr",
    className: "s16",
    d: "m-1215 1867c0-7.5 15-13 37.5-13 22.5 0 37.5 5.5 37.5 13 0 5.5-9 7-37.5 7-28.5 0-37.5-1.5-37.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdTzXqVsC",
    className: "s16",
    d: "m470 1831c0-19.5 4.5-19 20 3l10.5 15h-15c-14.5 0-15.5-1.5-15.5-18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfSeBENav",
    className: "s16",
    d: "m-3424.5 1820c-4.5-8.5-2-14 14-34.5 22-28 56-56.5 66.5-56.5 4 0 11.5 4.5 16.5 10 5 5.5 6.5 10 3.5 10-3.5 0-6 5-6 10.5 0 9-1.5 9.5-7 4.5-9.5-7.5-15.5-3.5-42 25.5-16 17.5-19.5 24-15 28.5 4.5 4.5 4 6-2 6-4.5 0-11.5 1.5-15.5 3-4.5 1.5-10-1-13-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyAlEdICv",
    className: "s16",
    d: "m-1270 1817.5c0-8.5 16-25.5 60-64 32.5-28.5 63-52.5 67-53.5 10.5-2 15 8 7.5 17.5-12.5 15-124.5 111.5-129.5 111.5-3 0-5-5-5-11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p190JKo1oL",
    className: "s16",
    d: "m1910 1771.5c0-3.5 40.5-32.5 46-32.5 2 0 4 5.5 4 12.5 0 8-3 12.5-7.5 12.5-4 0-7.5 2.5-7.5 5 0 3-8 5-17.5 5-9.5 0-17.5-1-17.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptnUwfTHO",
    className: "s16",
    d: "m1996 1735c-30-4.5 14-26 68-33.5 24-3 26-2.5 26 7 0 8-4 10.5-18.5 13-10.5 2-29 6-41.5 9-12.5 3.5-27.5 5.5-34 4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11wPGeDOD",
    className: "s16",
    d: "m2119 1720.5c-12-3-11.5-15 0.5-19 13-4 35.5 2 35.5 10 0 10.5-15.5 14.5-36 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUGGNupvk",
    className: "s16",
    d: "m-3338 1136c1.5-4.5 3-9 3-10 0-1 3.5-2 7.5-2 10 0 9.5 13-0.5 17-12 4.5-13.5 4-10-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19eGmwMw1",
    className: "s16",
    d: "m-3315 1109c0-2.5-3.5-5-7.5-5-5.5 0-7.5-5.5-7.5-18v-18.5l13 13c20.5 21 29 21 61 1.5 29.5-18.5 36-21 36-14 0 2-16 13.5-35 25-33.5 20-60 27-60 16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvDNazIGy",
    className: "s16",
    d: "m-3195 1045c0-4 35.5-26 42-26 9 0 0.5 9.5-16.5 19-21 12-25.5 13-25.5 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnSQVFTCd",
    className: "s16",
    d: "m-3145 1014.5c0-5.5 22.5-20.5 31-20.5 3.5 0 0 6-7.5 12.5-14.5 13-23.5 16-23.5 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pM775ZhFs",
    className: "s16",
    d: "m345 1001c-18-3.5-33-9-34-12-1-2.5-7.5-5-14-5-9.5 0-12-2.5-12-12.5 0-11 1.5-12 12-7.5 7 2.5 16.5 7 21.5 9.5 5 3 25.5 7.5 45.5 11 30 4.5 36 7 36 15 0 11.5-9 11.5-55 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18qUb1OhY",
    className: "s16",
    d: "m410 999.5c0-8 16.5-15.5 35.5-15.5 10 0 4 19-6.5 22-20.5 5.5-29 3.5-29-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p146bySH2j",
    className: "s16",
    d: "m470 991c0-7 8-12.5 31.5-21 17-6 43.5-20.5 58.5-31.5 15-11 31.5-21 36.5-22.5 4.5-2 8.5-6.5 8.5-10 0-4 4.5-9.5 10-13 5.5-3.5 10-10.5 10-15 0-5 3.5-9 7.5-9 4 0 7.5-4.5 7.5-10 0-8 3.5-10 15.5-10h15l-16.5 23.5c-27.5 39.5-66.5 76.5-81 76.5-9 0-12 2-10 7 3 8-49.5 35.5-77.5 41-13 2.5-15.5 1.5-15.5-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pq1d5cA8Y",
    className: "s16",
    d: "m2095.5 981c-11.5-8.5-25.5-35-25.5-49.5 0-4 4.5-7.5 10-7.5 7 0 10 3.5 10 10.5 0 12 25.5 39.5 37 39.5 4.5 0 8 3.5 8 7.5 0 10-24.5 10-39.5-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pshY1zDLM",
    className: "s16",
    d: "m2145 981.5c0-4 3.5-7.5 8-7.5 11.5 0 37-27.5 37-39.5 0-7 3-10.5 10-10.5 5.5 0 10 3.5 10 7.5 0 14.5-14 41-25.5 49.5-15 10.5-39.5 10.5-39.5 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "po1meTga8",
    className: "s16",
    d: "m-3180 971.5c0-11 2-12.5 18-12.5 22 0 21 9-2 18.5-15.5 6.5-16 6-16-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pC8zjcqWt",
    className: "s16",
    d: "m-3095 954.5c0-22.5 5-30.5 18-30.5 14.5 0 14.5 1.5 1 25.5-13 23-19 25-19 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FPqEZ706",
    className: "s16",
    d: "m224 948c-22.5-13-24-19-6-19 14 0 52 19 52 26 0 8-27.5 3.5-46-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLV9hlQGu",
    className: "s16",
    d: "m-3286.5 934c-2-8.5 0-10 12-10 9 0 14.5-2.5 14.5-6.5 0-9 21.5-18.5 40-18.5 14 0 15 1 14.5 19q-0.8 17.3-3 7.5c-1-6.5-3-11.5-4.5-11.5-1.5 0-15.5 7-32 15-35 17.5-38 18-41.5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FWOwHTFr",
    className: "s16",
    d: "m-3333 904c2-16.5 7.5-39 12-49 14-31.5 93-166 97-166 2 0 4 8 4 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 12-2.5 17.5-7.5 17.5-4.5 0-7.5 4.5-7.5 12.5 0 6.5-6 18-13 25-9.5 9.5-13.5 20-15.5 40-1.5 15-5 27.5-8 27.5-3 0-3.5-11.5-1.5-30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BwdyGQJI",
    className: "s16",
    d: "m178.5 920.5c-4.5-4-4.5-21.5-0.5-21.5 6 0 32 17 32 21 0 5-27 5.5-31.5 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTSmZUTW9",
    className: "s16",
    d: "m140 894.5l-17.5-15 16.5-0.5c16.5 0 23.5 7.5 20 22.5-1 6.5-5 5-19-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15mBK4sUx",
    className: "s16",
    d: "m-3055 881.5c0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-15.5 1.5-17.5 12.5-17.5 7 0 12.5 1 12.5 2.5 0 6-37.5 67.5-41 67.5-2 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17vJr8WH2",
    className: "s16",
    d: "m514 878.5c-14.5-8-10.5-15.5 7-13.5q16.5 1.5 18 10.5c2 9.5-11 11.5-25 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4UqZaB6B",
    className: "s16",
    d: "m83.5 838.5c-7.5-10-11-19.5-9.5-27.5 1-6.5 3.5-12 5.5-12 1.5 0.5 11.5 12.5 22 27.5 19 27.5 19 27.5 6.5 27.5-8 0-16.5-5.5-24.5-15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pR7MaYUVg",
    className: "s16",
    d: "m-1460 826.5c0-16 1-17.5 15-17.5h15l-11 17.5c-14.5 22-19 22-19 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptE4BKumw",
    className: "s16",
    d: "m336.5 777.5c-53-30.5-96.5-57.5-96.5-59.5 0-2.5 7-4 15.5-4 11 0 16 2.5 18 10 2 7 7 10 17.5 10 10.5 0 15.5 3 17.5 10 2 7 7 10 17.5 10 10.5 0 15.5 3 17.5 10 2 7 7 10 17 10 8.5 0 16 3 17.5 7.5 2 4 7.5 7.5 13 7.5 5.5 0 11 4 12.5 9.5 1.5 7 7.5 10.5 18.5 11.5 11.5 1 16 4 17 13 1 6 0 11-2.5 10.5-2 0-47.5-25-100-56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwCYh6rlm",
    className: "s16",
    d: "m675 822.5c0-18.5 14.5-43.5 25-43.5 8.5 0 9 2 4.5 13.5-7 19-21 41.5-25.5 41.5-2 0-4-5.5-4-11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p50bXQShA",
    className: "s16",
    d: "m1797.5 809c-6-2-13.5-7.5-17-12-6-7-5-8 9-8 9.5 0 17 3 18.5 7.5 4.5 11.5 0.5 16.5-10.5 12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peVsRFXCB",
    className: "s16",
    d: "m1834.5 809c-0.5-3-1-7-1.5-9.5-0.5-3 42.5-29.5 95-60 68-39 99-54 106.5-52 8 2 10.5 0.5 10.5-6.5 0-7 29.5-26.5 112.5-74 62-35.5 112.5-65.5 112.5-67 0-1.5-3.5-7-8.5-12-7.5-8.5-7-9 10-9 15 0 18.5 2 18.5 9.5 0 5.5 1 12.5 2.5 16.5 2 4.5-12 15-40 31.5-37 21-43 26.5-45.5 41-3 16.5-17 23.5-17 9 0-12-8.5-9-51.5 15.5-31 18-40.5 21.5-44 16.5-3-5-4.5-4-4.5 4.5 0 6-2 11-5 11-2.5 0-5 7-5 15 0 17-8.5 20.5-11 5-1.5-9-14-3-106.5 50.5-112.5 64.5-127 72-128 64.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14R6AexMo",
    className: "s16",
    d: "m-3000 786.5c0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-12 2.5-17.5 7.5-17.5 4.5 0 7.5-4.5 7.5-12.5 0-10 2.5-12.5 12.5-12.5 7 0 12.5 1 12.5 2.5 0 6-72.5 127.5-76 127.5-2.5 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19bIFHxFt",
    className: "s16",
    d: "m-1460 795.5c0-7 1-7.5 4.5-2.5 3 5 11-3.5 28-31 13-21 25.5-38 28-38 2.5 0 4.5-3.5 4.5-7.5 0-4 2.5-7.5 5-7.5 3 0 5-3.5 5-7.5 0-4.5 4.5-7.5 12.5-7.5 7 0 12.5 1.5 12.5 3 0 2-15 26.5-33.5 55-31 49-34 52-50 52-12.5 0-16.5-2-16.5-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8gOccjMh",
    className: "s16",
    d: "m1760 767c-8.5-23-8-43 1.5-43 3.5 0 9 9.5 12.5 21.5 3.5 11.5 7.5 24 9 27.5 2 3.5-1 6-7.5 6-6.5 0-12.5-4.5-15.5-12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CGQUgUed",
    className: "s16",
    d: "m39 748c-4.5-14.5-9.5-37-11.5-50-3-22-2-24 7-24 7.5 0 11 4.5 13 19 2 10 7.5 32.5 12.5 50l9 31h-11c-9 0-12.5-5-19-26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pghdjn93M",
    className: "s16",
    d: "m705 756.5c0-15.5 1.5-17.5 12.5-17.5 15 0 15 1.5 4 20.5-11.5 19-16.5 18.5-16.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVHMfBBDL",
    className: "s16",
    d: "m1776 709c1.5-15.5 5-19.5 36.5-38.5 19.5-11.5 37-21.5 39-21.5 2.5 0 3.5 5 2.5 11.5-1 8.5-5.5 11.5-17.5 12.5-10 1-16.5 4.5-16.5 8.5 0 3.5-7.5 12-16 18-9 6-19.5 14.5-23 19-6 7-6.5 5.5-5-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWg2kAV7B",
    className: "s16",
    d: "m-1570 714c0-2.5-5-5.5-11-5.5-7-0.5-8.5-1.5-4-3 4-1 11.5-11 16.5-21.5 5-11 11-20 13.5-20 6 0 9.5 26.5 4.5 36.5-4 7-2.5 9.5 6.5 13.5 10 4 9.5 4.5-7 4.5-10.5 0.5-19-1.5-19-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p0CopooyL",
    className: "s16",
    d: "m740 696.5c0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-14 2-17.5 10-17.5 8 0 10-3.5 10-15 0-9 3-16.5 7.5-18 4-2 7.5-8.5 7.5-15 0-9.5 2.5-12 13-12 7 0 12 2 11 4.5-5 14.5-92 160.5-95 160.5-2 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptmcOfNTU",
    className: "s16",
    d: "m194 695c-18.5-11-17.5-17 2.5-15 12 1 16.5 4 17.5 13 2 13-2 13.5-20 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FYocgYf0",
    className: "s16",
    d: "m-1360 659.5c0-5.5-1.5-10.5-3.5-11.5-2.5-0.5-8-10-12.5-20-6.5-13.5-16.5-23-36.5-34.5-15-8.5-27.5-17.5-27.5-20 0-2.5 8-4.5 17.5-4.5 12 0 17.5 2.5 17.5 7.5 0 4.5 4.5 7.5 12.5 7.5 9 0 12.5 2.5 12.5 10 0 6.5 3.5 10 10 10 6.5 0 11 5 14.5 16.5 3.5 12.5 4.5 13.5 5 5 0.5-6.5 3-11.5 5.5-11.5 3 0 5-3.5 5-7.5 0-4 3.5-7.5 7.5-7.5 4.5 0 7.5-4.5 7.5-12.5 0-10 2.5-12.5 13-12.5 15.5 0 14.5 3.5-10 42.5-10 15-19 33-21 40-3.5 14.5-17 17-17 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p111bCbJuG",
    className: "s16",
    d: "m-3210 661.5c0-6 57.5-102.5 61-102.5 2 0 4 8 4 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1-12.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1C17VCog1",
    className: "s16",
    d: "m107.5 638c-14.5-15.5-28-35.5-32-47.5-4-12-9-21.5-11-21.5-3.5 0-11 29-17 66.5-2 14-5.5 18.5-12.5 18.5-12 0-12-2.5-2.5-48 8.5-40 37.5-113 46.5-116 4-1 6 4.5 6 16 0 12.5-2 18-7.5 18-4.5 0-7.5 4.5-7.5 12.5 0 7.5 3 12.5 7.5 12.5 4 0 8.5 7.5 10.5 19 2 10 5 19.5 6.5 21 7 6 15.5 26 15.5 37 0 10.5 3 12.5 16.5 14 12 1 16.5 4 17.5 13 2.5 18-9 13-36.5-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPggoNnhe",
    className: "s16",
    d: "m1860 654c0-5.5 4-12 9-13.5 4.5-2 11-6 14-9 3-2.5 46-28.5 96-57.5 84.5-48 91-53 94-68.5 3-16.5 17-23.5 17-9 0 10.5 9.5 9.5 32.5-5 11-6.5 21.5-12.5 24-12.5 7.5 0 3 20.5-5 23.5-5 2-10 5-11.5 7-1.5 2-32.5 21-69.5 42-52 30-68 37-71 31.5-3.5-5-4.5-4.5-4.5 2.5 0 5-4 10.5-8.5 12-5 2-10 5-11.5 7-3 4-98 59.5-102 59.5-2 0-3-4.5-3-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16IRApj3s",
    className: "s16",
    d: "m-1545 636.5c9.5-25 21-44 39.5-64.5 10.5-11 24-30 30.5-41.5 14-25 20-27 20-7 0 19.5-4.5 30.5-13 30.5-4 0-7 2.5-7 5 0 3 4.5 5 10 5 18.5 0 10 13.5-12.5 20-12 3.5-21.5 7.5-21 9.5 0.5 1.5-5.5 15-13.5 29.5-11 19.5-17.5 26-26 26-10.5 0-11-1.5-7-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjHERXciq",
    className: "s16",
    d: "m-2905 621.5c0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-15.5 1.5-17.5 12.5-17.5 7 0 12.5 1 12.5 2.5 0 6-37.5 67.5-41 67.5-2 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAPt6wbKN",
    className: "s16",
    d: "m2124 585.5c-17-19-7.5-53.5 16-56.5 27-4 36 12 10.5 17.5-13.5 3-15 5.5-16.5 26-1.5 22-2 22.5-10 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppeDRpxqc",
    className: "s16",
    d: "m2145 584c0-8 3.5-10 18.5-10 17.5 0 18 0 9 10-5 5.5-13 10-18.5 10-5.5 0-9-3.5-9-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paJUSRXkD",
    className: "s16",
    d: "m2367.5 572c-2.5-1.5-13.5-3.5-23.5-5.5-10.5-1.5-19-5.5-19-9 0-4.5 17-6.5 65-6.5 46 0 65 2 65 6 0 3.5-5.5 7.5-12.5 9-17 4.5-69 8.5-75 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16JwCkP4Z",
    className: "s16",
    d: "m-1300 551.5c0-15.5 1.5-17.5 12.5-17.5 15 0 15 1.5 4 20.5-11.5 19-16.5 18.5-16.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pg9OsoPIo",
    className: "s16",
    d: "m2480 536.5c0-7.5 3-12.5 7-12.5 4 0 8-2.5 9-5.5 1-3 9.5-4.5 19-3.5l17.5 1.5-22 16.5c-26.5 19.5-30.5 20-30.5 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pG4OBGYlw",
    className: "s16",
    d: "m-2850 526.5c0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-12 2.5-17.5 7.5-17.5 4.5 0 7.5-4.5 7.5-12.5 0-10 2.5-12.5 12.5-12.5 7 0 12.5 1 12.5 2.5 0 6-72.5 127.5-76 127.5-2.5 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRVUklhOE",
    className: "s16",
    d: "m-3135 531.5c0-6 37.5-67.5 41-67.5 2 0 4 8 4 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1-12.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11rsaHoOq",
    className: "s16",
    d: "m845 516c0-16.5 8.5-32 17.5-32 5 0 7.5-5.5 7.5-17.5 0-12 2.5-17.5 7-17.5 4 0 8-5 9-11 1-7.5 5.5-12 13-13 6-1 11-0.5 11 1 0 6-57.5 103-61 103-2.5 0-4-6-4-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdLM9NNgF",
    className: "s16",
    d: "m-1260 486.5c0-12 2.5-17.5 7.5-17.5 4.5 0 7.5-4.5 7.5-12.5 0-8 3-12.5 7.5-12.5 4.5 0 7.5-4.5 7.5-12.5 0-9 2.5-12.5 10-12.5 8 0 10-3.5 10-17.5 0-15.5 1.5-17.5 12.5-17.5 7 0 12.5 1.5 12.5 3 0 6-67.5 117-71 117-2 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1ERrJSzCK",
    className: "s16",
    d: "m2540 487c0-16.5 1-18 15.5-18h15l-10.5 15c-15.5 22-20 22.5-20 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16NcEPnaI",
    className: "s16",
    d: "m2155 484c0-6 5-12.5 12.5-16 14-6 16.5-14 5-14-4 0-7.5-3.5-7.5-7.5 0-5 5.5-7.5 17.5-7.5 16.5 0 17.5 1 17.5 16.5 0 13.5-3 18-20 27.5-24 13.5-25 13.5-25 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pB6N50RxA",
    className: "s16",
    d: "m-1450 486c0-6.5 22-42 26-42 4.5 0 5.5 25.5 1 37-3 7.5-27 12-27 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppiuT3Sq1",
    className: "s16",
    d: "m80 480c0-2.5 6.5-13.5 14-24 8-10.5 22-32.5 31-48 9.5-16 19-29 21-29 2.5 0 4 8 4 17.5 0 12-2.5 17.5-7.5 17.5-4.5 0-7.5 4.5-7.5 12.5 0 9-2.5 12.5-10 12.5-6.5 0-10 3.5-10 10 0 15-14.5 35-25.5 35-5.5 0-9.5-2-9.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GM9Kl7c1",
    className: "s16",
    d: "m2365 446.5v-22.5h18.5 18.5l-11 11-11 11 11 11.5 10.5 11.5h-18-18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11Y4gVYEm",
    className: "s16",
    d: "m2565 442c0-9.5 2.5-18 5.5-19 3-1 6.5-23 8-50.5 2-35 5-48.5 9.5-48.5 10 0 14 32.5 8 67-9 55-31 91-31 51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Eccc2zcA",
    className: "s16",
    d: "m-3080 436.5c0-6.5 152.5-267.5 156-267.5 2.5 0 4 8 4 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 12-2.5 17.5-7.5 17.5-4.5 0-7.5 4.5-7.5 12.5 0 9-2.5 12.5-10 12.5-8 0-10 3.5-10 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1-12.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHdtWMyvc",
    className: "s16",
    d: "m-1420 431c0-6.5 22-42 26-42 4.5 0 5.5 25.5 1 37-3 7.5-27 12-27 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peDt6PPuR",
    className: "s16",
    d: "m2235 429.5c0-2.5 23-16.5 51.5-31.5 28-14.5 101-56 162.5-91.5 90-52 112.5-63 116.5-57 7 11.5 5.5 14.5-8 14.5-8 0-12.5 3-12.5 7.5 0 5-5.5 7.5-17.5 7.5-14 0-17.5 2-17.5 10 0 8-3.5 10-17.5 10-14 0-17.5 2-17.5 10 0 7.5-3.5 10-12.5 10-8 0-12.5 3-12.5 7.5 0 5-5.5 7.5-17.5 7.5-14 0-17.5 2-17.5 10 0 7.5-3.5 10-12.5 10-7.5 0-12.5 3-12.5 7 0 7.5-10.5 13-25.5 13-5 0-9.5 3.5-9.5 7.5 0 5-5.5 7.5-17.5 7.5-13.5 0-17.5 2-17.5 9 0 6-9.5 13.5-27.5 22.5-27 13-57.5 18-57.5 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p164MKTjQ0",
    className: "s16",
    d: "m2486.5 419.5c4-19-1-36.5-9.5-33.5-4 1.5-7 0.5-7-2 0-3 8-5 17.5-5h17.5v27.5c0 24.5-1 27.5-10.5 27.5-9 0-10.5-2-8-14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plwwqofC5",
    className: "s16",
    d: "m908 395.5c2.5-13.5 4-42.5 3.5-65-0.5-32 1-41.5 6-41.5 9.5 0 19 50.5 15 76.5-5 28-15.5 53.5-23 53.5-4.5 0-4.5-6.5-1.5-23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBAVUNeQv",
    className: "s16",
    d: "m2415 406.5c0-11 2-12.5 17.5-12.5 21.5 0 22 5 3 16.5-19 11-20.5 11-20.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRsQTRUdj",
    className: "s16",
    d: "m2051 405c-13-8.5-46-49.5-46-56.5 0-2.5 5.5-4.5 12.5-4.5 9 0 12.5 2.5 12.5 10 0 5.5 3 10 6.5 10 12 0 29.5 23 27.5 36.5-1.5 12-2 12-13 4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppHKyttje",
    className: "s16",
    d: "m2190 369c0-22.5 11.5-28.5 17-8.5 5.5 20.5 3.5 28.5-7 28.5-8.5 0-10-3.5-10-20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DGNhIGBK",
    className: "s16",
    d: "m-2755 361.5c0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-15.5 1.5-17.5 12.5-17.5 7 0 12.5 1 12.5 2.5 0 6-37.5 67.5-41 67.5-2 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9kKfletX",
    className: "s16",
    d: "m-1390 376c0-6 17-32 21-32 2 0 4 8 4 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9k31yIzN",
    className: "s16",
    d: "m-1175 333c0-21.5 6-30.5 19-28l10.5 1.5-9.5 21.5c-11.5 25-20 27-20 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puontwXuV",
    className: "s16",
    d: "m-1355 316c0-6 17-32 21-32 2 0 4 8 4 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxhViPd0Z",
    className: "s16",
    d: "m180 316.5c0-6 37.5-67.5 41-67.5 2 0 4 8 4 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1-12.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRshbYFTX",
    className: "s16",
    d: "m2570 296.5c0-19.5 7-23 15-8 8 15.5 6 25.5-5 25.5-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYIIyeyTl",
    className: "s16",
    d: "m1983 298c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Gk7zWs9d",
    className: "s16",
    d: "m2070 280.5v-18.5l17.5 17c9.5 9.5 17.5 17.5 17.5 18.5 0 1-8 1.5-17.5 1.5-17 0-17.5-0.5-17.5-18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12Gl8Do1b",
    className: "s16",
    d: "m-1150 276.5c0-9.5 2.5-17.5 5-17.5 3 0 5-5.5 5-12.5 0-10 2.5-12.5 12.5-12.5h12.5l-10.5 26c-12.5 31.5-14 34-20 34-2.5 0-4.5-8-4.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12PrKTqic",
    className: "s16",
    d: "m-2730 275c10-8 9.5-8.5-23.5-8.5-27 0-34-1.5-35.5-8-1-6.5 4-8 28-8 51.5-0.5 80-22 115.5-87 14.5-26 15.5-30.5 7.5-27.5-5 2-15.5 5-23 6.5-23 4.5-17-11 7.5-20.5 44.5-17 73.5-59.5 73.5-108 0-88.5-89.5-137.5-165-91-18 11.5-24 13-28.5 8-8-8 3.5-18 36-32.5 61-27 132.5-1.5 164 57.5 8.5 16 11 29 11 60.5 0 45.5 5 34-73.5 170l-54.5 95-25 1c-24.5 1-25 1-14.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GG1dZH1K",
    className: "s16",
    d: "m883.5 260.5c-2-1.5-3.5-7-3.5-12 0-5-5-9.5-12.5-11.5-7-2-12.5-5.5-12.5-8 0-3-3.5-5-7.5-5-4.5 0-9-3.5-10.5-7.5-2-4-7.5-7.5-13-7.5-5.5 0-11-4-12.5-10-2-7-7-10-17-10-8.5 0-16-3-17.5-7.5-2-4-7.5-7.5-12.5-7.5-5.5 0-11-3.5-12.5-7.5-2-4-7.5-7.5-12.5-7.5-5.5 0-11-3.5-12.5-7.5-2-4-8.5-7.5-15-7.5-8.5 0-12-3-12-10 0-8-3.5-10-17.5-10-14 0-17.5-2-17.5-9.5 0-7.5-4-10.5-16-11.5-12.5-1-17-4-18-12.5-1-6.5 0-11.5 1.5-11.5 7 0 215.5 123.5 238.5 141 10.5 8 23.5 21.5 29 29.5l10.5 14.5h-12c-6.5 0-13.5-1.5-15-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pChRmSLKV",
    className: "s16",
    d: "m1978.5 254c-3.5-14 1.5-30 9.5-30 5 0 7 6.5 7 20 0 21.5-11.5 28.5-16.5 10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psKGwTByf",
    className: "s16",
    d: "m2050 236.5c0-19 1.5-22.5 10-22.5 8.5 0 10 3.5 10 22.5 0 19-1.5 22.5-10 22.5-8.5 0-10-3.5-10-22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXEza0064",
    className: "s16",
    d: "m-1294.5 221.5c25-34.5 29.5-37 29.5-15.5 0 12.5-2 18-7.5 18-4 0-7.5 4.5-7.5 10 0 8-3.5 10-15.5 10h-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRsc4lxA4",
    fillRule: "evenodd",
    className: "s16",
    d: "m-2856 210.5c-1-10-4.5-14.5-12.5-15.5-6.5-1-11.5-3.5-11.5-5.5 0-2-3.5-8-8-13.5-7.5-9-7.5-9-5.5 2 2 9 0.5 11-5.5 10-6-1-9-7.5-10-20.5-1.5-16 0-18.5 8.5-18.5 6 0 10.5-3.5 10.5-7.5 0-4-3.5-7.5-7.5-7.5-4 0-7.5-1-7.5-2.5 0-3 70-125 91-158.5 9.5-15 18.5-24 24.5-24 11.5 0 11.5-3-0.5 29-13.5 35-12.5 59 3 90 15 30 35 47.5 66 56.5 21.5 6 29 19.5 11 19.5-23 0-68-26-62-35.5 1.5-2.5-1-4.5-5-4.5-4 0-13-7-20-16l-12.5-16-16 34c-17 37-21 76-10 104.5 5 12.5 4.5 13.5-7 13.5-9 0-12-3-13.5-13.5zm26-138c12-24 20-45 18-47-9-9-58 87-58 113 0 28 6.5 29 13 2 3-13 15-44 27-68z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piTisAGVh",
    className: "s16",
    d: "m235 221c0-6 17-32 21-32 2 0 4 8 4 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GdEs4AUW",
    className: "s16",
    d: "m1980 213c0-15 6.5-29 13-29 4.5 0 7 6 7 17.5 0 14-2 17.5-10 17.5-5.5 0-10-3-10-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Da954w4O",
    className: "s16",
    d: "m2123.5 183.5c-2-7.5-5.5-10-10.5-8-5.5 2.5-8 0-8-6.5 0-8 3.5-10 17.5-10 16.5 0 17.5 1 17.5 17.5 0 19.5-12 24.5-16.5 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZWLacKxd",
    className: "s16",
    d: "m-1255 169c15.5-22 20-22.5 20-3 0 16.5-1 18-15.5 18h-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pw7kVGaCR",
    className: "s16",
    d: "m2005 145c0-15 66-81 80.5-81 2.5 0 4.5 5.5 4.5 12.5 0 9-2.5 12.5-10 12.5-5.5 0-10 3.5-10 7.5q0 7.5-15 7.5c-13.5 0-15 1.5-15 15 0 8.5-2 15-5 15-2.5 0-5 3.5-5 7.5 0 4.5-4.5 7.5-12.5 7.5-7 0-12.5-2-12.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMC0FRr6d",
    className: "s16",
    d: "m-1090 127c0-16 1.5-18 12.5-18 12 0 12.5 0.5 6 16-9.5 23-18.5 24-18.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8mXY4t9n",
    className: "s16",
    d: "m-1226.5 133c22-29 63-79 64.5-79 1 0 2 8 2 17.5 0 14-2 17.5-10 17.5-7.5 0-10 3.5-10 12.5 0 9-2.5 12.5-10 12.5-7.5 0-10 3.5-10 12.5 0 10.5-2.5 12.5-15.5 12.5-12 0-14.5-1.5-11-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Fa4iwx9F",
    className: "s16",
    d: "m300 110.5c0-8 32.5-52.5 50.5-68.5 22.5-21 31-22.5 28.5-6.5-1 8.5-5.5 11.5-17.5 12.5-12 1-16.5 4-16.5 11 0 14.5-5.5 25-13 25-4.5 0-7 5.5-7 15 0 12.5-2 15-12.5 15-7 0-12.5-1.5-12.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNWQZquan",
    className: "s16",
    d: "m-1075 87c0-16 1.5-18 12.5-18 12 0 12.5 0.5 6 16-9.5 23-18.5 24-18.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AjTASyTl",
    className: "s16",
    d: "m576.5 67c-2-4-8.5-7.5-14-8.5-9-2-18-24.5-10-24.5 6.5 0 57.5 32.5 57.5 36 0 7-29.5 4-33.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSJKKpOKs",
    className: "s16",
    d: "m-1060 47c0-16 1.5-18 12.5-18 12 0 12.5 0.5 6 16-9.5 23-18.5 24-18.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJBzbY8Cd",
    className: "s16",
    d: "m2125 52c0-6.5 14-13 29-13 3 0 6 4.5 6 10 0 8-3.5 10-17.5 10-11.5 0-17.5-2.5-17.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLc0BNnHk",
    className: "s16",
    d: "m2170 47c0-7.5 22.5-15 30-10.5 12 7.5 4.5 17.5-12.5 17.5-11.5 0-17.5-2.5-17.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2nOzhSGk",
    className: "s16",
    d: "m-1139.5 25.5c18-23 101.5-121.5 103-121.5 0.5 0 1.5 8 1.5 17.5 0 16-1 17.5-15 17.5-14 0-15 1.5-15 17.5 0 15.5-1.5 17.5-12.5 17.5-10.5 0-12.5 2.5-12.5 15 0 12.5-2 15-12.5 15-10.5 0-12.5 2.5-12.5 15 0 13.5-1.5 15-15.5 15-14.5 0-15-1-9-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HBGXQ9bD",
    className: "s16",
    d: "m385 23.5c0-5.5 30-19.5 42.5-19.5 12 0 9 18.5-3.5 22-18 4.5-39 3.5-39-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKuHav2Dr",
    className: "s16",
    d: "m484 25.5c-11-3-12-21.5-1.5-21.5 12.5 0 42.5 14 42.5 19.5 0 5.5-24.5 6.5-41 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnUdOdaJF",
    className: "s16",
    d: "m-1040-4.5c0-26 5.5-36.5 18-36.5h12l-9 23.5c-10 27-21 34-21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FZMzezy0",
    className: "s16",
    d: "m-1005-113.5c0-14 2-17.5 10-17.5 10.5 0 12 5 7 24-5 18-17 13.5-17-6.5z"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "l17A3quOFWu7slU0cB0HtgT"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "p192Nhvggd",
    className: "s17",
    d: "m-1240 2501.5c0-16 1-17.5 15-17.5 14 0 15 1.5 15 17.5 0 16-1 17.5-15 17.5-14 0-15-1.5-15-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17uPHsKFB",
    fillRule: "evenodd",
    className: "s17",
    d: "m-1741 1059c-45-9.5-63.5-14.5-108-31l-26.5-10 32.5-34c41-43.5 71-88 89.5-132.5 20-47.5 33-67 62-92 32.5-29 68-49 94-53 12-1.5 23-6 24.5-10 1.5-4 8.5-7.5 16-7.5 11.5 0 12.5 1 7 7.5-8 9.5-3.5 14.5 22 22.5 25 8 54 34.5 65.5 60 8.5 18.5 9.5 19.5 17.5 12.5 8-7.5 9-7 12 5 2 8.5 0 17-6.5 26.5-5.5 7.5-12 29.5-15.5 50-23.5 160.5-117.5 221.5-286 186zm101-61c31-7.5 65-25.5 80.5-42.5 42.5-45.5 64-149 38.5-186.5-19-27.5-36.5-37.5-65.5-37.5-21 0-31.5 3-51 16-45 29-67 55-95 114-14.5 30.5-40 73.5-57 96-16.5 22-30.5 42-30.5 43.5 0 8.5 141 6.5 180-3z"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "l2s5FktmybIx1Q1kXnC1Uz2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "p1Bub9xkXe",
    className: "s18",
    d: "m540 5224.5c0-2.5-5-6-11-7.5-6.5-1.5-20.5-11-31.5-20.5-11-9.5-21.5-17.5-23.5-17.5-2.5 0-4-7-4-15.5v-15.5l14 11c7.5 5.5 28 20.5 46 33l32.5 22 1.5-15c1-11 4-15 11.5-15 8 0 9.5 3.5 9.5 22.5v22.5h-22.5c-12.5 0-22.5-2-22.5-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peC87GBj7",
    className: "s18",
    d: "m562.5 5155.5c-7.5-45-19.5-88-33.5-117.5-26-55-146-259-153-259-11 0-96 50.5-96 57 0 7.5 124 225.5 145.5 255.5 8 11 19 26 25 34l10.5 13.5h-15.5c-12 0-16-2.5-18.5-12.5-1.5-7-6-12.5-10-12.5-4 0-7-3.5-7-7.5 0-4-2-7.5-5-7.5-2.5 0-5-3.5-5-7.5 0-4-2-7.5-5-7.5-2.5 0-6-5.5-8-12.5-1.5-7-5-12.5-7-12.5-2.5 0-7-8-10.5-17.5-3.5-9.5-8-17.5-10-17.5-2 0-6.5-7.5-10-16-3.5-9-9.5-19.5-13-23-3.5-3.5-6.5-12-6.5-19 0-7-3-12-7-12-7.5 0-13-10.5-13-25.5 0-5-3-9.5-7-9.5-4 0-9-5-11-11-2-6.5-5-12.5-7-14-16.5-11.5-33.5-80-19.5-80 3 0 8.5-3.5 12.5-7.5 4.5-4 13-7.5 20-7.5 6.5 0 12-3 12-6.5 0-8.5 21-18.5 37.5-18.5 8 0 12.5-3 12.5-7.5 0-12 29.5-9.5 40.5 3.5 5.5 5.5 9.5 13.5 9.5 17.5 0 3.5 2 6.5 4.5 6.5 2.5 0 6.5 5 8.5 11.5 2 6 5 12 7 13.5 4.5 3 38 62 46 81.5 3.5 7.5 7.5 13.5 9.5 13.5 2 0 6 7.5 10 16.5 3.5 8.5 8 17 9.5 18.5 2 1.5 7 9.5 11.5 17.5 42 77.5 56.5 118.5 62 176.5 2.5 26.5 1.5 31-5 31-5.5 0-9-6-11-18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTZdoTdVV",
    className: "s18",
    d: "m-1305 4783.5c0-16 12-49.5 18-49.5 7.5 0 9 14 4 39.5-2.5 10.5-6 15.5-12.5 15.5-5.5 0-9.5-2.5-9.5-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pT9jQMhZg",
    className: "s18",
    d: "m-1316.5 4629.5c-11-19-11-20.5 4-20.5 11 0 12.5 2 12.5 17.5 0 21.5-5 22-16.5 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13C5D4jDI",
    fillRule: "evenodd",
    className: "s18",
    d: "m298.5 2756.5c-90.5-18-188-92-240-182.5-7-12.5-20-43.5-28.5-69.5-15.5-46-16-49-14-117.5 2.5-80 8-100 49.5-187.5 54-114 138-247 261.5-414 43-59 45.5-61.5 63-61.5 17.5 0 20 2 76 78.5 146.5 200.5 240.5 359 282.5 479 13 37 14 45 13.5 115 0 68.5-1.5 78.5-14 115-16 46.5-33.5 79-65 118.5-48.5 61-132.5 113-204.5 126.5-48 9-134 9-180 0zm173.5-20c73.5-15.5 155-70 202.5-134.5 23.5-32.5 31-46 12.5-23-47.5 58.5-98.5 102-143.5 123-120.5 55-272 39-376-40-14.5-11-17.5-12-10-4 25.5 30 104.5 70 158 80.5 35.5 7 119 6 156.5-2zm119-167c21-5.5 56-19 78.5-30 22-11.5 43.5-20.5 47-20.5 11.5 0 24-53 27-110 2-44 1-59.5-8-91-23.5-87.5-83.5-202-184.5-354-60-90.5-155-220-161-220-6 0-57.5 75-106 153-48 78-89 159.5-110.5 220-46 128.5-10.5 267 93.5 366 84.5 80.5 213.5 114.5 324 86.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pV86oWdjA",
    fillRule: "evenodd",
    className: "s18",
    d: "m-2801 2174.5c-35.5-22.5-41.5-43-37.5-134.5 1.5-40.5 4.5-78 6.5-82.5 6-16 36-10.5 91 16.5 86 42.5 107 71.5 98.5 136.5-3 22.5-7 29-27 49-25.5 24.5-39.5 29.5-82.5 29.5-20 0-31.5-3.5-49-14.5zm96-15.5c24.5-12.5 40.5-35.5 43.5-62 5-41-21.5-70-95.5-105.5-26-12.5-49.5-22.5-52-22.5-7 0-12.5 64.5-10.5 114 1.5 31 4.5 43.5 12.5 54.5 22.5 30.5 66 40 102 21.5z"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "l58svNxAom5yH5ZeW3L582L"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pn7ZdFZcR",
    className: "s19",
    d: "m529 5219c-12.5-8-24.5-17-26.5-19.5-5.5-9.5 24-6 41.5 4.5 17 10.5 26.5 12.5 25.5 6.5-1.5-10.5 1-16.5 7.5-16.5 9 0 12.5 15 7.5 29-6 15.5-26.5 14-55.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DxoPuwp2",
    className: "s19",
    d: "m-1210 5219c0-2.5-8-5-17.5-5-16 0-19.5-2.5-35-27.5-10-15-25-41.5-34-59-9-17-21-38-27-46.5-19-26.5-51.5-93.5-51.5-106 0-6.5-6-23.5-13.5-37l-13.5-25-30 4.5c-38.5 5-74.5 3.5-101.5-4-17-4.5-21.5-8-21.5-17 0-11.5 0-11.5 25.5-4 37 11 100 7 129.5-8.5 33.5-17 57.5-37.5 73.5-62.5 13.5-21.5 21.5-28 21.5-18 0 2.5 1 8 2.5 11.5 1.5 4-5 17-14.5 29-16 20.5-16.5 22-10 38 4 9 7 23.5 7 32 0 13.5 1.5 15 15 15 9.5 0 18.5 4 24 10.5 4.5 6 11.5 13.5 14.5 17 11 11.5 96 161.5 99.5 175 1.5 7 5 12.5 7 12.5 7 0 12 32 5.5 34-3 1-4.5 4-3 6.5 1.5 2.5 0.5 9-2.5 14.5-9 17-50 33.5-50 20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1G2Jzfys8",
    className: "s19",
    d: "m-3388 5178.5c1.5-8.5 3-17.5 3-20 0-9 14-4 16.5 5.5 1.5 5.5 6 10 10.5 10 14.5 0 8.5 13.5-7.5 17-25 5-26 4-22.5-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1io3sAFM",
    className: "s19",
    d: "m-2615 5184c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvYj0nPy0",
    className: "s19",
    d: "m-3230 5182.5c0-5 0.5-9 1.5-9.5 0.5 0 51-2 112-3.5 78.5-2 113-5 117-9 9.5-9.5 10-22.5 12.5-239 2-205-0.5-238.5-17-250.5-15.5-11.5-42-13-203.5-13-142 0-160 1-161.5 8-4 20.5-21-1-21-26.5 0-2 104.5-4 232.5-5 148-1 232.5 0.5 232.5 3.5 0 2.5 12 6.5 27 8 15.5 2 30 7 34 11.5 5 6.5 6.5 54.5 7.5 231 0.5 242.5-2.5 287.5-20.5 292.5-6 1.5-87.5 4.5-181.5 6.5-158 3-171.5 2.5-171.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIaybcw5Q",
    className: "s19",
    d: "m470 5174.5l-17.5-15 16.5-0.5c16.5 0 23.5 7.5 20 22.5-1 6.5-5 5-19-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HrnHe2ww",
    className: "s19",
    d: "m428 5131c-11-13.5-22-27.5-24.5-30.5-3.5-5-1.5-6.5 8-6.5 17.5 0 40 29 37.5 48-1.5 13.5-2 13.5-21-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11HwOL8Gq",
    fillRule: "evenodd",
    className: "s19",
    d: "m2209 5075.5c-14.5-15.5-135.5-222.5-147.5-252.5-4-10.5-9-19-11-19-2 0-7.5-7-12.5-15.5-7.5-12.5-10-14.5-13.5-8.5-2.5 5-9 7-16.5 5.5l-12.5-2.5 11-17c11-16.5 18.5-21.5 18.5-12 0 3 3.5 5 7.5 5 4 0 7.5-2 7.5-5 0-9 37-5 50 5 16.5 13 19 12.5 16-2.5-1.5-10 0-12.5 8.5-12.5 6 0 10.5-3 10.5-7.5 0-4 2-7.5 4-7.5 4 0 160 266.5 167 285.5 2 5.5 1.5 9.5-1 9.5-3 0-5 4.5-5 10 0 5.5 2.5 10 5 10 8.5 0 5.5 10-7.5 22.5-8 8.5-17.5 12.5-30 12.5-9.5 0-17.5 2.5-17.5 5 0 10-18.5 4.5-31-8.5zm-64-294c0-14-2-17.5-10-17.5-18 0-9.5 32.5 9 35 0.5 0 1-8 1-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcdrKL8TA",
    className: "s19",
    d: "m368.5 5041.5c-10-17.5-18.5-33.5-18.5-35 0-2 5-2.5 11.5-1.5 8.5 1 11.5 5.5 12.5 17 1 11 4.5 17 11.5 18.5 7 2 9.5 7 9.5 18 0 8.5-2 15.5-4 15.5-2 0-12-14.5-22.5-32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15H4qs0mf",
    className: "s19",
    d: "m540 5046c0-22 9-21 18.5 2 6.5 15.5 6 16-6 16-11 0-12.5-2-12.5-18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pc0bvCNjw",
    className: "s19",
    d: "m513.5 5000.5c-2-1.5-3.5-9.5-3.5-17 0-9-3-14-10-16-7-2-10-7-10-17.5 0-10.5-3-15.5-10-17.5-6-1.5-10-7-10-12.5 0-5.5-3.5-11-7.5-13-4.5-1.5-7.5-9-7.5-17.5 0-10-3-15-10-17-7.5-2-10-7-10-18 0-11-2.5-15.5-8-15.5-4.5 0-9-4.5-10.5-10-1.5-5.5-4-10-6-10-2 0-8.5-8.5-14.5-19.5-16-28-14-62 2.5-36.5 17 28 136.5 235.5 136.5 238 0 4-17.5 3.5-21.5-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcYOUFeo9",
    className: "s19",
    d: "m293.5 4911.5c-10-17.5-18.5-33.5-18.5-35 0-2 5-2.5 11.5-1.5 8.5 1 11.5 5.5 12.5 18 1 12 4 16 11.5 16 7.5 0 9.5 3.5 9.5 17.5 0 9.5-2 17.5-4 17.5-2 0-12-14.5-22.5-32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRdK0dT5X",
    className: "s19",
    d: "m-1593 4881.5c-2-4-6.5-7.5-10.5-7.5-4 0-8.5-4.5-10-10-1.5-5.5-6-10-10-10-4 0-8.5-4.5-10-9.5-1.5-5.5-5.5-11-9.5-12.5-7-2.5-10-33-3-33 2 0 11 11.5 20 25 9.5 13 28 31.5 41 41 13.5 9 25 18 25 20.5 0 7-30.5 3.5-33-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLQ80EsVs",
    className: "s19",
    d: "m261.5 4854.5c-3.5-5.5-14.5-11-27-13-36.5-6.5-62-42-51.5-71.5 9-25 17-18.5 17 13 0 33.5-4.5 30 52.5 40 19 3.5 20 4.5 21.5 22.5 1.5 20-3 24-12.5 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLsASnr6A",
    className: "s19",
    d: "m1973.5 4833c-10.5-59-10-64 1-64 8.5 0 10.5 3 10.5 18 0 9.5 2.5 22 5 27 3.5 6.5 3 13.5-1 22-7.5 17.5-12.5 16.5-15.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzQgDsman",
    className: "s19",
    d: "m345 4776.5c0-11 2-12.5 17.5-12.5 21.5 0 22.5 7 2.5 17.5-19 10-20 9.5-20-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjzTtnkQu",
    className: "s19",
    d: "m-1678.5 4760.5c-6-30-3-87 6-111.5 12-34 32-60 45.5-60h12l-15 23c-24.5 38.5-31.5 67-29.5 118.5 2 40 1 46-6.5 47.5-6 1-9.5-3.5-12.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNGmTJId7",
    className: "s19",
    d: "m-1296.5 4775c-1.5-2-1.5-18.5 0-37.5 2.5-28.5 4-33.5 12.5-33.5 8 0 9.5 3.5 9 24-1 35.5-5 51-12.5 51-4 0-8-1.5-9-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkW0ZUmwW",
    className: "s19",
    d: "m1962.5 4749c-4-18-5-18-71-3-28.5 6.5-51.5 10-51.5 8 0-6 18-20 25.5-20 5.5 0 5.5-1 0.5-4-10.5-7 23.5-42.5 38.5-40.5l11.5 2-10.5 13.5c-6 7-10.5 14-10.5 15 0 1 17-0.5 38-3 43-5.5 47-3 47 28.5 0 23-12.5 25.5-17.5 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxO0c71Re",
    className: "s19",
    d: "m184 4719c-7.5-9.5-15.5-23.5-18.5-31.5-5-12.5-4.5-13.5 7-13.5 8 0 13 3.5 15.5 11.5 2 6 5.5 12.5 8 14 2.5 1.5 4 10.5 3 20l-1.5 17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWX1aNRo3",
    className: "s19",
    d: "m375 4689c-4-5.5-11-10-16-10-5.5 0-9-3.5-9-10 0-12 10-13 30-2.5 13 6.5 25 21 25 29.5 0 7.5-23.5 2-30-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pB9TyrhGH",
    className: "s19",
    d: "m2140 4690c0-8 4-11.5 18-14l18-3.5-12-10.5c-6-5.5-22-15.5-35-21.5-23.5-11-31.5-21.5-16.5-21.5 4 0 7.5-4.5 7.5-10 0-5.5 3.5-10 7.5-10 4 0 7.5-4.5 7.5-10 0-8 3.5-10 15.5-10h15.5l-13 17c-7 9.5-13 19.5-13 22.5 0 2.5 12.5 12.5 27.5 21.5 18.5 11 27.5 19.5 27.5 26.5 0 7.5 1 8.5 4.5 3 3.5-5.5 7-5 20 2.5 20 12 19.5 17-2 18-30 1.5-44.5 3-61 6.5-14.5 3.5-16.5 2.5-16.5-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKPywvxbI",
    className: "s19",
    d: "m-1302 4664c-11.5-37.5-40.5-78-70-97.5-26-17-28.5-22.5-10-22.5 15.5 0 42 17.5 42 28 0 4 3.5 7 8 7 4.5 0 9 4.5 10.5 9.5 1.5 5.5 5.5 11 9.5 12.5 4 1.5 7 7 7 12.5 0 5 3.5 10.5 7 12 7 3 23 46.5 23 62 0 3.5-4 6.5-9 6.5-7 0-11.5-7.5-18-30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poGp3rYrr",
    className: "s19",
    d: "m1903.5 4671c8-12.5 8-13.5 0-19.5-12.5-9-10.5-12.5 9-12.5 16 0 17.5 1 17.5 14.5 0 23.5-5 30.5-20.5 30.5h-14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCWctQ5dG",
    className: "s19",
    d: "m-2810 4644c0-9.5 3.5-10 47.5-10 44 0 47.5 0.5 47.5 10 0 9.5-3.5 10-47.5 10-44 0-47.5-0.5-47.5-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pavGEQlJg",
    className: "s19",
    d: "m-2615 4644c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "powsINrZu",
    className: "s19",
    d: "m160 4636.5c0-10.5 12.5-34 22-42 7-6 8-4.5 8 11.5 0 10-2 18-5 18-2.5 0-5 4.5-5 10 0 6.5-3.5 10-10 10-5.5 0-10-3.5-10-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmNQZojd5",
    className: "s19",
    d: "m1849 4617.5c-19-11.5-34-22.5-34-24.5 0-2.5 7.5-4.5 16.5-5 31.5-1.5 50-4.5 87.5-12 13.5-2.5 14-11.5 2.5-52.5-7-26-7.5-31-1-35 6-3.5 5.5-4.5-1-4.5-5 0-9.5-5.5-11-13.5-1.5-8-2-14.5-1.5-15 0.5-0.5 13 8.5 28 20 26.5 20.5 27 21 13.5 22.5-12 1.5-13 3-10.5 15 2 7.5 5.5 18.5 7.5 25 2.5 6.5 4.5 20.5 4.5 31 0 23-6 27.5-44.5 31.5-30.5 3.5-36.5 7-24 14 8 5 12.5 24.5 5 24.5-2.5 0-19-9.5-37.5-21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phx8o95zN",
    className: "s19",
    d: "m290 4614c0-6.5-3.5-10-10-10-7.5 0-10-3.5-10-12.5 0-17 8-15.5 28 4.5 20 20 21.5 28 4.5 28-9 0-12.5-2.5-12.5-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcv91yGXk",
    className: "s19",
    d: "m210 4582c0-6.5 14-13 29-13 3 0 6 4.5 6 10 0 8-3.5 10-17.5 10-11.5 0-17.5-2.5-17.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pm7J7aJVK",
    className: "s19",
    d: "m-1605 4567.5c0-20.5 27-37.5 80-50 34.5-8 57.5-8 96.5 0 28 6 35 11.5 31 23-3 7-5.5 7-24 0-47.5-17-117-6.5-162 24.5l-21.5 14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCRtYt96k",
    className: "s19",
    d: "m2070 4549.5c0-18.5 2-25.5 7-25.5 3.5 0 8 5 9.5 10.5 2.5 9.5 5 10.5 25.5 7.5 20.5-3 23-2.5 23 6 0 7-5.5 10.5-23.5 15-13.5 3-28 7-32.5 8.5-8 3-9 0.5-9-22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18zt4hcun",
    className: "s19",
    d: "m2170 4560.5c0-9-3-11.5-12.5-11.5-17.5 0-16-13.5 2.5-17.5 8-2 17-2 19.5-0.5 2.5 2 5.5 1 6.5-1.5 0.5-2 7-6 13-8 10.5-3 11-2.5 7 6-3 5-12 17-20.5 26.5-14 16-15 16.5-15.5 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14bR3musY",
    className: "s19",
    d: "m1986.5 4541q-16.5-12.8-16.5-25.5v-12.5l17.5 13c17 13 17.5 13 23.5 3 9.5-14.5 14-12.5 14 7.5 0 14-2 17.5-9.5 17.5-5.5 0-10.5 2-11.5 5-0.5 2.5-9-1-17.5-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FgpUdy3",
    className: "s19",
    d: "m2065 4501.5c0-20 12-24.5 17-6 5 18.5 3.5 23.5-7 23.5-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13NtCzDAC",
    className: "s19",
    d: "m2025 4501c0-6 17-32 21-32 2 0 4 8 4 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Hg8LlVgx",
    className: "s19",
    d: "m2060 4460.5c0-18 7-36.5 11.5-31.5 1.5 1.5 4 13 5.5 26.5 3.5 21.5 3 23.5-6.5 23.5-9 0-10.5-3-10.5-18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPKfOagqw",
    className: "s19",
    d: "m517 3988.5c-1-2-0.5-10.5 1-19 3.5-17.5 14.5-20.5 18.5-5.5 2.5 9 7 10 41 10 34 0 38.5-1 41-10 4-15.5 15-12 18.5 6 2 10.5 1 17.5-3 20-7.5 4.5-114 3-117-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNzsVA1pt",
    className: "s19",
    d: "m-2765 3943c-13-21.5-12.5-24 4.5-24 10.5 0 16-3 18-10 2-6.5 7.5-10 15.5-10 12 0 12 0 4.5 19-10.5 24.5-21.5 41-27.5 41-3 0-9.5-7.5-15-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWNGLRC0t",
    className: "s19",
    d: "m-1185 3929c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pw0AyvJ6C",
    className: "s19",
    d: "m-3192 3908c-5-19-3.5-24 7-24 12 0 14 20.5 3 29.5-5.5 4.5-7.5 3.5-10-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCpbPJq3I",
    className: "s19",
    d: "m-2792 3889.5c-1.5-2-5-10-7.5-17.5-5-12-4-13 7-13 11 0 12.5 2 12.5 17.5 0 16.5-6 23-12 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNLyOfkqK",
    className: "s19",
    d: "m120 3884c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmfJEOYts",
    className: "s19",
    d: "m490 3884c0-7.5 3.5-10 12.5-10 12.5 0 12.5 0 12.5-47.5 0-47.5 0-47.5-12.5-47.5-9 0-12.5-2.5-12.5-10 0-8.5 3.5-10 19.5-10h19l3.5 26.5c4 33.5 4 90.5 0 100.5-2 5.5-9.5 8-22.5 8-16 0-19.5-1.5-19.5-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p52Uz8dnr",
    className: "s19",
    d: "m715 3884c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "po2TcbG5n",
    className: "s19",
    d: "m2315 3886c-39-10.5-57-22.5-59-38l-1.5-13.5 26.5 14.5c14.5 7.5 39.5 16.5 55.5 20 22.5 4.5 28.5 7.5 27.5 14-2 11.5-16 12-49 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwvvXbdSQ",
    className: "s19",
    d: "m2430 3885c0-8 4-11.5 18-14 20-3.5 31.5 3 20.5 12-4 3.5-14 7.5-22.5 9-14 3-16 2-16-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DrhxpyOU",
    className: "s19",
    d: "m-3197 3868c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPDHavgZS",
    className: "s19",
    d: "m-2715 3859.5c0-7.5 3-10.5 10.5-10.5 12.5 0 11 16.5-2 19-6 1-8.5-1.5-8.5-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcmok9WyU",
    className: "s19",
    d: "m-3145 3848c0-15.5 1.5-19 10-19 7.5 0 10-3.5 10-12.5 0-10.5 2.5-12.5 15.5-12.5h15l-10 14c-5.5 7.5-16.5 21.5-25 31l-15 17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1A0fxo42G",
    className: "s19",
    d: "m-2759 3836c-6.5-26.5-6-28 4.5-37.5 6-5 9.5-11 8-13-2-1.5-8 2-13 8-8 9-13 10.5-25 8-20.5-4.5-19.5-15.5 1.5-22.5 13-4 17.5-9 20-21 4.5-23 4-24-13-24-21.5 0-31.5-6.5-27-17.5 2-6 6.5-7.5 14.5-5.5 6 1.5 16 3 22 3 8 0 11.5 3.5 13 14l2 13.5 1-13.5c0.5-12.5 2.5-14 18-14 9.5 0 17.5-2 17.5-5 0-10 14-5 16.5 6 3.5 13.5-3.5 19-25 19-14.5 0-16.5 1.5-16.5 14 0 18.5 4.5 23.5 26.5 30.5 24.5 8.5 24 19.5-1.5 23.5-17.5 3-20 5-23 20-3.5 18.5 0 27 11 27 4 0 7 3.5 7 7.5 0 5-5 7.5-16.5 7.5-15.5 0-16.5-1-22.5-28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQEHpSVWP",
    className: "s19",
    d: "m2229 3834c-13.5-18-15.5-24-14.5-45 0.5-8.5 5.5-16 15.5-21.5 8-5 31-21 51-36.5 28.5-21.5 39.5-27 51.5-26 13 1.5 15 4 16.5 18 2 18-6 21.5-14 6-5-10-6.5-9.5-27.5 8.5-12.5 10-22.5 20-22.5 22 0 1.5 10 6 22.5 9.5 16.5 4.5 22.5 9 22.5 15.5 0 12-8 12-42-0.5-22-8.5-29-9.5-39.5-4.5-17 7.5-19.5 15-10.5 32.5 4 7.5 7 20 6 27-1.5 12.5-1.5 12.5-15-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1G6DlDTs2",
    className: "s19",
    d: "m-2825 3824c0-16.5 1.5-20 10-20 10.5 0 13.5 15 7 32-6.5 16.5-17 8.5-17-12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1ErAW50wU",
    className: "s19",
    d: "m-3202 3820.5c-9.5-50.5-9.5-56.5 1.5-56.5 6.5 0 10.5 3 10.5 9 0 4.5 1.5 20.5 3 35 3 21.5 2 26-4.5 26-4.5 0-9-6-10.5-13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQO0r2p7m",
    className: "s19",
    d: "m-2660 3822.5c0-11 16.5-23.5 31-23.5 3 0 10.5-5.5 17-12.5 10-11 13.5-12 22.5-7.5 5.5 3 9 8.5 8 11.5-1.5 6-32 24-62 36.5-16 7-16.5 6.5-16.5-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYPM3NmkN",
    className: "s19",
    d: "m1961 3826.5c-41.5-7.5-43.5-8.5-39-20.5 2.5-6 6.5-7.5 17-5 12.5 3 25.5 5 65 11 11.5 2 16 5 16 12 0 12-6.5 12-59 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnS2deieZ",
    className: "s19",
    d: "m2065 3825c0-8.5 4-11 19-13.5 10-2 29.5-5.5 42.5-8 32-6 33.5-6 33.5 4.5 0 6.5-6 10.5-23.5 14.5-13.5 3.5-27.5 5.5-31.5 5.5-4 0-15 1.5-23.5 3.5-14.5 3.5-16.5 2.5-16.5-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18soC9lLh",
    className: "s19",
    d: "m-2885.5 3813c-35-18.5-40.5-25.5-24-34 9-5 12-4.5 15 1 2 4 13 11.5 24.5 16.5 15 7 20 12 20 21 0 6-1 11.5-1.5 11.5-1 0-16.5-7.5-34-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSgUr4DVm",
    className: "s19",
    d: "m-1720 3819c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paMHYSuvN",
    className: "s19",
    d: "m-1495 3819c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15dnIPqQa",
    className: "s19",
    d: "m1877.5 3800.5c-32-13.5-72.5-40-72.5-47.5 0-2.5-2-3-5-1.5-6 4-56.5-46-53-52 1.5-2.5-0.5-5.5-4.5-7.5-4-1.5-7.5-5-7.5-8 0-3-4-10-9-15.5-11.5-12-23.5-46.5-19-54 7.5-12 17-4.5 23 18.5 4 13 8 24.5 10 26 8 7 40 54.5 40 60.5 0 3.5 1.5 5 3 3 1.5-1.5 20.5 9.5 42.5 24.5 22 15 42 27 44.5 27 3 0 5 4 5 9 0 5.5 1.5 6.5 4 2.5 2.5-4 7.5-4 20 1 16.5 7 18.5 10.5 12 21-2.5 4-12 2-33.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEhJtgkjP",
    className: "s19",
    d: "m2173 3805.5c-4-10-0.5-14.5 16.5-20.5 12-4 15.5-3.5 17.5 2.5 4 10 0.5 14.5-16.5 20.5-12 4-15.5 3.5-17.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVB2Wmtkt",
    className: "s19",
    d: "m-1110 3801.5c0-9.5 17-13.5 48-11.5 18.5 1 25 3.5 26 10.5 1.5 7.5-3 8.5-36 8.5-30 0-38-1.5-38-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pc8IYZzv",
    className: "s19",
    d: "m-1720 3796.5c0-9.5 23.5-13.5 70-11.5 31 1 37.5 3 39 10.5 1.5 7.5-3.5 8.5-53.5 8.5-45 0-55.5-1.5-55.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18o40MrJY",
    className: "s19",
    d: "m-1494 3795.5c1.5-8 8-9 54-9 46 0 52.5 1 54 9 1.5 7.5-3.5 8.5-54 8.5-50.5 0-55.5-1-54-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYlznzAKo",
    className: "s19",
    d: "m-1270 3797c0-10.5 11.5-13 55-13 43.5 0 55 2.5 55 13 0 5.5-11.5 7-55 7-43.5 0-55-1.5-55-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pShRWnu8R",
    className: "s19",
    d: "m2345 3771.5c0-14 2-17.5 10-17.5 11 0 13 10 5 25.5-8 15-15 11.5-15-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phmZL6zTb",
    fillRule: "evenodd",
    className: "s19",
    d: "m237.5 3758c-5-29-7-81.5-4-94 1.5-5.5 5.5-10 9-10 7 0 12.5 21.5 12.5 48.5 0 15 1 17 7.5 11.5 6-5 7.5-4.5 7.5 2.5 0 8.5 0.5 8.5 10 0 5.5-5 10-13.5 10-19 0-13 85.5-98.5 98.5-98.5 12.5 0 21.5-9.5 21.5-22 0-15 41.5-53 57.5-53 7 0 12.5-2 12.5-5 0-2.5-3.5-5-8-5-7 0-7-1.5-2-7.5 5-6.5 4.5-7.5-4.5-7.5-7.5 0-10.5-3-10.5-10.5 0-10 1.5-10.5 34-7 18.5 2 34.5 4.5 35.5 5.5 1.5 1.5 2.5 13 2.5 26 0.5 20.5-1 23.5-10.5 25-6.5 1-11.5 5-11.5 10 0 4-36.5 44.5-81 89.5-57.5 58-84.5 81.5-92.5 81.5-8.5 0-11.5 3-11.5 11 0 12-23 39-33.5 39-3.5 0-6.5 2.5-6.5 5 0 3-8.5 5-19.5 5-18.5 0-19.5-0.5-23-21zm154-122c68-68 123.5-127 123.5-131 0-10-0.5-10-138.5 127.5-106 105.5-124.5 126.5-112.5 126.5 2.5 0 59.5-55.5 127.5-123z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvK73YZhz",
    className: "s19",
    d: "m715 3769c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYsx3dw2A",
    className: "s19",
    d: "m-3070 3753c0-15.5 2-19 10-19 7.5 0 10-3.5 10-12.5 0-11 2-12.5 17-12.5 9.5 0 18-2 19-4 1-2 46-10.5 100.5-18.5 96.5-14 98.5-14.5 98.5-26v-12l15.5 10.5c17.5 12.5 16.5 13 31-15.5 13-25.5 23.5-31 23.5-12.5 0 21-10.5 38-23.5 38-10 0-11.5 2.5-11.5 17.5 0 12.5-2 17.5-8 17.5-5 0-7-3-5-7.5 3.5-10 3-10-122 8l-107.5 15.5-23.5 25.5-24 26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHUxM9LCX",
    className: "s19",
    d: "m-2827 3755.5c-2.5-8.5-1.5-14.5 3-17 10.5-7 16.5-2 18 14.5 1.5 13 0 16-8 16-6.5 0-11-4.5-13-13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSs5ykL1p",
    className: "s19",
    d: "m-2695 3749.5c0-14.5 7.5-16.5 27.5-8.5 24 10 22 18-5 18-19 0-22.5-1.5-22.5-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHyCl9EYm",
    className: "s19",
    d: "m-3212 3743c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXFDt0EYR",
    className: "s19",
    d: "m-1741.5 3740.5c-10-9.5-2.5-16.5 19-16.5 16 0 22.5 2 22.5 7 0 11-32.5 18.5-41.5 9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pihisTg7W",
    className: "s19",
    d: "m2205 3739c0-2.5 2.5-16.5 5.5-31 4.5-19.5 10.5-31 25.5-45.5 17-17 22-19 35.5-16.5 8.5 1.5 17 5.5 19 8.5 1.5 3 5 5 7 4.5 2-1 10.5 4 19 10.5l16 11.5-12.5 3c-8 2-17 0-25-5.5-33.5-23-57.5-6.5-67 47-2.5 14-6 18.5-13 18.5-5.5 0-10-2-10-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMj1zAXlM",
    className: "s19",
    d: "m-1165 3719c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6jsQ5mri",
    className: "s19",
    d: "m-3217 3703c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pv2XMMoCH",
    className: "s19",
    d: "m-3222 3663c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyZZfpJ3x",
    className: "s19",
    d: "m-1744 3643.5c1-10 5-12.5 20.5-13.5 13.5-1 19.5 0.5 21.5 6.5 4 10.5 3.5 10.5-22 15-21 3.5-22 3-20-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYXN2bVWe",
    className: "s19",
    d: "m-1165 3631c0-16.5 16.5-15 19 2 1.5 8.5-1 11-8.5 11-8 0-10.5-3-10.5-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3fdaDIir",
    className: "s19",
    d: "m-1190 3629c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGGuckJfX",
    className: "s19",
    d: "m-3227 3623c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8EqeGWSJ",
    className: "s19",
    d: "m2362.5 3624c-1.5-2.5 0-17.5 3.5-32.5 5-21.5 8.5-27.5 15.5-27.5 10 0 10 3 0.5 51.5-3 13.5-13.5 18-19.5 8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgrsJVvHT",
    className: "s19",
    d: "m1697.5 3589c-3.5-16.5-0.5-25 10-25 7.5 0 15 26.5 10 35-6 10-17 5-20-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6SorMWOU",
    className: "s19",
    d: "m-2935 3573.5v-15l15 10.5c22 15.5 22.5 20 3 20-16.5 0-18-1-18-15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXUN6mKdo",
    className: "s19",
    d: "m120 3539.5c0-56 1.5-60.5 23-60.5 19.5 0 24 12 6 16.5-11 3-11.5 5-10 46 1.5 40 1 42.5-8.5 42.5-10 0-10.5-3-10.5-44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUvpL9mRx",
    className: "s19",
    d: "m-3237 3543c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqpZ5Ul4j",
    className: "s19",
    d: "m1695 3546.5c0-16 11-57.5 15.5-57.5 2.5 0 4.5-5.5 4.5-12.5 0-10 2.5-12.5 12.5-12.5 12.5 0 12.5 0.5 5.5 17-4 9.5-9.5 29.5-13 45-4.5 22.5-7.5 28-15.5 28-5 0-9.5-3.5-9.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjSJYiYTM",
    className: "s19",
    d: "m2365 3525.5c-9-42.5-29-79.5-62-115l-29-31.5h15c27.5 0 80.5 72 91 124 2.5 10 5.5 26 7.5 35 3.5 14 2.5 16-6.5 16-8.5 0-11.5-5-16-28.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGqr7pOjb",
    className: "s19",
    d: "m235 3518.5c0-16-2-21-10-23-17-4.5-12-16.5 7-16.5 9.5 0 18.5 1.5 19.5 4 1.5 2 1 15.5 0 30-2 17.5-5 26-9.5 26-5 0-7-6.5-7-20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BXLhqtOL",
    className: "s19",
    d: "m-3015 3521.5c0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-8 0-10-3.5-10-15.5 0-12 1.5-14.5 6.5-11 3 3 42.5 32.5 87.5 66 44.5 33.5 81 62 81 63 0 1.5-8 2.5-17.5 2.5-12 0-17.5-2.5-17.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ph4rqkQCC",
    className: "s19",
    d: "m-1741.5 3515.5c-10-9.5-2.5-16.5 19-16.5 16 0 22.5 2 22.5 7 0 11-32.5 18.5-41.5 9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GiTsSE8J",
    className: "s19",
    d: "m-3242 3498c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUKKnJrPi",
    className: "s19",
    d: "m-1190 3494c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19K6Ni5G6",
    className: "s19",
    d: "m-1165 3494c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDTZUm5b0",
    className: "s19",
    d: "m-3247 3458c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12x3HHEtR",
    className: "s19",
    d: "m1725 3449.5c0-3 5.5-11.5 12.5-19l12-14 0.5 19c0 16.5-1.5 18.5-12.5 18.5-7 0-12.5-2-12.5-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prsLHElEc",
    fillRule: "evenodd",
    className: "s19",
    d: "m623 3419.5c-1.5-10.5-6-20-9-21-3.5-1-134-1.5-290-0.5-247 1-284 2-284 8.5 0 4-2 7.5-5 7.5-2.5 0-5-8-5-17.5 0-19 2.5-20 51-17.5 24 1 39-4 39-13 0-4 4.5-7 10-7 5.5 0 10 3.5 10 7.5 0 6.5 7.5 7.5 46.5 6.5l46-1.5 1-34.5c0.5-30-0.5-34.5-9-36.5-5-1.5-9.5-5.5-9.5-9 0-6.5 28-14.5 35.5-9.5 2.5 1.5 4.5 22.5 4.5 46.5 0 41.5 0.5 44.5 11.5 47.5 18.5 5 317 3.5 330.5-2 8.5-3 13-3 13 0 0 3 2.5 5 5 5 3 0 5-5.5 5-11.5 0-14 30-43.5 44-43.5 12.5 0 21-9.5 21-24 0-10.5 2-11.5 21.5-10 20.5 1.5 21 2 22.5 21 1.5 18-0.5 22-32.5 54-28 28.5-36.5 34-51.5 34.5-13.5 1-14.5 1.5-4.5 3 13 2 13 2 5 19-10.5 22.5-18.5 22-22.5-2zm59-75c23-23 32-35.5 28-38-6-3.5-70 59.5-70 68.5 0 9 9.5 2 42-30.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTRFuBKQ5",
    className: "s19",
    d: "m-3252 3418c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUedw7PMe",
    className: "s19",
    d: "m-1744 3415.5c1-7 6.5-9 21.5-9 15 0 20.5 2 21.5 9 1.5 7-2 8.5-21.5 8.5-19.5 0-23-1.5-21.5-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GQKtYYOi",
    className: "s19",
    d: "m-1165 3404c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTIInhCvZ",
    className: "s19",
    d: "m-3195 3386.5c0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-5.5 0-10-3-10-7 0-4-5-8-11-9-10-1.5-23.5-26-17.5-32.5 2.5-2.5 103.5 71.5 103.5 76 0 1.5-8 2.5-17.5 2.5-12 0-17.5-2.5-17.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSiqGHm6C",
    className: "s19",
    d: "m-3257 3378c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4jwIHFCR",
    className: "s19",
    d: "m1782.5 3379c6.5-10.5 64-46 97.5-60.5 38.5-16.5 98-31.5 108-27.5 4 1.5 7 6 7 10 0 4.5-12.5 9.5-38 15.5-21 4.5-45.5 11.5-54.5 15.5-13 5.5-17.5 5.5-19 0.5q-3-6-3 1.5c-1 9.5-47.5 36-57 32-4.5-1.5-8 1.5-10 7.5-2 8-6.5 10.5-18.5 10.5-9 0-14.5-2-12.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pk9hM9wmP",
    className: "s19",
    d: "m2236.5 3358c-29.5-16.5-33.5-24-12.5-24 13.5 0 56.5 23.5 63 34.5 7 11-24.5 4.5-50.5-10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDd0527aH",
    className: "s19",
    d: "m-1744 3343c1-15.5 4-22 10.5-23 7-1.5 8.5 2 8.5 21 0 20-1.5 23-10.5 23-9 0-10-2.5-8.5-21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DhK9uc7g",
    className: "s19",
    d: "m-1295 3354c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1B0DpZC90",
    className: "s19",
    d: "m-1205 3354c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pE1F5GhKV",
    className: "s19",
    d: "m-1655 3329c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pV3HeMjSs",
    className: "s19",
    d: "m-1205 3329c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5mL3ut0p",
    className: "s19",
    d: "m2160 3326.5c-58-17.5-87.5-23.5-102-19.5-19.5 4.5-58-2-58-10.5 0-9 25-13.5 57.5-10 14 1.5 35.5 3.5 48 4.5 12.5 1 39 7 59 13 31 10 35.5 13 35.5 23 0 6.5-0.5 12-1 11.5-1-0.5-18.5-5.5-39-12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19boBuKJA",
    className: "s19",
    d: "m342.5 2766.5c-2.5-1-13.5-3-23.5-5-12-2-19-5.5-19-10 0-8.5 7.5-9 42-4.5 18 2.5 23 5.5 23 12.5 0 9-9 11.5-22.5 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppay817dV",
    className: "s19",
    d: "m415 2760c0-7.5 4.5-10.5 23-13 34.5-4.5 42-4 42 4 0 7-5.5 9-46 16-16.5 2.5-19 2-19-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pACOJqWPm",
    className: "s19",
    d: "m245 2740c-34.5-15-72-37-77.5-46-5-8 21-6 29.5 2.5 4 4 8.5 7.5 10 7.5 1.5 0 14.5 5.5 29 12 14.5 6.5 33.5 14 41.5 16.5 17 5.5 24 21.5 9 21.5-5 0-23.5-6.5-41.5-14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxCt3E942",
    className: "s19",
    d: "m486 2746c1-5.5 6.5-10 14-11 7-1 14.5-4 17.5-6.5 6.5-6 32.5-5.5 32.5 1 0 5.5-27.5 18.5-51 23-13 2.5-15 1.5-13-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poOLJbDs0",
    className: "s19",
    d: "m565 2714.5c0-12.5 22-26.5 39-24.5 13.5 1.5 13 1.5-8.5 18-25.5 18.5-30.5 19.5-30.5 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwmNvIWZN",
    className: "s19",
    d: "m-1638.5 2703c-13-2.5-21.5-7.5-21.5-12 0-8 7.5-8.5 42-4 18 2.5 23 5.5 23 12.5 0 10.5-9.5 11.5-43.5 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GIS0j3Yy",
    className: "s19",
    d: "m-1375 2699.5c0-9 19.5-15.5 49-15.5 22 0 11.5 14-14 19.5-33.5 7-35 7-35-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppGVD3b5e",
    className: "s19",
    d: "m-1704 2669.5c-17-13.5-30-29.5-40.5-51-18-36-19.5-49.5-6-49.5 9.5 0 15.5 12.5 15.5 34 0 6.5 3 11 7.5 11 4 0 7.5 3 7.5 7 0 4 3.5 8 7.5 10 4 1.5 7.5 6 7.5 10.5 0 4 3.5 7.5 7.5 7.5 4 0 7.5 3.5 7.5 7.5 0 4 4.5 7.5 10 7.5 7.5 0 10 3.5 10 12.5 0 17-5 16-34-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p112Cgx5K3",
    className: "s19",
    d: "m-1305 2676.5c0-9 2.5-12.5 10-12.5 5.5 0 10-2 10-5 0-7.5 16.5-25 23.5-25 3.5 0 6.5-4.5 6.5-10 0-5.5 3-10 7-10 6.5 0 8-5 16-58.5 2.5-17 5.5-21.5 13-21.5 9 0 9.5 2.5 6.5 26.5-6.5 47.5-31 91-66.5 115.5-23.5 16-26 16-26 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgBzBT9EM",
    className: "s19",
    d: "m620 2678c0-15 8.5-24 23.5-24 9 0 11.5-3 11.5-12 0-14.5 11-24.5 25.5-22 10 1.5 9 3-10.5 25-11.5 13-27.5 28.5-35.5 34l-14.5 10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6cEQF3HX",
    className: "s19",
    d: "m122.5 2656.5c-24-23.5-28-30-21-31.5 14-3 23.5 2.5 23.5 14 0 5.5 3.5 10 8 10 12 0 23 13.5 21 26-1.5 10.5-4.5 8.5-31.5-18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FPKbfosE",
    className: "s19",
    d: "m-3341.5 2673c-19-5-58.5-37.5-58.5-47.5 0-12.5 19.5-10 33 4 7.5 8 26 18.5 40.5 23 19 6 26.5 11 26.5 17.5 0 10-11 11-41.5 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FkAzlteV",
    className: "s19",
    d: "m-2870 2669.5c0-6.5 6-11 23.5-16 27.5-7.5 61.5-36 61.5-51.5 0.5-35 17.5-45.5 21-12.5 3.5 35.5-23 70.5-63 82-33.5 10-43 9.5-43-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AVC347nT",
    className: "s19",
    d: "m2069 2626.5c-9.5-5.5-14-12-14-20.5 0-11.5 0.5-12 12-4.5 30 20 63 18.5 87-3.5 6.5-6.5 21-26.5 31.5-45 11-19 23-34 27-34 5 0 7.5-5 7.5-13.5 0-14 77.5-151.5 85.5-151.5 3 0 4.5-3 3.5-6-2-8 16.5-69 20.5-69 2 0 8.5 20 15 44.5 6 24.5 15.5 51 20.5 59 15.5 26 56.5 39 81.5 26 20-10.5 43.5-36 43.5-48 0-8 3-11.5 10-11.5 13 0 13.5 16.5 0.5 29.5-5.5 5.5-10.5 13.5-11.5 18.5-1 5-9 14-17.5 20-48 32-109 11.5-134-45l-10.5-24.5-74 128.5c-85 147-91 154-140 156.5-20.5 1-35-1-44-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUWOMtgiU",
    className: "s19",
    d: "m79 2605.5c-10.5-12.5-27.5-41.5-33.5-58-4.5-11.5-4-13.5 4-13.5 6 0 12.5 7.5 18.5 21.5 5 11.5 12 24 15.5 27.5 5.5 6 9.5 31 5 31-1 0-5.5-4-9.5-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19K0JARQK",
    className: "s19",
    d: "m690 2599.5c0-8.5 3-17 7-18.5 3.5-1.5 9.5-11.5 13.5-23 3.5-11 9.5-21 13-22.5 3.5-1.5 6.5-8.5 6.5-16 0-23.5 5.5-35.5 16-35.5 9 0 10 2.5 7 15.5-4 21.5-41.5 96.5-53.5 107-9 9-9.5 8.5-9.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12ennshG",
    className: "s19",
    d: "m-3405 2584c0-22.5 11.5-28.5 17-8.5 5.5 20.5 3.5 28.5-7 28.5-8.5 0-10-3.5-10-20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6KaZrFa9",
    className: "s19",
    d: "m2027 2581.5c-9.5-23-9-32.5 2.5-32.5 6.5 0 10 5 12.5 15.5 7 37-2 47.5-15 17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnYpFWeti",
    className: "s19",
    d: "m-1762 2553c-7-27-1-64 10-64 5.5 0 7 9 7 37.5 0 28.5-1.5 37.5-7 37.5-3.5 0-8-5-10-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phx9M2yGp",
    className: "s19",
    d: "m2022 2528.5c3.5-18 36-77.5 50-91.5 6.5-6.5 9.5-16 9-32 0-22 0-22 15.5-19 8.5 1.5 16.5 4 17.5 5.5 1.5 1-13.5 30-33 63.5-19.5 34-37 67.5-38.5 75.5q-3.8 13.5-13.5 13.5c-9 0-10-2.5-7-15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p135nLYGNd",
    className: "s19",
    d: "m-1425 2517c0-5-6.5-8-18-9-12-1-20.5-5-24-11.5-3-5.5-7.5-11.5-10-13-2-2-5.5-13.5-6.5-26.5-2.5-18.5-1.5-23 5-23 4.5 0 9 6.5 11 15.5 5.5 24 30.5 49 55.5 55 27 7 30 19.5 4.5 19.5-12 0-17.5-2.5-17.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9hKgp4DR",
    className: "s19",
    d: "m-1310 2517c0-4 9.5-9.5 21.5-12.5 11.5-3.5 24-7.5 27.5-8.5 4-2 6 1.5 6 9.5 0 13.5-10 18.5-38.5 18.5-11 0-16.5-2.5-16.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pokohPU2V",
    className: "s19",
    d: "m-3406 2258c-1-141 0-261.5 2-267 6.5-20.5 26.5-37 44.5-37h17l-16.5 15.5c-9 8.5-19 21.5-21.5 28.5-3 8-5 107-4.5 252 0 131.5-1 244.5-3 251.5-1.5 7-6 12.5-10 12.5-5.5 0-7-44.5-8-256z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdQHc0hgx",
    className: "s19",
    d: "m-1237 2470.5c2.5-5 5-62.5 6-128.5 1.5-111.5 0.5-120-8.5-136l-10-17h14c9 0 16 3.5 18.5 9 5 11 9 220 4.5 254.5-3 24-4.5 26.5-16 26.5-10.5 0-12-1.5-8.5-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFGxKoTkO",
    className: "s19",
    d: "m18 2465.5c-9.5-49.5-9.5-51.5 1.5-51.5 7 0 10.5 3 10.5 9.5 0 5 1.5 19.5 3 32.5 3 19 2 23-4.5 23-4.5 0-9-6-10.5-13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p46Rf1eQP",
    className: "s19",
    d: "m745 2470.5c0-5 1.5-21 3-35 3-22 5-26.5 13.5-26.5 8.5 0 9.5 2.5 6 24-5 37.5-8 46-15.5 46-4 0-7-4-7-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLPt4ZiOc",
    className: "s19",
    d: "m2011.5 2384c-12-5.5-21.5-12-21.5-15 0-6.5 28.5-6.5 32.5 0 1.5 3 8.5 5 15.5 5 8.5 0 12 2.5 12 10 0 12.5-10.5 12.5-38.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQlZFR31Q",
    className: "s19",
    d: "m10 2368c0-15 6.5-29 13-29 4.5 0 7 6 7 17.5 0 14-2 17.5-10 17.5-5.5 0-10-3-10-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1D0AZrQLu",
    className: "s19",
    d: "m750 2356.5c0-20 12-24.5 17-6 5 18.5 3.5 23.5-7 23.5-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnqKkTOHk",
    className: "s19",
    d: "m1947.5 2350.5c-16.5-9.5-31-19-32.5-21-1.5-2-6.5-5-11-7-5-1.5-9-8.5-9.5-14.5 0-10-0.5-10.5-4-2-3 8-7 6-34-19-38.5-35.5-66.5-77-56-83.5 10.5-6.5 11-6 25.5 17 22 34.5 58.5 67.5 110.5 99.5 34 21 48.5 33 48.5 39.5 0 12.5-2.5 12-37.5-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17eWP1J44",
    className: "s19",
    d: "m2470.5 2255.5c-12.5-46-27.5-93-33.5-104.5-11-20-11-22.5-3.5-45.5 4-13 7.5-45 8-70 0.5-39.5 2-46.5 9-46.5 6 0 9 6.5 11.5 24 3 24 2.5 33.5-8 86.5-4 23.5-3.5 30.5 3 43.5 7.5 15 53 178 53 190.5 0 3-4 5.5-9 5.5-7 0-12.5-15.5-30.5-83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3lGStfP7",
    className: "s19",
    d: "m30 2286c0-10.5 9-27 15-27 5.5 0 6.5 15 2 27-4 10.5-17 10.5-17 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FA2rC3xh",
    className: "s19",
    d: "m730 2276.5c0-19.5 7-23 15-8 8 15.5 6 25.5-5 25.5-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AVll6Ir4",
    className: "s19",
    d: "m-1483.5 2221c1-13 4.5-24.5 7-26.5 2.5-1.5 6-7 8-11.5 2-6.5 8.5-9 21.5-9h18l-17.5 19.5c-9.5 10.5-19 26.5-21 35-2 9-6.5 15.5-11 15.5-6.5 0-7.5-4.5-5-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFp6Tv2sg",
    className: "s19",
    d: "m51.5 2228c7-17.5 18.5-24.5 18.5-11.5 0 12.5-9.5 27.5-17.5 27.5-6.5 0-6.5-2.5-1-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBwprJdHe",
    className: "s19",
    d: "m708 2233c-11.5-43.5 5.5-45 22-2 4.5 11.5 3.5 13-7 13-8 0-13-3.5-15-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plnLMzr5t",
    className: "s19",
    d: "m1782 2180.5c-4.5-10-10-30.5-12.5-46-3-15.5-6.5-35.5-8-44-2.5-14-1.5-16.5 7.5-16.5 8.5 0 10.5 4.5 13.5 26.5 2 14 7.5 38.5 12 53.5 13 42.5 3 64-12.5 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psZI50cuL",
    className: "s19",
    d: "m-2750 2184.5c0-8.5 3-10.5 17-10.5 9.5 0 19-2 20.5-5 4-6 32.5-6.5 32.5-0.5 0 6-28.5 19-51 23-17 3.5-19 2.5-19-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZ9kVlVxc",
    className: "s19",
    d: "m-2803 2173.5c-22-15-34-35-39.5-65.5-3.5-17-2.5-19 7-19 8.5 0 10.5 3 10.5 17.5 0 9.5 2.5 17.5 5 17.5 3 0 5 3 5 7 0 4 8 14 18 22 12 10 17.5 18 16 25-1.5 9.5-2.5 9.5-22-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9JM8vgzK",
    className: "s19",
    d: "m-1283.5 2175c-24.5-9.5-28.5-21-7.5-21 25.5 0 36 5.5 36 18 0 13.5 0 13.5-28.5 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pF3C9ASdO",
    className: "s19",
    d: "m-1762 2161c-4.5-18 1-42 10-42 5 0 7 7 7 27.5 0 20-2 27.5-7 27.5-4 0-8.5-6-10-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puAsIjNbm",
    className: "s19",
    d: "m-1425 2164c0-8 3.5-10 17.5-10 20 0 24.5 12 6.5 17-19 5-24 3.5-24-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgOCdvStc",
    className: "s19",
    d: "m-2670 2146.5c0-8.5 3.5-20.5 8-26.5 6.5-9.5 7.5-18.5 4.5-47-3-28.5-2.5-35 3-33 4 1.5 10 11 13.5 22 8.5 25 0.5 66.5-16.5 86l-12 13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUj44ZuRI",
    className: "s19",
    d: "m-1230 2121.5c0-20 12-24.5 17-6 5 18.5 3.5 23.5-7 23.5-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BD2Tqkc1",
    className: "s19",
    d: "m658.5 2130.5c-2-1.5-3.5-9.5-3.5-17 0-9-3-14-10-16-6-1.5-10-7-10-12.5 0-5.5-3.5-11-7.5-13-4-1.5-7.5-7-7.5-12.5 0-5-3.5-10.5-7.5-12.5-7.5-3-11-33-3.5-33 3.5 0 71 111 71 117 0 4-17.5 4-21.5-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdiP9gC9S",
    className: "s19",
    d: "m-1760 2100.5c0.5-25.5 34.5-78 64-98.5 23.5-16 26-16 26-0.5 0 9-2.5 12.5-10 12.5-5.5 0-10 3.5-10 7.5 0 4-3.5 7.5-7.5 7.5-4 0-7.5 3.5-7.5 7.5 0 4-3.5 7.5-7.5 7.5-4 0-7.5 4.5-7.5 10 0 5.5-3.5 10-7.5 10-4.5 0-7.5 4.5-7.5 11.5 0 21-6 33.5-15.5 33.5-6 0-9.5-3.5-9.5-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSDekdwQY",
    className: "s19",
    d: "m-3159 2086.5l-18.5-17 18.5-0.5c10 0 20 2.5 21.5 5.5 2.5 3.5 7.5 1.5 15-5.5l11.5-10.5 2 15c2.5 17-8 30.5-22.5 30.5-5 0-17-8-27.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13vv5vj1l",
    className: "s19",
    d: "m-1240 2079q0-15-7.5-15c-4 0-7.5-4-7.5-9 0-4.5-5-11-11-13.5-6.5-3-13.5-10-16.5-16-2.5-6.5-9-11.5-13.5-11.5-6.5 0-9-4-9-12.5 0-15.5 2.5-15.5 26 0.5 20 14 37.5 35 51 60.5 11 21.5 10 31.5-2 31.5-8 0-10-3.5-10-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p151TTOree",
    className: "s19",
    d: "m135 2071c0-6 17-32 21-32 5.5 0 5 7.5-2 22.5-5 11-19 18-19 9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GMT4X0Sj",
    className: "s19",
    d: "m1762.5 2045.5c8-58 31.5-116.5 46.5-116.5 6.5 0 7-1 1.5-4.5-5.5-3.5-3-11 12-36 10-17.5 20-33 22-34.5 2-1.5 5-6.5 7-11 2-5.5 8.5-9 16-9h12.5l-17 26.5c-47.5 74.5-71.5 130.5-80.5 190-2.5 14.5-5 18.5-13 18.5-9 0-10-2-7-23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYOxMNmRV",
    className: "s19",
    d: "m-3070 2037.5c0-9.5-6-19-20-31.5-11-10-20-21.5-20-25 0-4-3.5-7-7.5-7-5 0-7.5-5.5-7.5-17.5 0-16.5 1-17.5 17.5-17.5 12 0 17.5 2.5 17.5 7.5 0 4-3.5 7.5-7.5 7.5-4 0-7.5 1-7.5 2 0 1.5 12.5 14.5 27.5 30 29.5 29.5 33.5 41 17.5 55.5-10 9-10 8.5-10-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnkiCKj7E",
    className: "s19",
    d: "m-2845 2040.5c0-17 6-31.5 13-31.5 5 0 7 6.5 7 20 0 16.5-1.5 20-10 20-6 0-10-3.5-10-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10tfAkJwK",
    className: "s19",
    d: "m160 2031c0-6 17-32 21-32 5.5 0 5 7.5-2 22.5-5 11-19 18-19 9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJSkgzuZi",
    className: "s19",
    d: "m-1179.5 2003c-17-14-29-27-26.5-28.5 2.5-1.5 5.5-6 6.5-9.5 1.5-4 8-1.5 19.5 8.5 9.5 8.5 14.5 15 11.5 15.5-3.5 0-6.5 3.5-6.5 7.5 0 5 5 7.5 14 7.5 14.5 0 34 15.5 27.5 21.5-7 7.5-16.5 2.5-46-22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1B7vebmxY",
    className: "s19",
    d: "m-2838 1978c2-9 5.5-17 8-18 11-4 4-11-10-11-12 0-15-2-15-10.5 0-9.5 2-10.5 16.5-7.5 22 4.5 98.5 41.5 98.5 48 0 8.5-23.5 5.5-52.5-7l-27.5-12.5v17.5c0 14-2 17-10.5 17-9.5 0-10.5-2-7.5-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgY6liRj8",
    className: "s19",
    d: "m568 1981c-5-7-8-18.5-7-26 1.5-13.5 1.5-13 18 8.5 8.5 12 16 24 16 26.5 0 9-19.5 3-27-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13DPtpVIm",
    className: "s19",
    d: "m-1640 1982c0-4 5.5-8.5 12.5-10 7-2 12.5-6.5 12.5-10.5 0-4 2.5-7.5 5-7.5 3 0 5 8 5 17.5 0 16.5-1 17.5-17.5 17.5-11.5 0-17.5-2.5-17.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZmAMLBLi",
    className: "s19",
    d: "m195 1974.5c0-3 5.5-11.5 12.5-19 13.5-15.5 17-8 4.5 11-8 12.5-17 16.5-17 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14Vwb5juf",
    className: "s19",
    d: "m2432.5 1958c-6-28-35.5-80.5-59.5-107.5-26.5-29.5-74-62-138.5-95-24.5-12.5-44.5-25-44.5-28 0-11.5 42.5 2 88.5 29 78 45.5 126 88 126.5 111.5 0 6.5 3 11 7.5 11 5 0 14 13 22.5 31.5 16 33.5 20 63.5 8 63.5-4 0-9-7-10.5-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnXqCM6Wh",
    className: "s19",
    d: "m-1233 1955.5c-12-11-15-16.5-12.5-25.5l3-11.5 15.5 14c12 11 15 16.5 12.5 25.5l-3 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8n8lcdhM",
    className: "s19",
    d: "m-3295 1956c-4-0.5-18-3-31-4.5-28-3.5-32.5-15-8.5-20l16-3.5-53.5-53.5c-52-52-61-66.5-45-72.5 13-5 22-3.5 19.5 3.5-1.5 3 23.5 32 55 63.5l58 57.5-16.5 3-16.5 3 16.5 1c13.5 0.5 16 2.5 16 13 0 7-0.5 12-1 12-1-0.5-5-1.5-9-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnJ4ETSPW",
    className: "s19",
    d: "m-1359.5 1932c-6-25-31-50-55-55.5-8.5-2-15.5-6.5-15.5-10.5 0-19 55 6 72.5 32.5 15.5 23.5 22 55.5 11 55.5-4.5 0-9.5-8.5-13-22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPQof1qJq",
    className: "s19",
    d: "m-1615 1939c0-13 16-45 28.5-56 11-10 42.5-24 54-24 15 0 7 13.5-12 19-24.5 7.5-44 27-51.5 51.5-6 20.5-19 26.5-19 9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBMdPXLRk",
    className: "s19",
    d: "m498.5 1880.5c-5.5-5-4-32.5 1.5-29 2.5 1.5 9.5 9.5 15 17.5l10.5 15h-12c-6.5 0-13.5-1.5-15-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19wY25P3t",
    className: "s19",
    d: "m-1237.5 1874c-4.5-7.5 2-15 13-15 6 0 9.5 3.5 9.5 10 0 10.5-16.5 14.5-22.5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17EMCOdrV",
    className: "s19",
    d: "m-1045 1869c0-7.5 2.5-10 9-9 4.5 1 8.5 5 8.5 9 0 4-4 8-8.5 9-6.5 1-9-1.5-9-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BmXhipF9",
    className: "s19",
    d: "m-3303 1798c-34.5-33.5-46.5-42.5-51-38-4.5 4.5-6 4-6-2.5 0-4.5-2.5-8.5-6-8.5-3.5 0-1.5-5 4.5-11 10-9.5 12.5-10 23-4.5 7 3.5 28.5 23 48.5 43 30 30.5 35.5 38.5 34 50.5-1.5 14.5-2 14-47-29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNfGzdtvC",
    className: "s19",
    d: "m-1273.5 1820.5c-2-5.5 2-12.5 14-22.5 11.5-9.5 17.5-12 19-8 1 3.5 4 8 7 9.5 4 3-25.5 29.5-33.5 29.5-2 0-5-4-6.5-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1EUcs0GcR",
    className: "s19",
    d: "m305 1814c12-17 20-23 20-15 0 9.5-16 30-23.5 30-5.5 0-5-3.5 3.5-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptzs2QrrP",
    className: "s19",
    d: "m458.5 1825.5c-5.5-5-4-32.5 1.5-29 2.5 1.5 9.5 9.5 15 17.5l10.5 15h-12c-6.5 0-13.5-1.5-15-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puN2WrNEj",
    className: "s19",
    d: "m1869.5 1815.5c11.5-17 48-52 65.5-63.5 12.5-8 40-11 40-4 0 2-9.5 9.5-21.5 17-11.5 7.5-32 25-46 38.5-15.5 16.5-29 25.5-36.5 25.5h-11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZB8v6fjx",
    className: "s19",
    d: "m-1225 1787c0-4.5-3-8-6-8-3.5-0.5 2.5-8.5 13.5-18 20-17.5 20-17.5 23-6 3.5 14.5 2.5 16-15.5 29-12.5 9-15 9.5-15 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLQVq4zei",
    className: "s19",
    d: "m-1186 1746.5c-2-10 1.5-16 19.5-30.5 24-19.5 41.5-20.5 31.5-1.5-3.5 6-9 9-13 7.5-5-2-7 0-6 5 1 4.5-5.5 13.5-14 20l-16 12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMwkzuKb7",
    className: "s19",
    d: "m398.5 1745.5c-2-1.5-3.5-7-3.5-12 0-5-4.5-9.5-9.5-10.5-9-1.5-9-2.5-2.5-11 8-11 5.5-12.5 32.5 23.5l10 13.5h-12c-6.5 0-13.5-1.5-15-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzp6Lw4te",
    className: "s19",
    d: "m1990 1731c0-10.5 2.5-12 17.5-12 9.5 0 17.5-2 17.5-4.5 0-4.5 9.5-7 49-13 18.5-3 21-2.5 21 6.5 0 10-19 16-53.5 16-8.5 0-17 2-18.5 4.5-1.5 2.5-9.5 7-18 9.5-14 5-15 4.5-15-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BUpnW3w8",
    className: "s19",
    d: "m2136.5 1723c-22-4-26.5-6.5-26.5-15 0-9 2-10 24-6.5 40 5.5 46 8 46 18 0 10.5-3.5 11-43.5 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p42fzOYnL",
    className: "s19",
    d: "m-3336.5 1141c-6.5-6.5 3.5-22 14-22 8 0 12-3.5 13.5-12.5 2.5-11 1-12.5-11.5-12.5-13 0-14.5-1.5-14.5-17.5 0-20 7.5-23.5 12-5.5 1.5 6.5 9 16 16.5 20.5 11 7.5 16 8 28.5 3.5 8-3.5 16-4.5 17.5-3.5 2.5 3 4.5 2-32 26-39.5 26-40.5 26.5-44 23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10zHHcZdG",
    className: "s19",
    d: "m-3240 1076c0-2.5 25.5-21 56.5-40.5 68-43.5 76.5-51.5 69-66l-5.5-10.5-26.5 10.5c-42 17-54 21-56.5 18-1.5-1-4-10.5-5.5-20.5-2.5-16-1.5-18 8-18 6 0 10.5 3 10.5 7.5 0 4 4.5 7.5 10 7.5 5.5 0 10-2 10-5 0-2.5 5.5-5 12.5-5 7 0 12.5-2 12.5-5 0-2.5 10-5 22.5-5 12.5 0 22.5 2 22.5 4.5 0 2.5 3 8 7 12 11.5 11.5-12 35.5-76.5 77-61.5 40-70.5 45-70.5 38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Crt091fV",
    className: "s19",
    d: "m379 1006c-5-1.5-9-5.5-9-9 0-4.5 13.5-7.5 44-10 24-1.5 49.5-4.5 57.5-6 11-2.5 13.5-1.5 13.5 7 0 7-4.5 10.5-16 13-27 4.5-81 7.5-90 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puYfZjkMb",
    className: "s19",
    d: "m-3333.5 940c2-32.5 6-66.5 9-75 5.5-15.5 7-16.5 26.5-15 20 1.5 20.5 2 22 20.5 1 13.5-0.5 18.5-5.5 18.5-4 0-8.5-4.5-10-10-3-11-11.5-12.5-23.5-5-6 3.5-8 18-9.5 65-1 37.5-3.5 60-7 60-3.5 0-4-19-2-59z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFRBCLKSW",
    className: "s19",
    d: "m287.5 982c-34-15.5-125-70-148.5-88.5-15-12-17.5-16.5-12.5-21.5 4.5-5.5 11.5-3 34.5 13.5 16 11.5 29 22.5 29 24.5 0 2 3.5 4 8 4 10 0 52 24.5 52 30.5 0 2.5 3.5 4.5 7.5 4.5 4.5 0 17.5 5 29 11 11.5 6 22 11.5 23.5 11.5 24.5 5 35 9.5 35 15.5 0 10.5-28.5 8-57.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17HJu2TIb",
    className: "s19",
    d: "m2104.5 986.5c-16.5-9-28-26-32-49.5-3-16-2.5-18 6.5-18 7.5 0 10.5 4.5 13 17.5 5 25.5 20 37.5 48 37.5 28.5 0 43.5-12.5 48-40 2.5-15.5 5.5-20 13.5-20 8.5 0 9.5 2 6.5 20.5-6.5 39.5-30 59.5-69 59.5-12-0.5-27.5-3.5-34.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6s3jkvHV",
    className: "s19",
    d: "m-3285 934c-2.5-5-5-16-5-24.5 0-12 2-15.5 10-15.5 6.5 0 10 3.5 10 10 0 8 3.5 10 17.5 10 20 0 22 4.5 7 14-23 14.5-34 16-39.5 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "py7N2WAHM",
    className: "s19",
    d: "m590 928c0-6 7.5-18.5 16.5-28l16-17-21 3.5c-19 3-21.5 2.5-21.5-6.5 0-10 16.5-16 43-16 25 0 9.5 47.5-21.5 67.5-11 7.5-11.5 7-11.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4TmMZrxW",
    className: "s19",
    d: "m-3070 906.5c0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-12 2.5-17.5 7.5-17.5 4.5 0 7.5-4.5 7.5-12.5 0-9 2.5-12.5 10-12.5 8 0 10-3.5 10-17.5 0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-12 2.5-17.5 7.5-17.5 4.5 0 7.5-4.5 7.5-12.5 0-9 2.5-12.5 10-12.5 8 0 10-3.5 10-17.5 0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-15.5 1.5-17.5 12.5-17.5 7 0 12.5 1 12.5 2.5 0 6.5-187.5 327.5-191 327.5-2.5 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paXek5kpe",
    className: "s19",
    d: "m524.5 881.5c-24-8.5-84.5-43.5-84.5-48.5 0-2 7-4 15.5-4 11 0 16 2.5 18 10 1.5 6.5 7 10 14.5 10 6.5 0 19.5 4.5 29.5 10 10 5.5 23.5 10 30 10 9 0 12.5 2.5 12.5 10 0 11.5-9 12.5-35.5 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjsPeRGdT",
    className: "s19",
    d: "m2190 749c0-74-1-135-2-135-1.5 0-23 12-49 27-44 25.5-46.5 28-48 45-1.5 14-4 18-11.5 18-6 0-9.5-3.5-9.5-10 0-5.5-1-10-2-10-1.5 0-44.5 24.5-96.5 54-148 85-148.5 85.5-180.5 66-22-13.5-36-38-36-64 0-17 3-24.5 16.5-38 21-22.5 283-173 300.5-173 9 0 13-2.5 13-8.5 0.5-9 37.5-31.5 52-31.5 4 0 8-3.5 10-7.5 1.5-4 9-7.5 16.5-7.5 16.5 0 26.5-17 26.5-43.5 0-13 2-16.5 10-16.5 7.5 0 10 3.5 10 12.5 0 12.5 0.5 12.5 15 5 8-4 15.5-7.5 17.5-7.5 6 0 2 24-5 27-8.5 3-10.5 18-2.5 18 3 0 5 8.5 5 19l-0.5 18.5-16.5-19.5c-15-17.5-17.5-18.5-28.5-13-69.5 37-404 233.5-410.5 241-14.5 16.5-11.5 45 6 64 13 14 17.5 16 34 14 10-1.5 32.5-11 49.5-21 17-10 36-18 43-18 7.5 0 13.5-3.5 15-8.5 3-11.5 194-121.5 210-121.5 7.5 0 13.5-3.5 14.5-8.5 1.5-5 28-23.5 59.5-41 31.5-17.5 58-33 59-33.5 1-1-5-7-12.5-14l-14.5-12.5 19-0.5h18.5v21.5c0 21-0.5 21.5-32.5 40-17.5 10-38.5 19-46 19-8.5 0.5-10.5 1.5-5 3 8 2 8.5 13 8.5 144.5 0 138.5 0 142-10 142-10 0-10-3.5-10-135z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1ChbSHFVR",
    className: "s19",
    d: "m650 855c0-10 3-17.5 7.5-19 4-2 7.5-6.5 7.5-10 0-4 3.5-8.5 7.5-10 4-2 7.5-7.5 7.5-12.5 0-10 10.5-17 19.5-13.5 7 2-11.5 37.5-32.5 62l-16.5 19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paU3J4aoc",
    className: "s19",
    d: "m86 840c-14.5-18-32-49.5-41-73.5-4-10.5-3.5-12.5 5-12.5 7 0 14.5 9 25.5 31.5 9 17 21 38 27 46 9.5 12.5 10.5 16 5 21-5.5 5-9.5 2.5-21.5-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pl8YuG29J",
    className: "s19",
    d: "m-1448.5 815c-1.5-20 8-36 22-36 6.5 0 11.5 2 11.5 4 0 4-28.5 46-31.5 46-0.5 0-1.5-6-2-14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8uXFhE8s",
    className: "s19",
    d: "m394 810c-18.5-11-17.5-17 2.5-15 12 1 16.5 4 17.5 13 2 13-2 13.5-20 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBQvujx2G",
    className: "s19",
    d: "m-1415 758c0-11 7-27 20-46.5 11-16.5 22.5-37.5 25.5-46 5.5-16.5 24.5-24 24.5-9.5 0 14-11.5 38-18 38-4 0-7 5-7 12.5 0 7-2 12.5-5 12.5-2.5 0-5 3-5 7 0 4-1.5 8-3.5 9-2.5 1-8.5 10-13.5 20.5-12 23-18 23.5-18 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCUeTA0SM",
    className: "s19",
    d: "m35 726.5c0-20 12-24.5 17-6 5 18.5 3.5 23.5-7 23.5-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXisxrVEn",
    className: "s19",
    d: "m234 717.5c-24.5-14-44-27.5-44-29.5 0-7.5 30-4 33 3.5 2 4 7.5 7.5 13 7.5 5.5 0 11 4 12.5 9.5 1.5 7 7.5 10.5 18.5 11.5 11.5 1 16 4 17 13 1 6 0 11-2.5 11-2-0.5-23.5-12-47.5-26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdt9nbgnG",
    className: "s19",
    d: "m725 723.5c0-11 2.5-16 10-18 7.5-2 10-7 10-19.5 0-13.5 2-17 10-17 8 0 10-3.5 10-15.5 0-11 2.5-16 9.5-18 7-1.5 10.5-7.5 11.5-18.5 1-11.5 4-16 13-17 6-1 11-0.5 11 1.5 0 6-77.5 137.5-81 137.5-2 0-4-7-4-15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7GLDSLY9",
    className: "s19",
    d: "m-3250 731.5c0-6 37.5-67.5 41-67.5 2 0 4 8 4 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1-12.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16qvNxHHJ",
    className: "s19",
    d: "m28 693c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AIfFPAC1",
    className: "s19",
    d: "m159 675c-18.5-11-17.5-17 2.5-15 12 1 16.5 4 17.5 13 2 13-2 13.5-20 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pt2RE4GNI",
    className: "s19",
    d: "m25 653c0-15 6.5-29 13-29 4.5 0 7 6 7 17.5 0 14-2 17.5-10 17.5-5.5 0-10-3-10-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1EOwIBzCF",
    className: "s19",
    d: "m-1536 636.5c-3-15.5 8.5-39.5 28.5-59.5 9-8.5 20-23 25.5-31.5 12-21 17-21 17 1 0 15-1.5 17.5-12 17.5-10.5 0-12.5 3-14 16.5-1 12-4 16.5-12.5 17.5-8 1-10.5 5-10.5 15.5 0.5 14.5-8.5 35.5-15.5 35.5-2.5 0-5.5-5.5-6.5-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDyRKtKxp",
    className: "s19",
    d: "m-3195 636.5c0-6 57.5-102.5 61-102.5 2 0 4 8 4 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1-12.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQ2hg1mNU",
    className: "s19",
    d: "m-1335 606.5c0-15.5 1.5-17.5 12.5-17.5 15 0 15 1.5 4 20.5-11.5 19-16.5 18.5-16.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXkFDUFXG",
    className: "s19",
    d: "m32 603c5-26 45-120.5 52-123 4-1 6 4 6 16 0 13-2 18-8 18-7 0-7.5 5-4.5 35.5 2.5 26 2 35-2 32.5-3-2-5.5-7-5.5-11 0-15-9-1.5-15.5 23-5 19-8.5 25-16 25-8.5 0-9.5-2.5-6.5-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pq0qc7o7H",
    className: "s19",
    d: "m-1416 590c-18.5-11-17.5-16 3.5-16 15.5 0 17.5 1.5 17.5 12.5 0 14.5-3 15-21 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPg0VhaBi",
    className: "s19",
    d: "m2126 588c-9.5-9.5-7-14 9-14 11.5 0 15 2 15 10 0 11.5-14.5 13.5-24 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6sVb7wb6",
    className: "s19",
    d: "m-1310 566.5c0-15.5 1.5-17.5 12.5-17.5 15 0 15 1.5 4 20.5-11.5 19-16.5 18.5-16.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLdXbpIoW",
    className: "s19",
    d: "m820 556.5c0-15.5 1.5-17.5 12.5-17.5 15 0 15 1.5 4 20.5-11.5 19-16.5 18.5-16.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4WPEnAf2",
    className: "s19",
    d: "m2370 571c-35.5-5.5-75-18.5-75-25 0-9 21-9 52 0.5 13.5 4 34.5 7.5 46.5 7.5 23.5 0 30.5 11.5 10.5 17-12 3-13 3-34 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5iqE2xmN",
    className: "s19",
    d: "m-2865 551.5c0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-15.5 1.5-17.5 12.5-17.5 7 0 12.5 1 12.5 2.5 0 6-57.5 102.5-61 102.5-2 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7GZ0Bej6",
    className: "s19",
    d: "m2160 556.5c0-4-3.5-7.5-7.5-7.5-4 0-7.5-4.5-7.5-10 0-13 15.5-13.5 26.5-1 11.5 13 11 26-1.5 26-5.5 0-10-3.5-10-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGcqIk2sw",
    className: "s19",
    d: "m2450 552c0-13 8.5-18 30.5-18 25 0 17 12-17.5 25-11.5 4.5-13 3.5-13-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8bU5FE8O",
    className: "s19",
    d: "m-1285 526.5c0-12 2.5-17.5 7.5-17.5 4.5 0 7.5-4.5 7.5-12.5 0-8 3-12.5 7.5-12.5 4.5 0 7.5-4.5 7.5-12.5 0-8 3-12.5 7.5-12.5 4.5 0 7.5-4.5 7.5-12.5 0-8 3-12.5 7.5-12.5 4.5 0 7.5-4.5 7.5-12.5 0-9 2.5-12.5 10-12.5 7.5 0 10-3.5 10-15 0-15.5 9-40 15-40 2 0 5-6.5 7-15 2-12 5.5-15 15.5-15 11 0 12 1 7.5 12.5-12 32-114.5 207.5-121 207.5-2 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BpwD7Kwh",
    className: "s19",
    d: "m-3120 506.5c0-6 37.5-67.5 41-67.5 2 0 4 8 4 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1-12.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8rPPhiA5",
    className: "s19",
    d: "m855 491.5c0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-12 2.5-17.5 7-17.5 4 0 8-5 9-11 1-7.5 5.5-12 13-13 6-1 11-0.5 11 1.5 0 6-52.5 92.5-56 92.5-2.5 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p192W1tEW",
    className: "s19",
    d: "m-1455 496c0-6 17-32 21-32 2 0 4 8 4 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn73NID7V",
    className: "s19",
    d: "m2550 475c0-23 5-31 18-31 6.5 0 12 1 12 2.5 0 6.5-15 31-22 37-7 6-8 5-8-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFAQsdULp",
    className: "s19",
    d: "m2390 479c0-2.5-4.5-5-10-5-8 0-10-3.5-10-17.5 0-9.5 2.5-17.5 5-17.5 3 0 5 3 5 7 0 6.5 28 23 39.5 23 3 0 5.5 3.5 5.5 7.5 0 5-5.5 7.5-17.5 7.5-9.5 0-17.5-2-17.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13UOTFRZq",
    className: "s19",
    d: "m2430 478c0.5-3.5 10.5-11 22.5-17l22.5-10.5v13.5c0 15-7.5 20-30.5 20-8.5 0-14.5-2.5-14.5-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxTd4zXat",
    className: "s19",
    d: "m2070 439v-20h25c14 0 25 2 25 4.5 0 2.5 11.5 5.5 25 7.5 20.5 2.5 25 5 25 13 0 12.5-6.5 12.5-46 0-17-5.5-32-10-32.5-10-1 0-1.5 5.5-1.5 12.5 0 9-2.5 12.5-10 12.5-8.5 0-10-3.5-10-20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p01eg1rAk",
    className: "s19",
    d: "m-1425 441c0-6 17-32 21-32 2 0 4 8 4 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYbSnbIjq",
    className: "s19",
    d: "m-2790 421.5c0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-15.5 1.5-17.5 12.5-17.5 7 0 12.5 1 12.5 2.5 0 6-57.5 102.5-61 102.5-2 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pV1fIDKZ8",
    className: "s19",
    d: "m2485 426c6-15.5 6-27.5 0.5-36.5-3.5-5-11.5-2.5-39.5 14-19.5 11-36.5 20.5-38 20.5-1.5 0-3-5.5-3-12.5 0-11 2-12.5 17.5-12.5 13.5 0 17.5-2 17.5-9.5 0-7 5-10 23-12.5 43.5-6 42-7 42 29.5 0 31-0.5 32.5-12.5 32.5-11 0-12-1-7.5-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pP7YKR7QI",
    className: "s19",
    d: "m2295 400c0-3.5 61.5-41 67.5-41 1.5 0 2.5 5.5 2.5 12.5 0 11-2 12.5-17.5 12.5-14 0-17.5 2-17.5 10 0 8-3.5 10-17.5 10-9.5 0-17.5-2-17.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18doXaTuO",
    className: "s19",
    d: "m2190 376.5c0-20 12-24.5 17-6 5 18.5 3.5 23.5-7 23.5-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7E2FcsjP",
    className: "s19",
    d: "m-1395 386c0-6 17-32 21-32 2 0 4 8 4 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVziFPRF8",
    className: "s19",
    d: "m140 386.5c0-6 37.5-67.5 41-67.5 2 0 4 8 4 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1-12.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pw0BsRcED",
    className: "s19",
    d: "m2578.5 348c-2-23-5.5-42-8.5-43-6.5-2.5-6.5-36 0.5-36 12.5 0 32.5 79 26.5 106.5-1.5 7.5-5.5 13.5-9 13.5-4.5 0-7.5-13-9.5-41z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piGGgzYEs",
    className: "s19",
    d: "m-3045 376.5c0-6 37.5-67.5 41-67.5 2 0 4 8 4 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1-12.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5ufG8fi6",
    className: "s19",
    d: "m915 344c0-27.5 11.5-35.5 17-12.5 4 16.5-1.5 37.5-10 37.5-5 0-7-7-7-25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pP9j9lrdN",
    className: "s19",
    d: "m2000.5 338c-8.5-17.5-16.5-40-18.5-50-2.5-16.5-2-19 6.5-19 7 0 11 6 15.5 22.5 3.5 12.5 6 27 6 32.5 0 5.5 3.5 10 7.5 10 5 0 7.5 5.5 7.5 17.5 0 9.5-2 17.5-4.5 17.5-3 0-11.5-14-20-31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvFVqc43Q",
    className: "s19",
    d: "m2390 345c0-3.5 156-96 162-96 1.5 0 3 5.5 3 12.5 0 11-2 12.5-17.5 12.5-14 0-17.5 2-17.5 10 0 7.5-3.5 10-12.5 10-7.5 0-12.5 3-12.5 7 0 7.5-10.5 13-25.5 13-5 0-9.5 3.5-9.5 7.5 0 5-5.5 7.5-17.5 7.5-14 0-17.5 2-17.5 10 0 8-3.5 10-17.5 10-9.5 0-17.5-2-17.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTYuJZc77",
    className: "s19",
    d: "m-1370 341c0-6 17-32 21-32 2 0 4 8 4 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXR9gG93K",
    className: "s19",
    d: "m2095 309c0-2.5-3.5-5-8-5-8.5 0-22-11.5-22-19 0-3-3-6-6-7-8-3-9-77.5-1-83 3-2 6.5-7.5 8.5-12 2-6.5 8.5-9 22-9h18.5l-16 16.5c-25 25.5-29 44-16.5 70.5 14.5 29.5 50.5 47.5 50.5 25 0-4 3.5-7 7.5-7 5 0 7.5 5.5 7.5 17.5 0 17.5 0 17.5-22.5 17.5-12.5 0-22.5-2-22.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWSiXSLld",
    fillRule: "evenodd",
    className: "s19",
    d: "m-2715 294c0-14-1-15-13.5-11.5l-14 3 30-26-20 5.5c-25.5 6.5-61.5 2.5-86.5-10.5-24.5-12.5-59.5-51-63.5-71-2-8-5.5-16-8.5-17.5-5-3-4 10.5 3.5 45.5 1.5 5.5-2 0.5-8-11-13-28-29.5-30-29.5-4 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3 0-2.5 32-59 123.5-215.5 33.5-57.5 46.5-73 75-90 16-9.5 31.5-13.5 56.5-15.5 30.5-2 38-0.5 62 11 33.5 16.5 55.5 42 65.5 75 9.5 31.5 9.5 56 0 83-9 25-138 250-143.5 250-2 0-4-7-4-15zm-12-47.5c30-9 53-31.5 81.5-81 11-19.5 20.5-37 20.5-38 0-1.5-8.5 2-18.5 7-21.5 11-58.5 12.5-88.5 3.5-20-6-63.5-43-69.5-59-4.5-12-20.5 11-33.5 48-20 57.5-4.5 105.5 38.5 119 31 9.5 39.5 9.5 69.5 0.5zm86-67.5c18.5-32.5 9-23-13.5 14-11.5 18.5-15.5 27.5-9.5 20 6.5-7.5 16.5-23 23-34zm-214-24.5c0-24.5 7.5-45.5 28.5-81 12.5-20.5 16.5-33.5 15.5-45.5-1.5-16.5-1.5-16.5-22.5 18.5-35 58.5-44 90.5-34.5 121.5 5.5 16.5 13 8.5 13-13.5zm241.5-24c4-8 13.5-25 21-39 17-30 14-28.5-8.5 5-15 21.5-26.5 47.5-21.5 47.5 1 0 5-6 9-13.5zm-41-7.5c26.5-8.5 43.5-22.5 57.5-47.5 36-60.5 18.5-130-39.5-159-72-35.5-153.5 11.5-162 94-3 29.5 9 65 30 88 25 27 75.5 38 114 24.5zm-198-59c4.5-8 6.5-15 5.5-15-1.5 0-6 7-10.5 15-4.5 8.5-6.5 15-5.5 15 1.5 0 6-6.5 10.5-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1ARo2eiwI",
    className: "s19",
    d: "m908.5 305.5c-2-1.5-3.5-8.5-3.5-15 0-6-2.5-11.5-5-11.5-3 0-7-4-8.5-8.5-2-5-6.5-12-10-15.5-3.5-3.5-6.5-12.5-6.5-20l0.5-13.5 15 17.5c17.5 20 34.5 51 34.5 62.5 0 7.5-10.5 10.5-16.5 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOTpbArx7",
    className: "s19",
    d: "m-1155 287c0-16 1.5-18 12.5-18 12 0 12.5 0.5 6 16-9.5 23-18.5 24-18.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxcNPZ7J1",
    className: "s19",
    d: "m195 291.5c0-6 37.5-67.5 41-67.5 2 0 4 8 4 17.5 0 14-2 17.5-9.5 17.5-7.5 0-10.5 4-11.5 16.5-1 12-4 16.5-12.5 17.5-6.5 1-11.5 0.5-11.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNJDJixwd",
    className: "s19",
    d: "m-1310 244c15.5-22 20-22.5 20-3 0 16.5-1 18-15.5 18h-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8NlsbPnI",
    className: "s19",
    d: "m-1130 227c0-10 2.5-18 5-18 3 0 5-5.5 5-12.5 0-7 2.5-12.5 5-12.5 3 0 5-5.5 5-12.5 0-7 2.5-12.5 5-12.5 3 0 5-5.5 5-12.5 0-10 2.5-12.5 12.5-12.5h12.5l-9.5 24c-27.5 69.5-34 83-39.5 85-4 1-6-4-6-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6yf0yccY",
    className: "s19",
    d: "m828 211.5c-4-4-11-7.5-15.5-7.5-4.5 0-9.5-4.5-11-10-2-7-7-10-17-10-7.5 0-16-3-18-7-2-4-8.5-7.5-14-8.5-9-2-18.5-24.5-10-24.5 6 0 117.5 67.5 117.5 71 0 7-24 4.5-32-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FfEaHs0j",
    className: "s19",
    d: "m-1276.5 198c3-3.5 17-21.5 31-40 14.5-19 27.5-34 28.5-34 1 0 2 8 2 17.5 0 12-2.5 17.5-7.5 17.5-4 0-7.5 4.5-7.5 10 0 6.5-3.5 10-10 10-7.5 0-10 3.5-10 12.5 0 10.5-2.5 12.5-15.5 12.5-12 0-14.5-1.5-11-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pu9HGDIiG",
    className: "s19",
    d: "m1991.5 173c9.5-23 18.5-24 18.5-2 0 16-1.5 18-12.5 18-12 0-12.5-0.5-6-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIr7O8kq0",
    className: "s19",
    d: "m260 181.5c0-5.5 61-107 68-113 6-4.5 7-3 7 10 0 9.5-3 17-7.5 18.5-4 2-7.5 8.5-7.5 15 0 8.5-3 12-10 12-8 0-10 3.5-10 17.5 0 12-2.5 17.5-7 17.5-4 0-8 5-9 11.5-1 7-5.5 11.5-12.5 12.5-6.5 1-11.5 0.5-11.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXGvYM7kV",
    className: "s19",
    d: "m691.5 129c-2-7-7-10-17.5-10-10.5 0-15.5-3-17.5-9.5-1.5-7-7.5-10.5-18.5-11.5-11.5-1-16-4-17-12.5-1-6.5-0.5-11.5 1.5-11.5 6 0 102.5 57.5 102.5 61 0 2-7 4-15.5 4-11 0-16-2.5-18-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQXBZD34D",
    className: "s19",
    d: "m-1085 112c0-16 1.5-18 12.5-18 12 0 12.5 0.5 6 16-9.5 23-18.5 24-18.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYhwwrLYn",
    className: "s19",
    d: "m2025 114c5.5-8 17-19.5 25-25l15-10.5v15c0 12-2 15.5-10 15.5-6.5 0-10 3.5-10 10 0 8-3.5 10-15.5 10h-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWmtxOoUm",
    className: "s19",
    d: "m-1070 72c0-16 1.5-18 12.5-18 12 0 12.5 0.5 6 16-9.5 23-18.5 24-18.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pM8pE6mSc",
    className: "s19",
    d: "m-1179.5 75.5c3.5-5 38.5-47 77-93.5 55-66.5 70.5-82.5 71.5-74 1 6 5 11 9 11 4 0 7 2.5 7 5 0 3 3.5 5 7.5 5 6.5 0 6 3.5-1.5 23.5-10 27.5-20.5 34-21.5 13-0.5-7.5 0-17.5 0.5-21.5 1-6-1.5-5.5-9.5 2-10.5 9.5-10.5 9.5-10.5-1 0-6-2-11-5-11-2.5 0-5 8-5 17.5 0 15.5-1.5 17.5-12.5 17.5-10.5 0-12.5 2.5-12.5 15 0 12.5-2 15-12.5 15-10.5 0-12.5 2.5-12.5 15 0 12.5-2 15-12.5 15-10.5 0-12.5 2.5-12.5 15 0 11.5-2 15-10 15-7.5 0-10 3.5-10 12.5 0 10.5-2.5 12.5-15.5 12.5-14 0-15-1-9-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvLFckQLN",
    className: "s19",
    d: "m2095 63.5c0-6 25.5-17.5 51.5-22 16-3 18.5-2.5 18.5 6 0 7-6 11-22.5 15.5-28 7.5-47.5 7.5-47.5 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7aPCi1fH",
    className: "s19",
    d: "m355 38.5c17-14.5 17.5-14.5 19-4 2 12.5-6.5 19.5-24 19-12 0-12 0 5-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11nywdEK2",
    className: "s19",
    d: "m543.5 50.5c-4.5-4-4.5-21.5-0.5-21.5 6 0 32 17 32 21 0 5-27 5.5-31.5 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbMCajcRu",
    className: "s19",
    d: "m-1055 32c0-16 1.5-18 12.5-18 12 0 12.5 0.5 6 16-9.5 23-18.5 24-18.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "penFdPy6d",
    className: "s19",
    d: "m405 17c0-6.5 14-13 29-13 3 0 6 4.5 6 10 0 8-3.5 10-17.5 10-11.5 0-17.5-2.5-17.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phpbbcQT8",
    className: "s19",
    d: "m470 14c0-10.5 5-12 24-7 18 5 13.5 17-6.5 17-14 0-17.5-2-17.5-10z"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "lt48qGodHhFOA6cUTPwQT4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "p1DOjQmAZi",
    className: "s20",
    d: "m-1636 2702c-53-11.5-104.5-59-119-110.5-4-14-5-93.5-4-262.5 1.5-242 1.5-242.5 13-266 15.5-31.5 45.5-60.5 80-77.5l28.5-14 146-1.5 146-1.5 32.5 15c39 19 78 59.5 90.5 94 4.5 13 9.5 47 11 75.5l3 51h-13.5c-8 0-22-7-34-16-20-16.5-20-16.5-85.5-18-61-1.5-67.5-1-88 10-38.5 20.5-40.5 29-40.5 159 0 130.5 2 139 40.5 159 20 10.5 27.5 11.5 88 10l65.5-1.5 20-16c12-9.5 26-16.5 34-16.5h13.5l-3 51.5c-1.5 28-6.5 61-11 73-17.5 49.5-64.5 91.5-116 103.5-38 9-256 9-297.5 0z"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "lQWqDGUtmcmBLW6eK9qj4f"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pyPsJJKlr",
    className: "s21",
    d: "m550 5216c0-7 1.5-7 7.5-2 8.5 7 9 5.5 8-26-1-21.5 0-24 9-24 9.5 0 10.5 3 10.5 30v30h-17.5c-13 0-17.5-2-17.5-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4dQSFRbh",
    className: "s21",
    d: "m408.5 5105.5c-4.5-4.5-4.5-31.5 0.5-31.5 2 0 8.5 8 15 17.5l11 17.5h-11.5c-6.5 0-13.5-1.5-15-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8t03EHRd",
    className: "s21",
    d: "m363.5 5030.5c-2-1.5-3.5-9.5-3.5-17 0-9-3-14-10-16-7-2-10-7-10-17.5 0-10.5-3-15.5-10-17.5-6-1.5-10-7-10-12.5 0-5.5-3.5-11-7.5-13-8-3-11-33-3-33 4 0 75.5 121 75.5 127.5 0 3.5-18 3-21.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnzRf9VqA",
    className: "s21",
    d: "m496 4972c-19-32-19.5-34-5-32 6.5 1 12 5.5 13.5 11.5 1 5.5 4.5 12 8.5 14 7 4 10 33.5 3 33.5-2 0-11-12-20-27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pw3aaUM58",
    className: "s21",
    d: "m431 4859c-14-24.5-26-46-26-47.5 0-8.5 22.5 1 24.5 10 1 5.5 4.5 12 8.5 14 4 2 7 10.5 7 18 0 10 3 15 10 17 7.5 2 10 7 10 18 0 8.5-1.5 15.5-4 15.5-2 0-15.5-20-30-45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1586al49p",
    className: "s21",
    d: "m370 2759c0-8.5 3.5-10 25-10 21.5 0 25 1.5 25 10 0 8.5-3.5 10-25 10-21.5 0-25-1.5-25-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pt6hu0s3x",
    className: "s21",
    d: "m307.5 2759.5c-9-2-15.5-7-16.5-12.5-2-8.5 0.5-9 22.5-6 38 6 46.5 8.5 46.5 16 0 7.5-24 8.5-52.5 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19rWFzj9n",
    className: "s21",
    d: "m450 2752c0-6.5 14-13 29-13 3 0 6 4.5 6 10 0 8-3.5 10-17.5 10-11.5 0-17.5-2.5-17.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p182DQ4vEo",
    className: "s21",
    d: "m490 2742.5c0-3.5 8-9.5 18-12.5 16.5-5 17.5-4.5 16 5.5-1 8.5-5.5 11.5-17.5 12.5-11.5 1-16.5-0.5-16.5-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIEcgMHf0",
    className: "s21",
    d: "m236.5 2735.5c-3.5-1-6.5-6.5-6.5-12 0-8.5 1.5-9 16-3 19.5 8 24.5 18.5 8 18-6 0-14.5-1.5-17.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyJkSRb2w",
    className: "s21",
    d: "m196.5 2715.5c-3.5-1-6.5-5.5-6.5-9.5 0-4-4-7-9-7-23.5 0-101-81-101-104.5l0.5-13 12.5 15c32.5 38.5 78.5 81.5 104 97.5 15.5 9.5 28 19 28 21.5 0 4-19 4-28.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "po2hZgiTZ",
    className: "s21",
    d: "m570 2705.5c0-2.5 8-9 17.5-15.5l17.5-11v12c0 6.5-3.5 13.5-8 15-11 4-27 4-27-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfbrWDDe0",
    className: "s21",
    d: "m693.5 2583c8-12 17-27.5 20.5-35 7-17.5 16-18 16-1.5 0 20-25.5 57.5-39 57.5h-11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYpUiBKgl",
    className: "s21",
    d: "m25.5 2493.5c-7.5-21.5-7-39.5 1-39.5 4 0 10 11.5 14.5 27.5 7 26 7 27.5-1 27.5-5.5 0-11-6-14.5-15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Eb462lTl",
    className: "s21",
    d: "m745 2443c0-15 6.5-29 13-29 4.5 0 7 6 7 17.5 0 14-2 17.5-10 17.5-5.5 0-10-3-10-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10ilnIYNl",
    className: "s21",
    d: "m750 2376.5c0-14 2-17.5 10-17.5 8 0 10 3.5 10 17.5 0 14-2 17.5-10 17.5-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLhtHA8oS",
    className: "s21",
    d: "m20 2323c0-3 5-21 11-40 8-24.5 13.5-34 19.5-34 7.5 0 7.5 4-4.5 40-7.5 22.5-16 40-19.5 40-3.5 0-6.5-2.5-6.5-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXWpiv7bV",
    className: "s21",
    d: "m725.5 2275.5c-37-103-155.5-302-270-454-27.5-36.5-29-40-19-41.5 11-2 33.5 20 33.5 33 0 3 2.5 6 5 6 3 0 6.5 3.5 8.5 8 1.5 4.5 8.5 14 14.5 21 6.5 7 12 15.5 12 19 0 4 2 7 4.5 7 6 0 115.5 167 115.5 176 0 4.5 3.5 9 7.5 11 4 1.5 7.5 6 7.5 10.5 0 4 4.5 12 10 17.5 5.5 5.5 10 14.5 10 20 0 5.5 2.5 10 5.5 10 6.5 0 69.5 131.5 69.5 145 0 5 2.5 11 5 12.5 7.5 4.5 6 32.5-1.5 32.5-3.5 0-11.5-15-18-33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGFgMdmwc",
    className: "s21",
    d: "m50 2239c0-12.5 15-40 22-40 8 0 5.5 11.5-7 35.5-5.5 10-15 13-15 4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1EuBS9yO5",
    className: "s21",
    d: "m-2745 2182c0-6.5 14-13 29-13 3 0 6 4.5 6 10 0 8-3.5 10-17.5 10-11.5 0-17.5-2.5-17.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1151f7QFu",
    className: "s21",
    d: "m-2826.5 2150.5c-5-5-4-31.5 1-31.5 2.5 0 9 8 15 17.5l10 17.5h-11.5c-6 0-13-1.5-14.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQ0iaheZY",
    className: "s21",
    d: "m-2660 2108c0-15 6.5-29 13-29 4.5 0 7 6 7 17.5 0 14-2 17.5-10 17.5-5.5 0-10-3-10-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paYj8CgTt",
    className: "s21",
    d: "m-2840 2019c0-16.5 1.5-20 10-20 10.5 0 12.5 8 7 29-5.5 19.5-17 13.5-17-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15udnvQ9v",
    className: "s21",
    d: "m307 1815.5c2-4.5 17-27 34-50 26-35 33.5-41.5 45-41.5 10.5 0 14 2.5 14 10 0 6-2.5 8.5-7 7-4-1.5-15.5 8-28 24-22.5 27.5-53.5 59-58.5 59-1.5 0-1-3.5 0.5-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVDkuRlZF",
    className: "s21",
    d: "m-1345 611c0-2 25-44 56-94 102-166 146.5-262.5 242-529 20-55 32-69 32-36.5 0 9.5-2 17.5-4.5 17.5-2.5 0-5.5 8.5-7.5 19-3 19.5-33.5 102.5-84 231-33 83-102 225-109.5 225-2.5 0-4.5 3-4.5 7 0 4-3 10.5-7 14-3.5 4-8.5 12-10 18-2 6-6 11-8.5 11-2.5 0-4.5 3-4.5 7 0 4-3 10.5-6 14-3.5 3.5-11 15-16 25.5-5.5 10-11.5 18.5-14 18.5-2 0-4 3.5-4 7.5 0 4-2 7.5-4.5 7.5-2.5 0-6 5.5-7.5 12.5-2 7-5.5 12.5-8 12.5-3 0-5 3.5-5 7.5 0 4.5-4.5 7.5-12.5 7.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmqdBUehu",
    className: "s21",
    d: "m-1420 588.5c-9.5-5.5-26-11-36-12.5-18.5-3-19-4-19-23.5 0-16 10.5-39.5 53.5-118 69.5-128 92.5-164.5 153.5-245.5 108.5-144.5 198.5-247.5 221-253 6.5-1.5 12-2 12-0.5 0 1.5-18.5 34.5-41 73-23 38.5-50.5 86.5-61.5 106-11 19.5-32 56-47 81.5-29 49.5-93.5 161.5-129.5 225.5-12 22-29.5 51.5-38 65-9 14-23.5 38-32.5 54l-16.5 29.5 16.5 14 17 14.5-17.5-0.5c-9.5 0-25.5-4.5-35-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piIFttT8l",
    fillRule: "evenodd",
    className: "s21",
    d: "m2325 561.5c-15-4-34-8.5-41.5-10-7.5-1.5-12.5-5-11-7.5 1.5-2.5-9-16.5-24-31-14.5-14.5-30.5-32.5-36-40-7.5-10.5-16-14.5-41.5-19-17.5-3-42-9-54-13-12.5-4-24.5-6-27.5-4.5-5.5 3.5-66-59-81.5-84.5-28-45.5-36-120.5-18-172 29-82 108.5-141 190.5-141h24.5l1 171.5c1 94 1.5 184 1.5 200 0 15.5 1.5 28.5 3 28.5 6.5 0 121.5-63 231-126.5 60.5-35 112.5-63.5 117-63.5 4 0 13 13 20.5 29 12 25.5 13.5 34 13.5 86 0 54-1 59.5-15 87.5-19.5 39-62 81.5-100 100-25.5 12-37 14.5-77.5 15.5-30 1-58-1-75-5.5zm137-103c23.5-18.5 37.5-63 23-72-7-4.5-105 52.5-105 61 0 9.5 25.5 21 48 21.5 13.5 0 25-3.5 34-10.5zm-337-222c0-43-1.5-62.5-5.5-62.5-21 0-54.5 38.5-54.5 62.5 0 16 16.5 43.5 32 53 27.5 16.5 28 15.5 28-53z"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "l3Xr8cWsab5FWDEatml5nB"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pokJQS4lE",
    className: "s22",
    d: "m536 5222c-48-30-82-59-111.5-96.5-30-37.5-164.5-270-164.5-284 0-22 6-32.5 18-32.5 7 0 12-3 12-7 0-8.5 11-13 30.5-13 11 0 14.5-2.5 14.5-10 0-6.5 3.5-10 10-10 5.5 0 10-2 10-5 0-2.5 5.5-5 12.5-5 10 0 13-3.5 17.5-20 4-14.5 8-20 15-20 12 0 13 13.5 2 29-7 10-7 12.5-0.5 22.5 6 9.5 6 12 0 18-6 5.5-8.5 5-14.5-3.5-5-7-10-9.5-16-7.5-8 3-91.5 50.5-95 54-1.5 1.5 12.5 29 36.5 72.5 9 16.5 11 23 6 26-4 2.5-3.5 4 2.5 4 9 0 34 37.5 34 51 0 4.5 3.5 9 7.5 11 4.5 1.5 7.5 9 7.5 18q0 15 7.5 15c4 0 16.5 16.5 28.5 36 25.5 43.5 73.5 95.5 111.5 122 15 10 27.5 21 27.5 23.5 0 3 1.5 3.5 3.5 2 1.5-2 6-1 10 2.5 5.5 4.5 7.5 3.5 10-5 5-20.5 16.5-12.5 16.5 11.5 0 15-2 22.5-6.5 22.5-3.5 0-22.5-10-42.5-22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDyhpK7bL",
    fillRule: "evenodd",
    className: "s22",
    d: "m-1233.5 5217.5c-15.5-9-24.5-21.5-82.5-123.5-31.5-54.5-54.5-101-56.5-112.5-2-11-9.5-32-16.5-46.5-12-23.5-15-26-26-23.5-7 1.5-23 4-36 6-20 2.5-24 1.5-24-5 0-5.5 6.5-9 19-11 36-6.5 64-17.5 90-37.5 14.5-11 30.5-20 36-20 9.5 0 10 0.5 2.5 12-7.5 11-7 13.5 7 35.5 8 13 23.5 31.5 34 41.5 21 20 124 194.5 132.5 224 11.5 42.5-40.5 82.5-79.5 60.5zm49-29c7.5-7.5 10-14.5 7.5-25-2-12-41-82-104.5-188.5-17.5-29.5-33-37-53-25.5-26 14.5-21 31 35 128.5 66 114 71 121 90 121 8 0 19-4.5 25-10.5zm-160.5-263.5c9.5-8 10-10 4.5-22.5-4.5-9.5-9.5-13.5-16-12.5-15.5 2.5-21.5 16-14.5 31 7 15.5 11 16 26 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppOqcCPBH",
    className: "s22",
    d: "m-3386 5191c-14.5-14.5-2-15.5 240-18.5 134-1.5 248-4.5 254-6 17-5 20-47.5 19.5-276 0-196-0.5-212-9-220-8-8-22.5-9.5-120-12-61-1.5-111.5-3.5-112-3.5-1-0.5-1.5-4-1.5-8 0-5.5 30-7.5 157.5-10 86.5-2 159.5-2.5 162-1 11 7 50 11.5 52 6 1-3.5 25.5-5.5 74-5.5 64.5 0 72 1 73.5 9 1.5 7.5-4 8.5-61 8.5h-62.5l3.5 14c2 7.5 2.5 123 1 257-2 185-4 245-8.5 249.5-3.5 3.5-19.5 8.5-35 10.5-37 5.5-623 11-627.5 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBxzbPEAb",
    className: "s22",
    d: "m563 5148c-5-33.5-18-85.5-23-95-6.5-12-6.5-34 0-34 11 0 35 71.5 42.5 126.5 3.5 21.5 2.5 23.5-6.5 23.5-7.5 0-10.5-4.5-13-21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9GnEXwXk",
    fillRule: "evenodd",
    className: "s22",
    d: "m2214 5079c-10.5-8-167-270.5-177-297-1.5-4.5-4.5-8-6.5-8-1.5 0-13 16-25.5 35-12.5 19-24 35-25.5 35-4.5 0-8.5-21-12.5-66-1.5-21-4.5-40.5-6.5-43-3.5-5.5-5.5-5.5-77 11.5-19 4.5-35.5 7-37 5.5-1.5-1.5 3.5-11 11-21 13-17 14.5-17.5 18-9 3 7.5 4 6.5 4-5.5 0.5-9 7.5-23.5 18-37l17.5-22-36.5-22.5c-19.5-12-37-24-38.5-25.5-1.5-2-9-6.5-17.5-10-14.5-7-12.5-7.5 46-15 33.5-4.5 62-9.5 64-11 1.5-2 0.5-9-2.5-16.5-7.5-20-6-28 4.5-28 10 0 18.5 26 16 50-2 16-0.5 15-31 18.5-14.5 1.5-32 4.5-38.5 6-12 3.5-11 4.5 17 20 49.5 28 49.5 28 28 55-10 12.5-21.5 26-24.5 29.5-11.5 12-7 14.5 17.5 9.5 48.5-10 65.5 0 66 39 0.5 35.5 11 31.5 37-13.5 7.5-13.5 15-24 16.5-24 1.5 0 18.5 12.5 37 27.5 19 15.5 34.5 26.5 34.5 25 0-2-4.5-21.5-10.5-43.5-5.5-22-9.5-41-8.5-41.5 1-1 21.5-4.5 46.5-8.5l44.5-6.5-33.5-19.5c-32-19-40.5-27.5-27-28.5 3 0 2-2-3-3.5-8-3.5-6-7.5 14-33 12.5-16.5 22-30 21-31-0.5-1-14.5 2-30.5 6-16.5 4.5-35 6.5-41 5-12.5-3.5-13.5-6-20.5-52.5l-4-27-22.5 35.5c-12.5 20-24.5 35.5-27.5 34.5-6.5-2.5-9.5-24-4-28 2.5-1.5 17-22.5 32-46.5 14.5-24.5 28.5-44 30.5-44 5.5 0 13.5 31 17 69 2 20 5 37 6.5 38 2 1.5 29.5-4 61.5-11.5 33.5-8 57.5-11.5 55.5-8.5-2 3-19 25.5-38 49.5-27.5 35-33.5 45.5-28 49 4 2.5 24.5 15 46 28 21 13 38.5 25 38.5 26.5 0 5.5-35 14-71 17.5-19 2-34 5.5-34 7.5 0 2 24 45 53 95.5 116.5 202.5 121.5 211.5 122.5 232 1.5 24.5-3 33.5-25.5 47-22 13-40 13.5-56 0.5zm42.5-20.5c28-15 25.5-23.5-32-124-59-102-74-124-79.5-115.5-2.5 4.5-16-3-44.5-24.5-22.5-16.5-42-30.5-43-30.5-1 0-0.5 4 1 9 3.5 8 145 256.5 159.5 280 8 12 22 14 38.5 5.5zm-128-313c-1.5-5-2.5-1-2.5 8.5 0 9.5 1 13.5 2.5 9 1-5 1-13 0-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12FiW9dKz",
    className: "s22",
    d: "m518.5 5010.5c-2-1.5-3.5-9.5-3.5-17 0-9-3-14-10-16-6-1.5-10-7-10-13 0-6-2-10.5-4.5-10.5-7.5 0-30.5-43-30.5-56.5 0-8-3.5-13-10-15-7-2-10-7-10-17.5 0-10.5-3-15.5-10-17.5-6-1.5-10-7-10-12.5 0-5.5-3.5-11-7.5-13-7.5-3-11-33-3.5-33 4 0 131 216 131 222 0 4-17.5 3.5-21.5-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8QMXaXWO",
    className: "s22",
    d: "m-1540.5 4911c-13-3.5-34.5-14.5-47.5-23.5-19.5-12.5-24-18.5-23-27.5 1.5-10 0-11.5-10-10-14.5 2-40.5-35-52-75-12.5-43-8-110 10.5-148.5 54-113 201-150.5 302-77 17 12 19.5 16 14.5 21.5-3.5 4-8.5 5-11.5 3-2.5-2.5-19.5-12.5-37.5-22.5-30.5-17.5-35-18.5-77.5-19-35.5-0.5-51 2-72.5 10.5-15 6-31.5 11-36 11-5 0-9 3-9 6.5 0 8-36 43.5-44 43.5-3.5 0-6 5-6 11.5 0 6-3 15.5-7 21-11.5 17-18.5 71.5-13 104 13 82 70 141.5 151.5 158.5 18.5 3.5 28.5 8 28.5 13 0 9-29.5 9-60.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNUH74w45",
    className: "s22",
    d: "m-1320 4828c0-6 6-25 13-43 23-57.5 15.5-123.5-20.5-175.5-16-23-16.5-24.5-7-27 11.5-3 28 16.5 45 54 9.5 21 11.5 34 11.5 80 0.5 52.5-0.5 56.5-16 89-17 34-26 42-26 22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peBSbT5pK",
    className: "s22",
    d: "m201.5 4826.5c-13.5-9.5-23-37.5-18.5-54.5 5-20.5 17-16.5 17 6 0 13 3 20.5 10 25 5.5 3.5 10 11.5 10 18.5 0 14.5-3.5 15.5-18.5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1EMvBIX47",
    className: "s22",
    d: "m165 4684.5c-8-15.5-6-25.5 5-25.5 8 0 10 3.5 10 17.5 0 19.5-7 23-15 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQyKD3xGT",
    className: "s22",
    d: "m374 4688.5c-1-3-13-6.5-26.5-8-28.5-3-37.5-11.5-37.5-35 0-20.5 7.5-21 17.5-1.5 5.5 11 11.5 15 20.5 15 17.5 0 43 12.5 51 25 5.5 9 5 10-8.5 10-8 0-15.5-2.5-16.5-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pw8kkZtuZ",
    className: "s22",
    d: "m-3389 4645.5c3-16.5 109-15 109 1 0 6-10.5 7.5-55.5 7.5-50 0-55-1-53.5-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3UlJYd2n",
    className: "s22",
    d: "m163.5 4623.5c8-30 58-59 90-51.5 20 4.5 44 20.5 53.5 34.5 8 12.5 8 12.5-7 12.5-11.5 0-15-2.5-15-9.5 0-6.5-5-10.5-16-13-24.5-5-56-4-58 2-1 3-5 5.5-9 5.5-4 0-7 3.5-7 7.5 0 4-2 7.5-5 7.5-2.5 0-5 3.5-5 7.5 0 4.5-4.5 7.5-12 7.5-9.5 0-11.5-2-9.5-10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p0FFHbc2d",
    className: "s22",
    d: "m1962.5 4523.5c-16-12-20.5-13.5-21.5-7.5-1 4.5-5.5 8-10.5 8-6.5 0-10.5-8-16.5-32.5-4-18-6.5-32.5-5-32.5 9 0 86 64 86 71.5 0 12.5-9.5 10.5-32.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEvaVf8cq",
    fillRule: "evenodd",
    className: "s22",
    d: "m525 3976.5c0-7-2-12.5-5-12.5-3 0-5-15-5-35v-35l-196-1c-184-1.5-196.5-2-198-10.5-1.5-8.5 8.5-9 196-7.5 109 1 198 0.5 198.5-1 2-16.5 2.5-52.5 0.5-72.5l-2-25-136.5 1.5-136 1.5-3-26.5c-6-46-4.5-69 4-69 5 0 7.5 5 7.5 14 0 8 1.5 16 3.5 18 3 3 221.5-210.5 221.5-217 0-1.5-52.5-1.5-116 0-64 1.5-118.5 1-121-1-3-2.5-26-4-52-4-42.5 0-47 1-49.5 10-3 11.5-16.5 13.5-16.5 2.5 0-5.5-10-7.5-48.5-8.5l-49-1.5-1.5-58.5-1.5-59h38c29.5 0 37.5 1.5 37.5 7 0 5.5-7.5 8-26 9l-26.5 1.5v80l246.5 1.5 246 1-0.5 21.5c-0.5 33.5-6.5 65-13 67-3 1-6.5-2.5-7.5-8.5-1-8-22 10.5-106.5 95l-105 105h212.5v-87.5c0-84.5 0.5-87.5 10-87.5 10 0 10.5 2.5 10 89 0 48.5-0.5 136.5 0 195v106h42.5c42 0 42.5 0 42.5-12.5 0-9 2.5-12.5 10-12.5 8.5 0 10 3.5 10 20v20h-115zm-134-336c108-107.5 137-141.5 120.5-141.5-6.5 0-256.5 252-256.5 258.5 0 3.5 2.5 6.5 6 6.5 3 0 61.5-55.5 130-123.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pC4oA10qQ",
    className: "s22",
    d: "m-2785 3901.5c-11.5-23-19.5-44.5-17.5-47.5 5.5-9 17.5-5.5 17.5 5 0 5.5 2 10 4 10 7 0 26 44.5 26 60 0 25-8.5 17-30-27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQKXiESGC",
    className: "s22",
    d: "m-1183 3932c-1.5-3.5-2-20-1-36l1.5-29.5h20c15 0 20.5 2 21.5 9 1.5 6.5-1.5 8.5-11 8.5-12.5 0-13 1.5-13 27.5 0 21.5-1.5 27.5-7.5 27.5-4.5 0-9-3-10.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDb8oaR03",
    className: "s22",
    d: "m-3192 3900.5c-1.5-8-4-26-5.5-40-3-24.5-2.5-26.5 6.5-26.5 8.5 0 10.5 3.5 12 21 1.5 23 14 33.5 14 12 0-8 3-13 7.5-13 5.5 0 7.5-5.5 7.5-19.5 0-19 0.5-19.5 20-23 19.5-3.5 20-3.5 20-25 0-20.5 0.5-21.5 17.5-24.5 13-2.5 17.5-6 17.5-13 0-6.5 3.5-10 10-10 7.5 0 10-3.5 10-12.5 0-11 2-12.5 17.5-12.5 11 0 17.5-2.5 17.5-6.5 0-4.5 14-8.5 46.5-13 57-7.5 158-24.5 150-25-3.5-0.5-6.5-4-6.5-8 0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-5.5 0-10-3.5-10-7.5 0-4-4.5-7.5-10-7.5-8 0-10-3.5-10-15.5 0-12 1.5-14.5 6.5-11 46 36 190.5 142.5 196 144.5 4 2 9-0.5 10.5-5 5.5-14 12-8.5 12 9.5 0 9.5-2 17.5-5 17.5-2.5 0-5 3.5-5 7.5 0 4-2 7.5-5 7.5-2.5 0-5 2.5-5 5 0 3 14 5 32.5 5 31.5 0 32.5-0.5 32.5-12.5 0-15 7.5-16.5 15-3 7.5 14 6.5 30.5-1.5 27.5-4-1.5-13 0-20 2.5-11 4.5-13.5 8.5-13.5 22 0 21 7.5 28.5 28.5 28.5 15.5 0 16.5-1 16.5-16 0-32 4.5-32.5 58-6 52.5 26 63.5 37 37.5 37-8.5 0-15.5-2-15.5-5 0-2.5-3.5-5-7.5-5-4.5 0-16.5-4.5-27.5-10-11-5.5-21-10-22.5-10-1.5 0-2.5 13.5-2.5 30 0 23.5 1.5 30 7.5 30 11 0 9 8.5-3 15-16.5 9-24.5 2.5-24.5-20.5v-21l-18.5 3c-24 4-27.5 8.5-30.5 38-2 25-2.5 25.5-19 25.5-19.5 0-24-12-6.5-16.5 9.5-2.5 10.5-5.5 8-21.5-3.5-22.5-3-22-25-25.5l-17.5-2.5-3.5 23c-4 24-7 26.5-23 18-11.5-6.5-12.5-15-2-15 6 0 7.5-6.5 7.5-30 0-16.5-1-30-2.5-30-1.5 0-11.5 4.5-22.5 10-11 5.5-23 10-27.5 10-4 0-7.5 2.5-7.5 5 0 3-3.5 5-7.5 5-4 0-7.5 2.5-7.5 5 0 3.5-3 3.5-10 0-5.5-3-10-7.5-10-10 0-6 100-55.5 105.5-52 2.5 1.5 6 11.5 7.5 22.5 3 19 7.5 22 27 19.5 11-1 20-15 20-30.5 0-14-7.5-19.5-27.5-19.5-16.5 0-19.5-7-10.5-24 4-8 6.5-15.5 5.5-17-2-2-211.5 28.5-230 33.5-5.5 1.5-43.5 45.5-84 97.5-41 52.5-76 95-78.5 95-2.5 0-5.5-6-7-13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDloq5l4w",
    className: "s22",
    d: "m625 3891.5v-17.5h45c44.5 0 45 0 45-12.5 0-9.5 2.5-12.5 10.5-12.5 9 0 10 2.5 8.5 21.5l-1.5 21-46 1.5c-37 1-46.5 3-46.5 8.5 0 4-3.5 7.5-7.5 7.5-5 0-7.5-5.5-7.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piZ0622Cf",
    fillRule: "evenodd",
    className: "s22",
    d: "m2322.5 3887c-54-14-80-31-100-65.5l-13-22-24.5 9.5c-20 8-105.5 25-125 25-2.5 0-5-4-5-9 0-8 6.5-10.5 42-15.5 55-7.5 103.5-24 106.5-36 1.5-5.5 4.5-9.5 7-9.5 6.5 0 5.5-14-1-16-8-2.5 3.5-56.5 16-77.5 18-29 51-31 86-4.5 9.5 7 18 13 19.5 13 3.5 0 29-57 29-64.5 0-3 4.5-5.5 10-5.5 14.5 0 12.5 13.5-8 55l-18 36 9 20.5c12.5 27.5 12 57.5-0.5 67-12 8.5-44.5 6-67.5-6-19-10-31.5-9.5-45 1.5-10 8-10.5 10.5-5 21.5 21.5 42 66.5 64 139 68.5 40.5 2 46 3.5 46 11.5 0 8.5-4 9.5-36 9-20 0-47.5-3-61.5-6.5zm20-118.5c4-6-7-49.5-12-49.5-2 0-8.5 3.5-14.5 8-10.5 7-11 7-11-5.5 0-9 3-14.5 10-16 8.5-2.5 7-4.5-10.5-19-25.5-22-37-25-52-15.5-13.5 9-27.5 48.5-27.5 79v19l19-10c10-5.5 26-16 35-23l16-13.5v13c0 7-2 14.5-5 16-8.5 5.5-5.5 11.5 9 16.5 18.5 7 39.5 7 43.5 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppU4GmBET",
    className: "s22",
    d: "m2425 3884.5c0-5.5 3-10.5 7-10.5 3.5 0 14-1.5 22.5-3 12-2.5 15.5-1.5 15.5 4.5 0 10-3 11.5-26.5 16-16.5 3.5-18.5 2.5-18.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCtWE0qQR",
    className: "s22",
    d: "m-2715 3864c0-9.5 2.5-15 7-15 11 0 14 8.5 8 20-8 14.5-15 12.5-15-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pseXk1L8D",
    className: "s22",
    d: "m-1110 3814c0-16.5 1.5-20 10-20 8.5 0 10 3.5 10 20 0 16.5-1.5 20-10 20-8.5 0-10-3.5-10-20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBfOSQr3X",
    className: "s22",
    d: "m1990 3830.5c-89-10.5-186-59.5-236.5-120-82.5-99-74.5-227 20-320.5 23-23 42-37.5 51.5-39.5 8.5-1.5 15-5 15-7.5 0-7.5 70-37.5 108.5-46 45-10 46.5-10 46.5 1 0 8-8 11-43 18.5-76 16-158.5 69-198 127-9 12.5-17 24-18.5 25.5-1.5 1.5-3.5 5.5-4.5 9.5-1 4-5 19.5-9 35-8.5 33-9 51.5-1.5 86.5 22.5 105 128 188.5 264.5 209.5 33 5 40 8 40 15.5 0 5.5-3.5 8.5-8.5 8-5 0-17-1.5-26.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14gxi3KJi",
    className: "s22",
    d: "m-3202 3815.5c-1.5-8-4-24.5-6-37.5-3-22-2.5-24 7.5-24 7.5 0 10.5 3 10.5 11.5 0 6 1.5 23 3 37.5 3 21.5 2 26-4.5 26-4.5 0-9-6-10.5-13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "perMq19jK",
    className: "s22",
    d: "m-1405 3819c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18BpoKwcn",
    className: "s22",
    d: "m-1270 3819c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUVn6jcXM",
    className: "s22",
    d: "m-1180 3819c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKjEyrdfm",
    className: "s22",
    d: "m-1495 3797.5c0-10 4.5-12.5 15.5-10 14 4 12 16.5-3 16.5-7 0-12.5-3-12.5-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pY98DQ3D2",
    className: "s22",
    d: "m715 3791.5c0-12.5-0.5-12.5-45-12.5h-45v-17.5c0-12 2.5-17.5 7.5-17.5 4 0 7.5 3.5 7.5 7.5 0 5.5 9.5 7.5 46.5 8.5l46 1.5 1.5 21.5c1.5 18.5 0.5 21-8.5 21-8 0-10.5-3-10.5-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnsH9UVdz",
    className: "s22",
    d: "m-3212 3738c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p60PdDasR",
    className: "s22",
    d: "m-1736 3740c-8-1.5-9-8-9-48.5 0-25.5 1.5-50 3-54.5 3-8 19.5-10.5 34-5 12 4.5 10.5 27-1.5 27-5.5 0-11-3-12-6-1.5-3.5-3 11-3 32.5-0.5 31 1 38.5 7 38.5 4 0 7.5 3 7.5 7 0 7.5-12.5 12-26 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8e9gELux",
    className: "s22",
    d: "m-1190 3719c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQRsq1Jx2",
    className: "s22",
    d: "m-1165 3699.5c0-27.5 1-30.5 10-30.5 9.5 0 10.5 2.5 9 28.5-1 23-3.5 29.5-10 30.5-8 1.5-9-2.5-9-28.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfWjdWVOZ",
    className: "s22",
    d: "m-3217 3698c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Cn731C7O",
    className: "s22",
    d: "m-3222 3655.5c-1-8-4-24.5-5.5-37.5-3-21.5-2-24 6.5-24 8 0 10 5 13 26.5 1.5 14 3 31 3 37.5 0 16-13.5 14-17-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pj5w3J45n",
    className: "s22",
    d: "m120 3611.5c0-45.5 1.5-57.5 7-57.5 10 0 13 16 13 69 0 42.5-0.5 46-10 46-9.5 0-10-3.5-10-57.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prs1eUFoB",
    className: "s22",
    d: "m235 3629c0-28 1.5-35 7.5-35 6 0 7.5 7 7.5 35 0 28-1.5 35-7.5 35-6 0-7.5-7-7.5-35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pd1eAyQ7K",
    className: "s22",
    d: "m-1165 3636.5c0-18.5 11-24.5 17-9.5 6 16 3 27-7 27-8 0-10-3.5-10-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18F31wvZ0",
    className: "s22",
    d: "m-1189 3635.5c1-8.5 5-14.5 10.5-15.5 6.5-1.5 8.5 1.5 8.5 13.5 0 12.5-2 15.5-10.5 15.5-8 0-10-2.5-8.5-13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paEbJ1eSr",
    className: "s22",
    d: "m-2765 3640c0-2.5 3.5-8.5 7.5-14 7.5-9.5 7.5-9.5 15 0 11 14.5 9.5 18-7.5 18-8 0-15-2-15-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16b0p5aoB",
    className: "s22",
    d: "m2367 3560.5c-0.5-28-3.5-52-8.5-65-8-21-7.5-21.5 2-21.5 6 0 11.5 5 15 14 17 44.5 17 116 0 116-7.5 0-8.5-6-8.5-43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZe2hiSzZ",
    className: "s22",
    d: "m-3232 3575.5c-1.5-8-4-26-5.5-40-3-24-2.5-26.5 6.5-26.5 8 0 10 4.5 13 30.5 1.5 17 3 35 3 40 0 15-14 11-17-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pC4kNcsAc",
    className: "s22",
    d: "m235 3553c0-12 1.5-26.5 3-32.5 6-22 12-11 12 21 0 25.5-1.5 32.5-7.5 32.5-5.5 0-7.5-5.5-7.5-21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11tPIF3FF",
    className: "s22",
    d: "m-3030 3503.5v-15l15 10.5c22 15.5 22.5 20 3 20-16.5 0-18-1-18-15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNNJ9Hw1l",
    className: "s22",
    d: "m-1738.5 3515.5c-4.5-1.5-6.5-17.5-6.5-54 0-55.5 2.5-61 28-54.5 14.5 3.5 16 17 2 17-9 0-10 3.5-10 37 0 36.5 0 36.5 12.5 34 10-1.5 12.5 0 12.5 8.5 0 7-3 10.5-9.5 10.5-5.5 0-12.5 1-16.5 2-3.5 1.5-9.5 1-12.5-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pShAF8ySa",
    className: "s22",
    d: "m-3242 3493c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18pUSgE3U",
    className: "s22",
    d: "m-1165 3469.5c0-32.5 1-35.5 10-35.5 9.5 0 10.5 2.5 9 33.5-1 27.5-3 34-10 35.5-8 1.5-9-2.5-9-33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgTxYKRgN",
    className: "s22",
    d: "m-3070 3473.5v-15l15 10.5c22 15.5 22.5 20 3 20-16.5 0-18-1-18-15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pChjVvw8j",
    className: "s22",
    d: "m-3247 3453c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXwwzttGy",
    className: "s22",
    d: "m-3110 3443.5v-15l15 10.5c22 15.5 22.5 20 3 20-16.5 0-18-1-18-15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLEOE3b39",
    className: "s22",
    d: "m2319 3426c-23.5-30-64-60.5-109.5-82.5-21.5-10.5-29.5-17-29.5-24.5 0-8.5 2-9 12.5-5 42.5 16 120 67 115 75-2 3 0.5 5 4.5 5 7 0 43 42 43 50 0 2-3.5 5-7.5 7-4.5 1.5-14.5-7-28.5-25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1ASRzCNOp",
    fillRule: "evenodd",
    className: "s22",
    d: "m630 3421.5c0-4-2-7.5-4.5-7.5-2.5 0-5.5-4.5-7-10-2-7.5-7-10-20.5-10-12.5 0-18-2-18-7.5 0-4 3.5-7.5 8-7.5 4.5 0 30-21.5 56.5-47.5 54.5-53.5 64.5-57 88-32.5l14.5 15-55 57c-30 31-56 57-58 57.5-2.5 0-4-3-4-7zm51-71c32.5-32.5 41-46.5 28-46.5-8.5 0-74 65.5-74 73.5 0 13.5 13.5 5.5 46-27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQzQraTSe",
    className: "s22",
    d: "m-3252 3410.5c-1.5-8-4-26-5.5-40-3-24-2.5-26.5 6.5-26.5 8 0 10 4.5 13 30.5 1.5 17 3 35 3 40 0 15-14 11-17-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLbRiirUJ",
    className: "s22",
    d: "m-1165 3419c0-2.5-6-5-13-5-9.5 0-12.5-2-11-8.5 1-7 6.5-9 21.5-9 18 0 20 1.5 21.5 14 1.5 11-0.5 13.5-8.5 13.5-6 0-10.5-2-10.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjJhkOV0T",
    className: "s22",
    d: "m-3175 3393.5v-15l15 10.5c22 15.5 22.5 20 3 20-16.5 0-18-1-18-15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p0DMxydKO",
    className: "s22",
    d: "m100 3387c0-3.5 4.5-8 10-9.5 7-1.5 10-7 10-15.5 0-9.5 2.5-13 10-13 7.5 0 10 3.5 10 13 0 8.5 3 14 10 15.5 5.5 1.5 10 6 10 9.5 0 5-8 7-30 7-22 0-30-2-30-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p08EEozK1",
    className: "s22",
    d: "m215 3386.5c0-4 3.5-7.5 8-7.5 4.5 0 9-4.5 10.5-10 3-11.5 16.5-13.5 16.5-2.5 0 4 5.5 8.5 12.5 10.5 7 1.5 12.5 6 12.5 10 0 5-7.5 7-30 7-23.5 0-30-1.5-30-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkwFVUwdw",
    className: "s22",
    d: "m300 3386.5c0-6.5 17.5-7.5 127.5-7.5 110 0 127.5 1 127.5 7.5 0 6.5-17.5 7.5-127.5 7.5-110 0-127.5-1-127.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRCvTdVGD",
    className: "s22",
    d: "m-1655 3354c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYIfwhExc",
    className: "s22",
    d: "m-1518 3357c-1.5-4-2-13.5-1-21.5l1.5-14 54-1.5c51-1.5 53.5-1 53.5 9 0 9.5-3 10-44.5 10h-44l2.5 12.5c1.5 10 0 12.5-8.5 12.5-6 0-12-3-13.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1C074yack",
    className: "s22",
    d: "m-1430 3354c0-6.5 3.5-10 10-10 6.5 0 10 3.5 10 10 0 6.5-3.5 10-10 10-6.5 0-10-3.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxWJrHAy6",
    className: "s22",
    d: "m-1745 3342c0-21 4.5-23 53-23 43.5 0 47 0.5 47 10 0 9-3.5 10-40 10-23.5 0-40 2-40 5 0 3-4.5 5-10 5-5.5 0-10-3-10-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p49dPiaJQ",
    className: "s22",
    d: "m-1294 3332c1.5-10 5-10.5 53-12 43-1 51.5 0 54 6.5 2 4.5 2.5 8.5 1.5 9.5-1 1-26.5 3-56 4-52.5 2.5-54 2-52.5-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWFWCODBe",
    className: "s22",
    d: "m-3261.5 3328c-2-6-2-12-1-13.5 4-3.5 22.5 15.5 19.5 20-5 8.5-16 4.5-18.5-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGXV8t8Ia",
    className: "s22",
    d: "m120 3301.5v-22.5h55c51.5 0 55 0.5 55 10 0 9.5-3.5 10-45 10-44.5 0-45 0-45 12.5 0 9-2.5 12.5-10 12.5-8.5 0-10-3.5-10-22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CL8ihANX",
    className: "s22",
    d: "m2132.5 3316.5c-2.5-1-13.5-3-23.5-5-14.5-2-19-5.5-19-12.5 0-12 1.5-12 45.5-2 22.5 5 34.5 10 34.5 15 0 6.5-23.5 9.5-37.5 4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWY1jpIJs",
    className: "s22",
    d: "m2000 3299c0-6.5 5.5-9.5 21.5-12 32.5-5 63.5 1 63.5 12.5 0 8-5 9-42.5 9-37.5-0.5-42.5-1.5-42.5-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFtc4Pgp0",
    className: "s22",
    d: "m344 2765.5c-18-4.5-10-16.5 11-16.5 16.5 0 20 1.5 20 10 0 10-10 12-31 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BWc66zFk",
    className: "s22",
    d: "m405 2759c0-8.5 3.5-10 20-10 22.5 0 28.5 11.5 9 17-21 5.5-29 3.5-29-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNpjUMeQi",
    className: "s22",
    d: "m289 2755.5c-12-3-11.5-16.5 0.5-16.5 15 0 25.5 5.5 25.5 13 0 7-9 8-26 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19fcQmXpO",
    className: "s22",
    d: "m466 2750.5c1-6 8-10 19.5-12 10-1.5 31.5-10 48.5-18.5 29-15 56-21 56-12 0 6.5-44 29-79.5 40.5-39 13-46.5 13-44.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prQHEGr6A",
    className: "s22",
    d: "m216.5 2725.5c-19-9-21.5-16.5-5-16.5 15 0 25 7 22.5 16.5-1.5 7.5-3 7.5-17.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnygBDbvn",
    className: "s22",
    d: "m-1616 2705.5c-16.5-4-9-11.5 11-11.5 14.5 0 20 2 20 7.5 0 7.5-12.5 9-31 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwKRYQwOC",
    className: "s22",
    d: "m-1385 2702c0-4.5 7-7.5 20-9 22-2 28.5 7.5 9 13-18.5 5-29 3.5-29-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxhr3tNvN",
    className: "s22",
    d: "m148 2679.5c-43.5-37-94-101-86-109.5 5.5-5 20.5 6.5 22.5 17 1 5 6 12.5 11 16 5.5 3.5 9.5 11 9.5 16.5 0 5 2.5 9.5 6 9.5 9.5 0 34 26 34 36 0 6 3.5 9 12 9 13.5 0 24.5 11 22 22.5-1 6-9 2-31-17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pT9tVFyY9",
    className: "s22",
    d: "m600 2691.5c0-10 3-13.5 15-15.5 9.5-2 15-6.5 15-11.5 0-10.5 25.5-35.5 36-35.5 4.5 0 9-6 11-15 1.5-9 6-15 10.5-15 4 0 7.5-4 7.5-9.5 0-5 3-12 7-15 4-3.5 8.5-11.5 10-18 2-7 5.5-12.5 8-12.5 3 0 5-7 5-15 0-14.5 8.5-23 19.5-19 6.5 2-12 45-37.5 84.5-21.5 34-63 78.5-91 99l-16 11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwlGcX5bS",
    className: "s22",
    d: "m-1668 2692c-5-4-8-9-5.5-11 5-5 29.5 4 32.5 12 2.5 8.5-15 7.5-27-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19VjrwAlH",
    className: "s22",
    d: "m-1334 2693c2.5-7 28.5-16.5 33-11.5 5 4.5-14 17.5-25.5 17.5-5 0-8.5-2.5-7.5-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1EY2JF9oG",
    className: "s22",
    d: "m-3330 2674.5c-9.5-2-24.5-7.5-33.5-12-26.5-14-50-54.5-44-77 4.5-18.5 16-13.5 21.5 10 6.5 25 19 40 46 53.5 19 9.5 29 10 253.5 9.5 166.5 0 238.5-2 250.5-6 24.5-9 45.5-31.5 51.5-56.5 6.5-25 17-29 22-7.5 4.5 22-19.5 65.5-36.5 65.5-4 0-10 3.5-13 8-3.5 4.5-16 10-28.5 12.5-26 5-464.5 5-489.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHLpEeDwn",
    className: "s22",
    d: "m-1714.5 2658.5c-10.5-10.5-14.5-17.5-10.5-18.5 8-3 32 21 29 29-1 4-8 0-18.5-10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pX3zyB2B3",
    className: "s22",
    d: "m-1280 2667.5c0-8 16-23.5 24-23.5 8 0-2 16.5-14.5 24.5-7.5 4.5-9.5 4-9.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "przJ1sBCu",
    className: "s22",
    d: "m2072.5 2627c-37.5-17-60-64-48.5-102.5 3.5-11 19-42 34-68.5 15.5-26 27-48.5 26-49-1-0.5-20.5-7.5-44-15-46-14.5-112-50.5-161-87-27.5-20.5-30-23.5-20-25 7.5-1 24.5 6.5 47.5 22.5 58 38.5 123 69.5 166.5 79 21.5 5 40 9.5 41 10 1 1-15.5 31.5-36 68-42 73.5-46.5 93-28 123.5 6.5 11 8 16 3.5 16.5-3 0 7.5 4.5 24 10 37 12.5 59 7.5 83-17.5 12-13.5 17.5-16 22-11.5 5 5 4.5 9-3.5 20-21 29.5-71.5 42-106.5 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQkPysHmw",
    className: "s22",
    d: "m-1245 2624.5c0-10.5 12-30.5 18.5-30.5 5.5 0 5.5 2.5 0 16-6.5 15.5-18.5 25-18.5 14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKumf6XO6",
    className: "s22",
    d: "m2183 2571c-2-4.5 18-43.5 51.5-101 61-105.5 76.5-134.5 85.5-163.5 11-36 17-33 16.5 9 0 4.5 2 8.5 4 8.5 2 0 5.5 7.5 7 16.5 2 8.5 8 24.5 13.5 35 33 65.5 129 41.5 129-32 0-12-8-50-17.5-84-9.5-34.5-17.5-66.5-17.5-71.5 0-5-5.5-18-12.5-29-13.5-21.5-15-32.5-8-60 2.5-9.5 6-26 8-36 1.5-12 5.5-19 10-19 9.5 0 9.5 24 0.5 58.5-6 22.5-6 27 0.5 36.5 4.5 6 8 16.5 8 23 0 6.5 1.5 12 3.5 12 2 0 9.5 24 17 54 7.5 29.5 17 64.5 21 78 4 13 7 31 7 40-0.5 22-16.5 54.5-33 66.5-53.5 38-123 14-141.5-49.5l-6.5-20.5-8.5 14.5c-4.5 8-35.5 61-68 118.5-33 57-61 103.5-63 103.5-2 0-5-3.5-6.5-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pi6p40b42",
    className: "s22",
    d: "m-1224.5 2529c0.5-25.5 3-35 8-35 7 0 9 37 3.5 59-6.5 23-12.5 10-11.5-24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pp0SBwuaj",
    className: "s22",
    d: "m-1433.5 2513c-6.5-3-11.5-8.5-11.5-12.5 0-3.5-3-6.5-7-6.5-9 0-25.5-23-30-41-2.5-10.5-1.5-14 4-14 3.5 0 8.5 6 10.5 13.5 6 24 22 41 48 50 13.5 5 24.5 10.5 24.5 12.5 0 5.5-25.5 4-38.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOuvUVmqK",
    className: "s22",
    d: "m-1280 2510c0-2 6.5-8 15-12.5 19-11.5 33-31.5 37-54.5 4.5-25 18-26 18-1.5 0 9.5-2 17.5-5 17.5-2.5 0-5 7-5 15 0 12.5-2 15-12.5 15-7 0-12.5 3-12.5 6.5 0 4-5.5 9.5-12.5 12.5-15 7-22.5 7.5-22.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pa3frNpnC",
    className: "s22",
    d: "m21 2475.5c-3-13.5-6.5-34.5-8.5-47.5-3.5-21.5-2.5-24 6-24 8.5 0 10.5 4.5 13 29 1.5 15.5 4.5 37 6.5 47.5 2.5 15 2 18.5-4.5 18.5-5 0-9.5-8-12.5-23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "px1TnwiRd",
    className: "s22",
    d: "m742 2475.5c1.5-13.5 4.5-36 6-50 3-22 5-26.5 13.5-26.5 8.5 0 9.5 2.5 6.5 24-7.5 54.5-13.5 76-21.5 76-6.5 0-7-4-4.5-23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peQgNaNDB",
    className: "s22",
    d: "m12.5 2358c7-44 13.5-64 21-64 5.5 0 7 3 4.5 11.5-1.5 6-4.5 25-6.5 42.5-2.5 26.5-4.5 31-12.5 31-9 0-9.5-2.5-6.5-21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMckopefQ",
    className: "s22",
    d: "m753 2373c-13.5-44.5-16-79-6-79 7 0 14 21.5 20.5 64 3 17.5 2 21-4.5 21-4.5 0-9-3-10-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1EEP1EaUW",
    className: "s22",
    d: "m725 2271c-3-7-5-18.5-5-25 0-19.5 11.5-12 21 14.5 8.5 23 8.5 23.5-1 23.5-6.5 0-12-5-15-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CUphXhaN",
    className: "s22",
    d: "m1826 2255c-35-44.5-53-88.5-61.5-149-10.5-76.5 14.5-153 86-261.5 24-37 32.5-45.5 42-45.5 13 0 17-7.5 6.5-11-9-3 44.5-43.5 79.5-60 40.5-19 104-30.5 146.5-26.5 36.5 4 93 20 98 28 7 11.5-10.5 13-37.5 3.5-104-36-232.5 4-299.5 92.5-29.5 39.5-79 128-90.5 162-28.5 84.5-13.5 176 41.5 251 14 19 15.5 24 10.5 29-5.5 5-9.5 2.5-21.5-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Az1BQBtV",
    className: "s22",
    d: "m39.5 2258c14-36.5 30.5-69 35-69 7.5 0 7 7-4 31-5 12-12 27.5-15 35.5-3 7.5-8.5 13.5-13 13.5-5.5 0-6-2.5-3-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12FCLk9fl",
    className: "s22",
    d: "m-1227 2243c-5-19-3.5-24 7-24 8 0 10 3.5 10 17.5 0 20-12 24.5-17 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pge99D99Y",
    className: "s22",
    d: "m-1485 2237c0-9.5 14-38.5 24.5-49.5 13.5-15 40.5-28.5 56-28.5 16.5 0 10.5 8-10 14.5-24.5 7-48.5 30.5-53 50.5-2 8-6.5 15-10.5 15-4 0-7-1-7-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18lAJxB50",
    className: "s22",
    d: "m703.5 2220.5c-2-1.5-3.5-9.5-3.5-17.5 0-19 10-16 18.5 5 6 14.5 5.5 16-2.5 16-5 0-11-1.5-12.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pc23HwHQ7",
    className: "s22",
    d: "m-2778.5 2200.5c-1.5-5-7-13.5-12-19-5.5-6.5-7.5-12.5-5-17 3.5-5 7-5 20.5 2 13 6.5 23 8 48 5 49-5 41 12.5-9 20-15.5 2.5-24 6-24 10.5 0 10-14.5 8.5-18.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRQBGYOYL",
    className: "s22",
    d: "m-1252 2191.5c-10.5-9.5-25.5-18.5-33.5-20-16.5-3.5-19.5-12.5-4.5-12.5 11.5 0 47.5 17 52.5 25 4.5 7.5 12.5 6 12.5-2.5 0-4 3.5-7.5 7.5-7.5 5 0 7.5 5.5 7.5 17.5 0 15-1.5 17.5-11 17.5-6.5-0.5-20-8-31-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5wKy5x3d",
    className: "s22",
    d: "m-1225 2132.5c0-11.5-2-28.5-4.5-37.5-3.5-12-3.5-16 2-16 7 0 10.5 10 15.5 49 3 22 2 26-5 26-6 0-8-5-8-21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pysEkS0dz",
    className: "s22",
    d: "m90 2150.5c0-6.5 72-126.5 76-126.5 8.5 0 3 13.5-18.5 47.5-12 19.5-27 45.5-33 59-6 13-14 23.5-17.5 23.5-4 0-7-1.5-7-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Gbg8N7ap",
    className: "s22",
    d: "m666 2141.5c-3.5-7-6-17.5-6-22.5 0-5.5-3.5-10-7.5-10-4 0-8.5-5.5-10.5-12.5-1.5-7-5-12.5-7-12.5-2.5 0-6-5-8-11-1.5-6-6.5-14-10-18-4-3.5-7-10-7-14 0-4-2-7-4-7-2 0-7.5-6.5-12.5-14.5-9-15.5-11.5-35.5-4.5-35.5 4.5 0 92 143.5 98.5 161.5 6 14.5-15 10.5-21.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKLxJlf2j",
    className: "s22",
    d: "m-2834.5 2135.5c-2.5-5-6-19.5-8-32.5-3.5-22-3-24 7-24 7.5 0 10.5 3 10.5 12 0 6.5 3.5 21 7.5 32.5 6.5 19.5 6.5 20.5-2.5 20.5-5.5 0-12-4-14.5-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptxeYi2tI",
    className: "s22",
    d: "m-2655 2098c0-6-4-23.5-8.5-39l-8.5-27.5-44.5-22.5c-43-22-51.5-28.5-47.5-40 2.5-7.5 67 25.5 92.5 47.5 23 19.5 39 58.5 33.5 80.5-4 15-17 15.5-17 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puI8EOODM",
    className: "s22",
    d: "m-3219.5 2026.5c-44-42.5-81.5-77.5-84-77.5-12 0-45.5 12.5-57.5 21-12 8-14 8.5-14 2 0-4.5-3-8-6-8-12.5-0.5 21.5-25 42-30l20.5-6-34.5-34.5c-34-34-34-34.5-19-34.5 15.5 0 47 26 47 39 0 3.5 3.5 6 8 6 4.5 0 48 39.5 97 88l88.5 87.5 28-29 28-29-13-13.5-13.5-14h15c10 0 19.5 4.5 27 12.5 10.5 11 11 13.5 5 25-9.5 18-67.5 72.5-77 72.5-4.5 0-43.5-35-87.5-77.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZ8JNlk5D",
    className: "s22",
    d: "m-2845 2050.5c0-17 6-31.5 13-31.5 5 0 7 6.5 7 20 0 16.5-1.5 20-10 20-6 0-10-3.5-10-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9rv7hYTg",
    className: "s22",
    d: "m-3407 2026.5c-4-16.5 1.5-37.5 9.5-37.5 9 0 14 17 10 35-4 18-15.5 19.5-19.5 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNEcnV9YZ",
    className: "s22",
    d: "m-1723 2028.5c4-5.5 12-13.5 17.5-17.5 15-11 14 2-1.5 17-15.5 14.5-26.5 15-16 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BfptrgjG",
    className: "s22",
    d: "m170 2016c0-6 27-47 31.5-47 6 0 4 6.5-8 27-10 18-23.5 29.5-23.5 20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pojKNO0ud",
    className: "s22",
    d: "m2445 2015.5c0-2.5-3.5-19-7.5-37.5-18.5-89.5-71.5-152.5-171-206.5-28-15-31.5-19.5-18.5-24.5 11-4 93 46 99.5 61 2.5 6 8.5 11 13 11 12.5 0 52 46.5 69.5 82 27 54 39 118 22.5 118-4 0-7.5-1.5-7.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phSQHblml",
    className: "s22",
    d: "m-1320 1995c-12.5-5.5-38-8.5-91-10-59-1.5-74-3.5-74-9 0-5.5 13-7 65-7h65v-16.5c0-24.5-19.5-59-40-69.5-9.5-5-27-9-38.5-9-16 0-21.5-2-21.5-7.5 0-9 23-10 51-2.5 33 9.5 64 55 64 95.5 0 10.5 4.5 14.5 25 23 14 6 25 13 25 16 0 7.5-9 6.5-30-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p186GcPIAV",
    className: "s22",
    d: "m-2838.5 1975.5c0.5-17-1-24-5-23.5-3.5 0.5-65.5 1-137 1.5-115.5 0.5-130 1.5-124.5 8 5.5 6.5 4 7.5-7 7.5-10.5 0-13-2.5-13-12.5 0-10.5-2.5-12.5-15-12.5-13 0-15-1.5-15-14.5v-14.5l19 10c17 9 29 9.5 156 9 171.5-1 158-2 170 10 10.5 10.5 14 28 4.5 22-7-4-14.5 7-14.5 22 0 7.5-3 11-10 11-8.5 0-10-3-8.5-23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pumdxJFz8",
    className: "s22",
    d: "m-1675 1993.5c0-5.5 30-19.5 42.5-19.5 17 0 6.5 14-14.5 19.5-27.5 7-28 7-28 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15AOv9ETJ",
    className: "s22",
    d: "m-1214 1972.5c-45.5-39.5-55.5-50.5-56-59.5 0-5 2-9 4.5-9 8 0 65.5 51 62.5 55.5-1.5 2.5 0.5 4.5 4 4.5 4 0 14.5 6.5 24 14l17 14.5-13.5 2.5c-11 2-19-2-42.5-22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pz0tf3byW",
    className: "s22",
    d: "m-1617 1960.5c4-33.5 11-53.5 23-69.5 11-13.5 45-31.5 60.5-32 15 0 9.5 13.5-7 17-35 7-59.5 38-59.5 75.5 0 12 2 17.5 7.5 17.5 4 0 7.5 3.5 7.5 7.5 0 5-5.5 7.5-17.5 7.5h-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pT6EjvK8F",
    className: "s22",
    d: "m-1545 1976.5c0-5.5 6-7.5 22.5-7.5 16.5 0 22.5 2 22.5 7.5 0 5.5-6 7.5-22.5 7.5-16.5 0-22.5-2-22.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHPweJkeY",
    className: "s22",
    d: "m248 1895.5c18.5-27 55.5-78.5 82.5-115 56.5-76 59.5-77 93.5-34 33.5 42.5 126 173 126 178 0 2.5-4 4.5-8.5 4.5-10.5 0-36.5-39-36.5-54.5 0-7-3-10.5-10-10.5-5.5 0-10-2-10-4 0-2.5-4.5-9.5-10-16-5.5-6.5-10-17-10-23.5 0-8-3-11.5-9.5-11.5-5.5 0-11-4.5-13-9.5-1.5-5.5-6-11-10-12.5-4-1.5-7.5-5-7.5-7.5 0-7-31-40.5-37.5-40.5-3 0-10.5 5-16.5 11.5-6 6-15.5 15.5-21.5 21-6 5.5-20.5 24.5-32 42.5-12 18-26 37-31 43-5 5.5-11 13.5-14 18-25 41-46 69-51.5 69-4 0 8.5-22 27-48.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3Uvpc3Au",
    className: "s22",
    d: "m-1234.5 1874.5c-8-5-3-15.5 7.5-15.5 4 0 7 4.5 7 10 0 11-3.5 12.5-14.5 5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptqROZvKu",
    className: "s22",
    d: "m-1050 1869c0-6.5 3.5-10 9-10 12 0 16 4 12.5 13-4 11-21.5 8.5-21.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnfSiY8SW",
    className: "s22",
    d: "m-3420 1811.5c0-16.5 1-17.5 15.5-17.5 14 0 15 1 9 8-5 6-5 10-0.5 17.5 5.5 8.5 4.5 9.5-9 9.5-14 0-15-1.5-15-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phA2kkkoO",
    className: "s22",
    d: "m-1272 1824.5c-8.5-13.5 17.5-35.5 36.5-30.5 12 2.5 12 3-8 19-22 17.5-24.5 18.5-28.5 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2dhec97X",
    className: "s22",
    d: "m-1230 1784l-12-3 17.5-13.5c10-7.5 24-13.5 31-13.5 14.5 0 19-10 5-10-6.5-0.5-4.5-4.5 8.5-15.5 9.5-8 18-12.5 19-9.5 1 2.5 5.5 5 10 5 5.5 0-0.5 8-16.5 22.5-39.5 35.5-48.5 41-62.5 37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTCOdtWUB",
    className: "s22",
    d: "m-3350 1741.5c0-15.5 5.5-16 23.5 0l14 12-18.5 0.5c-17 0-19-1.5-19-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13Yaa4Psz",
    className: "s22",
    d: "m-3325 1116.5c0-9.5-2-17.5-5-17.5-2.5 0-5-8-5-17.5 0-19.5 5-22.5 12.5-7 3 5.5 12 14.5 20 19.5l15.5 9.5 31-20.5c17-11 32.5-19 34-17.5 2.5 2.5-93.5 68.5-100 68.5-1.5 0-3-8-3-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p160mwC3gp",
    className: "s22",
    d: "m-3206 1052.5c7.5-9 46-30 46-25 0 4.5-41 31.5-47.5 31.5-2 0-1.5-3 1.5-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUyoAmKYs",
    className: "s22",
    d: "m-3332.5 970.5c1.5-29.5 4-54.5 5-56 1.5-1 2.5 23 2.5 53.5 0 35.5-2 56-5 56-3.5 0-4.5-18-2.5-53.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pW3oDC7ob",
    className: "s22",
    d: "m-3145 1013.5c38-31 40-34 30.5-49-3.5-5.5-11.5-4-43.5 8.5-22 8.5-41.5 13.5-44 11-2-2-5.5-19-6.5-37l-3-33-19 3c-15.5 2.5-19.5 1.5-19.5-4.5 0-8.5 28-21.5 42.5-19 16 2.5 19 8.5 18.5 39.5l-0.5 29 15-2c8-1 14.5-4 14.5-6.5 0-2.5 9-4.5 20-4.5 14.5 0 20-2 20-7.5 0-5.5 4-7.5 14-6.5 11 1 15-1.5 20.5-14.5 4-9 10.5-16.5 14-16.5 3.5 0 6.5-5.5 6.5-12.5 0-9 2.5-12.5 10-12.5 8 0 10-3.5 10-17.5 0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-12 2.5-17.5 7.5-17.5 4.5 0 7.5-4.5 7.5-12.5 0-9 2.5-12.5 10-12.5 8 0 10-3.5 10-17.5 0-14.5 2-17.5 10.5-17.5 8 0 9.5-2 7-10-4.5-14 15.5-45 28.5-45 7.5 0 9 2 6.5 9-6.5 17-149.5 264-163.5 282-13.5 17.5-42.5 39-52 39-2.5-0.5 1-5 8-10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Ail8fC6Q",
    className: "s22",
    d: "m335 998c-44.5-12.5-151-71-199-109-78-61.5-120-165-106-263 2.5-21 6.5-40.5 8.5-44 2-3 4-8.5 5-12.5 2.5-18.5 46-110.5 52-110.5 7 0 5.5 24.5-2.5 39-4 7.5-8.5 19.5-10 27-1.5 7-7 14.5-12 15.5-6.5 2-5.5 2.5 3 3 7 0.5 11 3.5 11 10 0 5 6.5 22.5 15 38.5 8 16 15 32.5 15 36 0 3 4 6 9 6 10.5 0.5 31 17 31 25 0 3.5 3.5 5 8 3 8-3 163 83 166 92.5 1 2.5 4.5 4.5 7.5 4.5 3.5 0 37.5 18 76 40.5 110 63.5 123.5 69.5 154 69.5 14.5 0 37-3.5 50-8 12.5-4 28.5-7 35.5-6l12.5 1.5-20.5 27c-13.5 18-21.5 24.5-24 20.5-2.5-3.5-6.5-4.5-10.5-2.5-4 2.5-3-0.5 2-6 12-14 10.5-16.5-7.5-11-24 6.5-50.5 5.5-76-3-22-7.5-298-164.5-303-172-1.5-2.5-7.5-5.5-13.5-7.5-6.5-2-11.5-7-11.5-11.5 0-5-3-6.5-8-4.5-11 4.5-73-33.5-92-56-8.5-10-19-29-24-42-4.5-13.5-10-24-12-24-1.5 0-7 17-12 38.5-14.5 65-1.5 149.5 30 198 4.5 6.5 7 16 5 20.5-2 5-0.5 8 4 8 10.5 0 24 16.5 24 29 0 7.5 3 11 10 11 5 0 28.5 12 51 27 83 54 144 82 195.5 90.5 11.5 2 18.5 5.5 18.5 10 0 9-27.5 9.5-55 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pI8XVnkLs",
    className: "s22",
    d: "m425 997.5c0-5.5 6-9 19-11 10-2 31-7.5 46.5-12.5 27-8.5 44.5-7 37.5 4-4.5 7.5-46.5 20.5-76.5 24.5-22 2.5-26.5 1.5-26.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgCv5Y6Eh",
    fillRule: "evenodd",
    className: "s22",
    d: "m2106 985.5c-32-15.5-33.5-23.5-33.5-172.5 0-121-0.5-132.5-8-128.5-4.5 2-51 29-103.5 59-56.5 32.5-99 54-103.5 52.5-4.5-2-7.5 0-7.5 4.5 0 11-26.5 15.5-47.5 8.5-30.5-10-53.5-51-45.5-82.5 2-8 6.5-12.5 13-12.5 7.5 0 10-3.5 10-12 0-8.5 3.5-13.5 11.5-16 6-2 12-5 13.5-7.5 1.5-2 60-36.5 130-77 70-40.5 129-75 131-76.5 2-2 4-25.5 4.5-52.5 1-47.5 1-49-13-63.5-18-19-9.5-19.5 18.5-0.5 12 7.5 30 17 40.5 21 10 3.5 18.5 8.5 18.5 11 0 4.5-10 3.5-33.5-4-11.5-3.5-11.5-3-11.5 37 0 23.5 2 40.5 5 40.5 3 0 5-1.5 5-4 0-5 54-37 59-34.5 2 1 9-3.5 15.5-10l12-11.5h-12c-17.5 0-34.5-5.5-34.5-11 0-2.5 9.5-3 23-1 29 4 32 0 32-44 0-19 2-34 5-34 6.5 0 11.5 32 8.5 55.5-3 22.5 1.5 24.5 24 9.5 19.5-13 23.5-12.5 21.5 1.5-1 7.5-5.5 11.5-14.5 12.5-18.5 2-22.5 19.5-9.5 36 6 7 11.5 16.5 13.5 21.5 1.5 4.5 5.5 8.5 9 8.5 3.5 0 9.5 4 13 8.5 9 10.5 61.5 34.5 86 39 10 2 18.5 5.5 18.5 8 0 6.5-10 5.5-38-3-35.5-10.5-40.5-9.5-83 15-31 18-39 25-41.5 37.5-3.5 16.5-17.5 20.5-17.5 5 0-12.5-2.5-12.5-15-1-5 5-27 17.5-48.5 28.5l-39 20 1.5 137c1 108 3 140 8.5 151 15 29 70 28.5 85-0.5 5-9.5 7.5-29 7.5-57.5 0-34 1.5-42.5 7.5-42.5 15.5 0 16 79 0.5 109.5-14.5 27.5-59 38.5-92 22zm-255-196c1.5-5 18.5-15 254-150.5 92-53 168.5-97 169.5-98 1-1-9-11.5-22.5-24-13.5-12-28-27.5-31.5-35-4-7-10-13-13.5-13-3 0-82 44-175 97.5-93 53.5-172 97.5-175.5 97.5-3.5 0-6.5 2-6.5 4 0 2.5-13.5 12-30 21-34 19-43.5 28-45 42.5-2.5 22 0.5 32.5 13 47 11 13.5 16 15.5 37 15.5 13.5 0 25-2 26-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pewQ1xGB4",
    className: "s22",
    d: "m2125 584c-5.5-5.5-10-15.5-10-22.5 0-12.5 15.5-32.5 25-32.5 6.5 0 6.5 21.5-0.5 28.5-4 4-4 6.5 0 8.5 7 4.5 7.5 28 0.5 28-2.5 0-9.5-4.5-15-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFfdrTnvL",
    className: "s22",
    d: "m2160 574c0-11.5 2-15 10-15 11.5 0 13.5 14.5 4 24-9.5 9.5-14 7-14-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOvhATyQJ",
    className: "s22",
    d: "m540 964c-4-2.5-6-5.5-5-6.5 1.5-1 12.5-8.5 25-17 19-13 23.5-14 29-8.5 5 5.5 2.5 9.5-14.5 22-23 16.5-24 17-34.5 10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYeKud95s",
    className: "s22",
    d: "m-3285 940.5c-2-34-6.5-70-10-73-4.5-5-24.5 4.5-25.5 11.5-0.5 3-1 7-1.5 9.5 0 2.5-2 6.5-4 8.5-6 5.5-5-14.5 1.5-32.5 5-14 7.5-15.5 27-15.5 25.5 0 27.5 3.5 27.5 45 0 18.5 2.5 30 6.5 32 4 1.5 3 4.5-3.5 10-10.5 8.5-18 10-18 4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIn1izUms",
    className: "s22",
    d: "m-3310 836.5c0-6.5 112.5-197.5 116-197.5 2.5 0 4 8 4 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 12-2.5 17.5-7.5 17.5-4.5 0-7.5 4.5-7.5 12.5 0 9-2.5 12.5-10 12.5-8 0-10 3.5-10 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1-12.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phYaA4AU8",
    className: "s22",
    d: "m685.5 785.5c8.5-18 35.5-68 60.5-111 24.5-43 59-102 75.5-131.5 19.5-33.5 32-51 34.5-47.5 2 3.5 4-2.5 4-12.5 0-17 1.5-19 12.5-19 7 0 12.5 1 12.5 2.5 0 4-51 95-110 197.5-31 53.5-62.5 110.5-70.5 126.5-10 19.5-17.5 28.5-24.5 28.5-8.5 0-8.5-2.5 5.5-33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pA9TOK54X",
    className: "s22",
    d: "m-1440 786c0-6 17-32 21-32 2 0 4-2 4-5 0-2.5 10.5-21 23-40.5l23-35.5-3.5-41-3.5-40.5 13 12c13 12 13 12 20.5 2.5 4-5 7.5-11 7.5-13 0-8.5 9-3.5 11.5 7 2 6.5-1.5 18.5-9 31-6.5 11.5-14 29-16.5 39.5-3 10-19.5 41-37 68.5-24.5 38.5-34 50-42.5 50-6.5 0-11.5-1.5-11.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pATyzcC5N",
    className: "s22",
    d: "m-1565 692c0-14.5 14.5-48 21-48 2 0 4-4.5 4-10 0-7.5 3.5-10 12-10 11.5 0 12 1 7.5 14-8 23-31.5 62.5-38 65-4 1-6.5-3-6.5-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4qedpjH0",
    className: "s22",
    d: "m-2935 671.5c0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-12 2.5-17.5 7.5-17.5 4.5 0 7.5-4.5 7.5-12.5 0-7 4.5-15 10-18.5 5.5-3.5 10-11.5 10-17.5 0-8 3-11.5 10-11.5 8 0 10-3.5 10-17.5 0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-12 2.5-17.5 7.5-17.5 4.5 0 7.5-4.5 7.5-12.5 0-9 2.5-12.5 10-12.5 8 0 10-3.5 10-17.5 0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-14 2-17.5 10-17.5 8 0 10-3.5 10-17.5 0-12 2.5-17.5 7.5-17.5 4.5 0 7.5-4.5 7.5-11 0-13.5 5-21.5 15-25.5 5-2 4-3-3.5-3-17.5-0.5-14-8 15-28.5 32-23 31-21 87.5-119 45-78.5 61-100 29.5-40-34 64.5-341 592-344.5 592-2.5 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pimnDMfNF",
    className: "s22",
    d: "m-3180 611.5c0-6 57.5-102.5 61-102.5 2 0 4 8 4 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1-12.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxoiU81U0",
    className: "s22",
    d: "m-1515 602c0-8.5 6.5-21.5 17.5-34.5 9.5-11 17.5-22 17.5-24.5 0-2 2.5-4 5-4 6 0 6.5 30 1 37.5-2 3-12 13-22.5 22l-18.5 17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZ90APQv9",
    className: "s22",
    d: "m-1404.5 596c-9.5-6.5-23.5-13-31.5-14.5-7.5-2-14-6.5-14-10.5 0-9.5 22-9 32 0.5 4 4 12 7.5 18 7.5 11 0 17 9.5 14 21.5-1 6-5 5-18.5-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17hYpA8hw",
    className: "s22",
    d: "m-1320 581.5c0-12 2.5-17.5 7.5-17.5 4 0 7.5-3 7.5-7 0-4 12.5-29 28-55 20-34 30.5-48 37.5-48 5 0 9.5 2 9.5 5 0 7-82 140-86 140-2.5 0-4-8-4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDx9K1GAy",
    className: "s22",
    d: "m-3090 577c0-17 1-18 15.5-18h15.5l-9.5 16c-13 23-21.5 23.5-21.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5M2Sa7hP",
    className: "s22",
    d: "m2415 565.5c0-2.5 13.5-8.5 30.5-14 17-5 40.5-16.5 52.5-25.5 12-9.5 25.5-17 29.5-17 4 0 7.5-3.5 7.5-7.5 0-4 9-21 20-37.5 11-18 21-40 23-53 2-14.5 5.5-22 10.5-22 6 0 7 4 4 19-10 53.5-61 117.5-113 142-31.5 15-64.5 22.5-64.5 15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AMne3lQp",
    className: "s22",
    d: "m-1465 516c0-6.5 22-42 26-42 5.5 0 5 24-1 35.5-5 8.5-25 14-25 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCj2YdZru",
    className: "s22",
    d: "m715 494.5c-12.5-4.5-49.5-24.5-82.5-43.5-33-19.5-96.5-56.5-141-82-45-26-81.5-49-81.5-51 0-7 24-4.5 32 3.5 4 4 11 7.5 15.5 7.5 4.5 0 9.5 4.5 11 10 2 7 7 10 17.5 10 10.5 0 15.5 3 17.5 10 1.5 6.5 7 10 14 10 6.5 0 15 3.5 19.5 7.5 4 4 10.5 7.5 14 7.5 9 0.5 24 12.5 24 19.5 0 3 5.5 5.5 12 5.5 7 0 15.5 3.5 20 7.5 4 4 11 7.5 15.5 7.5 4.5 0 9.5 4.5 11 10 1.5 6.5 7 10 14 10 6.5 0 15 3.5 19.5 7.5 4 4 9.5 7.5 12 7.5 2.5 0 14.5 5.5 27 12 12.5 6.5 28 13 34.5 14 14.5 2 20 19 6 19-5-0.5-19-4.5-31.5-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjEaZBiEH",
    className: "s22",
    d: "m816.5 495.5c-11.5-4-7-11 13.5-21.5 24-12 25-12.5 25-1 0 5-6 12.5-13.5 16-18 9-18 9-25 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pw2Bk7KbC",
    className: "s22",
    d: "m-3105 481.5c0-6 57.5-102.5 61-102.5 2 0 4 8 4 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1-12.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10aQgYJFG",
    className: "s22",
    d: "m2397 476c-9-4-21-13-27-19.5l-11-11.5 30.5-20.5c16.5-11.5 32.5-20.5 35-20.5 3 0 5.5-2 5.5-4 0-7 48.5-27.5 57-24.5 5 2 8 9 7.5 17 0 13.5-0.5 13.5-4.5 3-2.5-6.5-6-11.5-8-11.5-9 0-102 57.5-102 63.5 0 9.5 27 21.5 50 21.5 14.5 0 20 2 19 6.5-3.5 9-34.5 9.5-52 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HiiblCoN",
    className: "s22",
    d: "m-1435 461c0-6.5 22-42 26-42 5.5 0 5 16.5-1 32-3 8-8.5 13-15 13-5.5 0-10-1.5-10-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pujdWFYFc",
    className: "s22",
    d: "m2481 436.5c5.5-10 11.5-17 13-15.5 4.5 4.5-10 33-17 33-5 0-4-4.5 4-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p56Upf0tm",
    className: "s22",
    d: "m124 410.5c13.5-21.5 34-56.5 46-77.5 12-21.5 23.5-39 25.5-39 2 0 5.5 4.5 7 10 3.5 11-9 35-17.5 35-3 0-5 4.5-5 10.5 0 6-4 11.5-10 13-7 2-10 7-10 17 0 8.5-3 16-7.5 17.5-4 2-7.5 8.5-7.5 15 0 7-3 12-7 12-4 0-8 5-9 11.5-1 8-5.5 11.5-15 12.5l-14 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pF69PCrG3",
    className: "s22",
    d: "m-1234 435.5c1-2.5 20.5-42 43.5-89 47-95.5 52-107.5 61-133.5 3.5-10.5 8.5-19 10.5-19 2 0 4-5.5 4-12.5 0-7 2.5-12.5 5-12.5 3 0 5-5.5 5-12.5 0-7 2.5-12.5 5-12.5 3 0 5-5.5 5-12.5 0-10 2.5-12.5 12.5-12.5h12.5l-10.5 26.5c-38 96.5-64.5 158-88 206-37 74.5-45.5 87.5-57.5 87.5-5.5 0-9-1.5-8-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9gEg0kJ0",
    className: "s22",
    d: "m895 428.5c0-5.5 2.5-15 6-21 3-6 7-17.5 9-26 1.5-9 6.5-15.5 12-16.5 8-2 9 0 6 14.5-4 21.5-22.5 59.5-28.5 59.5-2.5 0-4.5-4.5-4.5-10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnH23d6V9",
    className: "s22",
    d: "m-1403 401c13.5-35 123-205 138-214.5 3-2 5 3.5 5 12 0 8-3 17-6.5 19-4 2-8 8-10 13-1.5 4.5-8 8.5-13.5 8.5-7.5 0-10 3.5-10 12.5 0 13-23 52.5-30.5 52.5-2.5 0-4.5 4.5-4.5 10 0 5.5-3.5 11.5-7.5 13-4 2-7.5 7-7.5 11.5-0.5 10-12 25.5-19.5 25.5-3 0-5.5 6-5.5 13 0 18.5-9 32-20.5 32-7.5 0-9.5-2.5-7.5-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIcrplyfD",
    className: "s22",
    d: "m2305 395c0-4 246-147.5 253.5-147.5 6-0.5 30 51 34 73 3 14.5 2 18.5-3.5 18.5-5 0-9.5-10-14-28.5-9-41.5-12.5-47-29-43.5-7.5 2-14.5 5-16 7-5 7-45 30-52.5 30-4 0-7.5 2-7.5 4 0 2.5-9.5 9.5-21 16-12 6.5-37.5 21.5-57.5 33.5-19.5 12-38 21.5-41 21.5-3 0-10 4.5-15.5 10-10 10-30 14-30 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puFu3kvSS",
    className: "s22",
    d: "m2024.5 376c-11-13.5-24-35-29.5-49.5-3.5-9.5-3-12.5 2.5-12.5 3.5 0 8 4.5 10 9.5 1.5 5.5 8.5 18 15.5 28 14 21 15.5 40.5 1.5 24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLGsZ7Plw",
    className: "s22",
    d: "m-3030 351c0-6 227-395 240.5-412.5 13-16.5 62.5-48 67.5-43.5 1 1.5-7 6.5-18 11.5-28 12.5-48 36.5-89 105.5-60.5 103.5-64 112.5-63 164.5 0.5 19.5-0.5 26.5-3.5 20-2-5.5-4-15-4-21-0.5-15.5-10.5-14.5-10.5 1 0 9-2.5 12.5-10 12.5-8 0-10 3.5-10 17.5 0 12-2.5 17.5-7.5 17.5-4.5 0-7.5 4.5-7.5 12.5 0 9-2.5 12.5-10 12.5-8 0-10 3.5-10 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 14-2 17.5-10 17.5-8 0-10 3.5-10 17.5 0 15.5-1.5 17.5-12.5 17.5-7 0-12.5-1.5-12.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phVfKUQvZ",
    className: "s22",
    d: "m910.5 310.5c-7-26-38-70.5-56-81-8-4.5-14.5-9.5-14.5-11.5 0-2.5-2.5-4-6-4-8.5 0-89-46-89-51 0-2 7-4 15.5-4 11.5 0 16 2.5 18 10.5 2 6 5.5 9 10 7.5 10-4 74.5 35 97.5 58.5 30.5 31.5 55 93.5 37.5 93.5-5 0-10-7-13-18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDH6bo6UC",
    className: "s22",
    d: "m2195 229c0-60 2-95 5-95 3 0 5 35 5 95 0 60-2 95-5 95-3 0-5-35-5-95z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paAd27oS9",
    className: "s22",
    d: "m371.5 296.5c-13.5-11.5-13.5-12-3-12.5 17 0 26.5 5.5 26.5 15.5 0 13-6.5 12-23.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9gKgHWIO",
    className: "s22",
    d: "m1982.5 283.5c-3-14-0.5-24 5-18.5 1.5 1 4 9.5 5.5 18 4 21-6 21.5-10.5 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxnmKaQS7",
    className: "s22",
    d: "m200 286c0-7.5 61.5-112 66-112 2 0 4 8 4 17.5 0 12-2.5 17.5-7.5 17.5-4 0-7.5 3.5-7.5 7.5 0 15.5-33.5 70-44.5 71.5-5.5 1-10.5 0-10.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pks4MUMYV",
    className: "s22",
    d: "m2065 269c-12.5-24-12.5-36.5-0.5-63 9.5-20.5 28.5-37.5 49.5-44 19.5-6.5 12 8.5-10 19.5-38 18.5-48 58.5-24 92.5 9 12.5 9.5 15 3 15-4.5 0-12.5-9-18-20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pY8gpdxkh",
    className: "s22",
    d: "m-2877.5 274c-5-5.5-10.5-8.5-12.5-7.5-4 2.5-10-21.5-10-40 0-6.5 3.5-12.5 7.5-14.5 4.5-1.5 7.5 0 7.5 4 0 3.5 5.5 15 12.5 25 12 18 17 43 8.5 43-2.5 0-8.5-4.5-13.5-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDQqNkKTs",
    className: "s22",
    d: "m-2809 260.5c-3-1-4.5-5-2.5-8 2-3.5 0-4-5.5-2-5.5 2-7.5 1.5-5.5-2 2-3 0-4.5-5.5-3.5-7 1-9-2-10-13.5l-0.5-15.5 13.5 13.5c17.5 17.5 50 26.5 83 22 34-4 64-29.5 92.5-78 11-19 21-34.5 22.5-34.5 3 0-19.5 40-39.5 69-7.5 11.5-23.5 27.5-34.5 35-18.5 12-25.5 13.5-62 13.5-23 0-38 1.5-33 3.5 6.5 2.5 6.5 3.5 1 3.5-4-0.5-10.5-1.5-14-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15oX4bd6G",
    className: "s22",
    d: "m-2859 221.5c-6-7-11-15-11-17.5 0-3-2-5-4-5-2 0-4-5-4.5-11-0.5-11-0.5-11 5-2 3.5 5 11 17 17.5 26.5 14 21 12 26.5-3 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVNFMHSfs",
    className: "s22",
    d: "m1980 219c0-17.5 19.5-66.5 36.5-91.5 22-33 67-66 107-78.5 18-5.5 37-10 42-10 16.5 0 10 8-11.5 15-35 10-89.5 39.5-102.5 55.5-7 8-15.5 14.5-19.5 14.5-4 0-7 4-7 9 0 4.5-5.5 16.5-12 26-6 9.5-14.5 29.5-18 44-6 26-15 35.5-15 16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkTjcDkxD",
    className: "s22",
    d: "m300 201c-3-7-5-15.5-5-19.5 0-12-9-13-13-1.5-3.5 11-4 11-7.5-3-3.5-12 0-21 18.5-53.5 16.5-28.5 25.5-39.5 33-39.5 5.5 0 9 2 8 4-10 26-27.5 56-32.5 56-3.5 0-6.5 2.5-6.5 5 0 3 3 5 6.5 5 5.5 0 18.5 38.5 18.5 55.5 0 10-15.5 3.5-20-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FayAU4Oy",
    className: "s22",
    d: "m-2847 198c-1.5-6.5-2.5-16-2.5-21.5 0.5-5.5 2.5-1 5 9.5 5 21 3 31-2.5 12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQ7lUNXeF",
    className: "s22",
    d: "m716.5 144c-2-7-7-10-17.5-10-10.5 0-15.5-3-17.5-10-2-7-7-10-17.5-10-10.5 0-15.5-3-17.5-10-2-7-7-10-16-10-11 0-68-29.5-75.5-39.5-2.5-3-9.5-6-58.5-25-28.5-10.5-29-23-1.5-19 20.5 2.5 255 131 255 139.5 0 2-7 4-15.5 4-11 0-16-2.5-18-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVmMlgYOw",
    className: "s22",
    d: "m-2739 134c-14-6.5-20.5-12-18-16 2.5-3.5 1-4.5-4-2.5-5 1.5-12.5-2.5-19.5-10.5-6.5-7-8-10-3-6.5 13 10 10.5 3-9-24.5-11.5-16.5-17.5-30.5-17.5-42 0-24 14-64.5 28.5-81l12.5-14.5-10 15c-42 65.5-21 140.5 49 172 12.5 5.5 19 10.5 15 11-4 0.5 0.5 2.5 10 4.5 17.5 3.5 17.5 3.5 2.5 4-8 0.5-24.5-3.5-36.5-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDBfEkYiI",
    className: "s22",
    d: "m-2679.5 132c6-5 30-8 27-3-1.5 2.5-9 5-16 5-7.5 0-12-1-11-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10szH3sM1",
    className: "s22",
    d: "m-2644 128c1-3.5 7.5-10 14.5-15 21.5-13 40.5-42 50-75.5 5-17 9-27.5 9-23 1 15.5-14 55.5-27 75-15 21-48.5 49.5-46.5 38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pG6TaHqh6",
    className: "s22",
    d: "m-1218 123.5c4-6 49-61 99-121.5 72.5-87 92-108 93-99 2.5 17.5 8.5 13 16.5-12.5 5-15.5 10.5-24.5 16.5-25.5 8-2 9 0.5 6 17-7.5 37.5-23 72-33.5 72-6.5 0-9.5-3.5-9.5-11 0-10.5 0-10.5-7.5-1-7 9.5-7 9-7.5-1.5 0-6.5-2-11.5-5-11.5-2.5 0-5 8-5 17.5 0 15.5-1.5 17.5-12.5 17.5-10.5 0-12.5 2.5-12.5 15 0 12.5-2 15-12 15-9.5 0-12.5 3-14 14-1 9.5-4.5 14-12.5 15-8.5 1.5-11.5 5-11.5 14.5 0 8-3.5 13.5-9.5 15-5.5 1.5-10.5 7.5-11.5 13.5-1 6.5-5.5 11-12.5 12-8.5 1.5-11.5 5-11.5 14.5 0 8-3.5 13.5-9.5 15-5.5 1.5-10.5 7.5-11.5 13.5-1 7.5-5.5 11-16 12-13.5 1.5-14 1.5-6-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfxer0r6",
    className: "s22",
    d: "m-1080 100.5c0-8 4-24.5 8.5-37.5 6.5-19 11-24 20-24h11l-12.5 33.5c-7 18.5-14 35.5-15 37.5-5.5 8.5-12 3.5-12-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn6demfdX",
    className: "s22",
    d: "m329.5 64.5c22.5-31.5 62-53.5 107.5-58.5 23-3 28-2 28 4 0 7.5-14 14-31 14-19 0-64 21.5-79.5 37.5-9.5 9.5-21 17.5-26 17.5-8.5 0-8.5-1 1-14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p108aptRE3",
    className: "s22",
    d: "m2191 49c-5.5-9-5-10 4-10 6.5 0 10 3.5 10 10 0 5.5-1.5 10-4 10-2 0-6.5-4.5-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pedDKg9kU",
    className: "s22",
    d: "m-1050 21c0-7 2.5-22 6-32.5 4.5-15.5 8-19.5 17-19.5h11.5l-11 31c-12 33.5-23.5 44-23.5 21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Gd4QnxeZ",
    className: "s22",
    d: "m-2566.5-12.5c1-1.5-1.5-11-6-21.5-14.5-35.5-62-75-74.5-62-4 4-3 4.5 4 2 6.5-2.5 8.5-2 6 2-2.5 4-0.5 5 5 2.5 6.5-2.5 7.5-1.5 4.5 4-2 4-2.5 5.5 0 3.5 2-2 9 3 16 11.5 7 8 14.5 13 17.5 11.5 2.5-1.5 4.5 0 3.5 3.5-1.5 13.5 0.5 20 5.5 17 3-2 7.5 4 10.5 12.5 3 8.5 6.5 14.5 8 13.5z"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "l7a18SICBwWs9tAfGjmPyqw"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "p13xPnHQrK",
    className: "s23",
    d: "m1973.5 4800.5c-1.5-2.5-4-19.5-6-38.5l-3.5-34-15.5 3c-9 1.5-29 4.5-44.5 6l-29 3.5v-18.5c0-12.5 2-18 7.5-18 4 0 7.5-3.5 7.5-7.5 0-4.5 3.5-9 7.5-10.5 4-2 7.5-6 7.5-10 0-3.5 4-8.5 8.5-11.5 7.5-4 6-6-10-15.5-19-11.5-27-33-9.5-26.5 11 4 31 17 42 26.5 8.5 7.5 8.5 8.5 0 15.5-4.5 4.5-12 13-16 19.5-4 6.5-11.5 15-16 19.5-12 10.5-11.5 20.5 1 17.5 23-5 28.5-6 49.5-12 11.5-3 22-5 23-4 1 1 3.5 16 5 34 5 48 5.5 49.5 10 53.5 2 2.5 2.5 1.5 1-1.5-2-3 2.5-11 9-17l12.5-11.5v12.5c0 22.5-5 29-22.5 29-9.5 0-18-1.5-19-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4jVZF2DU",
    className: "s23",
    d: "m2018.5 4750.5c7.5-29 23-31.5 49.5-9l14.5 12.5h-18.5c-10 0-19.5-3-20.5-6-1.5-4-3-3-3 2.5-0.5 5.5-4.5 8.5-12.5 8.5-9 0-11.5-2-9.5-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyv7OPwbW",
    className: "s23",
    d: "m2104.5 4748c-0.5-6.5-1-9-6.5-32.5-8-30.5-7.5-31.5 3.5-32 6-0.5 15.5-1.5 21-2.5 42-6 52.5-5.5 52.5 3 0 7-6 9.5-30 12l-30 3.5 3 27c3 23.5 2 27.5-5 27.5-4.5 0-8-3-8.5-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14gxXvx75",
    className: "s23",
    d: "m2150 4651.5c-7-4-20-10.5-28.5-15-19.5-9-20-11-5-28.5 6.5-7.5 16-19.5 21.5-27 5-7 12.5-16 16-19.5 8.5-9.5 7.5-13.5-2.5-8-5 2.5-15.5 5.5-24 7-31 6-45 9-51 11-3.5 1-7-1.5-7-6.5-1-8.5-1.5-15.5-6-54.5-2-18-0.5-21.5 6.5-21.5 7 0 9 6 11.5 28 1.5 15.5 4 29 5.5 30.5 1 1.5 14.5-0.5 29.5-3.5 37.5-8.5 53.5-4 53.5 15 0 8-3 16.5-6.5 18.5-4 2-8 8-10 13-1.5 4.5-6.5 8.5-11 8.5-4 0-7.5 4.5-7.5 9.5 0 5.5-1.5 13-3 17.5-2.5 6.5 0.5 8 12.5 8 9.5 0 17 3 18.5 7.5 5.5 13.5 0 17.5-13 10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVnTY3VcD",
    className: "s23",
    d: "m1915 4588.5c0-6 3.5-9.5 10-9.5 8 0 10-3.5 10-15.5 0-21 10.5-16.5 19 8 3.5 10.5 5.5 19.5 5 20.5-1 0.5-11 2-23 3.5-18 1.5-21 0.5-21-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMZCVte6n",
    className: "s23",
    d: "m1997.5 4549c-7-7.5-7.5-10-2-10 7 0 29.5-30.5 29.5-40 0-2.5 3-5 7-5 4 0 11-1.5 15.5-3 7.5-3 8-2 1.5 8.5-3.5 6.5-7.5 13-9 14.5-1.5 1.5-5.5 8.5-9.5 16.5-4 7.5-9 13.5-11.5 13.5-2 0-4 3.5-4 7.5 0 10.5-6.5 9.5-17.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMYiw99qu",
    className: "s23",
    d: "m1925 4530.5c0-27.5 5-36.5 20.5-36.5 8.5 0 16 3 17.5 7 1.5 4 7 8 12.5 9.5 6.5 2 9.5 7 9.5 16 0 15 1 15.5-37-16-11.5-9.5-13.5-8-8 6.5 7.5 19 6 27-5 27-7.5 0-10-3.5-10-13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HBvV0xhL",
    fillRule: "evenodd",
    className: "s23",
    d: "m-3205 959.5c0-10.5-1.5-26-3-34.5l-3-15-31 14.5c-16.5 8-33 14.5-36.5 14.5-8.5 0-10.5-10.5-5-28 4-13 3-20.5-6-38-5.5-12-10.5-29.5-10.5-39 0-12.5 43-91 184-335.5 156.5-272 185-319 195-319.5 6 0 11-2 11-5 0-2.5 3-5 7-5 6 0 14.5 25.5 19 58.5 2 11 43 47 62 54.5 27 10.5 70.5 7.5 90.5-5.5 7.5-5.5 15-10 16.5-10 1.5 0 5.5-2 9-4 8.5-5.5 8 17-1 38.5-4 9.5-84.5 150.5-178.5 314-94.5 163-178 308.5-186 323.5-15 26.5-15 26.5-35 24-13.5-2-28 0.5-44.5 7-13.5 5-31 9.5-39 9.5-14 0-15-1-15-19.5zm58-13c18.5-7 37.5-11.5 42-10 7 2 30.5-35 118-186 167-289.5 252-438 252-442 0-2-10.5-1-23.5 1.5-16.5 3.5-31 3.5-49.5-0.5-27-6.5-74.5-33-70-39.5 1.5-2.5-1-4.5-5-4.5-4 0-14.5 12.5-23 28-59.5 105-161.5 278.5-165 281-3 1.5-4.5 4.5-4 6.5 0.5 2-35.5 67-80.5 144.5-118.5 205.5-108 186-96.5 181.5 5-2.5 12.5-4.5 16-4.5 3 0 6-2 6-3.5 0-6 29-16 35-12.5 3.5 2 5 10.5 4 18.5-1.5 8-0.5 15.5 2 17 2 1.5 4 10.5 4 20 0 9.5 1 17 2.5 17 1 0 17.5-5.5 35.5-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQygJDprl",
    className: "s23",
    d: "m-3330 895c0-8.5 2-16.5 4.5-18 2-1.5 3.5 4.5 2.5 13-2.5 21-7 24.5-7 5z"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "l5VAdVI8dNXUU2H1R8rUI9H"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pAY3rf0Mg",
    fillRule: "evenodd",
    className: "s24",
    d: "m557.5 5233.5c-72-38.5-131.5-98-178.5-178-18-29.5-53-90.5-79-135-45.5-79.5-47-81.5-63-81.5-11.5 0-22-5-34.5-15.5-15.5-13.5-17.5-18.5-17.5-39 0-13 3.5-28 8-34.5 7-10 6.5-12-5-27.5-30-39.5-35.5-77.5-15.5-111 14-24.5 37.5-37.5 67.5-37.5 38 0 61.5 18 82.5 63.5 9 18.5 14.5 25.5 19.5 23.5 12.5-5 42 8 55.5 23.5 14.5 18 16 37 4 61.5-7.5 16-7.5 18.5-0.5 26.5 4 5 39 64 78 131.5 71.5 125 90.5 168 100.5 230 6.5 37.5 7.5 110 1.5 110-2 0-12.5-5-23.5-10.5zm10-53c-8-89-25-131-112.5-281.5-31-53.5-60.5-103.5-64.5-111-4.5-8-10-14-12.5-14-8 0-103 55.5-103 60.5 0 3 33 63 74 133.5 59.5 104 80 135 108.5 165 31 33 97.5 85 109.5 85.5 2 0.5 2.5-17 0.5-38z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6Y97gWQD",
    fillRule: "evenodd",
    className: "s24",
    d: "m-1227.5 5219.5c-17-7.5-29.5-25-76-105.5-58-100-62-107.5-69-137.5-8-34.5-30.5-69.5-41.5-65-4.5 2-27.5 4.5-51 6-88.5 5.5-158.5-36.5-197-118.5-14.5-30-15.5-36.5-15.5-85 0-48.5 1-55 16-86 72-152.5 289.5-153.5 364.5-2 37 75.5 26 166.5-27.5 224.5l-12.5 14 12 22.5c7 13 18 28 24.5 34 28 25 36 36.5 87.5 126 63.5 110.5 69 129.5 45 156.5-15.5 17-41.5 24-59.5 16zm49-26.5c12.5-14.5 10.5-27.5-8-60-8.5-15.5-36-63.5-61-106.5-50.5-89-57.5-95.5-86.5-80-31 17-29 25.5 34.5 136.5 66 115.5 75.5 127.5 97 123.5 8-2 19-8 24-13.5zm-166-262.5c17-10.5 17.5-14 4.5-35.5l-10.5-17-16 10.5c-20 12.5-20.5 14.5-8.5 34.5 11.5 18.5 11.5 18.5 30.5 7.5zm-90-33.5c93.5-21.5 157.5-118.5 139.5-210-24.5-125-152.5-192.5-261.5-139-117.5 58-143 207-51 298.5 48 48.5 108 66 173 50.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pru8RrqoU",
    fillRule: "evenodd",
    className: "s24",
    d: "m-3361 5190l-29-1.5v-549.5l391.5-1c215-1 394-0.5 397.5 0.5 5 1 6 59 5 277.5l-1.5 275.5h-367.5c-202 0-380.5-0.5-396-1.5zm564.5-19c25.5-1.5 50-6 55-9.5 8.5-6.5 9-21.5 11.5-236 1.5-126 1-234.5-0.5-241.5-5.5-26-15-27-340.5-29l-299-2v520.5l51.5 1.5c81 2.5 471.5-0.5 522-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "py2H1FpyX",
    fillRule: "evenodd",
    className: "s24",
    d: "m2213 5078c-11.5-10.5-39-56.5-150-250-16.5-29.5-32-54-34-54-1.5 0-14 17-27 37.5-13 20.5-24.5 37-25 36-0.5-0.5-4-26-7.5-56-3-30.5-7.5-56.5-9-58.5-2-2.5-28 1.5-58 8.5-30 6.5-55.5 11-56.5 10-1.5-1 13.5-22.5 33.5-47.5 19.5-24.5 35.5-46 35.5-47 0-1-21.5-14.5-47.5-30-25.5-15.5-48-30-49.5-32.5-1.5-2 24-7 57-10.5 33-3.5 60-7 60-7.5 0-1-5.5-26-12.5-55.5-7-29.5-12-55-11.5-57.5 1-2 22 12 46.5 31 25 19 46 34.5 47.5 34.5 1.5 0 16-21.5 32-48 16.5-26 31-48.5 33-49.5 1.5-1 6 25 10 58 3.5 32.5 8 59.5 10.5 59.5 2 0 27.5-5.5 57-12.5 29.5-7 54.5-12 55.5-11 1 1-13.5 22-33 46.5-19 24.5-35 46-35 47.5 0 2 21.5 16 47.5 32 26 15.5 48.5 30.5 50 32 1 2-25 6.5-58 10l-59.5 6.5 16 28.5c9 15.5 50.5 87.5 92.5 160.5 83.5 144.5 86.5 153.5 63 176-26.5 25.5-54 30-73.5 13zm47.5-15.5c28-19 26-27.5-32-127-28.5-49-59-103-68-120-17.5-32.5-27.5-37.5-22-10.5l3 16-14.5-10.5c-8-6-28-21-44-33.5-50.5-39-51.5-42.5 42 119.5 34.5 60.5 71 123.5 80 140 24 42.5 28 44.5 55.5 26zm-222.5-337c3-1 20 9.5 38.5 23.5 18.5 14 33.5 22.5 33.5 19 0-3.5-3.5-20-7.5-36.5-11.5-47-12-46 26.5-49.5 40.5-4.5 52-7.5 48.5-13-1.5-2.5-17-12.5-35-22.5-18-10-32.5-20.5-32.5-23.5 0-2.5 11.5-19 25-36.5 14-17.5 25-32.5 25-33.5 0-1.5-16.5 1.5-36 6.5-55 14-52.5 15-56.5-27.5-2-20-5-39-7-42-1.5-3-13 10-25.5 29.5-12 19-24 34.5-26.5 34.5-2.5 0-18.5-11-36-25-17.5-13.5-32.5-25-34-25-1 0 2 17.5 7 39 5 21 9 41 9.5 44 0 3.5-14 7-33.5 9-40 4-52.5 7.5-49 12.5 1 2 17 12.5 35 23 18 10.5 32.5 20.5 32.5 22 0 1.5-11.5 17.5-25 35-13.5 18-24 33-23 34.5 1.5 1 18-1.5 37.5-6 51.5-11.5 48.5-13.5 52.5 30.5 2 21 5 40.5 6.5 43 1.5 2 12-11 23.5-29.5 11.5-18.5 23.5-34.5 26-35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prGy5RTLG",
    fillRule: "evenodd",
    className: "s24",
    d: "m516.5 3940.5l1-49-198.5-1.5-199-1-1-196.5c-1.5-170-2.5-196-9-196.5-4-0.5-25-1-46-1.5l-39-0.5v-115h94.5l1.5-48.5 1.5-48 127-3 3 97 172.5 1.5 172 1 54-53.5 54-54 18 18c14 14 17.5 20.5 14.5 29-2 6.5-6 10-10 8.5-4-1.5-9.5 1.5-13.5 6-6 7.5-5.5 8 2.5 1.5 4.5-3.5 8.5-5 8.5-2.5 0 2.5-19 22.5-42.5 44.5l-42.5 40v347.5h95v62c0 72.5 3 69-56 65.5l-39-2v99.5h-124.5zm105.5 29.5c-0.5-3-1-134-1-291l-1-285h-580v42.5c0 30.5 2 42.5 6.5 43 3 0.5 16 1 28.5 1.5 12.5 0.5 27 2.5 32.5 5 8 3 8.5 3 2.5-1.5-5.5-4 52.5-5.5 209-5.5h216v246.5c0 136 1.5 248.5 3.5 250.5 6.5 6 84 1 83.5-6zm-104.5-193.5l-283 4 3-284-104-3 3 121c2 66.5 3.5 152 3.5 190v69.5l81.5 1c44.5 1 129.5 1.5 188.5 1.5h107.5zm200 2.5h-77.5v95h77.5zm-315-145.5c96-96 117.5-120.5 117.5-131.5v-13.5l-13 10c-7.5 5.5-15.5 9-18.5 7-2.5-1.5-3.5-1-2 2 1.5 2.5-29 36.5-68.5 75.5-65 65-84.5 81.5-75 65 2-3.5-10.5 7-27.5 23.5-16.5 16.5-30.5 31-30.5 32 0 1.5 8-5 17.5-14.5 9.5-9.5 17.5-15 17.5-12 0 2.5-14.5 19.5-32.5 37-21.5 21.5-32.5 36-32.5 44 0 11.5 0 11.5 15 2.5 8.5-5 68-62 132.5-127zm109.5 130c5.5-5 9-112 5.5-165.5l-3.5-53.5-107 106.5c-59 58.5-107 108-107 110 0 1.5 10 2.5 22.5 2 12.5 0 24 1 26.5 3 4 4.5 158.5 2 163-2.5zm-268.5-58c-1.5-5-2.5-1-2.5 8.5 0 9.5 1 13.5 2.5 9 1-5 1-13 0-17.5zm123-95c62.5-62.5 113.5-114.5 113.5-115.5 0-1.5-221.5 2.5-228.5 3.5-2 0.5-2 225.5 0 225.5 0.5 0 52.5-51 115-113.5zm98-80c1-1 1-2.5-0.5-4-1-1.5-9 5-17 14l-14.5 16 15-12.5c8.5-7 16-13 17-13.5zm-290.5-45c-8-1-20-1-27.5 0-8 1-1.5 2 13.5 2 15 0 21.5-1 14-2zm60 0c-5-1-13-1-17.5 0-5 1.5-1 2.5 8.5 2.5 9.5 0 13.5-1 9-2.5zm237.5-100c-28-1-75.5-1-105 0-29.5 0.5-6.5 1.5 51 1.5 58 0 82-1 54-1.5zm213-33.5c25.5-25.5 36-39.5 34-45-5-13-14.5-9.5-39.5 15-13 12.5-26 21.5-28.5 20-2.5-1.5-7.5 1-11 6-6.5 7.5-6 8 2 1.5 12-9.5 10.5-1-2 12.5-11 12-10 27 1.5 27 4 0 23.5-16.5 43.5-37zm-449.5-53h-97.5l1 38.5c0.5 21.5 1 39.5 1 40.5 0.5 0.5 22 1 48 1h47.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pweMi6h1x",
    className: "s24",
    d: "m327.5 3664c5-5.5 10-9 11.5-7.5 3.5 3-9 17.5-15.5 17.5-2.5 0-1-4.5 4-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peOFgCMXm",
    fillRule: "evenodd",
    className: "s24",
    d: "m-2777.5 3914c-29-57.5-29-65-2.5-65 20 0 20 0 20-19 0-24-7-31-31-31-19 0-19 0-19 19.5 0 11-2 21-4.5 22.5-7.5 5-101-43.5-99.5-51.5 1.5-8 81-49.5 95.5-50 6.5-0.5 8.5 3.5 8.5 20v20l24-1.5 23.5-1.5v-45l-19.5-1.5c-17.5-1.5-19-2.5-16.5-15 1-7.5 4-18 6-23 3.5-8 2.5-9-8-6.5-6.5 1.5-53.5 8.5-104.5 16-51 7.5-100.5 15.5-110 18-15 4-28.5 18.5-94.5 103-42.5 54-78 96-79 93.5-1-4-50.5-402.5-67-541-3.5-28-5-52.5-3-54 1.5-1.5 109 77.5 239 175l236 178.5 13-24c7-13 16.5-24 20.5-24 8 0 50 77.5 50 93 0 7-4.5 9.5-21 10.5l-21.5 1.5 1.5 20c2 24.5 3.5 26 28.5 28.5l20 1.5 1.5-21c1-16.5 3.5-21.5 10-21 14 0.5 93.5 42 95 50 1 5-13.5 14.5-42.5 28.5-58 27.5-58.5 27.5-61.5 3.5-2.5-20-2.5-20-25-20h-22.5l-1.5 24-1.5 23.5h20c17 0 20.5 1.5 20.5 10 0 13-43.5 100-50 100-2.5 0-15-20-27.5-45zm-327.5-161.5l52.5-66 80-11.5c44-6.5 84-13.5 89.5-15.5 7-2.5-26.5-30-161.5-131.5-94-70.5-170.5-127.5-170.5-126.5 0 1 11.5 95 25 209 14 114 25 209 25 211.5 0 5.5 2.5 2.5 60-69.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfaL1UYnb",
    className: "s24",
    d: "m-1181 3908c-2.5-38 3-46.5 25.5-41.5l15.5 3.5v34.5 34.5h-19.5-19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9s848KrQ",
    fillRule: "evenodd",
    className: "s24",
    d: "m2324 3886c-16-3.5-38-11.5-48.5-17-24.5-12-54.5-42.5-59-59-2-8-5.5-11-11-9-118 39.5-201.5 41.5-299.5 8.5-56-19.5-92-41.5-134-83-134.5-132.5-81.5-327 110.5-407 51.5-21.5 99-30.5 161.5-30.5 140.5 0 266.5 67.5 318.5 170 34.5 68.5 31 155-9.5 219.5l-13 20.5 10.5 21c15 29 14.5 52.5-0.5 65-14 11.5-35 9.5-67-6-17.5-8.5-21-9-34-2-20.5 10.5-22 19.5-7.5 41.5 27 40.5 109 64.5 188.5 55.5 20.5-2 38.5-3.5 39.5-2.5 1 1 0.5 5-1 9-5.5 14.5-94 18-144.5 5.5zm-201.5-79.5c19.5-4 45.5-11 58-15.5l23-8.5 3.5-37c5-61.5 25.5-96.5 56.5-96.5 19.5 0 40 9.5 53.5 24.5 5 5.5 11.5 9 13.5 7.5 6.5-4 25-46 32.5-74.5 18.5-69-5-144.5-63.5-202.5-71-70.5-191-108.5-302.5-95.5-117.5 14-217 76-259.5 162.5-81.5 164 75 341 302.5 342.5 26 0 63.5-3 82.5-7zm214.5-30.5c4.5-1.5 8-8 8-14.5 0-17-10-42.5-17-42.5-3 0-15.5 10-27.5 22l-22 22.5 24.5 7.5c13.5 4 25 7.5 25.5 7.5 0.5 0.5 4-1 8.5-2.5zm-78-26.5c15.5-10.5 35.5-26.5 43.5-35.5l15-15.5-18.5-17.5c-30-27.5-52-20.5-67 21.5-6.5 18.5-9.5 66.5-4 66.5 1.5 0 15.5-9 31-19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paIDKOgrr",
    className: "s24",
    d: "m-1108 3827c-1.5-4-2-12.5-1-19 1.5-10.5 4-11.5 38-13l36-1.5v20.5 20h-35c-26 0-36-2-38-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19lyi4TBd",
    className: "s24",
    d: "m-1716.5 3825.5c-2-1.5-3.5-10.5-3.5-20v-16.5h55 55v20 20h-51.5c-28.5 0-53.5-1.5-55-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16OTQ6oLn",
    className: "s24",
    d: "m-1491.5 3826c-2-2-3.5-11-3.5-20.5v-16.5h55.5 55l-1.5 19-1.5 18.5-50.5 1.5c-27.5 0.5-51.5 0-53.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pV0snRFAy",
    className: "s24",
    d: "m-1266.5 3826c-2-2-3.5-11-3.5-20.5v-16.5h55.5 55l-1.5 19-1.5 18.5-50.5 1.5c-27.5 0.5-51.5 0-53.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p34pq1SM3",
    className: "s24",
    d: "m-1741 3733c-1-3.5-1-27.5 0-52.5l1.5-46.5h17c21 0 22.5 4.5 22.5 60.5v44.5h-19.5c-11 0-20-2.5-21.5-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4LKmP8Fm",
    className: "s24",
    d: "m-1186.5 3725.5c-4.5-4-4.5-80-0.5-95 2.5-9 7-11.5 20-11.5 15.5 0 16.5 1 19.5 21.5 1.5 11.5 2 31 0.5 43.5-1.5 12.5-2.5 27.5-2.5 34-0.5 9-3.5 11-17 11-9.5 0-18.5-1.5-20-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DsBnHVep",
    className: "s24",
    d: "m-1740.5 3509.5c-1-3-1.5-26.5-0.5-53l1.5-47.5h20 20l-1.5 51.5-1.5 51-18 1.5c-10.5 1-19.5-1-20-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnSlMwEZK",
    className: "s24",
    d: "m-1186.5 3500.5c-2-1.5-3.5-25-3.5-52 0-52 1.5-54.5 27.5-54.5 15.5 0 18.5 14 14.5 67.5l-3.5 42.5h-16c-8.5 0-17.5-1.5-19-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poX1n4FPz",
    className: "s24",
    d: "m-1742.5 3359c-2-3-2-13-0.5-21.5l3-16 51 0.5h51.5v20 19.5l-51 1.5c-33 1-52-0.5-54-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5pheAPqP",
    className: "s24",
    d: "m-1514 3359.5c-4-2-6-10.5-5-18.5l1.5-14.5 47.5-3c26-1.5 50.5-2 54-0.5 4 1.5 6 9 5 20.5l-1.5 18-47.5 1.5c-26 0.5-50.5-1-54-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkzBtAhyO",
    className: "s24",
    d: "m-1291.5 3361c-4-4.5-4.5-23-1-33 2-5 14.5-6.5 51.5-5.5 26.5 0.5 50.5 1 52.5 1 2.5 0.5 3.5 9 2.5 19.5l-1.5 18.5-50.5 1.5c-27.5 0.5-51.5 0-53.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQWOk7Gok",
    fillRule: "evenodd",
    className: "s24",
    d: "m337.5 2764.5c-42.5-7-83.5-20.5-125-42-56-29-126-99.5-156.5-156.5-35.5-69-52-155.5-41-217 17.5-98.5 83-229 206-412.5 65-96 162.5-227.5 169-227.5 3 0 30.5 34.5 61.5 76.5 187 251.5 292.5 441.5 314 565 4.5 26.5 4.5 45 0 80-12 93.5-44.5 159-112.5 226-51 51-99 79.5-163 97-42 12-115 17-152.5 11zm97.5-17.5c62-10.5 68-12.5 116.5-36.5 50-25 111-78.5 142.5-126.5 25-37.5 49.5-112 55-166.5 4.5-48.5-3-91.5-27.5-155.5-45.5-119.5-162.5-309-313-504.5l-18.5-24-12.5 12.5c-7 7-14.5 13-17 13-9 0-128 173-192 280-61.5 102-93 164-117.5 230-15 41.5-17.5 55-20 105.5-1 34 0 69 3.5 85 32.5 154.5 162 273 315.5 289 20.5 2.5 38.5 4.5 40 4.5 1.5 0.5 21.5-2.5 45-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHtMpC0Fc",
    fillRule: "evenodd",
    className: "s24",
    d: "m-1623.5 2704c-38-5.5-68-22-96-52.5-41-45.5-40.5-40.5-40.5-312.5 0-279-1.5-269.5 47.5-318.5 25.5-25.5 36-32 63-40.5l32-10 4-26c4.5-33 18.5-56 42.5-71 16-10 26.5-11.5 80.5-13.5 68.5-2 91.5 2.5 115.5 22.5 20 17 26 28.5 32.5 64 5.5 29 6 30 27.5 37.5 14.5 5 34 19 53.5 38.5 49.5 49 49 45 49 319.5 0 270.5 1 264-50 315.5-46 46.5-54 48.5-207.5 50-70 0.5-139-0.5-153.5-3zm309-23c33-15.5 61.5-43 74-72.5 10-22.5 21-100 16.5-114-1-3-13 1-28 9.5-26 14.5-27.5 15-98.5 15-81 0-91-3.5-117.5-38l-14.5-18.5-1.5-110.5c-2-123.5 1-143.5 26-167 23-23 37-26 111-26 71 0 85.5 3.5 111.5 27l11.5 10.5-2-52.5c-1.5-44.5-4-56.5-15-77.5-16.5-31.5-39.5-54-71.5-68.5-23.5-11-32-11.5-152-13-129.5-2-177 2-209 17-25.5 12.5-55.5 46.5-67 76.5-9.5 26.5-10 35.5-8.5 267.5 1.5 265 0 250.5 35 293.5 17.5 21.5 45.5 39 79 50 7 2 76.5 3.5 155 3 134-1 144-1.5 165.5-11.5zm52.5-185c7.5-5.5 18.5-16.5 24-24 10-13 10.5-20.5 10.5-133 0-113-0.5-120-10.5-133.5-23.5-32-37-36.5-108-36.5-55 0-67.5 1.5-84.5 10-37.5 19.5-39.5 26.5-39.5 160.5 0 114 0.5 118.5 11.5 134.5 20.5 31 37 35.5 114.5 34 60-1.5 70-3 82-12zm-92-544.5c-3.5-40.5-26.5-69.5-61.5-76.5-9.5-2-44.5-2.5-78-1-51.5 2-63 4-75 13-18.5 14-29.5 34.5-33 60.5l-2.5 21 38.5 1.5c21 1 77.5 1.5 125.5 1.5h87.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psCNYBsBm",
    fillRule: "evenodd",
    className: "s24",
    d: "m-3358.5 2663.5c-11-5.5-27-19.5-35-30.5l-14-20.5-1.5-297c-1-209.5 0.5-303 4.5-318 7-27 37.5-57 63-61.5 10.5-2 21-4.5 23-5.5 2-1.5-21-26.5-51.5-56-34.5-33.5-55-57.5-55-63.5 0-11 69.5-82 80-82 3.5 0 51.5 45 107 99.5l100.5 100 306 3 69 34c103.5 51 122.5 70 122.5 123 0 56.5-44 100.5-99.5 100.5h-20l-3 423-14 21.5c-27.5 41-21 40.5-308.5 40.5-245 0-253-0.5-273.5-10.5zm541-19.5c36-22.5 35-14 36-247.5l1-210-21-15c-31-22.5-40.5-45.5-40.5-100 0-24.5 1.5-61 3.5-80.5l4-35.5-23.5-3.5c-31-4-252-4-252 0.5 0 1.5 13.5 17 30 34.5 16.5 17 30 34 30 37.5 0 8.5-72 79.5-80.5 79.5-3 0-41.5-35-85.5-78l-79.5-78-21 3c-31 5-49.5 18-62.5 43l-11 22.5 1 295 1.5 295 11 15.5c23 32.5 18 32 293.5 32 241.5 0 250-0.5 265.5-10zm110.5-479.5c49.5-22.5 65.5-82 33.5-124.5-14.5-19.5-134-80.5-142-72.5-7.5 7.5-11.5 125.5-5 149.5 13 47 65.5 69.5 113.5 47.5zm-393.5-112.5c14.5-15 26-29 24.5-31-1-2.5-62-64-135.5-137l-133.5-132.5-60 60 134 134c73.5 73.5 136 133.5 139 133.5 2.5 0 17-12 31.5-27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJYaCJT6m",
    fillRule: "evenodd",
    className: "s24",
    d: "m2072.5 2625.5c-35.5-18.5-56.5-55.5-51-89 2.5-16.5 33.5-77.5 58.5-115.5l10-15.5-33.5-8.5c-62.5-15.5-183.5-88-222-132.5-25.5-30-57-92.5-64.5-129-9.5-44.5-4-122 11-161.5 15-39 62.5-122 91-159.5 28.5-38 82-77.5 128-94 34-12.5 43.5-14 102.5-14 77 0 94.5 5.5 179.5 53.5 119.5 68 178 157 178 272.5 0 21.5-3.5 52-7.5 68-7 26.5-6.5 29.5 2 44.5 14.5 25 52 167.5 52.5 199 0.5 50.5-34 85-85.5 85-40.5 0-69.5-21.5-83-60.5-3.5-9.5-8-18-10-18.5-2.5-1-33.5 50-69.5 112.5-35.5 62.5-70.5 122.5-77.5 132.5-23 34-75 48.5-109 30.5zm75-18.5c6.5-4 22.5-26.5 36.5-49 76.5-129 126.5-220 134.5-245 5-16 10.5-29 12-29 2 0 5 8 7 18 14.5 77.5 39 112 80.5 112 44 0 74-28.5 73.5-69.5-0.5-26.5-37.5-163.5-52.5-193.5-10-20-10-22-2-56 25.5-112-19-225-114-290.5-39-27-124.5-70-155.5-78-60-15.5-126.5-8-185 20.5-64.5 31.5-106 79-164.5 187.5-36 67.5-47 138-30.5 202 20.5 80.5 68.5 138.5 159 192 61.5 36 87.5 47 133.5 55.5 18 3.5 33 7 34 7.5 1 1-14.5 29-34.5 62.5-19.5 34-38 68-40.5 75.5-10 28.5 13 70.5 46 84 16 7 47 3.5 62.5-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5y4wVuvc",
    className: "s24",
    d: "m-1211.5 1973.5c-59-51.5-73.5-69.5-56.5-69.5 10 0 133 109 133 117.5 0 15.5-15 6-76.5-48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTmo5Wupy",
    className: "s24",
    d: "m-1231.5 1875.5c-2-1.5-3.5-6-3.5-10 0-5 20.5-6.5 101.5-6.5 56 0 103.5 1.5 105 3.5 2 1.5 1 6-2 10-4.5 5-27.5 6.5-102 6.5-52.5 0-97.5-1.5-99-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCqBaRLC4",
    className: "s24",
    d: "m-1272 1824.5c-5-8 2-17 31-42.5 15.5-13.5 43.5-37.5 62.5-53.5 36-31.5 43.5-35 43.5-20.5 0 6-23.5 30-59.5 61-65.5 56.5-73.5 62.5-77.5 55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prhy9HyxX",
    fillRule: "evenodd",
    className: "s24",
    d: "m-3334.5 1078c0.5-34 2.5-75 4.5-91.5 3-25.5 3.5-21 4.5 32.5l0.5 62.5 18 11.5 17.5 11.5 18.5-11.5c10-6 50.5-32 90-57.5 61-39.5 71-48 71-59 0-18.5-8.5-19.5-46.5-5-43.5 16-48.5 16-48.5-2 0-7.5-1.5-24.5-3-37l-3.5-23-29 15c-42 21-44.5 20-44.5-15 0-37.5-3-45.5-17.5-45.5-15.5 0-19 6.5-23 40l-3 27.5-0.5-25c-0.5-13.5 2.5-33 6-42.5 6.5-18.5 435-764 444-772.5 3-2.5 0.5 4.5-5.5 16-14.5 29.5-15 89.5 0 120 32 66.5 110.5 85.5 170.5 41.5 38.5-28.5 44-35 78.5-95 17-30.5 32-55 33.5-55 1.5 0 0 4-2.5 9-5 9.5-10 18-253 438.5-98.5 170.5-191 331.5-206.5 357.5-15 26-31.5 53.5-36.5 60.5-8 11.5-222.5 154.5-231.5 154.5-1.5 0-3-27.5-2.5-61zm187-127c28-11 34-12 41-6.5 6.5 6 8.5 6 12.5-0.5 2-4 36.5-63.5 75.5-132.5 159-277.5 285.5-495.5 292.5-504 11-12.5 6-14-21.5-5.5-44.5 13.5-87 3-122.5-31l-17.5-16.5-79.5 138.5c-44 76-102.5 178-130.5 226-139.5 240-167.5 289.5-167.5 294.5 0 3 14.5-2 32.5-10.5 17.5-9 33.5-15 34.5-13.5 1.5 1.5 4.5 19 6 38.5 2 20 5.5 36 7.5 36 2.5 0 19-6 37-13zm-59.5-172c29.5-51 71-123 92-160 78-137.5 191.5-333 203-351.5 10-15 12-24.5 11-45-2-39-12-36-41 11.5-13.5 22-25.5 39-27 38-1.5-1.5 0.5-6 4-10.5 3.5-4.5 5.5-9 4-10-1-1.5-7.5 7-14 19-10 17.5-10.5 19.5-2.5 13.5 8.5-7 8.5-7 2.5 3.5-4 6-8.5 10-10.5 8.5-6.5-3.5-49.5 76.5-46.5 86.5q3 9-1.5 3c-5.5-8-24 21-18.5 29.5 2 3 1.5 4-1.5 2.5-3-2-7 0-8.5 4.5-1.5 4.5-1 6 2.5 4 3-1.5 1.5 4-2.5 12.5-9 17-14.5 20.5-10 7 2-5-1.5-1.5-7.5 7.5-6 9-9 19-7.5 22 2.5 3.5 1 4-3 1.5-5-3-6-2-3.5 4 2 5 1 8-3 7-3.5-0.5-5.5 3.5-5 10.5 1 6.5-0.5 10.5-3.5 8.5-2.5-1.5-7 2-10 8-4.5 8.5-4.5 10 0 7 4-2.5 5.5-1.5 4 3-1.5 4-5 6.5-7.5 6-2.5-0.5-4.5 3-4.5 7.5 0 11.5-47.5 90.5-53.5 89.5-2.5-0.5-12.5 13.5-22.5 31-10 18-15 30.5-12 28.5 4-2.5 5-1 3 4-1.5 4.5-5 7-7.5 5.5-2-1.5-6.5 2.5-10 8.5-6 11-5.5 11 3 4 8.5-7 9-7 3 4-3.5 6-8.5 10-11.5 8-3.5-2-4-1.5-2 2 2 3.5-9 29.5-24.5 58.5l-28 52.5 8.5 20c5 11 11 19.5 13 19 2-1 28-43 57-94zm44.5-175c4.5-8 6.5-15 5.5-15-1.5 0-6 7-10.5 15-4.5 8.5-6.5 15-5.5 15 1.5 0 6-6.5 10.5-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSSdIBFcR",
    className: "s24",
    d: "m-3012.5 344c4.5-8 9-15 10.5-15 1 0-1 7-5.5 15-4.5 8.5-9 15-10.5 15-1 0 1-6.5 5.5-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRjSbZm8u",
    fillRule: "evenodd",
    className: "s24",
    d: "m326.5 994.5c-58-16.5-173.5-86.5-217.5-132-34.5-35.5-49.5-60.5-66.5-111-14.5-43-18-109.5-8-154 7-30 51-129.5 67-150.5 6.5-8.5 37.5-59.5 68.5-113 30.5-53.5 72.5-124.5 92-157.5 20-33 42.5-70.5 50-84 38-66.5 114.5-102 180.5-84 22.5 6 178 91 297.5 163 112.5 67.5 140.5 103 140 177-0.5 45 1.5 40-140 288-38 66-76 134.5-85 152.5-21.5 43-74 113.5-108 144.5-31 28-75.5 51.5-119.5 63-39.5 10-112 9-151-2zm143-13c47-11.5 94-38 128-73.5 16.5-16.5 26-29 21-27-26 9-62 8.5-88.5-0.5-23-7.5-318-173.5-397-223-26-16.5-49.5-48-59-79.5-3-10.5-7-19-8.5-19-7.5 0-20.5 66.5-20.5 102.5 0 128 67.5 212 240 298.5 56 28 123.5 35.5 184.5 21.5zm154-123.5c26.5-12 44-33 62-71.5 12-27 41-78.5 138.5-247.5 16.5-29 29.5-53 28.5-54-1-1-9 2-18.5 7-25 13-81 15-112 4-30-11-325.5-180.5-361-207-30.5-23-53.5-58-61.5-92.5-3.5-15-7.5-27.5-9-27.5-1.5 0-9 11-16 24-35 64-140.5 242-158.5 268-34 48-39 83-19 125.5 6.5 14 20.5 33 31 43 25.5 23.5 389 233 415 239 25 5.5 54 2 80.5-10.5zm104-129c4.5-8 6.5-15 5.5-15-1.5 0-6 7-10.5 15-4.5 8.5-6.5 15-5.5 15 1.5 0 6-6.5 10.5-15zm35-60c4.5-8 6.5-15 5.5-15-1.5 0-6 7-10.5 15-4.5 8.5-6.5 15-5.5 15 1.5 0 6-6.5 10.5-15zm35-60c4.5-8 6.5-15 5.5-15-1.5 0-6 7-10.5 15-4.5 8.5-6.5 15-5.5 15 1.5 0 6-6.5 10.5-15zm35.5-135c87.5-42.5 108-160 40-227-19-18.5-309-189.5-365-215-13.5-6-31.5-9.5-53-9.5-58 0.5-101.5 28-125.5 79-27.5 57-16 121.5 28.5 163 21.5 20.5 337 204 372.5 216.5 28.5 10.5 72 7.5 102.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1G4E180X4",
    fillRule: "evenodd",
    className: "s24",
    d: "m2112 989c-5.5-2-16.5-11-23.5-20l-13.5-16v-137c0-75.5-1-137-2-137-2 0-118.5 66.5-208 119-41 24-75.5 16.5-97.5-21.5-15-25-16-44.5-3-65.5 11-17.5 2-12 168-107 69-39.5 129-75 134-79 7-6 8.5-16 8.5-54.5v-47l-27.5-25.5c-87-81-89-219-5-298.5 33-31 68-49 111.5-56.5 55.5-9.5 53-14 49 94.5-1.5 51-4 94.5-5.5 95.5-1.5 1.5-2.5-39-2.5-90.5 0-51-2-94-4.5-95.5-6.5-4.5-54.5 11.5-90.5 29.5-50.5 26-93 77-105 127-25 106 49.5 216 161 237 25 4.5 30.5 4 34.5-2 2.5-4 4.5-48.5 5-99.5 1-70.5 2-84 4.5-57.5 2 19.5 4 63.5 4.5 99l0.5 63.5 54-28c29.5-16 106-59 170.5-96 64-37 120.5-68 125-69.5 6.5-1.5 12.5 5.5 23.5 29.5 13 28.5 14.5 36.5 14.5 84 0 50-1 54.5-17 87.5-46.5 94-145.5 137.5-247.5 108l-35-9.5-44 25.5-44 26v175.5c0 170.5-0.5 176-10.5 189-19.5 24.5-54.5 34.5-82.5 23zm50.5-17c9-4 19-11.5 22-17 6.5-12 8-341 2-341-2.5 0-24 12-49 26.5l-45 26.5-1.5 140c-1 135-0.5 141 9 153.5 9 11.5 18 15.5 39 18 3.5 0 14-2.5 23.5-6.5zm-197.5-251.5c70-40.5 168-96.5 217-125 49.5-28.5 92-51.5 95-51.5 2.5 0-7.5-12-22.5-26-15.5-14.5-32-32.5-37.5-40l-9.5-14-190 109.5c-104.5 60.5-200 116-212.5 124-41 26-45 52.5-12 85.5 14 14 19.5 16.5 31 14 7.5-2 71-36.5 141-76.5zm505.5-178c31-15 70-53 91-88.5 20.5-35.5 26.5-85.5 15.5-135-13.5-63.5-11-62.5-80-23-74 42.5-221.5 129.5-253 149.5-13.5 8-24 16.5-24 19.5 0 7.5 51.5 59.5 67.5 68 40.5 21 64.5 26 110 24.5 36.5-1.5 50.5-4.5 73-15zm-340-53.5c18.5-11 40-22.5 48-25.5 13.5-6 13-6.5-19-12.5-18.5-3.5-41.5-10-51.5-14l-18-7.5v40c0 21.5 1.5 39.5 3.5 39.5 2 0 18.5-9 37-20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CPKhkMU7",
    className: "s24",
    d: "m2125.5 581c-13.5-17-13-27.5 1-41 14.5-13.5 30.5-14 43.5-1 19.5 19.5 5.5 55-22 55-7.5 0-16.5-5.5-22.5-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12sLd4flV",
    fillRule: "evenodd",
    className: "s24",
    d: "m2397 476c-9-4.5-21-13-27-19.5l-11-12 44.5-29c49.5-32.5 73-44 83-40 13.5 5 14.5 39 2 63.5-19.5 39.5-56.5 54.5-91.5 37zm49.5-9c26-11 39.5-29.5 42.5-57 1-13.5 0-26-2-27.5-4-2-19 6-94 50.5l-19.5 11.5 10 10.5c5.5 5.5 18 12 27 14 9.5 2 17.5 4 18.5 4.5 0.5 0.5 8.5-2.5 17.5-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPmPYMXqB",
    fillRule: "evenodd",
    className: "s24",
    d: "m-1448 812.5c1-17 8.5-31.5 49.5-93 13.5-20 26.5-43 28.5-51 15.5-53.5-62-109.5-114.5-82-10.5 5-22 22-42 61-20 40-30 54.5-38 55.5-5.5 1-10.5 0.5-10.5-1 0-11.5 54.5-109.5 69.5-125.5 10.5-11 47.5-73 83-137.5 93.5-172.5 129.5-225 280-407.5 135-164 157.5-186 153.5-150-4.5 39-137 385-182 474.5-26.5 52.5-55.5 102-129.5 220.5-24 38.5-46 80-49.5 92.5-3 12-15.5 36.5-27 54.5-12 18-32 49.5-44.5 69.5-13 19.5-24 36-25 36-1 0-1.5-7.5-1.5-16.5zm118.5-225c10-17 40-67 67-111 81-132 134.5-252.5 215.5-482 20-58 25-80 12.5-56.5-3 5.5-25 31-48.5 56.5-81.5 88-175 206.5-233 294.5-43 65-144 251-144 264.5 0 3 4.5 5.5 9.5 5.5 18.5 0 74.5 29 86 44.5 6.5 8.5 12.5 15.5 14 15.5 1.5 0 11-14.5 21-31.5zm124.5-183.5c5.5-11 9-20 7.5-20-1 0-7 9-12.5 20-5.5 11-9 20-7.5 20 1 0 7-9 12.5-20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1ADMkoX2t",
    fillRule: "evenodd",
    className: "s24",
    d: "m2091 299c-22-13.5-38.5-48-34-71.5 4.5-24.5 22.5-48.5 44.5-60 32.5-17 34-13.5 32.5 69l-1.5 72.5h-12.5c-7 0-20-4.5-29-10zm34-62.5c0-69.5-2-72.5-30.5-52-39 27.5-38 80 2 104.5 28 17 28.5 16 28.5-52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12mGp9PZp",
    className: "s24",
    d: "m-2625 112.5c0-1 7.5-8 16.5-16.5l16-14.5-14.5 16.5c-14 15-18 18.5-18 14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BwhocIrn",
    className: "s24",
    d: "m-2867.5 69c4.5-8 9-15 10.5-15 1 0-1 7-5.5 15-4.5 8.5-9 15-10.5 15-1 0 1-6.5 5.5-15z"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "l7kHog5wyIHIdSK2rmXJtb7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "p1CaCfyv7M",
    className: "s25",
    d: "m-2764 3897c-6-12-11-23-11-25 0-1.5 11.5-3 25-3 14 0 25 1 25 2.5 0 5.5-22 47.5-25 47.5-2 0-8-10-14-22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GRG4Ar1G",
    className: "s25",
    d: "m-3177 3852.5c-3-18-52-419-56.5-466l-3-29.5 19.5 14.5c11 8.5 97.5 73 192 144.5 166.5 125 199.5 151 194.5 154.5-1 0.5-47 7.5-102 15.5-55 7.5-103 16.5-107 19.5-3.5 3-33.5 40-66.5 82-33 42-61.5 77.5-64 79-2 1.5-5-5-7-14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10zw6bwsQ",
    className: "s25",
    d: "m-2859 3803c-24.5-12-23-17.5 10.5-31.5 21.5-9 25.5-5 22.5 23-2 20.5-6 21.5-33 8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9889wiAq",
    className: "s25",
    d: "m-2671.5 3810.5c-5-4.5-4.5-40.5 0.5-43.5 5.5-3.5 46 15.5 46 21.5 0 3-9 10-20 15.5-22 11.5-22 11.5-26.5 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pARPKLJDC",
    className: "s25",
    d: "m-2775 3706.5c0-5.5 22.5-47.5 25.5-47.5 2 0 4.5 3 6 6.5 1.5 3 6 14.5 10.5 25l8 18.5h-25c-13.5 0-25-1-25-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16JnOVSRh",
    className: "s25",
    d: "m246.5 3614c0-18 1-25 2-16 1 8.5 1 23.5 0 32.5-1 8.5-2 1.5-2-16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9NCcKsTn",
    className: "s25",
    d: "m-1757.5 2331.5c0-123.5 0.5-173.5 1-111 1 63 1 164 0 225-0.5 61-1 10-1-114z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15Aqohev5",
    className: "s25",
    d: "m-1368.5 2510.5c10-1 27-1 37.5 0 10 1 1.5 2-19 2-20.5 0-29-1-18.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnLl6XZRS",
    className: "s25",
    d: "m-1260 2028c-9.5-12-13-18.5-8.5-14.5 9.5 7.5 30.5 35.5 27 35.5-1 0-9.5-9.5-18.5-21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFDe1jpjW",
    className: "s25",
    d: "m2196.5 241.5c0-13.5 1-19 2-11 1 7.5 1 18.5 0 25-1 6-2 0-2-14z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraser);
export default __webpack_public_path__ + "static/media/eraser.3cff035fe366db01369de1c7efed3a6e.svg";
export { ForwardRef as ReactComponent };